(function () {

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
//import Alpine from 'alpinejs'
//Alpine.start()
const $e35dfd66294e81cf$var$t = (t, e = 1e4)=>(t = parseFloat(t + "") || 0, Math.round((t + Number.EPSILON) * e) / e), $e35dfd66294e81cf$var$e = function(t) {
    if (!(t && t instanceof Element && t.offsetParent)) return !1;
    const e = t.scrollHeight > t.clientHeight, i = window.getComputedStyle(t).overflowY, n = -1 !== i.indexOf("hidden"), s = -1 !== i.indexOf("visible");
    return e && !n && !s;
}, $e35dfd66294e81cf$var$i = function(t, n) {
    return !(!t || t === document.body || n && t === n) && ($e35dfd66294e81cf$var$e(t) ? t : $e35dfd66294e81cf$var$i(t.parentElement, n));
}, $e35dfd66294e81cf$var$n = function(t) {
    var e = (new DOMParser).parseFromString(t, "text/html").body;
    if (e.childElementCount > 1) {
        for(var i = document.createElement("div"); e.firstChild;)i.appendChild(e.firstChild);
        return i;
    }
    return e.firstChild;
}, $e35dfd66294e81cf$var$s = (t)=>`${t || ""}`.split(" ").filter((t)=>!!t), $e35dfd66294e81cf$var$o = (t, e, i)=>{
    t && $e35dfd66294e81cf$var$s(e).forEach((e)=>{
        t.classList.toggle(e, i || !1);
    });
};
class $e35dfd66294e81cf$var$a {
    constructor(t){
        Object.defineProperty(this, "pageX", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), Object.defineProperty(this, "pageY", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), Object.defineProperty(this, "clientX", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), Object.defineProperty(this, "clientY", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), Object.defineProperty(this, "id", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), Object.defineProperty(this, "time", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), Object.defineProperty(this, "nativePointer", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), this.nativePointer = t, this.pageX = t.pageX, this.pageY = t.pageY, this.clientX = t.clientX, this.clientY = t.clientY, this.id = self.Touch && t instanceof Touch ? t.identifier : -1, this.time = Date.now();
    }
}
const $e35dfd66294e81cf$var$r = {
    passive: !1
};
class $e35dfd66294e81cf$var$l {
    constructor(t, { start: e = ()=>!0, move: i = ()=>{}, end: n = ()=>{} }){
        Object.defineProperty(this, "element", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), Object.defineProperty(this, "startCallback", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), Object.defineProperty(this, "moveCallback", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), Object.defineProperty(this, "endCallback", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), Object.defineProperty(this, "currentPointers", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: []
        }), Object.defineProperty(this, "startPointers", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: []
        }), this.element = t, this.startCallback = e, this.moveCallback = i, this.endCallback = n;
        for (const t of [
            "onPointerStart",
            "onTouchStart",
            "onMove",
            "onTouchEnd",
            "onPointerEnd",
            "onWindowBlur"
        ])this[t] = this[t].bind(this);
        this.element.addEventListener("mousedown", this.onPointerStart, $e35dfd66294e81cf$var$r), this.element.addEventListener("touchstart", this.onTouchStart, $e35dfd66294e81cf$var$r), this.element.addEventListener("touchmove", this.onMove, $e35dfd66294e81cf$var$r), this.element.addEventListener("touchend", this.onTouchEnd), this.element.addEventListener("touchcancel", this.onTouchEnd);
    }
    onPointerStart(t) {
        if (!t.buttons || 0 !== t.button) return;
        const e = new $e35dfd66294e81cf$var$a(t);
        this.currentPointers.some((t)=>t.id === e.id) || this.triggerPointerStart(e, t) && (window.addEventListener("mousemove", this.onMove), window.addEventListener("mouseup", this.onPointerEnd), window.addEventListener("blur", this.onWindowBlur));
    }
    onTouchStart(t) {
        for (const e of Array.from(t.changedTouches || []))this.triggerPointerStart(new $e35dfd66294e81cf$var$a(e), t);
        window.addEventListener("blur", this.onWindowBlur);
    }
    onMove(t) {
        const e = this.currentPointers.slice(), i = "changedTouches" in t ? Array.from(t.changedTouches || []).map((t)=>new $e35dfd66294e81cf$var$a(t)) : [
            new $e35dfd66294e81cf$var$a(t)
        ], n = [];
        for (const t of i){
            const e = this.currentPointers.findIndex((e)=>e.id === t.id);
            e < 0 || (n.push(t), this.currentPointers[e] = t);
        }
        n.length && this.moveCallback(t, this.currentPointers.slice(), e);
    }
    onPointerEnd(t) {
        t.buttons > 0 && 0 !== t.button || (this.triggerPointerEnd(t, new $e35dfd66294e81cf$var$a(t)), window.removeEventListener("mousemove", this.onMove), window.removeEventListener("mouseup", this.onPointerEnd), window.removeEventListener("blur", this.onWindowBlur));
    }
    onTouchEnd(t) {
        for (const e of Array.from(t.changedTouches || []))this.triggerPointerEnd(t, new $e35dfd66294e81cf$var$a(e));
    }
    triggerPointerStart(t, e) {
        return !!this.startCallback(e, t, this.currentPointers.slice()) && (this.currentPointers.push(t), this.startPointers.push(t), !0);
    }
    triggerPointerEnd(t, e) {
        const i = this.currentPointers.findIndex((t)=>t.id === e.id);
        i < 0 || (this.currentPointers.splice(i, 1), this.startPointers.splice(i, 1), this.endCallback(t, e, this.currentPointers.slice()));
    }
    onWindowBlur() {
        this.clear();
    }
    clear() {
        for(; this.currentPointers.length;){
            const t = this.currentPointers[this.currentPointers.length - 1];
            this.currentPointers.splice(this.currentPointers.length - 1, 1), this.startPointers.splice(this.currentPointers.length - 1, 1), this.endCallback(new Event("touchend", {
                bubbles: !0,
                cancelable: !0,
                clientX: t.clientX,
                clientY: t.clientY
            }), t, this.currentPointers.slice());
        }
    }
    stop() {
        this.element.removeEventListener("mousedown", this.onPointerStart, $e35dfd66294e81cf$var$r), this.element.removeEventListener("touchstart", this.onTouchStart, $e35dfd66294e81cf$var$r), this.element.removeEventListener("touchmove", this.onMove, $e35dfd66294e81cf$var$r), this.element.removeEventListener("touchend", this.onTouchEnd), this.element.removeEventListener("touchcancel", this.onTouchEnd), window.removeEventListener("mousemove", this.onMove), window.removeEventListener("mouseup", this.onPointerEnd), window.removeEventListener("blur", this.onWindowBlur);
    }
}
function $e35dfd66294e81cf$var$c(t, e) {
    return e ? Math.sqrt(Math.pow(e.clientX - t.clientX, 2) + Math.pow(e.clientY - t.clientY, 2)) : 0;
}
function $e35dfd66294e81cf$var$h(t, e) {
    return e ? {
        clientX: (t.clientX + e.clientX) / 2,
        clientY: (t.clientY + e.clientY) / 2
    } : t;
}
const $e35dfd66294e81cf$var$d = (t)=>"object" == typeof t && null !== t && t.constructor === Object && "[object Object]" === Object.prototype.toString.call(t), $e35dfd66294e81cf$var$u = (t, ...e)=>{
    const i = e.length;
    for(let n = 0; n < i; n++){
        const i = e[n] || {};
        Object.entries(i).forEach(([e, i])=>{
            const n = Array.isArray(i) ? [] : {};
            t[e] || Object.assign(t, {
                [e]: n
            }), $e35dfd66294e81cf$var$d(i) ? Object.assign(t[e], $e35dfd66294e81cf$var$u(n, i)) : Array.isArray(i) ? Object.assign(t, {
                [e]: [
                    ...i
                ]
            }) : Object.assign(t, {
                [e]: i
            });
        });
    }
    return t;
}, $e35dfd66294e81cf$var$p = function(t, e) {
    return t.split(".").reduce((t, e)=>"object" == typeof t ? t[e] : void 0, e);
};
class $e35dfd66294e81cf$var$f {
    constructor(t = {}){
        Object.defineProperty(this, "options", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: t
        }), Object.defineProperty(this, "events", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: new Map
        }), this.setOptions(t);
        for (const t of Object.getOwnPropertyNames(Object.getPrototypeOf(this)))t.startsWith("on") && "function" == typeof this[t] && (this[t] = this[t].bind(this));
    }
    setOptions(t) {
        this.options = t ? $e35dfd66294e81cf$var$u({}, this.constructor.defaults, t) : {};
        for (const [t, e] of Object.entries(this.option("on") || {}))this.on(t, e);
    }
    option(t, ...e) {
        let i = $e35dfd66294e81cf$var$p(t, this.options);
        return i && "function" == typeof i && (i = i.call(this, this, ...e)), i;
    }
    optionFor(t, e, i, ...n) {
        let s = $e35dfd66294e81cf$var$p(e, t);
        var o;
        "string" != typeof (o = s) || isNaN(o) || isNaN(parseFloat(o)) || (s = parseFloat(s)), "true" === s && (s = !0), "false" === s && (s = !1), s && "function" == typeof s && (s = s.call(this, this, t, ...n));
        let a = $e35dfd66294e81cf$var$p(e, this.options);
        return a && "function" == typeof a ? s = a.call(this, this, t, ...n, s) : void 0 === s && (s = a), void 0 === s ? i : s;
    }
    cn(t) {
        const e = this.options.classes;
        return e && e[t] || "";
    }
    localize(t, e = []) {
        t = String(t).replace(/\{\{(\w+).?(\w+)?\}\}/g, (t, e, i)=>{
            let n = "";
            return i ? n = this.option(`${e[0] + e.toLowerCase().substring(1)}.l10n.${i}`) : e && (n = this.option(`l10n.${e}`)), n || (n = t), n;
        });
        for(let i = 0; i < e.length; i++)t = t.split(e[i][0]).join(e[i][1]);
        return t = t.replace(/\{\{(.*?)\}\}/g, (t, e)=>e);
    }
    on(t, e) {
        let i = [];
        "string" == typeof t ? i = t.split(" ") : Array.isArray(t) && (i = t), this.events || (this.events = new Map), i.forEach((t)=>{
            let i = this.events.get(t);
            i || (this.events.set(t, []), i = []), i.includes(e) || i.push(e), this.events.set(t, i);
        });
    }
    off(t, e) {
        let i = [];
        "string" == typeof t ? i = t.split(" ") : Array.isArray(t) && (i = t), i.forEach((t)=>{
            const i = this.events.get(t);
            if (Array.isArray(i)) {
                const t = i.indexOf(e);
                t > -1 && i.splice(t, 1);
            }
        });
    }
    emit(t, ...e) {
        [
            ...this.events.get(t) || []
        ].forEach((t)=>t(this, ...e)), "*" !== t && this.emit("*", t, ...e);
    }
}
Object.defineProperty($e35dfd66294e81cf$var$f, "version", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: "5.0.36"
}), Object.defineProperty($e35dfd66294e81cf$var$f, "defaults", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: {}
});
class $e35dfd66294e81cf$var$g extends $e35dfd66294e81cf$var$f {
    constructor(t = {}){
        super(t), Object.defineProperty(this, "plugins", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: {}
        });
    }
    attachPlugins(t = {}) {
        const e = new Map;
        for (const [i, n] of Object.entries(t)){
            const t = this.option(i), s = this.plugins[i];
            s || !1 === t ? s && !1 === t && (s.detach(), delete this.plugins[i]) : e.set(i, new n(this, t || {}));
        }
        for (const [t, i] of e)this.plugins[t] = i, i.attach();
    }
    detachPlugins(t) {
        t = t || Object.keys(this.plugins);
        for (const e of t){
            const t = this.plugins[e];
            t && t.detach(), delete this.plugins[e];
        }
        return this.emit("detachPlugins"), this;
    }
}
var $e35dfd66294e81cf$var$m;
!function(t) {
    t[t.Init = 0] = "Init", t[t.Error = 1] = "Error", t[t.Ready = 2] = "Ready", t[t.Panning = 3] = "Panning", t[t.Mousemove = 4] = "Mousemove", t[t.Destroy = 5] = "Destroy";
}($e35dfd66294e81cf$var$m || ($e35dfd66294e81cf$var$m = {}));
const $e35dfd66294e81cf$var$v = [
    "a",
    "b",
    "c",
    "d",
    "e",
    "f"
], $e35dfd66294e81cf$var$b = {
    PANUP: "Move up",
    PANDOWN: "Move down",
    PANLEFT: "Move left",
    PANRIGHT: "Move right",
    ZOOMIN: "Zoom in",
    ZOOMOUT: "Zoom out",
    TOGGLEZOOM: "Toggle zoom level",
    TOGGLE1TO1: "Toggle zoom level",
    ITERATEZOOM: "Toggle zoom level",
    ROTATECCW: "Rotate counterclockwise",
    ROTATECW: "Rotate clockwise",
    FLIPX: "Flip horizontally",
    FLIPY: "Flip vertically",
    FITX: "Fit horizontally",
    FITY: "Fit vertically",
    RESET: "Reset",
    TOGGLEFS: "Toggle fullscreen"
}, $e35dfd66294e81cf$var$y = {
    content: null,
    width: "auto",
    height: "auto",
    panMode: "drag",
    touch: !0,
    dragMinThreshold: 3,
    lockAxis: !1,
    mouseMoveFactor: 1,
    mouseMoveFriction: .12,
    zoom: !0,
    pinchToZoom: !0,
    panOnlyZoomed: "auto",
    minScale: 1,
    maxScale: 2,
    friction: .25,
    dragFriction: .35,
    decelFriction: .05,
    click: "toggleZoom",
    dblClick: !1,
    wheel: "zoom",
    wheelLimit: 7,
    spinner: !0,
    bounds: "auto",
    infinite: !1,
    rubberband: !0,
    bounce: !0,
    maxVelocity: 75,
    transformParent: !1,
    classes: {
        content: "f-panzoom__content",
        isLoading: "is-loading",
        canZoomIn: "can-zoom_in",
        canZoomOut: "can-zoom_out",
        isDraggable: "is-draggable",
        isDragging: "is-dragging",
        inFullscreen: "in-fullscreen",
        htmlHasFullscreen: "with-panzoom-in-fullscreen"
    },
    l10n: $e35dfd66294e81cf$var$b
}, $e35dfd66294e81cf$var$w = '<circle cx="25" cy="25" r="20"></circle>', $e35dfd66294e81cf$var$x = '<div class="f-spinner"><svg viewBox="0 0 50 50">' + $e35dfd66294e81cf$var$w + $e35dfd66294e81cf$var$w + "</svg></div>", $e35dfd66294e81cf$var$E = (t)=>t && null !== t && t instanceof Element && "nodeType" in t, $e35dfd66294e81cf$var$S = (t, e)=>{
    t && $e35dfd66294e81cf$var$s(e).forEach((e)=>{
        t.classList.remove(e);
    });
}, $e35dfd66294e81cf$var$P = (t, e)=>{
    t && $e35dfd66294e81cf$var$s(e).forEach((e)=>{
        t.classList.add(e);
    });
}, $e35dfd66294e81cf$var$C = {
    a: 1,
    b: 0,
    c: 0,
    d: 1,
    e: 0,
    f: 0
}, $e35dfd66294e81cf$var$T = 1e5, $e35dfd66294e81cf$var$M = 1e4, $e35dfd66294e81cf$var$O = "mousemove", $e35dfd66294e81cf$var$A = "drag", $e35dfd66294e81cf$var$L = "content", $e35dfd66294e81cf$var$z = "auto";
let $e35dfd66294e81cf$var$R = null, $e35dfd66294e81cf$var$k = null;
class $e35dfd66294e81cf$export$b704d075ddd20210 extends $e35dfd66294e81cf$var$g {
    get fits() {
        return this.contentRect.width - this.contentRect.fitWidth < 1 && this.contentRect.height - this.contentRect.fitHeight < 1;
    }
    get isTouchDevice() {
        return null === $e35dfd66294e81cf$var$k && ($e35dfd66294e81cf$var$k = window.matchMedia("(hover: none)").matches), $e35dfd66294e81cf$var$k;
    }
    get isMobile() {
        return null === $e35dfd66294e81cf$var$R && ($e35dfd66294e81cf$var$R = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent)), $e35dfd66294e81cf$var$R;
    }
    get panMode() {
        return this.options.panMode !== $e35dfd66294e81cf$var$O || this.isTouchDevice ? $e35dfd66294e81cf$var$A : $e35dfd66294e81cf$var$O;
    }
    get panOnlyZoomed() {
        const t = this.options.panOnlyZoomed;
        return t === $e35dfd66294e81cf$var$z ? this.isTouchDevice : t;
    }
    get isInfinite() {
        return this.option("infinite");
    }
    get angle() {
        return 180 * Math.atan2(this.current.b, this.current.a) / Math.PI || 0;
    }
    get targetAngle() {
        return 180 * Math.atan2(this.target.b, this.target.a) / Math.PI || 0;
    }
    get scale() {
        const { a: t, b: e } = this.current;
        return Math.sqrt(t * t + e * e) || 1;
    }
    get targetScale() {
        const { a: t, b: e } = this.target;
        return Math.sqrt(t * t + e * e) || 1;
    }
    get minScale() {
        return this.option("minScale") || 1;
    }
    get fullScale() {
        const { contentRect: t } = this;
        return t.fullWidth / t.fitWidth || 1;
    }
    get maxScale() {
        return this.fullScale * (this.option("maxScale") || 1) || 1;
    }
    get coverScale() {
        const { containerRect: t, contentRect: e } = this, i = Math.max(t.height / e.fitHeight, t.width / e.fitWidth) || 1;
        return Math.min(this.fullScale, i);
    }
    get isScaling() {
        return Math.abs(this.targetScale - this.scale) > 1e-5 && !this.isResting;
    }
    get isContentLoading() {
        const t = this.content;
        return !!(t && t instanceof HTMLImageElement) && !t.complete;
    }
    get isResting() {
        if (this.isBouncingX || this.isBouncingY) return !1;
        for (const t of $e35dfd66294e81cf$var$v){
            const e = "e" == t || "f" === t ? 1e-4 : 1e-5;
            if (Math.abs(this.target[t] - this.current[t]) > e) return !1;
        }
        return !(!this.ignoreBounds && !this.checkBounds().inBounds);
    }
    constructor(t, e = {}, i = {}){
        var s;
        if (super(e), Object.defineProperty(this, "pointerTracker", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "resizeObserver", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "updateTimer", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "clickTimer", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "rAF", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "isTicking", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: !1
        }), Object.defineProperty(this, "ignoreBounds", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: !1
        }), Object.defineProperty(this, "isBouncingX", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: !1
        }), Object.defineProperty(this, "isBouncingY", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: !1
        }), Object.defineProperty(this, "clicks", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: 0
        }), Object.defineProperty(this, "trackingPoints", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: []
        }), Object.defineProperty(this, "pwt", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: 0
        }), Object.defineProperty(this, "cwd", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: 0
        }), Object.defineProperty(this, "pmme", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), Object.defineProperty(this, "friction", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: 0
        }), Object.defineProperty(this, "state", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: $e35dfd66294e81cf$var$m.Init
        }), Object.defineProperty(this, "isDragging", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: !1
        }), Object.defineProperty(this, "container", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), Object.defineProperty(this, "content", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), Object.defineProperty(this, "spinner", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "containerRect", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: {
                width: 0,
                height: 0,
                innerWidth: 0,
                innerHeight: 0
            }
        }), Object.defineProperty(this, "contentRect", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: {
                top: 0,
                right: 0,
                bottom: 0,
                left: 0,
                fullWidth: 0,
                fullHeight: 0,
                fitWidth: 0,
                fitHeight: 0,
                width: 0,
                height: 0
            }
        }), Object.defineProperty(this, "dragStart", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: {
                x: 0,
                y: 0,
                top: 0,
                left: 0,
                time: 0
            }
        }), Object.defineProperty(this, "dragOffset", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: {
                x: 0,
                y: 0,
                time: 0
            }
        }), Object.defineProperty(this, "current", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: Object.assign({}, $e35dfd66294e81cf$var$C)
        }), Object.defineProperty(this, "target", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: Object.assign({}, $e35dfd66294e81cf$var$C)
        }), Object.defineProperty(this, "velocity", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: {
                a: 0,
                b: 0,
                c: 0,
                d: 0,
                e: 0,
                f: 0
            }
        }), Object.defineProperty(this, "lockedAxis", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: !1
        }), !t) throw new Error("Container Element Not Found");
        this.container = t, this.initContent(), this.attachPlugins(Object.assign(Object.assign({}, $e35dfd66294e81cf$export$b704d075ddd20210.Plugins), i)), this.emit("attachPlugins"), this.emit("init");
        const o = this.content;
        if (o.addEventListener("load", this.onLoad), o.addEventListener("error", this.onError), this.isContentLoading) {
            if (this.option("spinner")) {
                t.classList.add(this.cn("isLoading"));
                const e = $e35dfd66294e81cf$var$n($e35dfd66294e81cf$var$x);
                !t.contains(o) || o.parentElement instanceof HTMLPictureElement ? this.spinner = t.appendChild(e) : this.spinner = (null === (s = o.parentElement) || void 0 === s ? void 0 : s.insertBefore(e, o)) || null;
            }
            this.emit("beforeLoad");
        } else queueMicrotask(()=>{
            this.enable();
        });
    }
    initContent() {
        const { container: t } = this, e = this.cn($e35dfd66294e81cf$var$L);
        let i = this.option($e35dfd66294e81cf$var$L) || t.querySelector(`.${e}`);
        if (i || (i = t.querySelector("img,picture") || t.firstElementChild, i && $e35dfd66294e81cf$var$P(i, e)), i instanceof HTMLPictureElement && (i = i.querySelector("img")), !i) throw new Error("No content found");
        this.content = i;
    }
    onLoad() {
        const { spinner: t, container: e, state: i } = this;
        t && (t.remove(), this.spinner = null), this.option("spinner") && e.classList.remove(this.cn("isLoading")), this.emit("afterLoad"), i === $e35dfd66294e81cf$var$m.Init ? this.enable() : this.updateMetrics();
    }
    onError() {
        this.state !== $e35dfd66294e81cf$var$m.Destroy && (this.spinner && (this.spinner.remove(), this.spinner = null), this.stop(), this.detachEvents(), this.state = $e35dfd66294e81cf$var$m.Error, this.emit("error"));
    }
    getNextScale(t) {
        const { fullScale: e, targetScale: i, coverScale: n, maxScale: s, minScale: o } = this;
        let a = o;
        switch(t){
            case "toggleMax":
                a = i - o < .5 * (s - o) ? s : o;
                break;
            case "toggleCover":
                a = i - o < .5 * (n - o) ? n : o;
                break;
            case "toggleZoom":
                a = i - o < .5 * (e - o) ? e : o;
                break;
            case "iterateZoom":
                let t1 = [
                    1,
                    e,
                    s
                ].sort((t, e)=>t - e), r = t1.findIndex((t)=>t > i + 1e-5);
                a = t1[r] || 1;
        }
        return a;
    }
    attachObserver() {
        var t;
        const e = ()=>{
            const { container: t, containerRect: e } = this;
            return Math.abs(e.width - t.getBoundingClientRect().width) > .1 || Math.abs(e.height - t.getBoundingClientRect().height) > .1;
        };
        this.resizeObserver || void 0 === window.ResizeObserver || (this.resizeObserver = new ResizeObserver(()=>{
            this.updateTimer || (e() ? (this.onResize(), this.isMobile && (this.updateTimer = setTimeout(()=>{
                e() && this.onResize(), this.updateTimer = null;
            }, 500))) : this.updateTimer && (clearTimeout(this.updateTimer), this.updateTimer = null));
        })), null === (t = this.resizeObserver) || void 0 === t || t.observe(this.container);
    }
    detachObserver() {
        var t;
        null === (t = this.resizeObserver) || void 0 === t || t.disconnect();
    }
    attachEvents() {
        const { container: t } = this;
        t.addEventListener("click", this.onClick, {
            passive: !1,
            capture: !1
        }), t.addEventListener("wheel", this.onWheel, {
            passive: !1
        }), this.pointerTracker = new $e35dfd66294e81cf$var$l(t, {
            start: this.onPointerDown,
            move: this.onPointerMove,
            end: this.onPointerUp
        }), document.addEventListener($e35dfd66294e81cf$var$O, this.onMouseMove);
    }
    detachEvents() {
        var t;
        const { container: e } = this;
        e.removeEventListener("click", this.onClick, {
            passive: !1,
            capture: !1
        }), e.removeEventListener("wheel", this.onWheel, {
            passive: !1
        }), null === (t = this.pointerTracker) || void 0 === t || t.stop(), this.pointerTracker = null, document.removeEventListener($e35dfd66294e81cf$var$O, this.onMouseMove), document.removeEventListener("keydown", this.onKeydown, !0), this.clickTimer && (clearTimeout(this.clickTimer), this.clickTimer = null), this.updateTimer && (clearTimeout(this.updateTimer), this.updateTimer = null);
    }
    animate() {
        this.setTargetForce();
        const t = this.friction, e = this.option("maxVelocity");
        for (const i of $e35dfd66294e81cf$var$v)t ? (this.velocity[i] *= 1 - t, e && !this.isScaling && (this.velocity[i] = Math.max(Math.min(this.velocity[i], e), -1 * e)), this.current[i] += this.velocity[i]) : this.current[i] = this.target[i];
        this.setTransform(), this.setEdgeForce(), !this.isResting || this.isDragging ? this.rAF = requestAnimationFrame(()=>this.animate()) : this.stop("current");
    }
    setTargetForce() {
        for (const t of $e35dfd66294e81cf$var$v)"e" === t && this.isBouncingX || "f" === t && this.isBouncingY || (this.velocity[t] = (1 / (1 - this.friction) - 1) * (this.target[t] - this.current[t]));
    }
    checkBounds(t = 0, e = 0) {
        const { current: i } = this, n = i.e + t, s = i.f + e, o = this.getBounds(), { x: a, y: r } = o, l = a.min, c = a.max, h = r.min, d = r.max;
        let u = 0, p = 0;
        return l !== 1 / 0 && n < l ? u = l - n : c !== 1 / 0 && n > c && (u = c - n), h !== 1 / 0 && s < h ? p = h - s : d !== 1 / 0 && s > d && (p = d - s), Math.abs(u) < 1e-4 && (u = 0), Math.abs(p) < 1e-4 && (p = 0), Object.assign(Object.assign({}, o), {
            xDiff: u,
            yDiff: p,
            inBounds: !u && !p
        });
    }
    clampTargetBounds() {
        const { target: t } = this, { x: e, y: i } = this.getBounds();
        e.min !== 1 / 0 && (t.e = Math.max(t.e, e.min)), e.max !== 1 / 0 && (t.e = Math.min(t.e, e.max)), i.min !== 1 / 0 && (t.f = Math.max(t.f, i.min)), i.max !== 1 / 0 && (t.f = Math.min(t.f, i.max));
    }
    calculateContentDim(t = this.current) {
        const { content: e, contentRect: i } = this, { fitWidth: n, fitHeight: s, fullWidth: o, fullHeight: a } = i;
        let r = o, l = a;
        if (this.option("zoom") || 0 !== this.angle) {
            const i = !(e instanceof HTMLImageElement) && ("none" === window.getComputedStyle(e).maxWidth || "none" === window.getComputedStyle(e).maxHeight), c = i ? o : n, h = i ? a : s, d = this.getMatrix(t), u = new DOMPoint(0, 0).matrixTransform(d), p = new DOMPoint(0 + c, 0).matrixTransform(d), f = new DOMPoint(0 + c, 0 + h).matrixTransform(d), g = new DOMPoint(0, 0 + h).matrixTransform(d), m = Math.abs(f.x - u.x), v = Math.abs(f.y - u.y), b = Math.abs(g.x - p.x), y = Math.abs(g.y - p.y);
            r = Math.max(m, b), l = Math.max(v, y);
        }
        return {
            contentWidth: r,
            contentHeight: l
        };
    }
    setEdgeForce() {
        if (this.ignoreBounds || this.isDragging || this.panMode === $e35dfd66294e81cf$var$O || this.targetScale < this.scale) return this.isBouncingX = !1, void (this.isBouncingY = !1);
        const { target: t } = this, { x: e, y: i, xDiff: n, yDiff: s } = this.checkBounds();
        const o = this.option("maxVelocity");
        let a = this.velocity.e, r = this.velocity.f;
        0 !== n ? (this.isBouncingX = !0, n * a <= 0 ? a += .14 * n : (a = .14 * n, e.min !== 1 / 0 && (this.target.e = Math.max(t.e, e.min)), e.max !== 1 / 0 && (this.target.e = Math.min(t.e, e.max))), o && (a = Math.max(Math.min(a, o), -1 * o))) : this.isBouncingX = !1, 0 !== s ? (this.isBouncingY = !0, s * r <= 0 ? r += .14 * s : (r = .14 * s, i.min !== 1 / 0 && (this.target.f = Math.max(t.f, i.min)), i.max !== 1 / 0 && (this.target.f = Math.min(t.f, i.max))), o && (r = Math.max(Math.min(r, o), -1 * o))) : this.isBouncingY = !1, this.isBouncingX && (this.velocity.e = a), this.isBouncingY && (this.velocity.f = r);
    }
    enable() {
        const { content: t } = this, e = new DOMMatrixReadOnly(window.getComputedStyle(t).transform);
        for (const t of $e35dfd66294e81cf$var$v)this.current[t] = this.target[t] = e[t];
        this.updateMetrics(), this.attachObserver(), this.attachEvents(), this.state = $e35dfd66294e81cf$var$m.Ready, this.emit("ready");
    }
    onClick(t) {
        var e;
        "click" === t.type && 0 === t.detail && (this.dragOffset.x = 0, this.dragOffset.y = 0), this.isDragging && (null === (e = this.pointerTracker) || void 0 === e || e.clear(), this.trackingPoints = [], this.startDecelAnim());
        const i = t.target;
        if (!i || t.defaultPrevented) return;
        if (i.hasAttribute("disabled")) return t.preventDefault(), void t.stopPropagation();
        if ((()=>{
            const t = window.getSelection();
            return t && "Range" === t.type;
        })() && !i.closest("button")) return;
        const n = i.closest("[data-panzoom-action]"), s = i.closest("[data-panzoom-change]"), o = n || s, a = o && $e35dfd66294e81cf$var$E(o) ? o.dataset : null;
        if (a) {
            const e = a.panzoomChange, i = a.panzoomAction;
            if ((e || i) && t.preventDefault(), e) {
                let t = {};
                try {
                    t = JSON.parse(e);
                } catch (t) {
                    console && console.warn("The given data was not valid JSON");
                }
                return void this.applyChange(t);
            }
            if (i) return void (this[i] && this[i]());
        }
        if (Math.abs(this.dragOffset.x) > 3 || Math.abs(this.dragOffset.y) > 3) return t.preventDefault(), void t.stopPropagation();
        if (i.closest("[data-fancybox]")) return;
        const r = this.content.getBoundingClientRect(), l = this.dragStart;
        if (l.time && !this.canZoomOut() && (Math.abs(r.x - l.x) > 2 || Math.abs(r.y - l.y) > 2)) return;
        this.dragStart.time = 0;
        const c = (e)=>{
            this.option("zoom", t) && e && "string" == typeof e && /(iterateZoom)|(toggle(Zoom|Full|Cover|Max)|(zoomTo(Fit|Cover|Max)))/.test(e) && "function" == typeof this[e] && (t.preventDefault(), this[e]({
                event: t
            }));
        }, h = this.option("click", t), d = this.option("dblClick", t);
        d ? (this.clicks++, 1 == this.clicks && (this.clickTimer = setTimeout(()=>{
            1 === this.clicks ? (this.emit("click", t), !t.defaultPrevented && h && c(h)) : (this.emit("dblClick", t), t.defaultPrevented || c(d)), this.clicks = 0, this.clickTimer = null;
        }, 350))) : (this.emit("click", t), !t.defaultPrevented && h && c(h));
    }
    addTrackingPoint(t) {
        const e = this.trackingPoints.filter((t)=>t.time > Date.now() - 100);
        e.push(t), this.trackingPoints = e;
    }
    onPointerDown(t, e, i) {
        var n;
        if (!1 === this.option("touch", t)) return !1;
        this.pwt = 0, this.dragOffset = {
            x: 0,
            y: 0,
            time: 0
        }, this.trackingPoints = [];
        const s = this.content.getBoundingClientRect();
        if (this.dragStart = {
            x: s.x,
            y: s.y,
            top: s.top,
            left: s.left,
            time: Date.now()
        }, this.clickTimer) return !1;
        if (this.panMode === $e35dfd66294e81cf$var$O && this.targetScale > 1) return t.preventDefault(), t.stopPropagation(), !1;
        const o = t.composedPath()[0];
        if (!i.length) {
            if ([
                "TEXTAREA",
                "OPTION",
                "INPUT",
                "SELECT",
                "VIDEO",
                "IFRAME"
            ].includes(o.nodeName) || o.closest("[contenteditable],[data-selectable],[data-draggable],[data-clickable],[data-panzoom-change],[data-panzoom-action]")) return !1;
            null === (n = window.getSelection()) || void 0 === n || n.removeAllRanges();
        }
        if ("mousedown" === t.type) [
            "A",
            "BUTTON"
        ].includes(o.nodeName) || t.preventDefault();
        else if (Math.abs(this.velocity.a) > .3) return !1;
        return this.target.e = this.current.e, this.target.f = this.current.f, this.stop(), this.isDragging || (this.isDragging = !0, this.addTrackingPoint(e), this.emit("touchStart", t)), !0;
    }
    onPointerMove(e, n, s) {
        if (!1 === this.option("touch", e)) return;
        if (!this.isDragging) return;
        if (n.length < 2 && this.panOnlyZoomed && $e35dfd66294e81cf$var$t(this.targetScale) <= $e35dfd66294e81cf$var$t(this.minScale)) return;
        if (this.emit("touchMove", e), e.defaultPrevented) return;
        this.addTrackingPoint(n[0]);
        const { content: o } = this, a = $e35dfd66294e81cf$var$h(s[0], s[1]), r = $e35dfd66294e81cf$var$h(n[0], n[1]);
        let l = 0, d = 0;
        if (n.length > 1) {
            const t = o.getBoundingClientRect();
            l = a.clientX - t.left - .5 * t.width, d = a.clientY - t.top - .5 * t.height;
        }
        const u = $e35dfd66294e81cf$var$c(s[0], s[1]), p = $e35dfd66294e81cf$var$c(n[0], n[1]);
        let f = u ? p / u : 1, g = r.clientX - a.clientX, m = r.clientY - a.clientY;
        this.dragOffset.x += g, this.dragOffset.y += m, this.dragOffset.time = Date.now() - this.dragStart.time;
        let v = $e35dfd66294e81cf$var$t(this.targetScale) === $e35dfd66294e81cf$var$t(this.minScale) && this.option("lockAxis");
        if (v && !this.lockedAxis) {
            if ("xy" === v || "y" === v || "touchmove" === e.type) {
                if (Math.abs(this.dragOffset.x) < 6 && Math.abs(this.dragOffset.y) < 6) return void e.preventDefault();
                const t = Math.abs(180 * Math.atan2(this.dragOffset.y, this.dragOffset.x) / Math.PI);
                this.lockedAxis = t > 45 && t < 135 ? "y" : "x", this.dragOffset.x = 0, this.dragOffset.y = 0, g = 0, m = 0;
            } else this.lockedAxis = v;
        }
        if ($e35dfd66294e81cf$var$i(e.target, this.content) && (v = "x", this.dragOffset.y = 0), v && "xy" !== v && this.lockedAxis !== v && $e35dfd66294e81cf$var$t(this.targetScale) === $e35dfd66294e81cf$var$t(this.minScale)) return;
        e.cancelable && e.preventDefault(), this.container.classList.add(this.cn("isDragging"));
        const b = this.checkBounds(g, m);
        this.option("rubberband") ? ("x" !== this.isInfinite && (b.xDiff > 0 && g < 0 || b.xDiff < 0 && g > 0) && (g *= Math.max(0, .5 - Math.abs(.75 / this.contentRect.fitWidth * b.xDiff))), "y" !== this.isInfinite && (b.yDiff > 0 && m < 0 || b.yDiff < 0 && m > 0) && (m *= Math.max(0, .5 - Math.abs(.75 / this.contentRect.fitHeight * b.yDiff)))) : (b.xDiff && (g = 0), b.yDiff && (m = 0));
        const y = this.targetScale, w = this.minScale, x = this.maxScale;
        y < .5 * w && (f = Math.max(f, w)), y > 1.5 * x && (f = Math.min(f, x)), "y" === this.lockedAxis && $e35dfd66294e81cf$var$t(y) === $e35dfd66294e81cf$var$t(w) && (g = 0), "x" === this.lockedAxis && $e35dfd66294e81cf$var$t(y) === $e35dfd66294e81cf$var$t(w) && (m = 0), this.applyChange({
            originX: l,
            originY: d,
            panX: g,
            panY: m,
            scale: f,
            friction: this.option("dragFriction"),
            ignoreBounds: !0
        });
    }
    onPointerUp(t, e, n) {
        if (n.length) return this.dragOffset.x = 0, this.dragOffset.y = 0, void (this.trackingPoints = []);
        this.container.classList.remove(this.cn("isDragging")), this.isDragging && (this.addTrackingPoint(e), this.panOnlyZoomed && this.contentRect.width - this.contentRect.fitWidth < 1 && this.contentRect.height - this.contentRect.fitHeight < 1 && (this.trackingPoints = []), $e35dfd66294e81cf$var$i(t.target, this.content) && "y" === this.lockedAxis && (this.trackingPoints = []), this.emit("touchEnd", t), this.isDragging = !1, this.lockedAxis = !1, this.state !== $e35dfd66294e81cf$var$m.Destroy && (t.defaultPrevented || this.startDecelAnim()));
    }
    startDecelAnim() {
        var e;
        const i = this.isScaling;
        this.rAF && (cancelAnimationFrame(this.rAF), this.rAF = null), this.isBouncingX = !1, this.isBouncingY = !1;
        for (const t of $e35dfd66294e81cf$var$v)this.velocity[t] = 0;
        this.target.e = this.current.e, this.target.f = this.current.f, $e35dfd66294e81cf$var$S(this.container, "is-scaling"), $e35dfd66294e81cf$var$S(this.container, "is-animating"), this.isTicking = !1;
        const { trackingPoints: n } = this, s = n[0], o = n[n.length - 1];
        let a = 0, r = 0, l = 0;
        o && s && (a = o.clientX - s.clientX, r = o.clientY - s.clientY, l = o.time - s.time);
        const c = (null === (e = window.visualViewport) || void 0 === e ? void 0 : e.scale) || 1;
        1 !== c && (a *= c, r *= c);
        let h = 0, d = 0, u = 0, p = 0, f = this.option("decelFriction");
        const g = this.targetScale;
        if (l > 0) {
            u = Math.abs(a) > 3 ? a / (l / 30) : 0, p = Math.abs(r) > 3 ? r / (l / 30) : 0;
            const t = this.option("maxVelocity");
            t && (u = Math.max(Math.min(u, t), -1 * t), p = Math.max(Math.min(p, t), -1 * t));
        }
        u && (h = u / (1 / (1 - f) - 1)), p && (d = p / (1 / (1 - f) - 1)), ("y" === this.option("lockAxis") || "xy" === this.option("lockAxis") && "y" === this.lockedAxis && $e35dfd66294e81cf$var$t(g) === this.minScale) && (h = u = 0), ("x" === this.option("lockAxis") || "xy" === this.option("lockAxis") && "x" === this.lockedAxis && $e35dfd66294e81cf$var$t(g) === this.minScale) && (d = p = 0);
        const m = this.dragOffset.x, b = this.dragOffset.y, y = this.option("dragMinThreshold") || 0;
        Math.abs(m) < y && Math.abs(b) < y && (h = d = 0, u = p = 0), (this.option("zoom") && (g < this.minScale - 1e-5 || g > this.maxScale + 1e-5) || i && !h && !d) && (f = .35), this.applyChange({
            panX: h,
            panY: d,
            friction: f
        }), this.emit("decel", u, p, m, b);
    }
    onWheel(t) {
        var e = [
            -t.deltaX || 0,
            -t.deltaY || 0,
            -t.detail || 0
        ].reduce(function(t, e) {
            return Math.abs(e) > Math.abs(t) ? e : t;
        });
        const i = Math.max(-1, Math.min(1, e));
        if (this.emit("wheel", t, i), this.panMode === $e35dfd66294e81cf$var$O) return;
        if (t.defaultPrevented) return;
        const n = this.option("wheel");
        "pan" === n ? (t.preventDefault(), this.panOnlyZoomed && !this.canZoomOut() || this.applyChange({
            panX: 2 * -t.deltaX,
            panY: 2 * -t.deltaY,
            bounce: !1
        })) : "zoom" === n && !1 !== this.option("zoom") && this.zoomWithWheel(t);
    }
    onMouseMove(t) {
        this.panWithMouse(t);
    }
    onKeydown(t) {
        "Escape" === t.key && this.toggleFS();
    }
    onResize() {
        this.updateMetrics(), this.checkBounds().inBounds || this.requestTick();
    }
    setTransform() {
        this.emit("beforeTransform");
        const { current: e, target: i, content: n, contentRect: s } = this, o = Object.assign({}, $e35dfd66294e81cf$var$C);
        for (const n of $e35dfd66294e81cf$var$v){
            const s = "e" == n || "f" === n ? $e35dfd66294e81cf$var$M : $e35dfd66294e81cf$var$T;
            o[n] = $e35dfd66294e81cf$var$t(e[n], s), Math.abs(i[n] - e[n]) < ("e" == n || "f" === n ? .51 : .001) && (e[n] = i[n]);
        }
        let { a: a, b: r, c: l, d: c, e: h, f: d } = o, u = `matrix(${a}, ${r}, ${l}, ${c}, ${h}, ${d})`, p = n.parentElement instanceof HTMLPictureElement ? n.parentElement : n;
        if (this.option("transformParent") && (p = p.parentElement || p), p.style.transform === u) return;
        p.style.transform = u;
        const { contentWidth: f, contentHeight: g } = this.calculateContentDim();
        s.width = f, s.height = g, this.emit("afterTransform");
    }
    updateMetrics(e = !1) {
        var i;
        if (!this || this.state === $e35dfd66294e81cf$var$m.Destroy) return;
        if (this.isContentLoading) return;
        const n = Math.max(1, (null === (i = window.visualViewport) || void 0 === i ? void 0 : i.scale) || 1), { container: s, content: o } = this, a = o instanceof HTMLImageElement, r = s.getBoundingClientRect(), l = getComputedStyle(this.container);
        let c = r.width * n, h = r.height * n;
        const d = parseFloat(l.paddingTop) + parseFloat(l.paddingBottom), u = c - (parseFloat(l.paddingLeft) + parseFloat(l.paddingRight)), p = h - d;
        this.containerRect = {
            width: c,
            height: h,
            innerWidth: u,
            innerHeight: p
        };
        const f = parseFloat(o.dataset.width || "") || ((t)=>{
            let e = 0;
            return e = t instanceof HTMLImageElement ? t.naturalWidth : t instanceof SVGElement ? t.width.baseVal.value : Math.max(t.offsetWidth, t.scrollWidth), e || 0;
        })(o), g = parseFloat(o.dataset.height || "") || ((t)=>{
            let e = 0;
            return e = t instanceof HTMLImageElement ? t.naturalHeight : t instanceof SVGElement ? t.height.baseVal.value : Math.max(t.offsetHeight, t.scrollHeight), e || 0;
        })(o);
        let v = this.option("width", f) || $e35dfd66294e81cf$var$z, b = this.option("height", g) || $e35dfd66294e81cf$var$z;
        const y = v === $e35dfd66294e81cf$var$z, w = b === $e35dfd66294e81cf$var$z;
        "number" != typeof v && (v = f), "number" != typeof b && (b = g), y && (v = f * (b / g)), w && (b = g / (f / v));
        let x = o.parentElement instanceof HTMLPictureElement ? o.parentElement : o;
        this.option("transformParent") && (x = x.parentElement || x);
        const E = x.getAttribute("style") || "";
        x.style.setProperty("transform", "none", "important"), a && (x.style.width = "", x.style.height = ""), x.offsetHeight;
        const S = o.getBoundingClientRect();
        let P = S.width * n, C = S.height * n, T = P, M = C;
        P = Math.min(P, v), C = Math.min(C, b), a ? { width: P, height: C } = ((t, e, i, n)=>{
            const s = i / t, o = n / e, a = Math.min(s, o);
            return {
                width: t *= a,
                height: e *= a
            };
        })(v, b, P, C) : (P = Math.min(P, v), C = Math.min(C, b));
        let O = .5 * (M - C), A = .5 * (T - P);
        this.contentRect = Object.assign(Object.assign({}, this.contentRect), {
            top: S.top - r.top + O,
            bottom: r.bottom - S.bottom + O,
            left: S.left - r.left + A,
            right: r.right - S.right + A,
            fitWidth: P,
            fitHeight: C,
            width: P,
            height: C,
            fullWidth: v,
            fullHeight: b
        }), x.style.cssText = E, a && (x.style.width = `${P}px`, x.style.height = `${C}px`), this.setTransform(), !0 !== e && this.emit("refresh"), this.ignoreBounds || ($e35dfd66294e81cf$var$t(this.targetScale) < $e35dfd66294e81cf$var$t(this.minScale) ? this.zoomTo(this.minScale, {
            friction: 0
        }) : this.targetScale > this.maxScale ? this.zoomTo(this.maxScale, {
            friction: 0
        }) : this.state === $e35dfd66294e81cf$var$m.Init || this.checkBounds().inBounds || this.requestTick()), this.updateControls();
    }
    calculateBounds() {
        const { contentWidth: e, contentHeight: i } = this.calculateContentDim(this.target), { targetScale: n, lockedAxis: s } = this, { fitWidth: o, fitHeight: a } = this.contentRect;
        let r = 0, l = 0, c = 0, h = 0;
        const d = this.option("infinite");
        if (!0 === d || s && d === s) r = -1 / 0, c = 1 / 0, l = -1 / 0, h = 1 / 0;
        else {
            let { containerRect: s, contentRect: d } = this, u = $e35dfd66294e81cf$var$t(o * n, $e35dfd66294e81cf$var$M), p = $e35dfd66294e81cf$var$t(a * n, $e35dfd66294e81cf$var$M), { innerWidth: f, innerHeight: g } = s;
            if (s.width === u && (f = s.width), s.width === p && (g = s.height), e > f) {
                c = .5 * (e - f), r = -1 * c;
                let t = .5 * (d.right - d.left);
                r += t, c += t;
            }
            if (o > f && e < f && (r -= .5 * (o - f), c -= .5 * (o - f)), i > g) {
                h = .5 * (i - g), l = -1 * h;
                let t = .5 * (d.bottom - d.top);
                l += t, h += t;
            }
            a > g && i < g && (r -= .5 * (a - g), c -= .5 * (a - g));
        }
        return {
            x: {
                min: r,
                max: c
            },
            y: {
                min: l,
                max: h
            }
        };
    }
    getBounds() {
        const t = this.option("bounds");
        return t !== $e35dfd66294e81cf$var$z ? t : this.calculateBounds();
    }
    updateControls() {
        const e = this, i = e.container, { panMode: n, contentRect: s, targetScale: a, minScale: r } = e;
        let l = r, c = e.option("click") || !1;
        c && (l = e.getNextScale(c));
        let h = e.canZoomIn(), d = e.canZoomOut(), u = n === $e35dfd66294e81cf$var$A && !!this.option("touch"), p = d && u;
        if (u && ($e35dfd66294e81cf$var$t(a) < $e35dfd66294e81cf$var$t(r) && !this.panOnlyZoomed && (p = !0), ($e35dfd66294e81cf$var$t(s.width, 1) > $e35dfd66294e81cf$var$t(s.fitWidth, 1) || $e35dfd66294e81cf$var$t(s.height, 1) > $e35dfd66294e81cf$var$t(s.fitHeight, 1)) && (p = !0)), $e35dfd66294e81cf$var$t(s.width * a, 1) < $e35dfd66294e81cf$var$t(s.fitWidth, 1) && (p = !1), n === $e35dfd66294e81cf$var$O && (p = !1), $e35dfd66294e81cf$var$o(i, this.cn("isDraggable"), p), !this.option("zoom")) return;
        let f = h && $e35dfd66294e81cf$var$t(l) > $e35dfd66294e81cf$var$t(a), g = !f && !p && d && $e35dfd66294e81cf$var$t(l) < $e35dfd66294e81cf$var$t(a);
        $e35dfd66294e81cf$var$o(i, this.cn("canZoomIn"), f), $e35dfd66294e81cf$var$o(i, this.cn("canZoomOut"), g);
        for (const t of i.querySelectorAll("[data-panzoom-action]")){
            let e = !1, i = !1;
            switch(t.dataset.panzoomAction){
                case "zoomIn":
                    h ? e = !0 : i = !0;
                    break;
                case "zoomOut":
                    d ? e = !0 : i = !0;
                    break;
                case "toggleZoom":
                case "iterateZoom":
                    h || d ? e = !0 : i = !0;
                    const n = t.querySelector("g");
                    n && (n.style.display = h ? "" : "none");
            }
            e ? (t.removeAttribute("disabled"), t.removeAttribute("tabindex")) : i && (t.setAttribute("disabled", ""), t.setAttribute("tabindex", "-1"));
        }
    }
    panTo({ x: t = this.target.e, y: e = this.target.f, scale: i = this.targetScale, friction: n = this.option("friction"), angle: s = 0, originX: o = 0, originY: a = 0, flipX: r = !1, flipY: l = !1, ignoreBounds: c = !1 }) {
        this.state !== $e35dfd66294e81cf$var$m.Destroy && this.applyChange({
            panX: t - this.target.e,
            panY: e - this.target.f,
            scale: i / this.targetScale,
            angle: s,
            originX: o,
            originY: a,
            friction: n,
            flipX: r,
            flipY: l,
            ignoreBounds: c
        });
    }
    applyChange({ panX: e = 0, panY: i = 0, scale: n = 1, angle: s = 0, originX: o = -this.current.e, originY: a = -this.current.f, friction: r = this.option("friction"), flipX: l = !1, flipY: c = !1, ignoreBounds: h = !1, bounce: d = this.option("bounce") }) {
        const u = this.state;
        if (u === $e35dfd66294e81cf$var$m.Destroy) return;
        this.rAF && (cancelAnimationFrame(this.rAF), this.rAF = null), this.friction = r || 0, this.ignoreBounds = h;
        const { current: p } = this, f = p.e, g = p.f, b = this.getMatrix(this.target);
        let y = (new DOMMatrix).translate(f, g).translate(o, a).translate(e, i);
        if (this.option("zoom")) {
            if (!h) {
                const t = this.targetScale, e = this.minScale, i = this.maxScale;
                t * n < e && (n = e / t), t * n > i && (n = i / t);
            }
            y = y.scale(n);
        }
        y = y.translate(-o, -a).translate(-f, -g).multiply(b), s && (y = y.rotate(s)), l && (y = y.scale(-1, 1)), c && (y = y.scale(1, -1));
        for (const e of $e35dfd66294e81cf$var$v)"e" !== e && "f" !== e && (y[e] > this.minScale + 1e-5 || y[e] < this.minScale - 1e-5) ? this.target[e] = y[e] : this.target[e] = $e35dfd66294e81cf$var$t(y[e], $e35dfd66294e81cf$var$M);
        (this.targetScale < this.scale || Math.abs(n - 1) > .1 || this.panMode === $e35dfd66294e81cf$var$O || !1 === d) && !h && this.clampTargetBounds(), u === $e35dfd66294e81cf$var$m.Init ? this.animate() : this.isResting || (this.state = $e35dfd66294e81cf$var$m.Panning, this.requestTick());
    }
    stop(t = !1) {
        if (this.state === $e35dfd66294e81cf$var$m.Init || this.state === $e35dfd66294e81cf$var$m.Destroy) return;
        const e = this.isTicking;
        this.rAF && (cancelAnimationFrame(this.rAF), this.rAF = null), this.isBouncingX = !1, this.isBouncingY = !1;
        for (const e of $e35dfd66294e81cf$var$v)this.velocity[e] = 0, "current" === t ? this.current[e] = this.target[e] : "target" === t && (this.target[e] = this.current[e]);
        this.setTransform(), $e35dfd66294e81cf$var$S(this.container, "is-scaling"), $e35dfd66294e81cf$var$S(this.container, "is-animating"), this.isTicking = !1, this.state = $e35dfd66294e81cf$var$m.Ready, e && (this.emit("endAnimation"), this.updateControls());
    }
    requestTick() {
        this.isTicking || (this.emit("startAnimation"), this.updateControls(), $e35dfd66294e81cf$var$P(this.container, "is-animating"), this.isScaling && $e35dfd66294e81cf$var$P(this.container, "is-scaling")), this.isTicking = !0, this.rAF || (this.rAF = requestAnimationFrame(()=>this.animate()));
    }
    panWithMouse(e, i = this.option("mouseMoveFriction")) {
        if (this.pmme = e, this.panMode !== $e35dfd66294e81cf$var$O || !e) return;
        if ($e35dfd66294e81cf$var$t(this.targetScale) <= $e35dfd66294e81cf$var$t(this.minScale)) return;
        this.emit("mouseMove", e);
        const { container: n, containerRect: s, contentRect: o } = this, a = s.width, r = s.height, l = n.getBoundingClientRect(), c = (e.clientX || 0) - l.left, h = (e.clientY || 0) - l.top;
        let { contentWidth: d, contentHeight: u } = this.calculateContentDim(this.target);
        const p = this.option("mouseMoveFactor");
        p > 1 && (d !== a && (d *= p), u !== r && (u *= p));
        let f = .5 * (d - a) - c / a * 100 / 100 * (d - a);
        f += .5 * (o.right - o.left);
        let g = .5 * (u - r) - h / r * 100 / 100 * (u - r);
        g += .5 * (o.bottom - o.top), this.applyChange({
            panX: f - this.target.e,
            panY: g - this.target.f,
            friction: i
        });
    }
    zoomWithWheel(e) {
        if (this.state === $e35dfd66294e81cf$var$m.Destroy || this.state === $e35dfd66294e81cf$var$m.Init) return;
        const i = Date.now();
        if (i - this.pwt < 45) return void e.preventDefault();
        this.pwt = i;
        var n = [
            -e.deltaX || 0,
            -e.deltaY || 0,
            -e.detail || 0
        ].reduce(function(t, e) {
            return Math.abs(e) > Math.abs(t) ? e : t;
        });
        const s = Math.max(-1, Math.min(1, n)), { targetScale: o, maxScale: a, minScale: r } = this;
        let l = o * (100 + 45 * s) / 100;
        $e35dfd66294e81cf$var$t(l) < $e35dfd66294e81cf$var$t(r) && $e35dfd66294e81cf$var$t(o) <= $e35dfd66294e81cf$var$t(r) ? (this.cwd += Math.abs(s), l = r) : $e35dfd66294e81cf$var$t(l) > $e35dfd66294e81cf$var$t(a) && $e35dfd66294e81cf$var$t(o) >= $e35dfd66294e81cf$var$t(a) ? (this.cwd += Math.abs(s), l = a) : (this.cwd = 0, l = Math.max(Math.min(l, a), r)), this.cwd > this.option("wheelLimit") || (e.preventDefault(), $e35dfd66294e81cf$var$t(l) !== $e35dfd66294e81cf$var$t(o) && this.zoomTo(l, {
            event: e
        }));
    }
    canZoomIn() {
        return this.option("zoom") && ($e35dfd66294e81cf$var$t(this.contentRect.width, 1) < $e35dfd66294e81cf$var$t(this.contentRect.fitWidth, 1) || $e35dfd66294e81cf$var$t(this.targetScale) < $e35dfd66294e81cf$var$t(this.maxScale));
    }
    canZoomOut() {
        return this.option("zoom") && $e35dfd66294e81cf$var$t(this.targetScale) > $e35dfd66294e81cf$var$t(this.minScale);
    }
    zoomIn(t = 1.25, e) {
        this.zoomTo(this.targetScale * t, e);
    }
    zoomOut(t = .8, e) {
        this.zoomTo(this.targetScale * t, e);
    }
    zoomToFit(t) {
        this.zoomTo("fit", t);
    }
    zoomToCover(t) {
        this.zoomTo("cover", t);
    }
    zoomToFull(t) {
        this.zoomTo("full", t);
    }
    zoomToMax(t) {
        this.zoomTo("max", t);
    }
    toggleZoom(t) {
        this.zoomTo(this.getNextScale("toggleZoom"), t);
    }
    toggleMax(t) {
        this.zoomTo(this.getNextScale("toggleMax"), t);
    }
    toggleCover(t) {
        this.zoomTo(this.getNextScale("toggleCover"), t);
    }
    iterateZoom(t) {
        this.zoomTo("next", t);
    }
    zoomTo(t = 1, { friction: e = $e35dfd66294e81cf$var$z, originX: i = $e35dfd66294e81cf$var$z, originY: n = $e35dfd66294e81cf$var$z, event: s } = {}) {
        if (this.isContentLoading || this.state === $e35dfd66294e81cf$var$m.Destroy) return;
        const { targetScale: o, fullScale: a, maxScale: r, coverScale: l } = this;
        if (this.stop(), this.panMode === $e35dfd66294e81cf$var$O && (s = this.pmme || s), s || i === $e35dfd66294e81cf$var$z || n === $e35dfd66294e81cf$var$z) {
            const t = this.content.getBoundingClientRect(), e = this.container.getBoundingClientRect(), o = s ? s.clientX : e.left + .5 * e.width, a = s ? s.clientY : e.top + .5 * e.height;
            i = o - t.left - .5 * t.width, n = a - t.top - .5 * t.height;
        }
        let c = 1;
        "number" == typeof t ? c = t : "full" === t ? c = a : "cover" === t ? c = l : "max" === t ? c = r : "fit" === t ? c = 1 : "next" === t && (c = this.getNextScale("iterateZoom")), c = c / o || 1, e = e === $e35dfd66294e81cf$var$z ? c > 1 ? .15 : .25 : e, this.applyChange({
            scale: c,
            originX: i,
            originY: n,
            friction: e
        }), s && this.panMode === $e35dfd66294e81cf$var$O && this.panWithMouse(s, e);
    }
    rotateCCW() {
        this.applyChange({
            angle: -90
        });
    }
    rotateCW() {
        this.applyChange({
            angle: 90
        });
    }
    flipX() {
        this.applyChange({
            flipX: !0
        });
    }
    flipY() {
        this.applyChange({
            flipY: !0
        });
    }
    fitX() {
        this.stop("target");
        const { containerRect: t, contentRect: e, target: i } = this;
        this.applyChange({
            panX: .5 * t.width - (e.left + .5 * e.fitWidth) - i.e,
            panY: .5 * t.height - (e.top + .5 * e.fitHeight) - i.f,
            scale: t.width / e.fitWidth / this.targetScale,
            originX: 0,
            originY: 0,
            ignoreBounds: !0
        });
    }
    fitY() {
        this.stop("target");
        const { containerRect: t, contentRect: e, target: i } = this;
        this.applyChange({
            panX: .5 * t.width - (e.left + .5 * e.fitWidth) - i.e,
            panY: .5 * t.innerHeight - (e.top + .5 * e.fitHeight) - i.f,
            scale: t.height / e.fitHeight / this.targetScale,
            originX: 0,
            originY: 0,
            ignoreBounds: !0
        });
    }
    toggleFS() {
        const { container: t } = this, e = this.cn("inFullscreen"), i = this.cn("htmlHasFullscreen");
        t.classList.toggle(e);
        const n = t.classList.contains(e);
        n ? (document.documentElement.classList.add(i), document.addEventListener("keydown", this.onKeydown, !0)) : (document.documentElement.classList.remove(i), document.removeEventListener("keydown", this.onKeydown, !0)), this.updateMetrics(), this.emit(n ? "enterFS" : "exitFS");
    }
    getMatrix(t = this.current) {
        const { a: e, b: i, c: n, d: s, e: o, f: a } = t;
        return new DOMMatrix([
            e,
            i,
            n,
            s,
            o,
            a
        ]);
    }
    reset(t) {
        if (this.state !== $e35dfd66294e81cf$var$m.Init && this.state !== $e35dfd66294e81cf$var$m.Destroy) {
            this.stop("current");
            for (const t of $e35dfd66294e81cf$var$v)this.target[t] = $e35dfd66294e81cf$var$C[t];
            this.target.a = this.minScale, this.target.d = this.minScale, this.clampTargetBounds(), this.isResting || (this.friction = void 0 === t ? this.option("friction") : t, this.state = $e35dfd66294e81cf$var$m.Panning, this.requestTick());
        }
    }
    destroy() {
        this.stop(), this.state = $e35dfd66294e81cf$var$m.Destroy, this.detachEvents(), this.detachObserver();
        const { container: t, content: e } = this, i = this.option("classes") || {};
        for (const e of Object.values(i))t.classList.remove(e + "");
        e && (e.removeEventListener("load", this.onLoad), e.removeEventListener("error", this.onError)), this.detachPlugins();
    }
}
Object.defineProperty($e35dfd66294e81cf$export$b704d075ddd20210, "defaults", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: $e35dfd66294e81cf$var$y
}), Object.defineProperty($e35dfd66294e81cf$export$b704d075ddd20210, "Plugins", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: {}
});
const $e35dfd66294e81cf$var$D = function(t, e) {
    let i = !0;
    return (...n)=>{
        i && (i = !1, t(...n), setTimeout(()=>{
            i = !0;
        }, e));
    };
}, $e35dfd66294e81cf$var$F = (t, e)=>{
    let i = [];
    return t.childNodes.forEach((t)=>{
        t.nodeType !== Node.ELEMENT_NODE || e && !t.matches(e) || i.push(t);
    }), i;
}, $e35dfd66294e81cf$var$j = {
    viewport: null,
    track: null,
    enabled: !0,
    slides: [],
    axis: "x",
    transition: "fade",
    preload: 1,
    slidesPerPage: "auto",
    initialPage: 0,
    friction: .12,
    Panzoom: {
        decelFriction: .12
    },
    center: !0,
    infinite: !0,
    fill: !0,
    dragFree: !1,
    adaptiveHeight: !1,
    direction: "ltr",
    classes: {
        container: "f-carousel",
        viewport: "f-carousel__viewport",
        track: "f-carousel__track",
        slide: "f-carousel__slide",
        isLTR: "is-ltr",
        isRTL: "is-rtl",
        isHorizontal: "is-horizontal",
        isVertical: "is-vertical",
        inTransition: "in-transition",
        isSelected: "is-selected"
    },
    l10n: {
        NEXT: "Next slide",
        PREV: "Previous slide",
        GOTO: "Go to slide #%d"
    }
};
var $e35dfd66294e81cf$var$B;
!function(t) {
    t[t.Init = 0] = "Init", t[t.Ready = 1] = "Ready", t[t.Destroy = 2] = "Destroy";
}($e35dfd66294e81cf$var$B || ($e35dfd66294e81cf$var$B = {}));
const $e35dfd66294e81cf$var$H = (t)=>{
    if ("string" == typeof t || t instanceof HTMLElement) t = {
        html: t
    };
    else {
        const e = t.thumb;
        void 0 !== e && ("string" == typeof e && (t.thumbSrc = e), e instanceof HTMLImageElement && (t.thumbEl = e, t.thumbElSrc = e.src, t.thumbSrc = e.src), delete t.thumb);
    }
    return Object.assign({
        html: "",
        el: null,
        isDom: !1,
        class: "",
        customClass: "",
        index: -1,
        dim: 0,
        gap: 0,
        pos: 0,
        transition: !1
    }, t);
}, $e35dfd66294e81cf$var$N = (t = {})=>Object.assign({
        index: -1,
        slides: [],
        dim: 0,
        pos: -1
    }, t);
class $e35dfd66294e81cf$var$_ extends $e35dfd66294e81cf$var$f {
    constructor(t, e){
        super(e), Object.defineProperty(this, "instance", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: t
        });
    }
    attach() {}
    detach() {}
}
const $e35dfd66294e81cf$var$$ = {
    classes: {
        list: "f-carousel__dots",
        isDynamic: "is-dynamic",
        hasDots: "has-dots",
        dot: "f-carousel__dot",
        isBeforePrev: "is-before-prev",
        isPrev: "is-prev",
        isCurrent: "is-current",
        isNext: "is-next",
        isAfterNext: "is-after-next"
    },
    dotTpl: '<button type="button" data-carousel-page="%i" aria-label="{{GOTO}}"><span class="f-carousel__dot" aria-hidden="true"></span></button>',
    dynamicFrom: 11,
    maxCount: 1 / 0,
    minCount: 2
};
class $e35dfd66294e81cf$var$W extends $e35dfd66294e81cf$var$_ {
    constructor(){
        super(...arguments), Object.defineProperty(this, "isDynamic", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: !1
        }), Object.defineProperty(this, "list", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        });
    }
    onRefresh() {
        this.refresh();
    }
    build() {
        let t = this.list;
        if (!t) {
            t = document.createElement("ul"), $e35dfd66294e81cf$var$P(t, this.cn("list")), t.setAttribute("role", "tablist");
            const e = this.instance.container;
            e.appendChild(t), $e35dfd66294e81cf$var$P(e, this.cn("hasDots")), this.list = t;
        }
        return t;
    }
    refresh() {
        var t;
        const e = this.instance.pages.length, i = Math.min(2, this.option("minCount")), n = Math.max(2e3, this.option("maxCount")), s = this.option("dynamicFrom");
        if (e < i || e > n) return void this.cleanup();
        const a = "number" == typeof s && e > 5 && e >= s, r = !this.list || this.isDynamic !== a || this.list.children.length !== e;
        r && this.cleanup();
        const l = this.build();
        if ($e35dfd66294e81cf$var$o(l, this.cn("isDynamic"), !!a), r) for(let t = 0; t < e; t++)l.append(this.createItem(t));
        let c, h = 0;
        for (const e of [
            ...l.children
        ]){
            const i = h === this.instance.page;
            i && (c = e), $e35dfd66294e81cf$var$o(e, this.cn("isCurrent"), i), null === (t = e.children[0]) || void 0 === t || t.setAttribute("aria-selected", i ? "true" : "false");
            for (const t of [
                "isBeforePrev",
                "isPrev",
                "isNext",
                "isAfterNext"
            ])$e35dfd66294e81cf$var$S(e, this.cn(t));
            h++;
        }
        if (c = c || l.firstChild, a && c) {
            const t = c.previousElementSibling, e = t && t.previousElementSibling;
            $e35dfd66294e81cf$var$P(t, this.cn("isPrev")), $e35dfd66294e81cf$var$P(e, this.cn("isBeforePrev"));
            const i = c.nextElementSibling, n = i && i.nextElementSibling;
            $e35dfd66294e81cf$var$P(i, this.cn("isNext")), $e35dfd66294e81cf$var$P(n, this.cn("isAfterNext"));
        }
        this.isDynamic = a;
    }
    createItem(t = 0) {
        var e;
        const i = document.createElement("li");
        i.setAttribute("role", "presentation");
        const s = $e35dfd66294e81cf$var$n(this.instance.localize(this.option("dotTpl"), [
            [
                "%d",
                t + 1
            ]
        ]).replace(/\%i/g, t + ""));
        return i.appendChild(s), null === (e = i.children[0]) || void 0 === e || e.setAttribute("role", "tab"), i;
    }
    cleanup() {
        this.list && (this.list.remove(), this.list = null), this.isDynamic = !1, $e35dfd66294e81cf$var$S(this.instance.container, this.cn("hasDots"));
    }
    attach() {
        this.instance.on([
            "refresh",
            "change"
        ], this.onRefresh);
    }
    detach() {
        this.instance.off([
            "refresh",
            "change"
        ], this.onRefresh), this.cleanup();
    }
}
Object.defineProperty($e35dfd66294e81cf$var$W, "defaults", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: $e35dfd66294e81cf$var$$
});
const $e35dfd66294e81cf$var$X = "disabled", $e35dfd66294e81cf$var$q = "next", $e35dfd66294e81cf$var$Y = "prev";
class $e35dfd66294e81cf$var$V extends $e35dfd66294e81cf$var$_ {
    constructor(){
        super(...arguments), Object.defineProperty(this, "container", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "prev", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "next", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "isDom", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: !1
        });
    }
    onRefresh() {
        const t = this.instance, e = t.pages.length, i = t.page;
        if (e < 2) return void this.cleanup();
        this.build();
        let n = this.prev, s = this.next;
        n && s && (n.removeAttribute($e35dfd66294e81cf$var$X), s.removeAttribute($e35dfd66294e81cf$var$X), t.isInfinite || (i <= 0 && n.setAttribute($e35dfd66294e81cf$var$X, ""), i >= e - 1 && s.setAttribute($e35dfd66294e81cf$var$X, "")));
    }
    addBtn(t) {
        var e;
        const i = this.instance, n = document.createElement("button");
        n.setAttribute("tabindex", "0"), n.setAttribute("title", i.localize(`{{${t.toUpperCase()}}}`)), $e35dfd66294e81cf$var$P(n, this.cn("button") + " " + this.cn(t === $e35dfd66294e81cf$var$q ? "isNext" : "isPrev"));
        const s = i.isRTL ? t === $e35dfd66294e81cf$var$q ? $e35dfd66294e81cf$var$Y : $e35dfd66294e81cf$var$q : t;
        var o;
        return n.innerHTML = i.localize(this.option(`${s}Tpl`)), n.dataset[`carousel${o = t, o ? o.match("^[a-z]") ? o.charAt(0).toUpperCase() + o.substring(1) : o : ""}`] = "true", null === (e = this.container) || void 0 === e || e.appendChild(n), n;
    }
    build() {
        const t = this.instance.container, e = this.cn("container");
        let { container: i, prev: n, next: s } = this;
        i || (i = t.querySelector("." + e), this.isDom = !!i), i || (i = document.createElement("div"), $e35dfd66294e81cf$var$P(i, e), t.appendChild(i)), this.container = i, s || (s = i.querySelector("[data-carousel-next]")), s || (s = this.addBtn($e35dfd66294e81cf$var$q)), this.next = s, n || (n = i.querySelector("[data-carousel-prev]")), n || (n = this.addBtn($e35dfd66294e81cf$var$Y)), this.prev = n;
    }
    cleanup() {
        this.isDom || (this.prev && this.prev.remove(), this.next && this.next.remove(), this.container && this.container.remove()), this.prev = null, this.next = null, this.container = null, this.isDom = !1;
    }
    attach() {
        this.instance.on([
            "refresh",
            "change"
        ], this.onRefresh);
    }
    detach() {
        this.instance.off([
            "refresh",
            "change"
        ], this.onRefresh), this.cleanup();
    }
}
Object.defineProperty($e35dfd66294e81cf$var$V, "defaults", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: {
        classes: {
            container: "f-carousel__nav",
            button: "f-button",
            isNext: "is-next",
            isPrev: "is-prev"
        },
        nextTpl: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" tabindex="-1"><path d="M9 3l9 9-9 9"/></svg>',
        prevTpl: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" tabindex="-1"><path d="M15 3l-9 9 9 9"/></svg>'
    }
});
class $e35dfd66294e81cf$var$Z extends $e35dfd66294e81cf$var$_ {
    constructor(){
        super(...arguments), Object.defineProperty(this, "selectedIndex", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "target", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "nav", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        });
    }
    addAsTargetFor(t) {
        this.target = this.instance, this.nav = t, this.attachEvents();
    }
    addAsNavFor(t) {
        this.nav = this.instance, this.target = t, this.attachEvents();
    }
    attachEvents() {
        const { nav: t, target: e } = this;
        t && e && (t.options.initialSlide = e.options.initialPage, t.state === $e35dfd66294e81cf$var$B.Ready ? this.onNavReady(t) : t.on("ready", this.onNavReady), e.state === $e35dfd66294e81cf$var$B.Ready ? this.onTargetReady(e) : e.on("ready", this.onTargetReady));
    }
    onNavReady(t) {
        t.on("createSlide", this.onNavCreateSlide), t.on("Panzoom.click", this.onNavClick), t.on("Panzoom.touchEnd", this.onNavTouch), this.onTargetChange();
    }
    onTargetReady(t) {
        t.on("change", this.onTargetChange), t.on("Panzoom.refresh", this.onTargetChange), this.onTargetChange();
    }
    onNavClick(t, e, i) {
        this.onNavTouch(t, t.panzoom, i);
    }
    onNavTouch(t, e, i) {
        var n, s;
        if (Math.abs(e.dragOffset.x) > 3 || Math.abs(e.dragOffset.y) > 3) return;
        const o = i.target, { nav: a, target: r } = this;
        if (!a || !r || !o) return;
        const l = o.closest("[data-index]");
        if (i.stopPropagation(), i.preventDefault(), !l) return;
        const c = parseInt(l.dataset.index || "", 10) || 0, h = r.getPageForSlide(c), d = a.getPageForSlide(c);
        a.slideTo(d), r.slideTo(h, {
            friction: (null === (s = null === (n = this.nav) || void 0 === n ? void 0 : n.plugins) || void 0 === s ? void 0 : s.Sync.option("friction")) || 0
        }), this.markSelectedSlide(c);
    }
    onNavCreateSlide(t, e) {
        e.index === this.selectedIndex && this.markSelectedSlide(e.index);
    }
    onTargetChange() {
        var t, e;
        const { target: i, nav: n } = this;
        if (!i || !n) return;
        if (n.state !== $e35dfd66294e81cf$var$B.Ready || i.state !== $e35dfd66294e81cf$var$B.Ready) return;
        const s = null === (e = null === (t = i.pages[i.page]) || void 0 === t ? void 0 : t.slides[0]) || void 0 === e ? void 0 : e.index, o = n.getPageForSlide(s);
        this.markSelectedSlide(s), n.slideTo(o, null === n.prevPage && null === i.prevPage ? {
            friction: 0
        } : void 0);
    }
    markSelectedSlide(t) {
        const e = this.nav;
        e && e.state === $e35dfd66294e81cf$var$B.Ready && (this.selectedIndex = t, [
            ...e.slides
        ].map((e)=>{
            e.el && e.el.classList[e.index === t ? "add" : "remove"]("is-nav-selected");
        }));
    }
    attach() {
        const t = this;
        let e = t.options.target, i = t.options.nav;
        e ? t.addAsNavFor(e) : i && t.addAsTargetFor(i);
    }
    detach() {
        const t = this, e = t.nav, i = t.target;
        e && (e.off("ready", t.onNavReady), e.off("createSlide", t.onNavCreateSlide), e.off("Panzoom.click", t.onNavClick), e.off("Panzoom.touchEnd", t.onNavTouch)), t.nav = null, i && (i.off("ready", t.onTargetReady), i.off("refresh", t.onTargetChange), i.off("change", t.onTargetChange)), t.target = null;
    }
}
Object.defineProperty($e35dfd66294e81cf$var$Z, "defaults", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: {
        friction: .35
    }
});
const $e35dfd66294e81cf$var$U = {
    Navigation: $e35dfd66294e81cf$var$V,
    Dots: $e35dfd66294e81cf$var$W,
    Sync: $e35dfd66294e81cf$var$Z
}, $e35dfd66294e81cf$var$G = "animationend", $e35dfd66294e81cf$var$K = "isSelected", $e35dfd66294e81cf$var$J = "slide";
class $e35dfd66294e81cf$export$144901db2ea8e967 extends $e35dfd66294e81cf$var$g {
    get axis() {
        return this.isHorizontal ? "e" : "f";
    }
    get isEnabled() {
        return this.state === $e35dfd66294e81cf$var$B.Ready;
    }
    get isInfinite() {
        let t = !1;
        const { contentDim: e, viewportDim: i, pages: n, slides: s } = this, o = s[0];
        return n.length >= 2 && o && e + o.dim >= i && (t = this.option("infinite")), t;
    }
    get isRTL() {
        return "rtl" === this.option("direction");
    }
    get isHorizontal() {
        return "x" === this.option("axis");
    }
    constructor(t, e = {}, i = {}){
        if (super(), Object.defineProperty(this, "bp", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: ""
        }), Object.defineProperty(this, "lp", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: 0
        }), Object.defineProperty(this, "userOptions", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: {}
        }), Object.defineProperty(this, "userPlugins", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: {}
        }), Object.defineProperty(this, "state", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: $e35dfd66294e81cf$var$B.Init
        }), Object.defineProperty(this, "page", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: 0
        }), Object.defineProperty(this, "prevPage", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "container", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), Object.defineProperty(this, "viewport", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "track", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "slides", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: []
        }), Object.defineProperty(this, "pages", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: []
        }), Object.defineProperty(this, "panzoom", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "inTransition", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: new Set
        }), Object.defineProperty(this, "contentDim", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: 0
        }), Object.defineProperty(this, "viewportDim", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: 0
        }), "string" == typeof t && (t = document.querySelector(t)), !t || !$e35dfd66294e81cf$var$E(t)) throw new Error("No Element found");
        this.container = t, this.slideNext = $e35dfd66294e81cf$var$D(this.slideNext.bind(this), 150), this.slidePrev = $e35dfd66294e81cf$var$D(this.slidePrev.bind(this), 150), this.userOptions = e, this.userPlugins = i, queueMicrotask(()=>{
            this.processOptions();
        });
    }
    processOptions() {
        var t, e;
        const i = $e35dfd66294e81cf$var$u({}, $e35dfd66294e81cf$export$144901db2ea8e967.defaults, this.userOptions);
        let n = "";
        const s = i.breakpoints;
        if (s && $e35dfd66294e81cf$var$d(s)) for (const [t, e] of Object.entries(s))window.matchMedia(t).matches && $e35dfd66294e81cf$var$d(e) && (n += t, $e35dfd66294e81cf$var$u(i, e));
        n === this.bp && this.state !== $e35dfd66294e81cf$var$B.Init || (this.bp = n, this.state === $e35dfd66294e81cf$var$B.Ready && (i.initialSlide = (null === (e = null === (t = this.pages[this.page]) || void 0 === t ? void 0 : t.slides[0]) || void 0 === e ? void 0 : e.index) || 0), this.state !== $e35dfd66294e81cf$var$B.Init && this.destroy(), super.setOptions(i), !1 === this.option("enabled") ? this.attachEvents() : setTimeout(()=>{
            this.init();
        }, 0));
    }
    init() {
        this.state = $e35dfd66294e81cf$var$B.Init, this.emit("init"), this.attachPlugins(Object.assign(Object.assign({}, $e35dfd66294e81cf$export$144901db2ea8e967.Plugins), this.userPlugins)), this.emit("attachPlugins"), this.initLayout(), this.initSlides(), this.updateMetrics(), this.setInitialPosition(), this.initPanzoom(), this.attachEvents(), this.state = $e35dfd66294e81cf$var$B.Ready, this.emit("ready");
    }
    initLayout() {
        const { container: t } = this, e = this.option("classes");
        $e35dfd66294e81cf$var$P(t, this.cn("container")), $e35dfd66294e81cf$var$o(t, e.isLTR, !this.isRTL), $e35dfd66294e81cf$var$o(t, e.isRTL, this.isRTL), $e35dfd66294e81cf$var$o(t, e.isVertical, !this.isHorizontal), $e35dfd66294e81cf$var$o(t, e.isHorizontal, this.isHorizontal);
        let i = this.option("viewport") || t.querySelector(`.${e.viewport}`);
        i || (i = document.createElement("div"), $e35dfd66294e81cf$var$P(i, e.viewport), i.append(...$e35dfd66294e81cf$var$F(t, `.${e.slide}`)), t.prepend(i)), i.addEventListener("scroll", this.onScroll);
        let n = this.option("track") || t.querySelector(`.${e.track}`);
        n || (n = document.createElement("div"), $e35dfd66294e81cf$var$P(n, e.track), n.append(...Array.from(i.childNodes))), n.setAttribute("aria-live", "polite"), i.contains(n) || i.prepend(n), this.viewport = i, this.track = n, this.emit("initLayout");
    }
    initSlides() {
        const { track: t } = this;
        if (!t) return;
        const e = [
            ...this.slides
        ], i = [];
        [
            ...$e35dfd66294e81cf$var$F(t, `.${this.cn($e35dfd66294e81cf$var$J)}`)
        ].forEach((t)=>{
            if ($e35dfd66294e81cf$var$E(t)) {
                const e = $e35dfd66294e81cf$var$H({
                    el: t,
                    isDom: !0,
                    index: this.slides.length
                });
                i.push(e);
            }
        });
        for (let t of [
            ...this.option("slides", []) || [],
            ...e
        ])i.push($e35dfd66294e81cf$var$H(t));
        this.slides = i;
        for(let t = 0; t < this.slides.length; t++)this.slides[t].index = t;
        for (const t of i)this.emit("beforeInitSlide", t, t.index), this.emit("initSlide", t, t.index);
        this.emit("initSlides");
    }
    setInitialPage() {
        const t = this.option("initialSlide");
        this.page = "number" == typeof t ? this.getPageForSlide(t) : parseInt(this.option("initialPage", 0) + "", 10) || 0;
    }
    setInitialPosition() {
        const { track: t, pages: e, isHorizontal: i } = this;
        if (!t || !e.length) return;
        let n = this.page;
        e[n] || (this.page = n = 0);
        const s = (e[n].pos || 0) * (this.isRTL && i ? 1 : -1), o = i ? `${s}px` : "0", a = i ? "0" : `${s}px`;
        t.style.transform = `translate3d(${o}, ${a}, 0) scale(1)`, this.option("adaptiveHeight") && this.setViewportHeight();
    }
    initPanzoom() {
        this.panzoom && (this.panzoom.destroy(), this.panzoom = null);
        const t = this.option("Panzoom") || {};
        this.panzoom = new $e35dfd66294e81cf$export$b704d075ddd20210(this.viewport, $e35dfd66294e81cf$var$u({}, {
            content: this.track,
            zoom: !1,
            panOnlyZoomed: !1,
            lockAxis: this.isHorizontal ? "x" : "y",
            infinite: this.isInfinite,
            click: !1,
            dblClick: !1,
            touch: (t)=>!(this.pages.length < 2 && !t.options.infinite),
            bounds: ()=>this.getBounds(),
            maxVelocity: (t)=>Math.abs(t.target[this.axis] - t.current[this.axis]) < 2 * this.viewportDim ? 100 : 0
        }, t)), this.panzoom.on("*", (t, e, ...i)=>{
            this.emit(`Panzoom.${e}`, t, ...i);
        }), this.panzoom.on("decel", this.onDecel), this.panzoom.on("refresh", this.onRefresh), this.panzoom.on("beforeTransform", this.onBeforeTransform), this.panzoom.on("endAnimation", this.onEndAnimation);
    }
    attachEvents() {
        const t = this.container;
        t && (t.addEventListener("click", this.onClick, {
            passive: !1,
            capture: !1
        }), t.addEventListener("slideTo", this.onSlideTo)), window.addEventListener("resize", this.onResize);
    }
    createPages() {
        let t = [];
        const { contentDim: e, viewportDim: i } = this;
        let n = this.option("slidesPerPage");
        n = ("auto" === n || e <= i) && !1 !== this.option("fill") ? 1 / 0 : parseFloat(n + "");
        let s = 0, o = 0, a = 0;
        for (const e of this.slides)(!t.length || o + e.dim - i > .05 || a >= n) && (t.push($e35dfd66294e81cf$var$N()), s = t.length - 1, o = 0, a = 0), t[s].slides.push(e), o += e.dim + e.gap, a++;
        return t;
    }
    processPages() {
        const e = this.pages, { contentDim: i, viewportDim: n, isInfinite: s } = this, o = this.option("center"), a = this.option("fill"), r = a && o && i > n && !s;
        if (e.forEach((t, e)=>{
            var s;
            t.index = e, t.pos = (null === (s = t.slides[0]) || void 0 === s ? void 0 : s.pos) || 0, t.dim = 0;
            for (const [e, i] of t.slides.entries())t.dim += i.dim, e < t.slides.length - 1 && (t.dim += i.gap);
            r && t.pos + .5 * t.dim < .5 * n ? t.pos = 0 : r && t.pos + .5 * t.dim >= i - .5 * n ? t.pos = i - n : o && (t.pos += -0.5 * (n - t.dim));
        }), e.forEach((e)=>{
            a && !s && i > n && (e.pos = Math.max(e.pos, 0), e.pos = Math.min(e.pos, i - n)), e.pos = $e35dfd66294e81cf$var$t(e.pos, 1e3), e.dim = $e35dfd66294e81cf$var$t(e.dim, 1e3), Math.abs(e.pos) <= .1 && (e.pos = 0);
        }), s) return e;
        const l = [];
        let c;
        return e.forEach((t)=>{
            const e = Object.assign({}, t);
            c && e.pos === c.pos ? (c.dim += e.dim, c.slides = [
                ...c.slides,
                ...e.slides
            ]) : (e.index = l.length, c = e, l.push(e));
        }), l;
    }
    getPageFromIndex(t = 0) {
        const e = this.pages.length;
        let i;
        return t = parseInt((t || 0).toString()) || 0, i = this.isInfinite ? (t % e + e) % e : Math.max(Math.min(t, e - 1), 0), i;
    }
    getSlideMetrics(e) {
        var i, n;
        const s = this.isHorizontal ? "width" : "height";
        let o = 0, a = 0, r = e.el;
        const l = !(!r || r.parentNode);
        if (r ? o = parseFloat(r.dataset[s] || "") || 0 : (r = document.createElement("div"), r.style.visibility = "hidden", (this.track || document.body).prepend(r)), $e35dfd66294e81cf$var$P(r, this.cn($e35dfd66294e81cf$var$J) + " " + e.class + " " + e.customClass), o) r.style[s] = `${o}px`, r.style["width" === s ? "height" : "width"] = "";
        else {
            l && (this.track || document.body).prepend(r), o = r.getBoundingClientRect()[s] * Math.max(1, (null === (i = window.visualViewport) || void 0 === i ? void 0 : i.scale) || 1);
            let t = r[this.isHorizontal ? "offsetWidth" : "offsetHeight"];
            t - 1 > o && (o = t);
        }
        const c = getComputedStyle(r);
        return "content-box" === c.boxSizing && (this.isHorizontal ? (o += parseFloat(c.paddingLeft) || 0, o += parseFloat(c.paddingRight) || 0) : (o += parseFloat(c.paddingTop) || 0, o += parseFloat(c.paddingBottom) || 0)), a = parseFloat(c[this.isHorizontal ? "marginRight" : "marginBottom"]) || 0, l ? null === (n = r.parentElement) || void 0 === n || n.removeChild(r) : e.el || r.remove(), {
            dim: $e35dfd66294e81cf$var$t(o, 1e3),
            gap: $e35dfd66294e81cf$var$t(a, 1e3)
        };
    }
    getBounds() {
        const { isInfinite: t, isRTL: e, isHorizontal: i, pages: n } = this;
        let s = {
            min: 0,
            max: 0
        };
        if (t) s = {
            min: -1 / 0,
            max: 1 / 0
        };
        else if (n.length) {
            const t = n[0].pos, o = n[n.length - 1].pos;
            s = e && i ? {
                min: t,
                max: o
            } : {
                min: -1 * o,
                max: -1 * t
            };
        }
        return {
            x: i ? s : {
                min: 0,
                max: 0
            },
            y: i ? {
                min: 0,
                max: 0
            } : s
        };
    }
    repositionSlides() {
        let e, { isHorizontal: i, isRTL: n, isInfinite: s, viewport: o, viewportDim: a, contentDim: r, page: l, pages: c, slides: h, panzoom: d } = this, u = 0, p = 0, f = 0, g = 0;
        d ? g = -1 * d.current[this.axis] : c[l] && (g = c[l].pos || 0), e = i ? n ? "right" : "left" : "top", n && i && (g *= -1);
        for (const i of h){
            const n = i.el;
            n ? ("top" === e ? (n.style.right = "", n.style.left = "") : n.style.top = "", i.index !== u ? n.style[e] = 0 === p ? "" : `${$e35dfd66294e81cf$var$t(p, 1e3)}px` : n.style[e] = "", f += i.dim + i.gap, u++) : p += i.dim + i.gap;
        }
        if (s && f && o) {
            let n = getComputedStyle(o), s = "padding", l = i ? "Right" : "Bottom", c = parseFloat(n[s + (i ? "Left" : "Top")]);
            g -= c, a += c, a += parseFloat(n[s + l]);
            for (const i of h)i.el && ($e35dfd66294e81cf$var$t(i.pos) < $e35dfd66294e81cf$var$t(a) && $e35dfd66294e81cf$var$t(i.pos + i.dim + i.gap) < $e35dfd66294e81cf$var$t(g) && $e35dfd66294e81cf$var$t(g) > $e35dfd66294e81cf$var$t(r - a) && (i.el.style[e] = `${$e35dfd66294e81cf$var$t(p + f, 1e3)}px`), $e35dfd66294e81cf$var$t(i.pos + i.gap) >= $e35dfd66294e81cf$var$t(r - a) && $e35dfd66294e81cf$var$t(i.pos) > $e35dfd66294e81cf$var$t(g + a) && $e35dfd66294e81cf$var$t(g) < $e35dfd66294e81cf$var$t(a) && (i.el.style[e] = `-${$e35dfd66294e81cf$var$t(f, 1e3)}px`));
        }
        let m, v, b = [
            ...this.inTransition
        ];
        if (b.length > 1 && (m = c[b[0]], v = c[b[1]]), m && v) {
            let i = 0;
            for (const n of h)n.el ? this.inTransition.has(n.index) && m.slides.indexOf(n) < 0 && (n.el.style[e] = `${$e35dfd66294e81cf$var$t(i + (m.pos - v.pos), 1e3)}px`) : i += n.dim + n.gap;
        }
    }
    createSlideEl(t) {
        const { track: e, slides: i } = this;
        if (!e || !t) return;
        if (t.el && t.el.parentNode) return;
        const n = t.el || document.createElement("div");
        $e35dfd66294e81cf$var$P(n, this.cn($e35dfd66294e81cf$var$J)), $e35dfd66294e81cf$var$P(n, t.class), $e35dfd66294e81cf$var$P(n, t.customClass);
        const s = t.html;
        s && (s instanceof HTMLElement ? n.appendChild(s) : n.innerHTML = t.html + "");
        const o = [];
        i.forEach((t, e)=>{
            t.el && o.push(e);
        });
        const a = t.index;
        let r = null;
        if (o.length) r = i[o.reduce((t, e)=>Math.abs(e - a) < Math.abs(t - a) ? e : t)];
        const l = r && r.el && r.el.parentNode ? r.index < t.index ? r.el.nextSibling : r.el : null;
        e.insertBefore(n, e.contains(l) ? l : null), t.el = n, this.emit("createSlide", t);
    }
    removeSlideEl(t, e = !1) {
        const i = null == t ? void 0 : t.el;
        if (!i || !i.parentNode) return;
        const n = this.cn($e35dfd66294e81cf$var$K);
        if (i.classList.contains(n) && ($e35dfd66294e81cf$var$S(i, n), this.emit("unselectSlide", t)), t.isDom && !e) return i.removeAttribute("aria-hidden"), i.removeAttribute("data-index"), void (i.style.left = "");
        this.emit("removeSlide", t);
        const s = new CustomEvent($e35dfd66294e81cf$var$G);
        i.dispatchEvent(s), t.el && (t.el.remove(), t.el = null);
    }
    transitionTo(t = 0, e = this.option("transition")) {
        var i, n, s, o;
        if (!e) return !1;
        const a = this.page, { pages: r, panzoom: l } = this;
        t = parseInt((t || 0).toString()) || 0;
        const c = this.getPageFromIndex(t);
        if (!l || !r[c] || r.length < 2 || Math.abs(((null === (n = null === (i = r[a]) || void 0 === i ? void 0 : i.slides[0]) || void 0 === n ? void 0 : n.dim) || 0) - this.viewportDim) > 1) return !1;
        let h = t > a ? 1 : -1;
        this.isInfinite && (0 === a && t === r.length - 1 && (h = -1), a === r.length - 1 && 0 === t && (h = 1));
        const d = r[c].pos * (this.isRTL ? 1 : -1);
        if (a === c && Math.abs(d - l.target[this.axis]) < 1) return !1;
        this.clearTransitions();
        const u = l.isResting;
        $e35dfd66294e81cf$var$P(this.container, this.cn("inTransition"));
        const p = (null === (s = r[a]) || void 0 === s ? void 0 : s.slides[0]) || null, f = (null === (o = r[c]) || void 0 === o ? void 0 : o.slides[0]) || null;
        this.inTransition.add(f.index), this.createSlideEl(f);
        let g = p.el, m = f.el;
        u || e === $e35dfd66294e81cf$var$J || (e = "fadeFast", g = null);
        const v = this.isRTL ? "next" : "prev", b = this.isRTL ? "prev" : "next";
        return g && (this.inTransition.add(p.index), p.transition = e, g.addEventListener($e35dfd66294e81cf$var$G, this.onAnimationEnd), g.classList.add(`f-${e}Out`, `to-${h > 0 ? b : v}`)), m && (f.transition = e, m.addEventListener($e35dfd66294e81cf$var$G, this.onAnimationEnd), m.classList.add(`f-${e}In`, `from-${h > 0 ? v : b}`)), l.current[this.axis] = d, l.target[this.axis] = d, l.requestTick(), this.onChange(c), !0;
    }
    manageSlideVisiblity() {
        const t = new Set, e = new Set, i = this.getVisibleSlides(parseFloat(this.option("preload", 0) + "") || 0);
        for (const n of this.slides)i.has(n) ? t.add(n) : e.add(n);
        for (const e of this.inTransition)t.add(this.slides[e]);
        for (const e of t)this.createSlideEl(e), this.lazyLoadSlide(e);
        for (const i of e)t.has(i) || this.removeSlideEl(i);
        this.markSelectedSlides(), this.repositionSlides();
    }
    markSelectedSlides() {
        if (!this.pages[this.page] || !this.pages[this.page].slides) return;
        const t = "aria-hidden";
        let e = this.cn($e35dfd66294e81cf$var$K);
        if (e) for (const i of this.slides){
            const n = i.el;
            n && (n.dataset.index = `${i.index}`, n.classList.contains("f-thumbs__slide") ? this.getVisibleSlides(0).has(i) ? n.removeAttribute(t) : n.setAttribute(t, "true") : this.pages[this.page].slides.includes(i) ? (n.classList.contains(e) || ($e35dfd66294e81cf$var$P(n, e), this.emit("selectSlide", i)), n.removeAttribute(t)) : (n.classList.contains(e) && ($e35dfd66294e81cf$var$S(n, e), this.emit("unselectSlide", i)), n.setAttribute(t, "true")));
        }
    }
    flipInfiniteTrack() {
        const { axis: t, isHorizontal: e, isInfinite: i, isRTL: n, viewportDim: s, contentDim: o } = this, a = this.panzoom;
        if (!a || !i) return;
        let r = a.current[t], l = a.target[t] - r, c = 0, h = .5 * s;
        n && e ? (r < -h && (c = -1, r += o), r > o - h && (c = 1, r -= o)) : (r > h && (c = 1, r -= o), r < -o + h && (c = -1, r += o)), c && (a.current[t] = r, a.target[t] = r + l);
    }
    lazyLoadImg(t, e) {
        const i = this, s = "f-fadeIn", o = "is-preloading";
        let a = !1, r = null;
        const l = ()=>{
            a || (a = !0, r && (r.remove(), r = null), $e35dfd66294e81cf$var$S(e, o), e.complete && ($e35dfd66294e81cf$var$P(e, s), setTimeout(()=>{
                $e35dfd66294e81cf$var$S(e, s);
            }, 350)), this.option("adaptiveHeight") && t.el && this.pages[this.page].slides.indexOf(t) > -1 && (i.updateMetrics(), i.setViewportHeight()), this.emit("load", t));
        };
        $e35dfd66294e81cf$var$P(e, o), e.src = e.dataset.lazySrcset || e.dataset.lazySrc || "", delete e.dataset.lazySrc, delete e.dataset.lazySrcset, e.addEventListener("error", ()=>{
            l();
        }), e.addEventListener("load", ()=>{
            l();
        }), setTimeout(()=>{
            const i = e.parentNode;
            i && t.el && (e.complete ? l() : a || (r = $e35dfd66294e81cf$var$n($e35dfd66294e81cf$var$x), i.insertBefore(r, e)));
        }, 300);
    }
    lazyLoadSlide(t) {
        const e = t && t.el;
        if (!e) return;
        const i = new Set;
        let n = Array.from(e.querySelectorAll("[data-lazy-src],[data-lazy-srcset]"));
        e.dataset.lazySrc && n.push(e), n.map((t)=>{
            t instanceof HTMLImageElement ? i.add(t) : t instanceof HTMLElement && t.dataset.lazySrc && (t.style.backgroundImage = `url('${t.dataset.lazySrc}')`, delete t.dataset.lazySrc);
        });
        for (const e of i)this.lazyLoadImg(t, e);
    }
    onAnimationEnd(t) {
        var e;
        const i = t.target, n = i ? parseInt(i.dataset.index || "", 10) || 0 : -1, s = this.slides[n], o = t.animationName;
        if (!i || !s || !o) return;
        const a = !!this.inTransition.has(n) && s.transition;
        a && o.substring(0, a.length + 2) === `f-${a}` && this.inTransition.delete(n), this.inTransition.size || this.clearTransitions(), n === this.page && (null === (e = this.panzoom) || void 0 === e ? void 0 : e.isResting) && this.emit("settle");
    }
    onDecel(t, e = 0, i = 0, n = 0, s = 0) {
        if (this.option("dragFree")) return void this.setPageFromPosition();
        const { isRTL: o, isHorizontal: a, axis: r, pages: l } = this, c = l.length, h = Math.abs(Math.atan2(i, e) / (Math.PI / 180));
        let d = 0;
        if (d = h > 45 && h < 135 ? a ? 0 : i : a ? e : 0, !c) return;
        let u = this.page, p = o && a ? 1 : -1;
        const f = t.current[r] * p;
        let { pageIndex: g } = this.getPageFromPosition(f);
        Math.abs(d) > 5 ? (l[u].dim < document.documentElement["client" + (this.isHorizontal ? "Width" : "Height")] - 1 && (u = g), u = o && a ? d < 0 ? u - 1 : u + 1 : d < 0 ? u + 1 : u - 1) : u = 0 === n && 0 === s ? u : g, this.slideTo(u, {
            transition: !1,
            friction: t.option("decelFriction")
        });
    }
    onClick(t) {
        const e = t.target, i = e && $e35dfd66294e81cf$var$E(e) ? e.dataset : null;
        let n, s;
        i && (void 0 !== i.carouselPage ? (s = "slideTo", n = i.carouselPage) : void 0 !== i.carouselNext ? s = "slideNext" : void 0 !== i.carouselPrev && (s = "slidePrev")), s ? (t.preventDefault(), t.stopPropagation(), e && !e.hasAttribute("disabled") && this[s](n)) : this.emit("click", t);
    }
    onSlideTo(t) {
        const e = t.detail || 0;
        this.slideTo(this.getPageForSlide(e), {
            friction: 0
        });
    }
    onChange(t, e = 0) {
        const i = this.page;
        this.prevPage = i, this.page = t, this.option("adaptiveHeight") && this.setViewportHeight(), t !== i && (this.markSelectedSlides(), this.emit("change", t, i, e));
    }
    onRefresh() {
        let t = this.contentDim, e = this.viewportDim;
        this.updateMetrics(), this.contentDim === t && this.viewportDim === e || this.slideTo(this.page, {
            friction: 0,
            transition: !1
        });
    }
    onScroll() {
        var t;
        null === (t = this.viewport) || void 0 === t || t.scroll(0, 0);
    }
    onResize() {
        this.option("breakpoints") && this.processOptions();
    }
    onBeforeTransform(t) {
        this.lp !== t.current[this.axis] && (this.flipInfiniteTrack(), this.manageSlideVisiblity()), this.lp = t.current.e;
    }
    onEndAnimation() {
        this.inTransition.size || this.emit("settle");
    }
    reInit(t = null, e = null) {
        this.destroy(), this.state = $e35dfd66294e81cf$var$B.Init, this.prevPage = null, this.userOptions = t || this.userOptions, this.userPlugins = e || this.userPlugins, this.processOptions();
    }
    slideTo(t = 0, { friction: e = this.option("friction"), transition: i = this.option("transition") } = {}) {
        if (this.state === $e35dfd66294e81cf$var$B.Destroy) return;
        t = parseInt((t || 0).toString()) || 0;
        const n = this.getPageFromIndex(t), { axis: s, isHorizontal: o, isRTL: a, pages: r, panzoom: l } = this, c = r.length, h = a && o ? 1 : -1;
        if (!l || !c) return;
        if (this.page !== n) {
            const e = new Event("beforeChange", {
                bubbles: !0,
                cancelable: !0
            });
            if (this.emit("beforeChange", e, t), e.defaultPrevented) return;
        }
        if (this.transitionTo(t, i)) return;
        let d = r[n].pos;
        if (this.isInfinite) {
            const e = this.contentDim, i = l.target[s] * h;
            if (2 === c) d += e * Math.floor(parseFloat(t + "") / 2);
            else d = [
                d,
                d - e,
                d + e
            ].reduce(function(t, e) {
                return Math.abs(e - i) < Math.abs(t - i) ? e : t;
            });
        }
        d *= h, Math.abs(l.target[s] - d) < 1 || (l.panTo({
            x: o ? d : 0,
            y: o ? 0 : d,
            friction: e
        }), this.onChange(n));
    }
    slideToClosest(t) {
        if (this.panzoom) {
            const { pageIndex: e } = this.getPageFromPosition();
            this.slideTo(e, t);
        }
    }
    slideNext() {
        this.slideTo(this.page + 1);
    }
    slidePrev() {
        this.slideTo(this.page - 1);
    }
    clearTransitions() {
        this.inTransition.clear(), $e35dfd66294e81cf$var$S(this.container, this.cn("inTransition"));
        const t = [
            "to-prev",
            "to-next",
            "from-prev",
            "from-next"
        ];
        for (const e of this.slides){
            const i = e.el;
            if (i) {
                i.removeEventListener($e35dfd66294e81cf$var$G, this.onAnimationEnd), i.classList.remove(...t);
                const n = e.transition;
                n && i.classList.remove(`f-${n}Out`, `f-${n}In`);
            }
        }
        this.manageSlideVisiblity();
    }
    addSlide(t, e) {
        var i, n, s, o;
        const a = this.panzoom, r = (null === (i = this.pages[this.page]) || void 0 === i ? void 0 : i.pos) || 0, l = (null === (n = this.pages[this.page]) || void 0 === n ? void 0 : n.dim) || 0, c = this.contentDim < this.viewportDim;
        let h = Array.isArray(e) ? e : [
            e
        ];
        const d = [];
        for (const t of h)d.push($e35dfd66294e81cf$var$H(t));
        this.slides.splice(t, 0, ...d);
        for(let t = 0; t < this.slides.length; t++)this.slides[t].index = t;
        for (const t of d)this.emit("beforeInitSlide", t, t.index);
        if (this.page >= t && (this.page += d.length), this.updateMetrics(), a) {
            const e = (null === (s = this.pages[this.page]) || void 0 === s ? void 0 : s.pos) || 0, i = (null === (o = this.pages[this.page]) || void 0 === o ? void 0 : o.dim) || 0, n = this.pages.length || 1, h = this.isRTL ? l - i : i - l, d = this.isRTL ? r - e : e - r;
            c && 1 === n ? (t <= this.page && (a.current[this.axis] -= h, a.target[this.axis] -= h), a.panTo({
                [this.isHorizontal ? "x" : "y"]: -1 * e
            })) : d && t <= this.page && (a.target[this.axis] -= d, a.current[this.axis] -= d, a.requestTick());
        }
        for (const t of d)this.emit("initSlide", t, t.index);
    }
    prependSlide(t) {
        this.addSlide(0, t);
    }
    appendSlide(t) {
        this.addSlide(this.slides.length, t);
    }
    removeSlide(t) {
        const e = this.slides.length;
        t = (t % e + e) % e;
        const i = this.slides[t];
        if (i) {
            this.removeSlideEl(i, !0), this.slides.splice(t, 1);
            for(let t = 0; t < this.slides.length; t++)this.slides[t].index = t;
            this.updateMetrics(), this.slideTo(this.page, {
                friction: 0,
                transition: !1
            }), this.emit("destroySlide", i);
        }
    }
    updateMetrics() {
        const { panzoom: e, viewport: i, track: n, slides: s, isHorizontal: o, isInfinite: a } = this;
        if (!n) return;
        const r = o ? "width" : "height", l = o ? "offsetWidth" : "offsetHeight";
        if (i) {
            let e = Math.max(i[l], $e35dfd66294e81cf$var$t(i.getBoundingClientRect()[r], 1e3)), n = getComputedStyle(i), s = "padding", a = o ? "Right" : "Bottom";
            e -= parseFloat(n[s + (o ? "Left" : "Top")]) + parseFloat(n[s + a]), this.viewportDim = e;
        }
        let c, h = 0;
        for (const [e, i] of s.entries()){
            let n = 0, o = 0;
            !i.el && c ? (n = c.dim, o = c.gap) : ({ dim: n, gap: o } = this.getSlideMetrics(i), c = i), n = $e35dfd66294e81cf$var$t(n, 1e3), o = $e35dfd66294e81cf$var$t(o, 1e3), i.dim = n, i.gap = o, i.pos = h, h += n, (a || e < s.length - 1) && (h += o);
        }
        h = $e35dfd66294e81cf$var$t(h, 1e3), this.contentDim = h, e && (e.contentRect[r] = h, e.contentRect[o ? "fullWidth" : "fullHeight"] = h), this.pages = this.createPages(), this.pages = this.processPages(), this.state === $e35dfd66294e81cf$var$B.Init && this.setInitialPage(), this.page = Math.max(0, Math.min(this.page, this.pages.length - 1)), this.manageSlideVisiblity(), this.emit("refresh");
    }
    getProgress(e, i = !1, n = !1) {
        void 0 === e && (e = this.page);
        const s = this, o = s.panzoom, a = s.contentDim, r = s.pages[e] || 0;
        if (!r || !o) return e > this.page ? -1 : 1;
        let l = -1 * o.current.e, c = $e35dfd66294e81cf$var$t((l - r.pos) / (1 * r.dim), 1e3), h = c, d = c;
        this.isInfinite && !0 !== n && (h = $e35dfd66294e81cf$var$t((l - r.pos + a) / (1 * r.dim), 1e3), d = $e35dfd66294e81cf$var$t((l - r.pos - a) / (1 * r.dim), 1e3));
        let u = [
            c,
            h,
            d
        ].reduce(function(t, e) {
            return Math.abs(e) < Math.abs(t) ? e : t;
        });
        return i ? u : u > 1 ? 1 : u < -1 ? -1 : u;
    }
    setViewportHeight() {
        const { page: t, pages: e, viewport: i, isHorizontal: n } = this;
        if (!i || !e[t]) return;
        let s = 0;
        n && this.track && (this.track.style.height = "auto", e[t].slides.forEach((t)=>{
            t.el && (s = Math.max(s, t.el.offsetHeight));
        })), i.style.height = s ? `${s}px` : "";
    }
    getPageForSlide(t) {
        for (const e of this.pages)for (const i of e.slides)if (i.index === t) return e.index;
        return -1;
    }
    getVisibleSlides(t = 0) {
        var e;
        const i = new Set;
        let { panzoom: n, contentDim: s, viewportDim: o, pages: a, page: r } = this;
        if (o) {
            s = s + (null === (e = this.slides[this.slides.length - 1]) || void 0 === e ? void 0 : e.gap) || 0;
            let l = 0;
            l = n && n.state !== $e35dfd66294e81cf$var$m.Init && n.state !== $e35dfd66294e81cf$var$m.Destroy ? -1 * n.current[this.axis] : a[r] && a[r].pos || 0, this.isInfinite && (l -= Math.floor(l / s) * s), this.isRTL && this.isHorizontal && (l *= -1);
            const c = l - o * t, h = l + o * (t + 1), d = this.isInfinite ? [
                -1,
                0,
                1
            ] : [
                0
            ];
            for (const t of this.slides)for (const e of d){
                const n = t.pos + e * s, o = n + t.dim + t.gap;
                n < h && o > c && i.add(t);
            }
        }
        return i;
    }
    getPageFromPosition(t) {
        const { viewportDim: e, contentDim: i, slides: n, pages: s, panzoom: o } = this, a = s.length, r = n.length, l = n[0], c = n[r - 1], h = this.option("center");
        let d = 0, u = 0, p = 0, f = void 0 === t ? -1 * ((null == o ? void 0 : o.target[this.axis]) || 0) : t;
        h && (f += .5 * e), this.isInfinite ? (f < l.pos - .5 * c.gap && (f -= i, p = -1), f > c.pos + c.dim + .5 * c.gap && (f -= i, p = 1)) : f = Math.max(l.pos || 0, Math.min(f, c.pos));
        let g = c, m = n.find((t)=>{
            const e = t.pos - .5 * g.gap, i = t.pos + t.dim + .5 * t.gap;
            return g = t, f >= e && f < i;
        });
        return m || (m = c), u = this.getPageForSlide(m.index), d = u + p * a, {
            page: d,
            pageIndex: u
        };
    }
    setPageFromPosition() {
        const { pageIndex: t } = this.getPageFromPosition();
        this.onChange(t);
    }
    destroy() {
        if ([
            $e35dfd66294e81cf$var$B.Destroy
        ].includes(this.state)) return;
        this.state = $e35dfd66294e81cf$var$B.Destroy;
        const { container: t, viewport: e, track: i, slides: n, panzoom: s } = this, o = this.option("classes");
        t.removeEventListener("click", this.onClick, {
            passive: !1,
            capture: !1
        }), t.removeEventListener("slideTo", this.onSlideTo), window.removeEventListener("resize", this.onResize), s && (s.destroy(), this.panzoom = null), n && n.forEach((t)=>{
            this.removeSlideEl(t);
        }), this.detachPlugins(), e && (e.removeEventListener("scroll", this.onScroll), e.offsetParent && i && i.offsetParent && e.replaceWith(...i.childNodes));
        for (const [e, i] of Object.entries(o))"container" !== e && i && t.classList.remove(i);
        this.track = null, this.viewport = null, this.page = 0, this.slides = [];
        const a = this.events.get("ready");
        this.events = new Map, a && this.events.set("ready", a);
    }
}
Object.defineProperty($e35dfd66294e81cf$export$144901db2ea8e967, "Panzoom", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: $e35dfd66294e81cf$export$b704d075ddd20210
}), Object.defineProperty($e35dfd66294e81cf$export$144901db2ea8e967, "defaults", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: $e35dfd66294e81cf$var$j
}), Object.defineProperty($e35dfd66294e81cf$export$144901db2ea8e967, "Plugins", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: $e35dfd66294e81cf$var$U
});
const $e35dfd66294e81cf$var$tt = function(t) {
    if (!$e35dfd66294e81cf$var$E(t)) return 0;
    const e = window.scrollY, i = window.innerHeight, n = e + i, s = t.getBoundingClientRect(), o = s.y + e, a = s.height, r = o + a;
    if (e > r || n < o) return 0;
    if (e < o && n > r) return 100;
    if (o < e && r > n) return 100;
    let l = a;
    o < e && (l -= e - o), r > n && (l -= r - n);
    const c = l / i * 100;
    return Math.round(c);
}, $e35dfd66294e81cf$var$et = !("undefined" == typeof window || !window.document || !window.document.createElement);
let $e35dfd66294e81cf$var$it;
const $e35dfd66294e81cf$var$nt = [
    "a[href]",
    "area[href]",
    'input:not([disabled]):not([type="hidden"]):not([aria-hidden])',
    "select:not([disabled]):not([aria-hidden])",
    "textarea:not([disabled]):not([aria-hidden])",
    "button:not([disabled]):not([aria-hidden]):not(.fancybox-focus-guard)",
    "iframe",
    "object",
    "embed",
    "video",
    "audio",
    "[contenteditable]",
    '[tabindex]:not([tabindex^="-"]):not([disabled]):not([aria-hidden])'
].join(","), $e35dfd66294e81cf$var$st = (t)=>{
    if (t && $e35dfd66294e81cf$var$et) {
        void 0 === $e35dfd66294e81cf$var$it && document.createElement("div").focus({
            get preventScroll () {
                return $e35dfd66294e81cf$var$it = !0, !1;
            }
        });
        try {
            if ($e35dfd66294e81cf$var$it) t.focus({
                preventScroll: !0
            });
            else {
                const e = window.scrollY || document.body.scrollTop, i = window.scrollX || document.body.scrollLeft;
                t.focus(), document.body.scrollTo({
                    top: e,
                    left: i,
                    behavior: "auto"
                });
            }
        } catch (t) {}
    }
}, $e35dfd66294e81cf$var$ot = ()=>{
    const t = document;
    let e, i = "", n = "", s = "";
    return t.fullscreenEnabled ? (i = "requestFullscreen", n = "exitFullscreen", s = "fullscreenElement") : t.webkitFullscreenEnabled && (i = "webkitRequestFullscreen", n = "webkitExitFullscreen", s = "webkitFullscreenElement"), i && (e = {
        request: function(e = t.documentElement) {
            return "webkitRequestFullscreen" === i ? e[i](Element.ALLOW_KEYBOARD_INPUT) : e[i]();
        },
        exit: function() {
            return t[s] && t[n]();
        },
        isFullscreen: function() {
            return t[s];
        }
    }), e;
}, $e35dfd66294e81cf$var$at = {
    animated: !0,
    autoFocus: !0,
    backdropClick: "close",
    Carousel: {
        classes: {
            container: "fancybox__carousel",
            viewport: "fancybox__viewport",
            track: "fancybox__track",
            slide: "fancybox__slide"
        }
    },
    closeButton: "auto",
    closeExisting: !1,
    commonCaption: !1,
    compact: ()=>window.matchMedia("(max-width: 578px), (max-height: 578px)").matches,
    contentClick: "toggleZoom",
    contentDblClick: !1,
    defaultType: "image",
    defaultDisplay: "flex",
    dragToClose: !0,
    Fullscreen: {
        autoStart: !1
    },
    groupAll: !1,
    groupAttr: "data-fancybox",
    hideClass: "f-fadeOut",
    hideScrollbar: !0,
    idle: 3500,
    keyboard: {
        Escape: "close",
        Delete: "close",
        Backspace: "close",
        PageUp: "next",
        PageDown: "prev",
        ArrowUp: "prev",
        ArrowDown: "next",
        ArrowRight: "next",
        ArrowLeft: "prev"
    },
    l10n: Object.assign(Object.assign({}, $e35dfd66294e81cf$var$b), {
        CLOSE: "Close",
        NEXT: "Next",
        PREV: "Previous",
        MODAL: "You can close this modal content with the ESC key",
        ERROR: "Something Went Wrong, Please Try Again Later",
        IMAGE_ERROR: "Image Not Found",
        ELEMENT_NOT_FOUND: "HTML Element Not Found",
        AJAX_NOT_FOUND: "Error Loading AJAX : Not Found",
        AJAX_FORBIDDEN: "Error Loading AJAX : Forbidden",
        IFRAME_ERROR: "Error Loading Page",
        TOGGLE_ZOOM: "Toggle zoom level",
        TOGGLE_THUMBS: "Toggle thumbnails",
        TOGGLE_SLIDESHOW: "Toggle slideshow",
        TOGGLE_FULLSCREEN: "Toggle full-screen mode",
        DOWNLOAD: "Download"
    }),
    parentEl: null,
    placeFocusBack: !0,
    showClass: "f-zoomInUp",
    startIndex: 0,
    tpl: {
        closeButton: '<button data-fancybox-close class="f-button is-close-btn" title="{{CLOSE}}"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" tabindex="-1"><path d="M20 20L4 4m16 0L4 20"/></svg></button>',
        main: '<div class="fancybox__container" role="dialog" aria-modal="true" aria-label="{{MODAL}}" tabindex="-1">\n    <div class="fancybox__backdrop"></div>\n    <div class="fancybox__carousel"></div>\n    <div class="fancybox__footer"></div>\n  </div>'
    },
    trapFocus: !0,
    wheel: "zoom"
};
var $e35dfd66294e81cf$var$rt, $e35dfd66294e81cf$var$lt;
!function(t) {
    t[t.Init = 0] = "Init", t[t.Ready = 1] = "Ready", t[t.Closing = 2] = "Closing", t[t.CustomClosing = 3] = "CustomClosing", t[t.Destroy = 4] = "Destroy";
}($e35dfd66294e81cf$var$rt || ($e35dfd66294e81cf$var$rt = {})), function(t) {
    t[t.Loading = 0] = "Loading", t[t.Opening = 1] = "Opening", t[t.Ready = 2] = "Ready", t[t.Closing = 3] = "Closing";
}($e35dfd66294e81cf$var$lt || ($e35dfd66294e81cf$var$lt = {}));
let $e35dfd66294e81cf$var$ct = "", $e35dfd66294e81cf$var$ht = !1, $e35dfd66294e81cf$var$dt = !1, $e35dfd66294e81cf$var$ut = null;
const $e35dfd66294e81cf$var$pt = ()=>{
    let t = "", e = "";
    const i = $e35dfd66294e81cf$export$cb45b08d97cdc4fd.getInstance();
    if (i) {
        const n = i.carousel, s = i.getSlide();
        if (n && s) {
            let o = s.slug || void 0, a = s.triggerEl || void 0;
            e = o || i.option("slug") || "", !e && a && a.dataset && (e = a.dataset.fancybox || ""), e && "true" !== e && (t = "#" + e + (!o && n.slides.length > 1 ? "-" + (s.index + 1) : ""));
        }
    }
    return {
        hash: t,
        slug: e,
        index: 1
    };
}, $e35dfd66294e81cf$var$ft = ()=>{
    const t = new URL(document.URL).hash, e = t.slice(1).split("-"), i = e[e.length - 1], n = i && /^\+?\d+$/.test(i) && parseInt(e.pop() || "1", 10) || 1;
    return {
        hash: t,
        slug: e.join("-"),
        index: n
    };
}, $e35dfd66294e81cf$var$gt = ()=>{
    const { slug: t, index: e } = $e35dfd66294e81cf$var$ft();
    if (!t) return;
    let i = document.querySelector(`[data-slug="${t}"]`);
    if (i && i.dispatchEvent(new CustomEvent("click", {
        bubbles: !0,
        cancelable: !0
    })), $e35dfd66294e81cf$export$cb45b08d97cdc4fd.getInstance()) return;
    const n = document.querySelectorAll(`[data-fancybox="${t}"]`);
    n.length && (i = n[e - 1], i && i.dispatchEvent(new CustomEvent("click", {
        bubbles: !0,
        cancelable: !0
    })));
}, $e35dfd66294e81cf$var$mt = ()=>{
    if (!1 === $e35dfd66294e81cf$export$cb45b08d97cdc4fd.defaults.Hash) return;
    const t = $e35dfd66294e81cf$export$cb45b08d97cdc4fd.getInstance();
    if (!1 === (null == t ? void 0 : t.options.Hash)) return;
    const { slug: e, index: i } = $e35dfd66294e81cf$var$ft(), { slug: n } = $e35dfd66294e81cf$var$pt();
    t && (e === n ? t.jumpTo(i - 1) : ($e35dfd66294e81cf$var$ht = !0, t.close())), $e35dfd66294e81cf$var$gt();
}, $e35dfd66294e81cf$var$vt = ()=>{
    $e35dfd66294e81cf$var$ut && clearTimeout($e35dfd66294e81cf$var$ut), queueMicrotask(()=>{
        $e35dfd66294e81cf$var$mt();
    });
}, $e35dfd66294e81cf$var$bt = ()=>{
    window.addEventListener("hashchange", $e35dfd66294e81cf$var$vt, !1), setTimeout(()=>{
        $e35dfd66294e81cf$var$mt();
    }, 500);
};
$e35dfd66294e81cf$var$et && (/complete|interactive|loaded/.test(document.readyState) ? $e35dfd66294e81cf$var$bt() : document.addEventListener("DOMContentLoaded", $e35dfd66294e81cf$var$bt));
const $e35dfd66294e81cf$var$yt = "is-zooming-in";
class $e35dfd66294e81cf$var$wt extends $e35dfd66294e81cf$var$_ {
    onCreateSlide(t, e, i) {
        const n = this.instance.optionFor(i, "src") || "";
        i.el && "image" === i.type && "string" == typeof n && this.setImage(i, n);
    }
    onRemoveSlide(t, e, i) {
        i.panzoom && i.panzoom.destroy(), i.panzoom = void 0, i.imageEl = void 0;
    }
    onChange(t, e, i, n) {
        $e35dfd66294e81cf$var$S(this.instance.container, $e35dfd66294e81cf$var$yt);
        for (const t of e.slides){
            const e = t.panzoom;
            e && t.index !== i && e.reset(.35);
        }
    }
    onClose() {
        var t;
        const e = this.instance, i = e.container, n = e.getSlide();
        if (!i || !i.parentElement || !n) return;
        const { el: s, contentEl: o, panzoom: a, thumbElSrc: r } = n;
        if (!s || !r || !o || !a || a.isContentLoading || a.state === $e35dfd66294e81cf$var$m.Init || a.state === $e35dfd66294e81cf$var$m.Destroy) return;
        a.updateMetrics();
        let l = this.getZoomInfo(n);
        if (!l) return;
        this.instance.state = $e35dfd66294e81cf$var$rt.CustomClosing, i.classList.remove($e35dfd66294e81cf$var$yt), i.classList.add("is-zooming-out"), o.style.backgroundImage = `url('${r}')`;
        const c = i.getBoundingClientRect();
        1 === ((null === (t = window.visualViewport) || void 0 === t ? void 0 : t.scale) || 1) && Object.assign(i.style, {
            position: "absolute",
            top: `${i.offsetTop + window.scrollY}px`,
            left: `${i.offsetLeft + window.scrollX}px`,
            bottom: "auto",
            right: "auto",
            width: `${c.width}px`,
            height: `${c.height}px`,
            overflow: "hidden"
        });
        const { x: h, y: d, scale: u, opacity: p } = l;
        if (p) {
            const t = ((t, e, i, n)=>{
                const s = e - t, o = n - i;
                return (e)=>i + ((e - t) / s * o || 0);
            })(a.scale, u, 1, 0);
            a.on("afterTransform", ()=>{
                o.style.opacity = t(a.scale) + "";
            });
        }
        a.on("endAnimation", ()=>{
            e.destroy();
        }), a.target.a = u, a.target.b = 0, a.target.c = 0, a.target.d = u, a.panTo({
            x: h,
            y: d,
            scale: u,
            friction: p ? .2 : .33,
            ignoreBounds: !0
        }), a.isResting && e.destroy();
    }
    setImage(t, e) {
        const i = this.instance;
        t.src = e, this.process(t, e).then((e)=>{
            const { contentEl: n, imageEl: s, thumbElSrc: o, el: a } = t;
            if (i.isClosing() || !n || !s) return;
            n.offsetHeight;
            const r = !!i.isOpeningSlide(t) && this.getZoomInfo(t);
            if (this.option("protected") && a) {
                a.addEventListener("contextmenu", (t)=>{
                    t.preventDefault();
                });
                const t = document.createElement("div");
                $e35dfd66294e81cf$var$P(t, "fancybox-protected"), n.appendChild(t);
            }
            if (o && r) {
                const s = e.contentRect, a = Math.max(s.fullWidth, s.fullHeight);
                let c = null;
                !r.opacity && a > 1200 && (c = document.createElement("img"), $e35dfd66294e81cf$var$P(c, "fancybox-ghost"), c.src = o, n.appendChild(c));
                const h = ()=>{
                    c && ($e35dfd66294e81cf$var$P(c, "f-fadeFastOut"), setTimeout(()=>{
                        c && (c.remove(), c = null);
                    }, 200));
                };
                (l = o, new Promise((t, e)=>{
                    const i = new Image;
                    i.onload = t, i.onerror = e, i.src = l;
                })).then(()=>{
                    i.hideLoading(t), t.state = $e35dfd66294e81cf$var$lt.Opening, this.instance.emit("reveal", t), this.zoomIn(t).then(()=>{
                        h(), this.instance.done(t);
                    }, ()=>{}), c && setTimeout(()=>{
                        h();
                    }, a > 2500 ? 800 : 200);
                }, ()=>{
                    i.hideLoading(t), i.revealContent(t);
                });
            } else {
                const n = this.optionFor(t, "initialSize"), s = this.optionFor(t, "zoom"), o = {
                    event: i.prevMouseMoveEvent || i.options.event,
                    friction: s ? .12 : 0
                };
                let a = i.optionFor(t, "showClass") || void 0, r = !0;
                i.isOpeningSlide(t) && ("full" === n ? e.zoomToFull(o) : "cover" === n ? e.zoomToCover(o) : "max" === n ? e.zoomToMax(o) : r = !1, e.stop("current")), r && a && (a = e.isDragging ? "f-fadeIn" : ""), i.hideLoading(t), i.revealContent(t, a);
            }
            var l;
        }, ()=>{
            i.setError(t, "{{IMAGE_ERROR}}");
        });
    }
    process(t, e) {
        return new Promise((i, s)=>{
            var o;
            const a = this.instance, r = t.el;
            a.clearContent(t), a.showLoading(t);
            let l = this.optionFor(t, "content");
            if ("string" == typeof l && (l = $e35dfd66294e81cf$var$n(l)), !l || !$e35dfd66294e81cf$var$E(l)) {
                if (l = document.createElement("img"), l instanceof HTMLImageElement) {
                    let i = "", n = t.caption;
                    i = "string" == typeof n && n ? n.replace(/<[^>]+>/gi, "").substring(0, 1e3) : `Image ${t.index + 1} of ${(null === (o = a.carousel) || void 0 === o ? void 0 : o.pages.length) || 1}`, l.src = e || "", l.alt = i, l.draggable = !1, t.srcset && l.setAttribute("srcset", t.srcset), this.instance.isOpeningSlide(t) && (l.fetchPriority = "high");
                }
                t.sizes && l.setAttribute("sizes", t.sizes);
            }
            $e35dfd66294e81cf$var$P(l, "fancybox-image"), t.imageEl = l, a.setContent(t, l, !1);
            t.panzoom = new $e35dfd66294e81cf$export$b704d075ddd20210(r, $e35dfd66294e81cf$var$u({
                transformParent: !0
            }, this.option("Panzoom") || {}, {
                content: l,
                width: (e, i)=>a.optionFor(t, "width", "auto", i) || "auto",
                height: (e, i)=>a.optionFor(t, "height", "auto", i) || "auto",
                wheel: ()=>{
                    const t = a.option("wheel");
                    return ("zoom" === t || "pan" == t) && t;
                },
                click: (e, i)=>{
                    var n, s;
                    if (a.isCompact || a.isClosing()) return !1;
                    if (t.index !== (null === (n = a.getSlide()) || void 0 === n ? void 0 : n.index)) return !1;
                    if (i) {
                        const t = i.composedPath()[0];
                        if ([
                            "A",
                            "BUTTON",
                            "TEXTAREA",
                            "OPTION",
                            "INPUT",
                            "SELECT",
                            "VIDEO"
                        ].includes(t.nodeName)) return !1;
                    }
                    let o = !i || i.target && (null === (s = t.contentEl) || void 0 === s ? void 0 : s.contains(i.target));
                    return a.option(o ? "contentClick" : "backdropClick") || !1;
                },
                dblClick: ()=>a.isCompact ? "toggleZoom" : a.option("contentDblClick") || !1,
                spinner: !1,
                panOnlyZoomed: !0,
                wheelLimit: 1 / 0,
                on: {
                    ready: (t)=>{
                        i(t);
                    },
                    error: ()=>{
                        s();
                    },
                    destroy: ()=>{
                        s();
                    }
                }
            }));
        });
    }
    zoomIn(t) {
        return new Promise((e, i)=>{
            const n = this.instance, s = n.container, { panzoom: o, contentEl: a, el: r } = t;
            o && o.updateMetrics();
            const l = this.getZoomInfo(t);
            if (!(l && r && a && o && s)) return void i();
            const { x: c, y: h, scale: d, opacity: u } = l, p = ()=>{
                t.state !== $e35dfd66294e81cf$var$lt.Closing && (u && (a.style.opacity = Math.max(Math.min(1, 1 - (1 - o.scale) / (1 - d)), 0) + ""), o.scale >= 1 && o.scale > o.targetScale - .1 && e(o));
            }, f = (t)=>{
                (t.scale < .99 || t.scale > 1.01) && !t.isDragging || ($e35dfd66294e81cf$var$S(s, $e35dfd66294e81cf$var$yt), a.style.opacity = "", t.off("endAnimation", f), t.off("touchStart", f), t.off("afterTransform", p), e(t));
            };
            o.on("endAnimation", f), o.on("touchStart", f), o.on("afterTransform", p), o.on([
                "error",
                "destroy"
            ], ()=>{
                i();
            }), o.panTo({
                x: c,
                y: h,
                scale: d,
                friction: 0,
                ignoreBounds: !0
            }), o.stop("current");
            const g = {
                event: "mousemove" === o.panMode ? n.prevMouseMoveEvent || n.options.event : void 0
            }, m = this.optionFor(t, "initialSize");
            $e35dfd66294e81cf$var$P(s, $e35dfd66294e81cf$var$yt), n.hideLoading(t), "full" === m ? o.zoomToFull(g) : "cover" === m ? o.zoomToCover(g) : "max" === m ? o.zoomToMax(g) : o.reset(.172);
        });
    }
    getZoomInfo(t) {
        const { el: e, imageEl: i, thumbEl: n, panzoom: s } = t, o = this.instance, a = o.container;
        if (!e || !i || !n || !s || $e35dfd66294e81cf$var$tt(n) < 3 || !this.optionFor(t, "zoom") || !a || o.state === $e35dfd66294e81cf$var$rt.Destroy) return !1;
        if ("0" === getComputedStyle(a).getPropertyValue("--f-images-zoom")) return !1;
        const r = window.visualViewport || null;
        if (1 !== (r ? r.scale : 1)) return !1;
        let { top: l, left: c, width: h, height: d } = n.getBoundingClientRect(), { top: u, left: p, fitWidth: f, fitHeight: g } = s.contentRect;
        if (!(h && d && f && g)) return !1;
        const m = s.container.getBoundingClientRect();
        p += m.left, u += m.top;
        const v = -1 * (p + .5 * f - (c + .5 * h)), b = -1 * (u + .5 * g - (l + .5 * d)), y = h / f;
        let w = this.option("zoomOpacity") || !1;
        return "auto" === w && (w = Math.abs(h / d - f / g) > .1), {
            x: v,
            y: b,
            scale: y,
            opacity: w
        };
    }
    attach() {
        const t = this, e = t.instance;
        e.on("Carousel.change", t.onChange), e.on("Carousel.createSlide", t.onCreateSlide), e.on("Carousel.removeSlide", t.onRemoveSlide), e.on("close", t.onClose);
    }
    detach() {
        const t = this, e = t.instance;
        e.off("Carousel.change", t.onChange), e.off("Carousel.createSlide", t.onCreateSlide), e.off("Carousel.removeSlide", t.onRemoveSlide), e.off("close", t.onClose);
    }
}
Object.defineProperty($e35dfd66294e81cf$var$wt, "defaults", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: {
        initialSize: "fit",
        Panzoom: {
            maxScale: 1
        },
        protected: !1,
        zoom: !0,
        zoomOpacity: "auto"
    }
}), "function" == typeof SuppressedError && SuppressedError;
const $e35dfd66294e81cf$var$xt = "html", $e35dfd66294e81cf$var$Et = "image", $e35dfd66294e81cf$var$St = "map", $e35dfd66294e81cf$var$Pt = "youtube", $e35dfd66294e81cf$var$Ct = "vimeo", $e35dfd66294e81cf$var$Tt = "html5video", $e35dfd66294e81cf$var$Mt = (t, e = {})=>{
    const i = new URL(t), n = new URLSearchParams(i.search), s = new URLSearchParams;
    for (const [t, i] of [
        ...n,
        ...Object.entries(e)
    ]){
        let e = i + "";
        if ("t" === t) {
            let t = e.match(/((\d*)m)?(\d*)s?/);
            t && s.set("start", 60 * parseInt(t[2] || "0") + parseInt(t[3] || "0") + "");
        } else s.set(t, e);
    }
    let o = s + "", a = t.match(/#t=((.*)?\d+s)/);
    return a && (o += `#t=${a[1]}`), o;
}, $e35dfd66294e81cf$var$Ot = {
    ajax: null,
    autoSize: !0,
    iframeAttr: {
        allow: "autoplay; fullscreen",
        scrolling: "auto"
    },
    preload: !0,
    videoAutoplay: !0,
    videoRatio: 16 / 9,
    videoTpl: '<video class="fancybox__html5video" playsinline controls controlsList="nodownload" poster="{{poster}}">\n  <source src="{{src}}" type="{{format}}" />Sorry, your browser doesn\'t support embedded videos.</video>',
    videoFormat: "",
    vimeo: {
        byline: 1,
        color: "00adef",
        controls: 1,
        dnt: 1,
        muted: 0
    },
    youtube: {
        controls: 1,
        enablejsapi: 1,
        nocookie: 1,
        rel: 0,
        fs: 1
    }
}, $e35dfd66294e81cf$var$At = [
    "image",
    "html",
    "ajax",
    "inline",
    "clone",
    "iframe",
    "map",
    "pdf",
    "html5video",
    "youtube",
    "vimeo"
];
class $e35dfd66294e81cf$var$Lt extends $e35dfd66294e81cf$var$_ {
    onBeforeInitSlide(t, e, i) {
        this.processType(i);
    }
    onCreateSlide(t, e, i) {
        this.setContent(i);
    }
    onClearContent(t, e) {
        e.xhr && (e.xhr.abort(), e.xhr = null);
        const i = e.iframeEl;
        i && (i.onload = i.onerror = null, i.src = "//about:blank", e.iframeEl = null);
        const n = e.contentEl, s = e.placeholderEl;
        if ("inline" === e.type && n && s) n.classList.remove("fancybox__content"), "none" !== getComputedStyle(n).getPropertyValue("display") && (n.style.display = "none"), setTimeout(()=>{
            s && (n && s.parentNode && s.parentNode.insertBefore(n, s), s.remove());
        }, 0), e.contentEl = void 0, e.placeholderEl = void 0;
        else for(; e.el && e.el.firstChild;)e.el.removeChild(e.el.firstChild);
    }
    onSelectSlide(t, e, i) {
        i.state === $e35dfd66294e81cf$var$lt.Ready && this.playVideo();
    }
    onUnselectSlide(t, e, i) {
        var n, s;
        if (i.type === $e35dfd66294e81cf$var$Tt) {
            try {
                null === (s = null === (n = i.el) || void 0 === n ? void 0 : n.querySelector("video")) || void 0 === s || s.pause();
            } catch (t) {}
            return;
        }
        let o;
        i.type === $e35dfd66294e81cf$var$Ct ? o = {
            method: "pause",
            value: "true"
        } : i.type === $e35dfd66294e81cf$var$Pt && (o = {
            event: "command",
            func: "pauseVideo"
        }), o && i.iframeEl && i.iframeEl.contentWindow && i.iframeEl.contentWindow.postMessage(JSON.stringify(o), "*"), i.poller && clearTimeout(i.poller);
    }
    onDone(t, e) {
        t.isCurrentSlide(e) && !t.isClosing() && this.playVideo();
    }
    onRefresh(t, e) {
        e.slides.forEach((t)=>{
            t.el && (this.resizeIframe(t), this.setAspectRatio(t));
        });
    }
    onMessage(t) {
        try {
            let e = JSON.parse(t.data);
            if ("https://player.vimeo.com" === t.origin) {
                if ("ready" === e.event) for (let e of Array.from(document.getElementsByClassName("fancybox__iframe")))e instanceof HTMLIFrameElement && e.contentWindow === t.source && (e.dataset.ready = "true");
            } else if (t.origin.match(/^https:\/\/(www.)?youtube(-nocookie)?.com$/) && "onReady" === e.event) {
                const t = document.getElementById(e.id);
                t && (t.dataset.ready = "true");
            }
        } catch (t) {}
    }
    loadAjaxContent(t) {
        const e = this.instance.optionFor(t, "src") || "";
        this.instance.showLoading(t);
        const i = this.instance, n = new XMLHttpRequest;
        i.showLoading(t), n.onreadystatechange = function() {
            n.readyState === XMLHttpRequest.DONE && i.state === $e35dfd66294e81cf$var$rt.Ready && (i.hideLoading(t), 200 === n.status ? i.setContent(t, n.responseText) : i.setError(t, 404 === n.status ? "{{AJAX_NOT_FOUND}}" : "{{AJAX_FORBIDDEN}}"));
        };
        const s = t.ajax || null;
        n.open(s ? "POST" : "GET", e + ""), n.setRequestHeader("Content-Type", "application/x-www-form-urlencoded"), n.setRequestHeader("X-Requested-With", "XMLHttpRequest"), n.send(s), t.xhr = n;
    }
    setInlineContent(t) {
        let e = null;
        if ($e35dfd66294e81cf$var$E(t.src)) e = t.src;
        else if ("string" == typeof t.src) {
            const i = t.src.split("#", 2).pop();
            e = i ? document.getElementById(i) : null;
        }
        if (e) {
            if ("clone" === t.type || e.closest(".fancybox__slide")) {
                e = e.cloneNode(!0);
                const i = e.dataset.animationName;
                i && (e.classList.remove(i), delete e.dataset.animationName);
                let n = e.getAttribute("id");
                n = n ? `${n}--clone` : `clone-${this.instance.id}-${t.index}`, e.setAttribute("id", n);
            } else if (e.parentNode) {
                const i = document.createElement("div");
                i.classList.add("fancybox-placeholder"), e.parentNode.insertBefore(i, e), t.placeholderEl = i;
            }
            this.instance.setContent(t, e);
        } else this.instance.setError(t, "{{ELEMENT_NOT_FOUND}}");
    }
    setIframeContent(t) {
        const { src: e, el: i } = t;
        if (!e || "string" != typeof e || !i) return;
        i.classList.add("is-loading");
        const n = this.instance, s = document.createElement("iframe");
        s.className = "fancybox__iframe", s.setAttribute("id", `fancybox__iframe_${n.id}_${t.index}`);
        for (const [e, i] of Object.entries(this.optionFor(t, "iframeAttr") || {}))s.setAttribute(e, i);
        s.onerror = ()=>{
            n.setError(t, "{{IFRAME_ERROR}}");
        }, t.iframeEl = s;
        const o = this.optionFor(t, "preload");
        if ("iframe" !== t.type || !1 === o) return s.setAttribute("src", t.src + ""), n.setContent(t, s, !1), this.resizeIframe(t), void n.revealContent(t);
        n.showLoading(t), s.onload = ()=>{
            if (!s.src.length) return;
            const e = "true" !== s.dataset.ready;
            s.dataset.ready = "true", this.resizeIframe(t), e ? n.revealContent(t) : n.hideLoading(t);
        }, s.setAttribute("src", e), n.setContent(t, s, !1);
    }
    resizeIframe(t) {
        const { type: e, iframeEl: i } = t;
        if (e === $e35dfd66294e81cf$var$Pt || e === $e35dfd66294e81cf$var$Ct) return;
        const n = null == i ? void 0 : i.parentElement;
        if (!i || !n) return;
        let s = t.autoSize;
        void 0 === s && (s = this.optionFor(t, "autoSize"));
        let o = t.width || 0, a = t.height || 0;
        o && a && (s = !1);
        const r = n && n.style;
        if (!1 !== t.preload && !1 !== s && r) try {
            const t = window.getComputedStyle(n), e = parseFloat(t.paddingLeft) + parseFloat(t.paddingRight), s = parseFloat(t.paddingTop) + parseFloat(t.paddingBottom), l = i.contentWindow;
            if (l) {
                const t = l.document, i = t.getElementsByTagName($e35dfd66294e81cf$var$xt)[0], n = t.body;
                r.width = "", n.style.overflow = "hidden", o = o || i.scrollWidth + e, r.width = `${o}px`, n.style.overflow = "", r.flex = "0 0 auto", r.height = `${n.scrollHeight}px`, a = i.scrollHeight + s;
            }
        } catch (t) {}
        if (o || a) {
            const t = {
                flex: "0 1 auto",
                width: "",
                height: ""
            };
            o && "auto" !== o && (t.width = `${o}px`), a && "auto" !== a && (t.height = `${a}px`), Object.assign(r, t);
        }
    }
    playVideo() {
        const t = this.instance.getSlide();
        if (!t) return;
        const { el: e } = t;
        if (!e || !e.offsetParent) return;
        if (!this.optionFor(t, "videoAutoplay")) return;
        if (t.type === $e35dfd66294e81cf$var$Tt) try {
            const t = e.querySelector("video");
            if (t) {
                const e = t.play();
                void 0 !== e && e.then(()=>{}).catch((e)=>{
                    t.muted = !0, t.play();
                });
            }
        } catch (t) {}
        if (t.type !== $e35dfd66294e81cf$var$Pt && t.type !== $e35dfd66294e81cf$var$Ct) return;
        const i = ()=>{
            if (t.iframeEl && t.iframeEl.contentWindow) {
                let e;
                if ("true" === t.iframeEl.dataset.ready) return e = t.type === $e35dfd66294e81cf$var$Pt ? {
                    event: "command",
                    func: "playVideo"
                } : {
                    method: "play",
                    value: "true"
                }, e && t.iframeEl.contentWindow.postMessage(JSON.stringify(e), "*"), void (t.poller = void 0);
                t.type === $e35dfd66294e81cf$var$Pt && (e = {
                    event: "listening",
                    id: t.iframeEl.getAttribute("id")
                }, t.iframeEl.contentWindow.postMessage(JSON.stringify(e), "*"));
            }
            t.poller = setTimeout(i, 250);
        };
        i();
    }
    processType(t) {
        if (t.html) return t.type = $e35dfd66294e81cf$var$xt, t.src = t.html, void (t.html = "");
        const e = this.instance.optionFor(t, "src", "");
        if (!e || "string" != typeof e) return;
        let i = t.type, n = null;
        if (n = e.match(/(youtube\.com|youtu\.be|youtube\-nocookie\.com)\/(?:watch\?(?:.*&)?v=|v\/|u\/|shorts\/|embed\/?)?(videoseries\?list=(?:.*)|[\w-]{11}|\?listType=(?:.*)&list=(?:.*))(?:.*)/i)) {
            const s = this.optionFor(t, $e35dfd66294e81cf$var$Pt), { nocookie: o } = s, a = function(t, e) {
                var i = {};
                for(var n in t)Object.prototype.hasOwnProperty.call(t, n) && e.indexOf(n) < 0 && (i[n] = t[n]);
                if (null != t && "function" == typeof Object.getOwnPropertySymbols) {
                    var s = 0;
                    for(n = Object.getOwnPropertySymbols(t); s < n.length; s++)e.indexOf(n[s]) < 0 && Object.prototype.propertyIsEnumerable.call(t, n[s]) && (i[n[s]] = t[n[s]]);
                }
                return i;
            }(s, [
                "nocookie"
            ]), r = `www.youtube${o ? "-nocookie" : ""}.com`, l = $e35dfd66294e81cf$var$Mt(e, a), c = encodeURIComponent(n[2]);
            t.videoId = c, t.src = `https://${r}/embed/${c}?${l}`, t.thumbSrc = t.thumbSrc || `https://i.ytimg.com/vi/${c}/mqdefault.jpg`, i = $e35dfd66294e81cf$var$Pt;
        } else if (n = e.match(/^.+vimeo.com\/(?:\/)?([\d]+)((\/|\?h=)([a-z0-9]+))?(.*)?/)) {
            const s = $e35dfd66294e81cf$var$Mt(e, this.optionFor(t, $e35dfd66294e81cf$var$Ct)), o = encodeURIComponent(n[1]), a = n[4] || "";
            t.videoId = o, t.src = `https://player.vimeo.com/video/${o}?${a ? `h=${a}${s ? "&" : ""}` : ""}${s}`, i = $e35dfd66294e81cf$var$Ct;
        }
        if (!i && t.triggerEl) {
            const e = t.triggerEl.dataset.type;
            $e35dfd66294e81cf$var$At.includes(e) && (i = e);
        }
        i || "string" == typeof e && ("#" === e.charAt(0) ? i = "inline" : (n = e.match(/\.(mp4|mov|ogv|webm)((\?|#).*)?$/i)) ? (i = $e35dfd66294e81cf$var$Tt, t.videoFormat = t.videoFormat || "video/" + ("ogv" === n[1] ? "ogg" : n[1])) : e.match(/(^data:image\/[a-z0-9+\/=]*,)|(\.(jp(e|g|eg)|gif|png|bmp|webp|svg|ico)((\?|#).*)?$)/i) ? i = $e35dfd66294e81cf$var$Et : e.match(/\.(pdf)((\?|#).*)?$/i) && (i = "pdf")), (n = e.match(/(?:maps\.)?google\.([a-z]{2,3}(?:\.[a-z]{2})?)\/(?:(?:(?:maps\/(?:place\/(?:.*)\/)?\@(.*),(\d+.?\d+?)z))|(?:\?ll=))(.*)?/i)) ? (t.src = `https://maps.google.${n[1]}/?ll=${(n[2] ? n[2] + "&z=" + Math.floor(parseFloat(n[3])) + (n[4] ? n[4].replace(/^\//, "&") : "") : n[4] + "").replace(/\?/, "&")}&output=${n[4] && n[4].indexOf("layer=c") > 0 ? "svembed" : "embed"}`, i = $e35dfd66294e81cf$var$St) : (n = e.match(/(?:maps\.)?google\.([a-z]{2,3}(?:\.[a-z]{2})?)\/(?:maps\/search\/)(.*)/i)) && (t.src = `https://maps.google.${n[1]}/maps?q=${n[2].replace("query=", "q=").replace("api=1", "")}&output=embed`, i = $e35dfd66294e81cf$var$St), i = i || this.instance.option("defaultType"), t.type = i, i === $e35dfd66294e81cf$var$Et && (t.thumbSrc = t.thumbSrc || t.src);
    }
    setContent(t) {
        const e = this.instance.optionFor(t, "src") || "";
        if (t && t.type && e) {
            switch(t.type){
                case $e35dfd66294e81cf$var$xt:
                    this.instance.setContent(t, e);
                    break;
                case $e35dfd66294e81cf$var$Tt:
                    const i = this.option("videoTpl");
                    i && this.instance.setContent(t, i.replace(/\{\{src\}\}/gi, e + "").replace(/\{\{format\}\}/gi, this.optionFor(t, "videoFormat") || "").replace(/\{\{poster\}\}/gi, t.poster || t.thumbSrc || ""));
                    break;
                case "inline":
                case "clone":
                    this.setInlineContent(t);
                    break;
                case "ajax":
                    this.loadAjaxContent(t);
                    break;
                case "pdf":
                case $e35dfd66294e81cf$var$St:
                case $e35dfd66294e81cf$var$Pt:
                case $e35dfd66294e81cf$var$Ct:
                    t.preload = !1;
                case "iframe":
                    this.setIframeContent(t);
            }
            this.setAspectRatio(t);
        }
    }
    setAspectRatio(t) {
        const e = t.contentEl;
        if (!(t.el && e && t.type && [
            $e35dfd66294e81cf$var$Pt,
            $e35dfd66294e81cf$var$Ct,
            $e35dfd66294e81cf$var$Tt
        ].includes(t.type))) return;
        let i, n = t.width || "auto", s = t.height || "auto";
        if ("auto" === n || "auto" === s) {
            i = this.optionFor(t, "videoRatio");
            const e = (i + "").match(/(\d+)\s*\/\s?(\d+)/);
            i = e && e.length > 2 ? parseFloat(e[1]) / parseFloat(e[2]) : parseFloat(i + "");
        } else n && s && (i = n / s);
        if (!i) return;
        e.style.aspectRatio = "", e.style.width = "", e.style.height = "", e.offsetHeight;
        const o = e.getBoundingClientRect(), a = o.width || 1, r = o.height || 1;
        e.style.aspectRatio = i + "", i < a / r ? (s = "auto" === s ? r : Math.min(r, s), e.style.width = "auto", e.style.height = `${s}px`) : (n = "auto" === n ? a : Math.min(a, n), e.style.width = `${n}px`, e.style.height = "auto");
    }
    attach() {
        const t = this, e = t.instance;
        e.on("Carousel.beforeInitSlide", t.onBeforeInitSlide), e.on("Carousel.createSlide", t.onCreateSlide), e.on("Carousel.selectSlide", t.onSelectSlide), e.on("Carousel.unselectSlide", t.onUnselectSlide), e.on("Carousel.Panzoom.refresh", t.onRefresh), e.on("done", t.onDone), e.on("clearContent", t.onClearContent), window.addEventListener("message", t.onMessage);
    }
    detach() {
        const t = this, e = t.instance;
        e.off("Carousel.beforeInitSlide", t.onBeforeInitSlide), e.off("Carousel.createSlide", t.onCreateSlide), e.off("Carousel.selectSlide", t.onSelectSlide), e.off("Carousel.unselectSlide", t.onUnselectSlide), e.off("Carousel.Panzoom.refresh", t.onRefresh), e.off("done", t.onDone), e.off("clearContent", t.onClearContent), window.removeEventListener("message", t.onMessage);
    }
}
Object.defineProperty($e35dfd66294e81cf$var$Lt, "defaults", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: $e35dfd66294e81cf$var$Ot
});
const $e35dfd66294e81cf$var$zt = "play", $e35dfd66294e81cf$var$Rt = "pause", $e35dfd66294e81cf$var$kt = "ready";
class $e35dfd66294e81cf$var$It extends $e35dfd66294e81cf$var$_ {
    constructor(){
        super(...arguments), Object.defineProperty(this, "state", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: $e35dfd66294e81cf$var$kt
        }), Object.defineProperty(this, "inHover", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: !1
        }), Object.defineProperty(this, "timer", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "progressBar", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        });
    }
    get isActive() {
        return this.state !== $e35dfd66294e81cf$var$kt;
    }
    onReady(t) {
        this.option("autoStart") && (t.isInfinite || t.page < t.pages.length - 1) && this.start();
    }
    onChange() {
        this.removeProgressBar(), this.pause();
    }
    onSettle() {
        this.resume();
    }
    onVisibilityChange() {
        "visible" === document.visibilityState ? this.resume() : this.pause();
    }
    onMouseEnter() {
        this.inHover = !0, this.pause();
    }
    onMouseLeave() {
        var t;
        this.inHover = !1, (null === (t = this.instance.panzoom) || void 0 === t ? void 0 : t.isResting) && this.resume();
    }
    onTimerEnd() {
        const t = this.instance;
        "play" === this.state && (t.isInfinite || t.page !== t.pages.length - 1 ? t.slideNext() : t.slideTo(0));
    }
    removeProgressBar() {
        this.progressBar && (this.progressBar.remove(), this.progressBar = null);
    }
    createProgressBar() {
        var t;
        if (!this.option("showProgress")) return null;
        this.removeProgressBar();
        const e = this.instance, i = (null === (t = e.pages[e.page]) || void 0 === t ? void 0 : t.slides) || [];
        let n = this.option("progressParentEl");
        if (n || (n = (1 === i.length ? i[0].el : null) || e.viewport), !n) return null;
        const s = document.createElement("div");
        return $e35dfd66294e81cf$var$P(s, "f-progress"), n.prepend(s), this.progressBar = s, s.offsetHeight, s;
    }
    set() {
        const t = this, e = t.instance;
        if (e.pages.length < 2) return;
        if (t.timer) return;
        const i = t.option("timeout");
        t.state = $e35dfd66294e81cf$var$zt, $e35dfd66294e81cf$var$P(e.container, "has-autoplay");
        let n = t.createProgressBar();
        n && (n.style.transitionDuration = `${i}ms`, n.style.transform = "scaleX(1)"), t.timer = setTimeout(()=>{
            t.timer = null, t.inHover || t.onTimerEnd();
        }, i), t.emit("set");
    }
    clear() {
        const t = this;
        t.timer && (clearTimeout(t.timer), t.timer = null), t.removeProgressBar();
    }
    start() {
        const t = this;
        if (t.set(), t.state !== $e35dfd66294e81cf$var$kt) {
            if (t.option("pauseOnHover")) {
                const e = t.instance.container;
                e.addEventListener("mouseenter", t.onMouseEnter, !1), e.addEventListener("mouseleave", t.onMouseLeave, !1);
            }
            document.addEventListener("visibilitychange", t.onVisibilityChange, !1), t.emit("start");
        }
    }
    stop() {
        const t = this, e = t.state, i = t.instance.container;
        t.clear(), t.state = $e35dfd66294e81cf$var$kt, i.removeEventListener("mouseenter", t.onMouseEnter, !1), i.removeEventListener("mouseleave", t.onMouseLeave, !1), document.removeEventListener("visibilitychange", t.onVisibilityChange, !1), $e35dfd66294e81cf$var$S(i, "has-autoplay"), e !== $e35dfd66294e81cf$var$kt && t.emit("stop");
    }
    pause() {
        const t = this;
        t.state === $e35dfd66294e81cf$var$zt && (t.state = $e35dfd66294e81cf$var$Rt, t.clear(), t.emit($e35dfd66294e81cf$var$Rt));
    }
    resume() {
        const t = this, e = t.instance;
        if (e.isInfinite || e.page !== e.pages.length - 1) {
            if (t.state !== $e35dfd66294e81cf$var$zt) {
                if (t.state === $e35dfd66294e81cf$var$Rt && !t.inHover) {
                    const e = new Event("resume", {
                        bubbles: !0,
                        cancelable: !0
                    });
                    t.emit("resume", e), e.defaultPrevented || t.set();
                }
            } else t.set();
        } else t.stop();
    }
    toggle() {
        this.state === $e35dfd66294e81cf$var$zt || this.state === $e35dfd66294e81cf$var$Rt ? this.stop() : this.start();
    }
    attach() {
        const t = this, e = t.instance;
        e.on("ready", t.onReady), e.on("Panzoom.startAnimation", t.onChange), e.on("Panzoom.endAnimation", t.onSettle), e.on("Panzoom.touchMove", t.onChange);
    }
    detach() {
        const t = this, e = t.instance;
        e.off("ready", t.onReady), e.off("Panzoom.startAnimation", t.onChange), e.off("Panzoom.endAnimation", t.onSettle), e.off("Panzoom.touchMove", t.onChange), t.stop();
    }
}
Object.defineProperty($e35dfd66294e81cf$var$It, "defaults", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: {
        autoStart: !0,
        pauseOnHover: !0,
        progressParentEl: null,
        showProgress: !0,
        timeout: 3e3
    }
});
class $e35dfd66294e81cf$var$Dt extends $e35dfd66294e81cf$var$_ {
    constructor(){
        super(...arguments), Object.defineProperty(this, "ref", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        });
    }
    onPrepare(t) {
        const e = t.carousel;
        if (!e) return;
        const i = t.container;
        i && (e.options.Autoplay = $e35dfd66294e81cf$var$u({
            autoStart: !1
        }, this.option("Autoplay") || {}, {
            pauseOnHover: !1,
            timeout: this.option("timeout"),
            progressParentEl: ()=>this.option("progressParentEl") || null,
            on: {
                start: ()=>{
                    t.emit("startSlideshow");
                },
                set: (e)=>{
                    var n;
                    i.classList.add("has-slideshow"), (null === (n = t.getSlide()) || void 0 === n ? void 0 : n.state) !== $e35dfd66294e81cf$var$lt.Ready && e.pause();
                },
                stop: ()=>{
                    i.classList.remove("has-slideshow"), t.isCompact || t.endIdle(), t.emit("endSlideshow");
                },
                resume: (e, i)=>{
                    var n, s, o;
                    !i || !i.cancelable || (null === (n = t.getSlide()) || void 0 === n ? void 0 : n.state) === $e35dfd66294e81cf$var$lt.Ready && (null === (o = null === (s = t.carousel) || void 0 === s ? void 0 : s.panzoom) || void 0 === o ? void 0 : o.isResting) || i.preventDefault();
                }
            }
        }), e.attachPlugins({
            Autoplay: $e35dfd66294e81cf$var$It
        }), this.ref = e.plugins.Autoplay);
    }
    onReady(t) {
        const e = t.carousel, i = this.ref;
        i && e && this.option("playOnStart") && (e.isInfinite || e.page < e.pages.length - 1) && i.start();
    }
    onDone(t, e) {
        const i = this.ref, n = t.carousel;
        if (!i || !n) return;
        const s = e.panzoom;
        s && s.on("startAnimation", ()=>{
            t.isCurrentSlide(e) && i.stop();
        }), t.isCurrentSlide(e) && i.resume();
    }
    onKeydown(t, e) {
        var i;
        const n = this.ref;
        n && e === this.option("key") && "BUTTON" !== (null === (i = document.activeElement) || void 0 === i ? void 0 : i.nodeName) && n.toggle();
    }
    attach() {
        const t = this, e = t.instance;
        e.on("Carousel.init", t.onPrepare), e.on("Carousel.ready", t.onReady), e.on("done", t.onDone), e.on("keydown", t.onKeydown);
    }
    detach() {
        const t = this, e = t.instance;
        e.off("Carousel.init", t.onPrepare), e.off("Carousel.ready", t.onReady), e.off("done", t.onDone), e.off("keydown", t.onKeydown);
    }
}
Object.defineProperty($e35dfd66294e81cf$var$Dt, "defaults", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: {
        key: " ",
        playOnStart: !1,
        progressParentEl: (t)=>{
            var e;
            return (null === (e = t.instance.container) || void 0 === e ? void 0 : e.querySelector(".fancybox__toolbar [data-fancybox-toggle-slideshow]")) || t.instance.container;
        },
        timeout: 3e3
    }
});
const $e35dfd66294e81cf$var$Ft = {
    classes: {
        container: "f-thumbs f-carousel__thumbs",
        viewport: "f-thumbs__viewport",
        track: "f-thumbs__track",
        slide: "f-thumbs__slide",
        isResting: "is-resting",
        isSelected: "is-selected",
        isLoading: "is-loading",
        hasThumbs: "has-thumbs"
    },
    minCount: 2,
    parentEl: null,
    thumbTpl: '<button class="f-thumbs__slide__button" tabindex="0" type="button" aria-label="{{GOTO}}" data-carousel-index="%i"><img class="f-thumbs__slide__img" data-lazy-src="{{%s}}" alt="" /></button>',
    type: "modern"
};
var $e35dfd66294e81cf$var$jt;
!function(t) {
    t[t.Init = 0] = "Init", t[t.Ready = 1] = "Ready", t[t.Hidden = 2] = "Hidden";
}($e35dfd66294e81cf$var$jt || ($e35dfd66294e81cf$var$jt = {}));
const $e35dfd66294e81cf$var$Bt = "isResting", $e35dfd66294e81cf$var$Ht = "thumbWidth", $e35dfd66294e81cf$var$Nt = "thumbHeight", $e35dfd66294e81cf$var$_t = "thumbClipWidth";
let $e35dfd66294e81cf$var$$t = class extends $e35dfd66294e81cf$var$_ {
    constructor(){
        super(...arguments), Object.defineProperty(this, "type", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: "modern"
        }), Object.defineProperty(this, "container", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "track", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "carousel", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "thumbWidth", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: 0
        }), Object.defineProperty(this, "thumbClipWidth", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: 0
        }), Object.defineProperty(this, "thumbHeight", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: 0
        }), Object.defineProperty(this, "thumbGap", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: 0
        }), Object.defineProperty(this, "thumbExtraGap", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: 0
        }), Object.defineProperty(this, "state", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: $e35dfd66294e81cf$var$jt.Init
        });
    }
    get isModern() {
        return "modern" === this.type;
    }
    onInitSlide(t, e) {
        const i = e.el ? e.el.dataset : void 0;
        i && (e.thumbSrc = i.thumbSrc || e.thumbSrc || "", e[$e35dfd66294e81cf$var$_t] = parseFloat(i[$e35dfd66294e81cf$var$_t] || "") || e[$e35dfd66294e81cf$var$_t] || 0, e[$e35dfd66294e81cf$var$Nt] = parseFloat(i.thumbHeight || "") || e[$e35dfd66294e81cf$var$Nt] || 0), this.addSlide(e);
    }
    onInitSlides() {
        this.build();
    }
    onChange() {
        var t;
        if (!this.isModern) return;
        const e = this.container, i = this.instance, n = i.panzoom, s = this.carousel, a = s ? s.panzoom : null, r = i.page;
        if (n && s && a) {
            if (n.isDragging) {
                $e35dfd66294e81cf$var$S(e, this.cn($e35dfd66294e81cf$var$Bt));
                let n = (null === (t = s.pages[r]) || void 0 === t ? void 0 : t.pos) || 0;
                n += i.getProgress(r) * (this[$e35dfd66294e81cf$var$_t] + this.thumbGap);
                let o = a.getBounds();
                -1 * n > o.x.min && -1 * n < o.x.max && a.panTo({
                    x: -1 * n,
                    friction: .12
                });
            } else $e35dfd66294e81cf$var$o(e, this.cn($e35dfd66294e81cf$var$Bt), n.isResting);
            this.shiftModern();
        }
    }
    onRefresh() {
        this.updateProps();
        for (const t of this.instance.slides || [])this.resizeModernSlide(t);
        this.shiftModern();
    }
    isDisabled() {
        const t = this.option("minCount") || 0;
        if (t) {
            const e = this.instance;
            let i = 0;
            for (const t of e.slides || [])t.thumbSrc && i++;
            if (i < t) return !0;
        }
        const e = this.option("type");
        return [
            "modern",
            "classic"
        ].indexOf(e) < 0;
    }
    getThumb(t) {
        const e = this.option("thumbTpl") || "";
        return {
            html: this.instance.localize(e, [
                [
                    "%i",
                    t.index
                ],
                [
                    "%d",
                    t.index + 1
                ],
                [
                    "%s",
                    t.thumbSrc || "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"
                ]
            ])
        };
    }
    addSlide(t) {
        const e = this.carousel;
        e && e.addSlide(t.index, this.getThumb(t));
    }
    getSlides() {
        const t = [];
        for (const e of this.instance.slides || [])t.push(this.getThumb(e));
        return t;
    }
    resizeModernSlide(t) {
        this.isModern && (t[$e35dfd66294e81cf$var$Ht] = t[$e35dfd66294e81cf$var$_t] && t[$e35dfd66294e81cf$var$Nt] ? Math.round(this[$e35dfd66294e81cf$var$Nt] * (t[$e35dfd66294e81cf$var$_t] / t[$e35dfd66294e81cf$var$Nt])) : this[$e35dfd66294e81cf$var$Ht]);
    }
    updateProps() {
        const t = this.container;
        if (!t) return;
        const e = (e)=>parseFloat(getComputedStyle(t).getPropertyValue("--f-thumb-" + e)) || 0;
        this.thumbGap = e("gap"), this.thumbExtraGap = e("extra-gap"), this[$e35dfd66294e81cf$var$Ht] = e("width") || 40, this[$e35dfd66294e81cf$var$_t] = e("clip-width") || 40, this[$e35dfd66294e81cf$var$Nt] = e("height") || 40;
    }
    build() {
        const t = this;
        if (t.state !== $e35dfd66294e81cf$var$jt.Init) return;
        if (t.isDisabled()) return void t.emit("disabled");
        const e = t.instance, i = e.container, n = t.getSlides(), s = t.option("type");
        t.type = s;
        const o = t.option("parentEl"), a = t.cn("container"), r = t.cn("track");
        let l = null == o ? void 0 : o.querySelector("." + a);
        l || (l = document.createElement("div"), $e35dfd66294e81cf$var$P(l, a), o ? o.appendChild(l) : i.after(l)), $e35dfd66294e81cf$var$P(l, `is-${s}`), $e35dfd66294e81cf$var$P(i, t.cn("hasThumbs")), t.container = l, t.updateProps();
        let c = l.querySelector("." + r);
        c || (c = document.createElement("div"), $e35dfd66294e81cf$var$P(c, t.cn("track")), l.appendChild(c)), t.track = c;
        const h = $e35dfd66294e81cf$var$u({}, {
            track: c,
            infinite: !1,
            center: !0,
            fill: "classic" === s,
            dragFree: !0,
            slidesPerPage: 1,
            transition: !1,
            preload: .25,
            friction: .12,
            Panzoom: {
                maxVelocity: 0
            },
            Dots: !1,
            Navigation: !1,
            classes: {
                container: "f-thumbs",
                viewport: "f-thumbs__viewport",
                track: "f-thumbs__track",
                slide: "f-thumbs__slide"
            }
        }, t.option("Carousel") || {}, {
            Sync: {
                target: e
            },
            slides: n
        }), d = new e.constructor(l, h);
        d.on("createSlide", (e, i)=>{
            t.setProps(i.index), t.emit("createSlide", i, i.el);
        }), d.on("ready", ()=>{
            t.shiftModern(), t.emit("ready");
        }), d.on("refresh", ()=>{
            t.shiftModern();
        }), d.on("Panzoom.click", (e, i, n)=>{
            t.onClick(n);
        }), t.carousel = d, t.state = $e35dfd66294e81cf$var$jt.Ready;
    }
    onClick(t) {
        t.preventDefault(), t.stopPropagation();
        const e = this.instance, { pages: i, page: n } = e, s = (t)=>{
            if (t) {
                const e = t.closest("[data-carousel-index]");
                if (e) return [
                    parseInt(e.dataset.carouselIndex || "", 10) || 0,
                    e
                ];
            }
            return [
                -1,
                void 0
            ];
        }, o = (t, e)=>{
            const i = document.elementFromPoint(t, e);
            return i ? s(i) : [
                -1,
                void 0
            ];
        };
        let [a, r] = s(t.target);
        if (a > -1) return;
        const l = this[$e35dfd66294e81cf$var$_t], c = t.clientX, h = t.clientY;
        let [d, u] = o(c - l, h), [p, f] = o(c + l, h);
        u && f ? (a = Math.abs(c - u.getBoundingClientRect().right) < Math.abs(c - f.getBoundingClientRect().left) ? d : p, a === n && (a = a === d ? p : d)) : u ? a = d : f && (a = p), a > -1 && i[a] && e.slideTo(a);
    }
    getShift(t) {
        var e;
        const i = this, { instance: n } = i, s = i.carousel;
        if (!n || !s) return 0;
        const o = i[$e35dfd66294e81cf$var$Ht], a = i[$e35dfd66294e81cf$var$_t], r = i.thumbGap, l = i.thumbExtraGap;
        if (!(null === (e = s.slides[t]) || void 0 === e ? void 0 : e.el)) return 0;
        const c = .5 * (o - a), h = n.pages.length - 1;
        let d = n.getProgress(0), u = n.getProgress(h), p = n.getProgress(t, !1, !0), f = 0, g = c + l + r;
        const m = d < 0 && d > -1, v = u > 0 && u < 1;
        return 0 === t ? (f = g * Math.abs(d), v && 1 === d && (f -= g * Math.abs(u))) : t === h ? (f = g * Math.abs(u) * -1, m && -1 === u && (f += g * Math.abs(d))) : m || v ? (f = -1 * g, f += g * Math.abs(d), f += g * (1 - Math.abs(u))) : f = g * p, f;
    }
    setProps(e) {
        var i;
        const n = this;
        if (!n.isModern) return;
        const { instance: s } = n, o = n.carousel;
        if (s && o) {
            const a = null === (i = o.slides[e]) || void 0 === i ? void 0 : i.el;
            if (a && a.childNodes.length) {
                let i = $e35dfd66294e81cf$var$t(1 - Math.abs(s.getProgress(e))), o = $e35dfd66294e81cf$var$t(n.getShift(e));
                a.style.setProperty("--progress", i ? i + "" : ""), a.style.setProperty("--shift", o + "");
            }
        }
    }
    shiftModern() {
        const t = this;
        if (!t.isModern) return;
        const { instance: e, track: i } = t, n = e.panzoom, s = t.carousel;
        if (!(e && i && n && s)) return;
        if (n.state === $e35dfd66294e81cf$var$m.Init || n.state === $e35dfd66294e81cf$var$m.Destroy) return;
        for (const i of e.slides)t.setProps(i.index);
        let o = (t[$e35dfd66294e81cf$var$_t] + t.thumbGap) * (s.slides.length || 0);
        i.style.setProperty("--width", o + "");
    }
    cleanup() {
        const t = this;
        t.carousel && t.carousel.destroy(), t.carousel = null, t.container && t.container.remove(), t.container = null, t.track && t.track.remove(), t.track = null, t.state = $e35dfd66294e81cf$var$jt.Init, $e35dfd66294e81cf$var$S(t.instance.container, t.cn("hasThumbs"));
    }
    attach() {
        const t = this, e = t.instance;
        e.on("initSlide", t.onInitSlide), e.state === $e35dfd66294e81cf$var$B.Init ? e.on("initSlides", t.onInitSlides) : t.onInitSlides(), e.on([
            "change",
            "Panzoom.afterTransform"
        ], t.onChange), e.on("Panzoom.refresh", t.onRefresh);
    }
    detach() {
        const t = this, e = t.instance;
        e.off("initSlide", t.onInitSlide), e.off("initSlides", t.onInitSlides), e.off([
            "change",
            "Panzoom.afterTransform"
        ], t.onChange), e.off("Panzoom.refresh", t.onRefresh), t.cleanup();
    }
};
Object.defineProperty($e35dfd66294e81cf$var$$t, "defaults", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: $e35dfd66294e81cf$var$Ft
});
const $e35dfd66294e81cf$var$Wt = Object.assign(Object.assign({}, $e35dfd66294e81cf$var$Ft), {
    key: "t",
    showOnStart: !0,
    parentEl: null
}), $e35dfd66294e81cf$var$Xt = "is-masked", $e35dfd66294e81cf$var$qt = "aria-hidden";
class $e35dfd66294e81cf$var$Yt extends $e35dfd66294e81cf$var$_ {
    constructor(){
        super(...arguments), Object.defineProperty(this, "ref", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "hidden", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: !1
        });
    }
    get isEnabled() {
        const t = this.ref;
        return t && !t.isDisabled();
    }
    get isHidden() {
        return this.hidden;
    }
    onClick(t, e) {
        e.stopPropagation();
    }
    onCreateSlide(t, e) {
        var i, n, s;
        const o = (null === (s = null === (n = null === (i = this.instance) || void 0 === i ? void 0 : i.carousel) || void 0 === n ? void 0 : n.slides[e.index]) || void 0 === s ? void 0 : s.type) || "", a = e.el;
        if (a && o) {
            let t = `for-${o}`;
            [
                "video",
                "youtube",
                "vimeo",
                "html5video"
            ].includes(o) && (t += " for-video"), $e35dfd66294e81cf$var$P(a, t);
        }
    }
    onInit() {
        var t;
        const e = this, i = e.instance, n = i.carousel;
        if (e.ref || !n) return;
        const s = e.option("parentEl") || i.footer || i.container;
        if (!s) return;
        const o = $e35dfd66294e81cf$var$u({}, e.options, {
            parentEl: s,
            classes: {
                container: "f-thumbs fancybox__thumbs"
            },
            Carousel: {
                Sync: {
                    friction: i.option("Carousel.friction") || 0
                }
            },
            on: {
                ready: (t)=>{
                    const i = t.container;
                    i && this.hidden && (e.refresh(), i.style.transition = "none", e.hide(), i.offsetHeight, queueMicrotask(()=>{
                        i.style.transition = "", e.show();
                    }));
                }
            }
        });
        o.Carousel = o.Carousel || {}, o.Carousel.on = $e35dfd66294e81cf$var$u((null === (t = e.options.Carousel) || void 0 === t ? void 0 : t.on) || {}, {
            click: this.onClick,
            createSlide: this.onCreateSlide
        }), n.options.Thumbs = o, n.attachPlugins({
            Thumbs: $e35dfd66294e81cf$var$$t
        }), e.ref = n.plugins.Thumbs, e.option("showOnStart") || (e.ref.state = $e35dfd66294e81cf$var$jt.Hidden, e.hidden = !0);
    }
    onResize() {
        var t;
        const e = null === (t = this.ref) || void 0 === t ? void 0 : t.container;
        e && (e.style.maxHeight = "");
    }
    onKeydown(t, e) {
        const i = this.option("key");
        i && i === e && this.toggle();
    }
    toggle() {
        const t = this.ref;
        if (t && !t.isDisabled()) return t.state === $e35dfd66294e81cf$var$jt.Hidden ? (t.state = $e35dfd66294e81cf$var$jt.Init, void t.build()) : void (this.hidden ? this.show() : this.hide());
    }
    show() {
        const t = this.ref;
        if (!t || t.isDisabled()) return;
        const e = t.container;
        e && (this.refresh(), e.offsetHeight, e.removeAttribute($e35dfd66294e81cf$var$qt), e.classList.remove($e35dfd66294e81cf$var$Xt), this.hidden = !1);
    }
    hide() {
        const t = this.ref, e = t && t.container;
        e && (this.refresh(), e.offsetHeight, e.classList.add($e35dfd66294e81cf$var$Xt), e.setAttribute($e35dfd66294e81cf$var$qt, "true")), this.hidden = !0;
    }
    refresh() {
        const t = this.ref;
        if (!t || !t.state) return;
        const e = t.container, i = (null == e ? void 0 : e.firstChild) || null;
        e && i && i.childNodes.length && (e.style.maxHeight = `${i.getBoundingClientRect().height}px`);
    }
    attach() {
        const t = this, e = t.instance;
        e.state === $e35dfd66294e81cf$var$rt.Init ? e.on("Carousel.init", t.onInit) : t.onInit(), e.on("resize", t.onResize), e.on("keydown", t.onKeydown);
    }
    detach() {
        var t;
        const e = this, i = e.instance;
        i.off("Carousel.init", e.onInit), i.off("resize", e.onResize), i.off("keydown", e.onKeydown), null === (t = i.carousel) || void 0 === t || t.detachPlugins([
            "Thumbs"
        ]), e.ref = null;
    }
}
Object.defineProperty($e35dfd66294e81cf$var$Yt, "defaults", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: $e35dfd66294e81cf$var$Wt
});
const $e35dfd66294e81cf$var$Vt = {
    panLeft: {
        icon: '<svg><path d="M5 12h14M5 12l6 6M5 12l6-6"/></svg>',
        change: {
            panX: -100
        }
    },
    panRight: {
        icon: '<svg><path d="M5 12h14M13 18l6-6M13 6l6 6"/></svg>',
        change: {
            panX: 100
        }
    },
    panUp: {
        icon: '<svg><path d="M12 5v14M18 11l-6-6M6 11l6-6"/></svg>',
        change: {
            panY: -100
        }
    },
    panDown: {
        icon: '<svg><path d="M12 5v14M18 13l-6 6M6 13l6 6"/></svg>',
        change: {
            panY: 100
        }
    },
    zoomIn: {
        icon: '<svg><circle cx="11" cy="11" r="7.5"/><path d="m21 21-4.35-4.35M11 8v6M8 11h6"/></svg>',
        action: "zoomIn"
    },
    zoomOut: {
        icon: '<svg><circle cx="11" cy="11" r="7.5"/><path d="m21 21-4.35-4.35M8 11h6"/></svg>',
        action: "zoomOut"
    },
    toggle1to1: {
        icon: '<svg><path d="M3.51 3.07c5.74.02 11.48-.02 17.22.02 1.37.1 2.34 1.64 2.18 3.13 0 4.08.02 8.16 0 12.23-.1 1.54-1.47 2.64-2.79 2.46-5.61-.01-11.24.02-16.86-.01-1.36-.12-2.33-1.65-2.17-3.14 0-4.07-.02-8.16 0-12.23.1-1.36 1.22-2.48 2.42-2.46Z"/><path d="M5.65 8.54h1.49v6.92m8.94-6.92h1.49v6.92M11.5 9.4v.02m0 5.18v0"/></svg>',
        action: "toggleZoom"
    },
    toggleZoom: {
        icon: '<svg><g><line x1="11" y1="8" x2="11" y2="14"></line></g><circle cx="11" cy="11" r="7.5"/><path d="m21 21-4.35-4.35M8 11h6"/></svg>',
        action: "toggleZoom"
    },
    iterateZoom: {
        icon: '<svg><g><line x1="11" y1="8" x2="11" y2="14"></line></g><circle cx="11" cy="11" r="7.5"/><path d="m21 21-4.35-4.35M8 11h6"/></svg>',
        action: "iterateZoom"
    },
    rotateCCW: {
        icon: '<svg><path d="M15 4.55a8 8 0 0 0-6 14.9M9 15v5H4M18.37 7.16v.01M13 19.94v.01M16.84 18.37v.01M19.37 15.1v.01M19.94 11v.01"/></svg>',
        action: "rotateCCW"
    },
    rotateCW: {
        icon: '<svg><path d="M9 4.55a8 8 0 0 1 6 14.9M15 15v5h5M5.63 7.16v.01M4.06 11v.01M4.63 15.1v.01M7.16 18.37v.01M11 19.94v.01"/></svg>',
        action: "rotateCW"
    },
    flipX: {
        icon: '<svg style="stroke-width: 1.3"><path d="M12 3v18M16 7v10h5L16 7M8 7v10H3L8 7"/></svg>',
        action: "flipX"
    },
    flipY: {
        icon: '<svg style="stroke-width: 1.3"><path d="M3 12h18M7 16h10L7 21v-5M7 8h10L7 3v5"/></svg>',
        action: "flipY"
    },
    fitX: {
        icon: '<svg><path d="M4 12V6a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v6M10 18H3M21 18h-7M6 15l-3 3 3 3M18 15l3 3-3 3"/></svg>',
        action: "fitX"
    },
    fitY: {
        icon: '<svg><path d="M12 20H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h6M18 14v7M18 3v7M15 18l3 3 3-3M15 6l3-3 3 3"/></svg>',
        action: "fitY"
    },
    reset: {
        icon: '<svg><path d="M20 11A8.1 8.1 0 0 0 4.5 9M4 5v4h4M4 13a8.1 8.1 0 0 0 15.5 2m.5 4v-4h-4"/></svg>',
        action: "reset"
    },
    toggleFS: {
        icon: '<svg><g><path d="M14.5 9.5 21 3m0 0h-6m6 0v6M3 21l6.5-6.5M3 21v-6m0 6h6"/></g><g><path d="m14 10 7-7m-7 7h6m-6 0V4M3 21l7-7m0 0v6m0-6H4"/></g></svg>',
        action: "toggleFS"
    }
};
var $e35dfd66294e81cf$var$Zt;
!function(t) {
    t[t.Init = 0] = "Init", t[t.Ready = 1] = "Ready", t[t.Disabled = 2] = "Disabled";
}($e35dfd66294e81cf$var$Zt || ($e35dfd66294e81cf$var$Zt = {}));
const $e35dfd66294e81cf$var$Ut = {
    absolute: "auto",
    display: {
        left: [
            "infobar"
        ],
        middle: [],
        right: [
            "iterateZoom",
            "slideshow",
            "fullscreen",
            "thumbs",
            "close"
        ]
    },
    enabled: "auto",
    items: {
        infobar: {
            tpl: '<div class="fancybox__infobar" tabindex="-1"><span data-fancybox-current-index></span>/<span data-fancybox-count></span></div>'
        },
        download: {
            tpl: '<a class="f-button" title="{{DOWNLOAD}}" data-fancybox-download href="javasript:;"><svg><path d="M4 17v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-2M7 11l5 5 5-5M12 4v12"/></svg></a>'
        },
        prev: {
            tpl: '<button class="f-button" title="{{PREV}}" data-fancybox-prev><svg><path d="m15 6-6 6 6 6"/></svg></button>'
        },
        next: {
            tpl: '<button class="f-button" title="{{NEXT}}" data-fancybox-next><svg><path d="m9 6 6 6-6 6"/></svg></button>'
        },
        slideshow: {
            tpl: '<button class="f-button" title="{{TOGGLE_SLIDESHOW}}" data-fancybox-toggle-slideshow><svg><g><path d="M8 4v16l13 -8z"></path></g><g><path d="M8 4v15M17 4v15"/></g></svg></button>'
        },
        fullscreen: {
            tpl: '<button class="f-button" title="{{TOGGLE_FULLSCREEN}}" data-fancybox-toggle-fullscreen><svg><g><path d="M4 8V6a2 2 0 0 1 2-2h2M4 16v2a2 2 0 0 0 2 2h2M16 4h2a2 2 0 0 1 2 2v2M16 20h2a2 2 0 0 0 2-2v-2"/></g><g><path d="M15 19v-2a2 2 0 0 1 2-2h2M15 5v2a2 2 0 0 0 2 2h2M5 15h2a2 2 0 0 1 2 2v2M5 9h2a2 2 0 0 0 2-2V5"/></g></svg></button>'
        },
        thumbs: {
            tpl: '<button class="f-button" title="{{TOGGLE_THUMBS}}" data-fancybox-toggle-thumbs><svg><circle cx="5.5" cy="5.5" r="1"/><circle cx="12" cy="5.5" r="1"/><circle cx="18.5" cy="5.5" r="1"/><circle cx="5.5" cy="12" r="1"/><circle cx="12" cy="12" r="1"/><circle cx="18.5" cy="12" r="1"/><circle cx="5.5" cy="18.5" r="1"/><circle cx="12" cy="18.5" r="1"/><circle cx="18.5" cy="18.5" r="1"/></svg></button>'
        },
        close: {
            tpl: '<button class="f-button" title="{{CLOSE}}" data-fancybox-close><svg><path d="m19.5 4.5-15 15M4.5 4.5l15 15"/></svg></button>'
        }
    },
    parentEl: null
}, $e35dfd66294e81cf$var$Gt = {
    tabindex: "-1",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
}, $e35dfd66294e81cf$var$Kt = "has-toolbar", $e35dfd66294e81cf$var$Jt = "fancybox__toolbar";
class $e35dfd66294e81cf$var$Qt extends $e35dfd66294e81cf$var$_ {
    constructor(){
        super(...arguments), Object.defineProperty(this, "state", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: $e35dfd66294e81cf$var$Zt.Init
        }), Object.defineProperty(this, "container", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        });
    }
    onReady(t) {
        var e;
        if (!t.carousel) return;
        let i = this.option("display"), n = this.option("absolute"), s = this.option("enabled");
        if ("auto" === s) {
            const t = this.instance.carousel;
            let e = 0;
            if (t) for (const i of t.slides)(i.panzoom || "image" === i.type) && e++;
            e || (s = !1);
        }
        s || (i = void 0);
        let o = 0;
        const a = {
            left: [],
            middle: [],
            right: []
        };
        if (i) for (const t of [
            "left",
            "middle",
            "right"
        ])for (const n of i[t]){
            const i = this.createEl(n);
            i && (null === (e = a[t]) || void 0 === e || e.push(i), o++);
        }
        let r = null;
        if (o && (r = this.createContainer()), r) {
            for (const [t, e] of Object.entries(a)){
                const i = document.createElement("div");
                $e35dfd66294e81cf$var$P(i, $e35dfd66294e81cf$var$Jt + "__column is-" + t);
                for (const t of e)i.appendChild(t);
                "auto" !== n || "middle" !== t || e.length || (n = !0), r.appendChild(i);
            }
            !0 === n && $e35dfd66294e81cf$var$P(r, "is-absolute"), this.state = $e35dfd66294e81cf$var$Zt.Ready, this.onRefresh();
        } else this.state = $e35dfd66294e81cf$var$Zt.Disabled;
    }
    onClick(t) {
        var e, i;
        const n = this.instance, s = n.getSlide(), o = null == s ? void 0 : s.panzoom, a = t.target, r = a && $e35dfd66294e81cf$var$E(a) ? a.dataset : null;
        if (!r) return;
        if (void 0 !== r.fancyboxToggleThumbs) return t.preventDefault(), t.stopPropagation(), void (null === (e = n.plugins.Thumbs) || void 0 === e || e.toggle());
        if (void 0 !== r.fancyboxToggleFullscreen) return t.preventDefault(), t.stopPropagation(), void this.instance.toggleFullscreen();
        if (void 0 !== r.fancyboxToggleSlideshow) {
            t.preventDefault(), t.stopPropagation();
            const e = null === (i = n.carousel) || void 0 === i ? void 0 : i.plugins.Autoplay;
            let s = e.isActive;
            return o && "mousemove" === o.panMode && !s && o.reset(), void (s ? e.stop() : e.start());
        }
        const l = r.panzoomAction, c = r.panzoomChange;
        if ((c || l) && (t.preventDefault(), t.stopPropagation()), c) {
            let t = {};
            try {
                t = JSON.parse(c);
            } catch (t) {}
            o && o.applyChange(t);
        } else l && o && o[l] && o[l]();
    }
    onChange() {
        this.onRefresh();
    }
    onRefresh() {
        if (this.instance.isClosing()) return;
        const t = this.container;
        if (!t) return;
        const e = this.instance.getSlide();
        if (!e || e.state !== $e35dfd66294e81cf$var$lt.Ready) return;
        const i = e && !e.error && e.panzoom;
        for (const e of t.querySelectorAll("[data-panzoom-action]"))i ? (e.removeAttribute("disabled"), e.removeAttribute("tabindex")) : (e.setAttribute("disabled", ""), e.setAttribute("tabindex", "-1"));
        let n = i && i.canZoomIn(), s = i && i.canZoomOut();
        for (const e of t.querySelectorAll('[data-panzoom-action="zoomIn"]'))n ? (e.removeAttribute("disabled"), e.removeAttribute("tabindex")) : (e.setAttribute("disabled", ""), e.setAttribute("tabindex", "-1"));
        for (const e of t.querySelectorAll('[data-panzoom-action="zoomOut"]'))s ? (e.removeAttribute("disabled"), e.removeAttribute("tabindex")) : (e.setAttribute("disabled", ""), e.setAttribute("tabindex", "-1"));
        for (const e of t.querySelectorAll('[data-panzoom-action="toggleZoom"],[data-panzoom-action="iterateZoom"]')){
            s || n ? (e.removeAttribute("disabled"), e.removeAttribute("tabindex")) : (e.setAttribute("disabled", ""), e.setAttribute("tabindex", "-1"));
            const t = e.querySelector("g");
            t && (t.style.display = n ? "" : "none");
        }
    }
    onDone(t, e) {
        var i;
        null === (i = e.panzoom) || void 0 === i || i.on("afterTransform", ()=>{
            this.instance.isCurrentSlide(e) && this.onRefresh();
        }), this.instance.isCurrentSlide(e) && this.onRefresh();
    }
    createContainer() {
        const t = this.instance.container;
        if (!t) return null;
        const e = this.option("parentEl") || t;
        let i = e.querySelector("." + $e35dfd66294e81cf$var$Jt);
        return i || (i = document.createElement("div"), $e35dfd66294e81cf$var$P(i, $e35dfd66294e81cf$var$Jt), e.prepend(i)), i.addEventListener("click", this.onClick, {
            passive: !1,
            capture: !0
        }), t && $e35dfd66294e81cf$var$P(t, $e35dfd66294e81cf$var$Kt), this.container = i, i;
    }
    createEl(t) {
        const e = this.instance, i = e.carousel;
        if (!i) return null;
        if ("toggleFS" === t) return null;
        if ("fullscreen" === t && !$e35dfd66294e81cf$var$ot()) return null;
        let s = null;
        const o = i.slides.length || 0;
        let a = 0, r = 0;
        for (const t of i.slides)(t.panzoom || "image" === t.type) && a++, ("image" === t.type || t.downloadSrc) && r++;
        if (o < 2 && [
            "infobar",
            "prev",
            "next"
        ].includes(t)) return s;
        if (void 0 !== $e35dfd66294e81cf$var$Vt[t] && !a) return null;
        if ("download" === t && !r) return null;
        if ("thumbs" === t) {
            const t = e.plugins.Thumbs;
            if (!t || !t.isEnabled) return null;
        }
        if ("slideshow" === t) {
            if (!i.plugins.Autoplay || o < 2) return null;
        }
        if (void 0 !== $e35dfd66294e81cf$var$Vt[t]) {
            const e = $e35dfd66294e81cf$var$Vt[t];
            s = document.createElement("button"), s.setAttribute("title", this.instance.localize(`{{${t.toUpperCase()}}}`)), $e35dfd66294e81cf$var$P(s, "f-button"), e.action && (s.dataset.panzoomAction = e.action), e.change && (s.dataset.panzoomChange = JSON.stringify(e.change)), s.appendChild($e35dfd66294e81cf$var$n(this.instance.localize(e.icon)));
        } else {
            const e = (this.option("items") || [])[t];
            e && (s = $e35dfd66294e81cf$var$n(this.instance.localize(e.tpl)), "function" == typeof e.click && s.addEventListener("click", (t)=>{
                t.preventDefault(), t.stopPropagation(), "function" == typeof e.click && e.click.call(this, this, t);
            }));
        }
        const l = null == s ? void 0 : s.querySelector("svg");
        if (l) for (const [t, e] of Object.entries($e35dfd66294e81cf$var$Gt))l.getAttribute(t) || l.setAttribute(t, String(e));
        return s;
    }
    removeContainer() {
        const t = this.container;
        t && t.remove(), this.container = null, this.state = $e35dfd66294e81cf$var$Zt.Disabled;
        const e = this.instance.container;
        e && $e35dfd66294e81cf$var$S(e, $e35dfd66294e81cf$var$Kt);
    }
    attach() {
        const t = this, e = t.instance;
        e.on("Carousel.initSlides", t.onReady), e.on("done", t.onDone), e.on([
            "reveal",
            "Carousel.change"
        ], t.onChange), t.onReady(t.instance);
    }
    detach() {
        const t = this, e = t.instance;
        e.off("Carousel.initSlides", t.onReady), e.off("done", t.onDone), e.off([
            "reveal",
            "Carousel.change"
        ], t.onChange), t.removeContainer();
    }
}
Object.defineProperty($e35dfd66294e81cf$var$Qt, "defaults", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: $e35dfd66294e81cf$var$Ut
});
const $e35dfd66294e81cf$var$te = {
    Hash: class extends $e35dfd66294e81cf$var$_ {
        onReady() {
            $e35dfd66294e81cf$var$ht = !1;
        }
        onChange(t) {
            $e35dfd66294e81cf$var$ut && clearTimeout($e35dfd66294e81cf$var$ut);
            const { hash: e } = $e35dfd66294e81cf$var$pt(), { hash: i } = $e35dfd66294e81cf$var$ft(), n = t.isOpeningSlide(t.getSlide());
            n && ($e35dfd66294e81cf$var$ct = i === e ? "" : i), e && e !== i && ($e35dfd66294e81cf$var$ut = setTimeout(()=>{
                try {
                    if (t.state === $e35dfd66294e81cf$var$rt.Ready) {
                        let t = "replaceState";
                        n && !$e35dfd66294e81cf$var$dt && (t = "pushState", $e35dfd66294e81cf$var$dt = !0), window.history[t]({}, document.title, window.location.pathname + window.location.search + e);
                    }
                } catch (t) {}
            }, 300));
        }
        onClose(t) {
            if ($e35dfd66294e81cf$var$ut && clearTimeout($e35dfd66294e81cf$var$ut), !$e35dfd66294e81cf$var$ht && $e35dfd66294e81cf$var$dt) return $e35dfd66294e81cf$var$dt = !1, $e35dfd66294e81cf$var$ht = !1, void window.history.back();
            if (!$e35dfd66294e81cf$var$ht) try {
                window.history.replaceState({}, document.title, window.location.pathname + window.location.search + ($e35dfd66294e81cf$var$ct || ""));
            } catch (t) {}
        }
        attach() {
            const t = this.instance;
            t.on("ready", this.onReady), t.on([
                "Carousel.ready",
                "Carousel.change"
            ], this.onChange), t.on("close", this.onClose);
        }
        detach() {
            const t = this.instance;
            t.off("ready", this.onReady), t.off([
                "Carousel.ready",
                "Carousel.change"
            ], this.onChange), t.off("close", this.onClose);
        }
        static parseURL() {
            return $e35dfd66294e81cf$var$ft();
        }
        static startFromUrl() {
            $e35dfd66294e81cf$var$gt();
        }
        static destroy() {
            window.removeEventListener("hashchange", $e35dfd66294e81cf$var$vt, !1);
        }
    },
    Html: $e35dfd66294e81cf$var$Lt,
    Images: $e35dfd66294e81cf$var$wt,
    Slideshow: $e35dfd66294e81cf$var$Dt,
    Thumbs: $e35dfd66294e81cf$var$Yt,
    Toolbar: $e35dfd66294e81cf$var$Qt
}, $e35dfd66294e81cf$var$ee = "with-fancybox", $e35dfd66294e81cf$var$ie = "hide-scrollbar", $e35dfd66294e81cf$var$ne = "--fancybox-scrollbar-compensate", $e35dfd66294e81cf$var$se = "--fancybox-body-margin", $e35dfd66294e81cf$var$oe = "aria-hidden", $e35dfd66294e81cf$var$ae = "is-using-tab", $e35dfd66294e81cf$var$re = "is-animated", $e35dfd66294e81cf$var$le = "is-compact", $e35dfd66294e81cf$var$ce = "is-loading", $e35dfd66294e81cf$var$he = "is-opening", $e35dfd66294e81cf$var$de = "has-caption", $e35dfd66294e81cf$var$ue = "disabled", $e35dfd66294e81cf$var$pe = "tabindex", $e35dfd66294e81cf$var$fe = "download", $e35dfd66294e81cf$var$ge = "href", $e35dfd66294e81cf$var$me = "src", $e35dfd66294e81cf$var$ve = (t)=>"string" == typeof t, $e35dfd66294e81cf$var$be = function() {
    var t = window.getSelection();
    return !!t && "Range" === t.type;
};
let $e35dfd66294e81cf$var$ye, $e35dfd66294e81cf$var$we = null, $e35dfd66294e81cf$var$xe = null, $e35dfd66294e81cf$var$Ee = 0, $e35dfd66294e81cf$var$Se = 0, $e35dfd66294e81cf$var$Pe = 0, $e35dfd66294e81cf$var$Ce = 0;
const $e35dfd66294e81cf$var$Te = new Map;
let $e35dfd66294e81cf$var$Me = 0;
class $e35dfd66294e81cf$export$cb45b08d97cdc4fd extends $e35dfd66294e81cf$var$g {
    get isIdle() {
        return this.idle;
    }
    get isCompact() {
        return this.option("compact");
    }
    constructor(t = [], e = {}, i = {}){
        super(e), Object.defineProperty(this, "userSlides", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: []
        }), Object.defineProperty(this, "userPlugins", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: {}
        }), Object.defineProperty(this, "idle", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: !1
        }), Object.defineProperty(this, "idleTimer", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "clickTimer", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "pwt", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: 0
        }), Object.defineProperty(this, "ignoreFocusChange", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: !1
        }), Object.defineProperty(this, "startedFs", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: !1
        }), Object.defineProperty(this, "state", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: $e35dfd66294e81cf$var$rt.Init
        }), Object.defineProperty(this, "id", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: 0
        }), Object.defineProperty(this, "container", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "caption", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "footer", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "carousel", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "lastFocus", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "prevMouseMoveEvent", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), $e35dfd66294e81cf$var$ye || ($e35dfd66294e81cf$var$ye = $e35dfd66294e81cf$var$ot()), this.id = e.id || ++$e35dfd66294e81cf$var$Me, $e35dfd66294e81cf$var$Te.set(this.id, this), this.userSlides = t, this.userPlugins = i, queueMicrotask(()=>{
            this.init();
        });
    }
    init() {
        if (this.state === $e35dfd66294e81cf$var$rt.Destroy) return;
        this.state = $e35dfd66294e81cf$var$rt.Init, this.attachPlugins(Object.assign(Object.assign({}, $e35dfd66294e81cf$export$cb45b08d97cdc4fd.Plugins), this.userPlugins)), this.emit("init"), this.emit("attachPlugins"), !0 === this.option("hideScrollbar") && (()=>{
            if (!$e35dfd66294e81cf$var$et) return;
            const t = document, e = t.body, i = t.documentElement;
            if (e.classList.contains($e35dfd66294e81cf$var$ie)) return;
            let n = window.innerWidth - i.getBoundingClientRect().width;
            const s = parseFloat(window.getComputedStyle(e).marginRight);
            n < 0 && (n = 0), i.style.setProperty($e35dfd66294e81cf$var$ne, `${n}px`), s && e.style.setProperty($e35dfd66294e81cf$var$se, `${s}px`), e.classList.add($e35dfd66294e81cf$var$ie);
        })(), this.initLayout(), this.scale();
        const t = ()=>{
            this.initCarousel(this.userSlides), this.state = $e35dfd66294e81cf$var$rt.Ready, this.attachEvents(), this.emit("ready"), setTimeout(()=>{
                this.container && this.container.setAttribute($e35dfd66294e81cf$var$oe, "false");
            }, 16);
        };
        this.option("Fullscreen.autoStart") && $e35dfd66294e81cf$var$ye && !$e35dfd66294e81cf$var$ye.isFullscreen() ? $e35dfd66294e81cf$var$ye.request().then(()=>{
            this.startedFs = !0, t();
        }).catch(()=>t()) : t();
    }
    initLayout() {
        var t, e;
        const i = this.option("parentEl") || document.body, s = $e35dfd66294e81cf$var$n(this.localize(this.option("tpl.main") || ""));
        if (s) {
            if (s.setAttribute("id", `fancybox-${this.id}`), s.setAttribute("aria-label", this.localize("{{MODAL}}")), s.classList.toggle($e35dfd66294e81cf$var$le, this.isCompact), $e35dfd66294e81cf$var$P(s, this.option("mainClass") || ""), $e35dfd66294e81cf$var$P(s, $e35dfd66294e81cf$var$he), this.container = s, this.footer = s.querySelector(".fancybox__footer"), i.appendChild(s), $e35dfd66294e81cf$var$P(document.documentElement, $e35dfd66294e81cf$var$ee), $e35dfd66294e81cf$var$we && $e35dfd66294e81cf$var$xe || ($e35dfd66294e81cf$var$we = document.createElement("span"), $e35dfd66294e81cf$var$P($e35dfd66294e81cf$var$we, "fancybox-focus-guard"), $e35dfd66294e81cf$var$we.setAttribute($e35dfd66294e81cf$var$pe, "0"), $e35dfd66294e81cf$var$we.setAttribute($e35dfd66294e81cf$var$oe, "true"), $e35dfd66294e81cf$var$we.setAttribute("aria-label", "Focus guard"), $e35dfd66294e81cf$var$xe = $e35dfd66294e81cf$var$we.cloneNode(), null === (t = s.parentElement) || void 0 === t || t.insertBefore($e35dfd66294e81cf$var$we, s), null === (e = s.parentElement) || void 0 === e || e.append($e35dfd66294e81cf$var$xe)), s.addEventListener("mousedown", (t)=>{
                $e35dfd66294e81cf$var$Ee = t.pageX, $e35dfd66294e81cf$var$Se = t.pageY, $e35dfd66294e81cf$var$S(s, $e35dfd66294e81cf$var$ae);
            }), this.option("closeExisting")) for (const t of $e35dfd66294e81cf$var$Te.values())t.id !== this.id && t.close();
            else this.option("animated") && ($e35dfd66294e81cf$var$P(s, $e35dfd66294e81cf$var$re), setTimeout(()=>{
                this.isClosing() || $e35dfd66294e81cf$var$S(s, $e35dfd66294e81cf$var$re);
            }, 350));
            this.emit("initLayout");
        }
    }
    initCarousel(t) {
        const i = this.container;
        if (!i) return;
        const n = i.querySelector(".fancybox__carousel");
        if (!n) return;
        const s = this.carousel = new $e35dfd66294e81cf$export$144901db2ea8e967(n, $e35dfd66294e81cf$var$u({}, {
            slides: t,
            transition: "fade",
            Panzoom: {
                lockAxis: this.option("dragToClose") ? "xy" : "x",
                infinite: !!this.option("dragToClose") && "y"
            },
            Dots: !1,
            Navigation: {
                classes: {
                    container: "fancybox__nav",
                    button: "f-button",
                    isNext: "is-next",
                    isPrev: "is-prev"
                }
            },
            initialPage: this.option("startIndex"),
            l10n: this.option("l10n")
        }, this.option("Carousel") || {}));
        s.on("*", (t, e, ...i)=>{
            this.emit(`Carousel.${e}`, t, ...i);
        }), s.on([
            "ready",
            "change"
        ], ()=>{
            this.manageCaption();
        }), this.on("Carousel.removeSlide", (t, e, i)=>{
            this.clearContent(i), i.state = void 0;
        }), s.on("Panzoom.touchStart", ()=>{
            var t, e;
            this.isCompact || this.endIdle(), (null === (t = document.activeElement) || void 0 === t ? void 0 : t.closest(".f-thumbs")) && (null === (e = this.container) || void 0 === e || e.focus());
        }), s.on("settle", ()=>{
            this.idleTimer || this.isCompact || !this.option("idle") || this.setIdle(), this.option("autoFocus") && !this.isClosing && this.checkFocus();
        }), this.option("dragToClose") && (s.on("Panzoom.afterTransform", (t, i)=>{
            const n = this.getSlide();
            if (n && $e35dfd66294e81cf$var$e(n.el)) return;
            const s = this.container;
            if (s) {
                const t = Math.abs(i.current.f), e = t < 1 ? "" : Math.max(.5, Math.min(1, 1 - t / i.contentRect.fitHeight * 1.5));
                s.style.setProperty("--fancybox-ts", e ? "0s" : ""), s.style.setProperty("--fancybox-opacity", e + "");
            }
        }), s.on("Panzoom.touchEnd", (t, i, n)=>{
            var s;
            const o = this.getSlide();
            if (o && $e35dfd66294e81cf$var$e(o.el)) return;
            if (i.isMobile && document.activeElement && -1 !== [
                "TEXTAREA",
                "INPUT"
            ].indexOf(null === (s = document.activeElement) || void 0 === s ? void 0 : s.nodeName)) return;
            const a = Math.abs(i.dragOffset.y);
            "y" === i.lockedAxis && (a >= 200 || a >= 50 && i.dragOffset.time < 300) && (n && n.cancelable && n.preventDefault(), this.close(n, "f-throwOut" + (i.current.f < 0 ? "Up" : "Down")));
        })), s.on("change", (t)=>{
            var e;
            let i = null === (e = this.getSlide()) || void 0 === e ? void 0 : e.triggerEl;
            if (i) {
                const e = new CustomEvent("slideTo", {
                    bubbles: !0,
                    cancelable: !0,
                    detail: t.page
                });
                i.dispatchEvent(e);
            }
        }), s.on([
            "refresh",
            "change"
        ], (t)=>{
            const e = this.container;
            if (!e) return;
            for (const i of e.querySelectorAll("[data-fancybox-current-index]"))i.innerHTML = t.page + 1;
            for (const i of e.querySelectorAll("[data-fancybox-count]"))i.innerHTML = t.pages.length;
            if (!t.isInfinite) {
                for (const i of e.querySelectorAll("[data-fancybox-next]"))t.page < t.pages.length - 1 ? (i.removeAttribute($e35dfd66294e81cf$var$ue), i.removeAttribute($e35dfd66294e81cf$var$pe)) : (i.setAttribute($e35dfd66294e81cf$var$ue, ""), i.setAttribute($e35dfd66294e81cf$var$pe, "-1"));
                for (const i of e.querySelectorAll("[data-fancybox-prev]"))t.page > 0 ? (i.removeAttribute($e35dfd66294e81cf$var$ue), i.removeAttribute($e35dfd66294e81cf$var$pe)) : (i.setAttribute($e35dfd66294e81cf$var$ue, ""), i.setAttribute($e35dfd66294e81cf$var$pe, "-1"));
            }
            const i = this.getSlide();
            if (!i) return;
            let n = i.downloadSrc || "";
            n || "image" !== i.type || i.error || !$e35dfd66294e81cf$var$ve(i[$e35dfd66294e81cf$var$me]) || (n = i[$e35dfd66294e81cf$var$me]);
            for (const t of e.querySelectorAll("[data-fancybox-download]")){
                const e = i.downloadFilename;
                n ? (t.removeAttribute($e35dfd66294e81cf$var$ue), t.removeAttribute($e35dfd66294e81cf$var$pe), t.setAttribute($e35dfd66294e81cf$var$ge, n), t.setAttribute($e35dfd66294e81cf$var$fe, e || n), t.setAttribute("target", "_blank")) : (t.setAttribute($e35dfd66294e81cf$var$ue, ""), t.setAttribute($e35dfd66294e81cf$var$pe, "-1"), t.removeAttribute($e35dfd66294e81cf$var$ge), t.removeAttribute($e35dfd66294e81cf$var$fe));
            }
        }), this.emit("initCarousel");
    }
    attachEvents() {
        const t = this, e = t.container;
        if (!e) return;
        e.addEventListener("click", t.onClick, {
            passive: !1,
            capture: !1
        }), e.addEventListener("wheel", t.onWheel, {
            passive: !1,
            capture: !1
        }), document.addEventListener("keydown", t.onKeydown, {
            passive: !1,
            capture: !0
        }), document.addEventListener("visibilitychange", t.onVisibilityChange, !1), document.addEventListener("mousemove", t.onMousemove), t.option("trapFocus") && document.addEventListener("focus", t.onFocus, !0), window.addEventListener("resize", t.onResize);
        const i = window.visualViewport;
        i && (i.addEventListener("scroll", t.onResize), i.addEventListener("resize", t.onResize));
    }
    detachEvents() {
        const t = this, e = t.container;
        if (!e) return;
        document.removeEventListener("keydown", t.onKeydown, {
            passive: !1,
            capture: !0
        }), e.removeEventListener("wheel", t.onWheel, {
            passive: !1,
            capture: !1
        }), e.removeEventListener("click", t.onClick, {
            passive: !1,
            capture: !1
        }), document.removeEventListener("mousemove", t.onMousemove), window.removeEventListener("resize", t.onResize);
        const i = window.visualViewport;
        i && (i.removeEventListener("resize", t.onResize), i.removeEventListener("scroll", t.onResize)), document.removeEventListener("visibilitychange", t.onVisibilityChange, !1), document.removeEventListener("focus", t.onFocus, !0);
    }
    scale() {
        const t = this.container;
        if (!t) return;
        const e = window.visualViewport, i = Math.max(1, (null == e ? void 0 : e.scale) || 1);
        let n = "", s = "", o = "";
        if (e && i > 1) {
            let t = `${e.offsetLeft}px`, a = `${e.offsetTop}px`;
            n = e.width * i + "px", s = e.height * i + "px", o = `translate3d(${t}, ${a}, 0) scale(${1 / i})`;
        }
        t.style.transform = o, t.style.width = n, t.style.height = s;
    }
    onClick(t) {
        var e;
        const { container: i, isCompact: n } = this;
        if (!i || this.isClosing()) return;
        !n && this.option("idle") && this.resetIdle();
        const s = t.composedPath()[0];
        if (s.closest(".fancybox-spinner") || s.closest("[data-fancybox-close]")) return t.preventDefault(), void this.close(t);
        if (s.closest("[data-fancybox-prev]")) return t.preventDefault(), void this.prev();
        if (s.closest("[data-fancybox-next]")) return t.preventDefault(), void this.next();
        if ("click" === t.type && 0 === t.detail) return;
        if (Math.abs(t.pageX - $e35dfd66294e81cf$var$Ee) > 30 || Math.abs(t.pageY - $e35dfd66294e81cf$var$Se) > 30) return;
        const o = document.activeElement;
        if ($e35dfd66294e81cf$var$be() && o && i.contains(o)) return;
        if (n && "image" === (null === (e = this.getSlide()) || void 0 === e ? void 0 : e.type)) return void (this.clickTimer ? (clearTimeout(this.clickTimer), this.clickTimer = null) : this.clickTimer = setTimeout(()=>{
            this.toggleIdle(), this.clickTimer = null;
        }, 350));
        if (this.emit("click", t), t.defaultPrevented) return;
        let a = !1;
        if (s.closest(".fancybox__content")) {
            if (o) {
                if (o.closest("[contenteditable]")) return;
                s.matches($e35dfd66294e81cf$var$nt) || o.blur();
            }
            if ($e35dfd66294e81cf$var$be()) return;
            a = this.option("contentClick");
        } else s.closest(".fancybox__carousel") && !s.matches($e35dfd66294e81cf$var$nt) && (a = this.option("backdropClick"));
        "close" === a ? (t.preventDefault(), this.close(t)) : "next" === a ? (t.preventDefault(), this.next()) : "prev" === a && (t.preventDefault(), this.prev());
    }
    onWheel(t) {
        const e = t.target;
        let n = this.option("wheel", t);
        e.closest(".fancybox__thumbs") && (n = "slide");
        const s = "slide" === n, o = [
            -t.deltaX || 0,
            -t.deltaY || 0,
            -t.detail || 0
        ].reduce(function(t, e) {
            return Math.abs(e) > Math.abs(t) ? e : t;
        }), a = Math.max(-1, Math.min(1, o)), r = Date.now();
        this.pwt && r - this.pwt < 300 ? s && t.preventDefault() : (this.pwt = r, this.emit("wheel", t, a), t.defaultPrevented || ("close" === n ? (t.preventDefault(), this.close(t)) : "slide" === n && ($e35dfd66294e81cf$var$i(e) || (t.preventDefault(), this[a > 0 ? "prev" : "next"]()))));
    }
    onScroll() {
        window.scrollTo($e35dfd66294e81cf$var$Pe, $e35dfd66294e81cf$var$Ce);
    }
    onKeydown(t) {
        if (!this.isTopmost()) return;
        this.isCompact || !this.option("idle") || this.isClosing() || this.resetIdle();
        const e = t.key, i = this.option("keyboard");
        if (!i) return;
        const n = t.composedPath()[0], s = document.activeElement && document.activeElement.classList, o = s && s.contains("f-button") || n.dataset.carouselPage || n.dataset.carouselIndex;
        if ("Escape" !== e && !o && $e35dfd66294e81cf$var$E(n)) {
            if (n.isContentEditable || -1 !== [
                "TEXTAREA",
                "OPTION",
                "INPUT",
                "SELECT",
                "VIDEO"
            ].indexOf(n.nodeName)) return;
        }
        if ("Tab" === t.key ? $e35dfd66294e81cf$var$P(this.container, $e35dfd66294e81cf$var$ae) : $e35dfd66294e81cf$var$S(this.container, $e35dfd66294e81cf$var$ae), t.ctrlKey || t.altKey || t.shiftKey) return;
        this.emit("keydown", e, t);
        const a = i[e];
        a && "function" == typeof this[a] && (t.preventDefault(), this[a]());
    }
    onResize() {
        const t = this.container;
        if (!t) return;
        const e = this.isCompact;
        t.classList.toggle($e35dfd66294e81cf$var$le, e), this.manageCaption(this.getSlide()), this.isCompact ? this.clearIdle() : this.endIdle(), this.scale(), this.emit("resize");
    }
    onFocus(t) {
        this.isTopmost() && this.checkFocus(t);
    }
    onMousemove(t) {
        this.prevMouseMoveEvent = t, !this.isCompact && this.option("idle") && this.resetIdle();
    }
    onVisibilityChange() {
        "visible" === document.visibilityState ? this.checkFocus() : this.endIdle();
    }
    manageCloseBtn(t) {
        const e = this.optionFor(t, "closeButton") || !1;
        if ("auto" === e) {
            const t = this.plugins.Toolbar;
            if (t && t.state === $e35dfd66294e81cf$var$Zt.Ready) return;
        }
        if (!e) return;
        if (!t.contentEl || t.closeBtnEl) return;
        const i = this.option("tpl.closeButton");
        if (i) {
            const e = $e35dfd66294e81cf$var$n(this.localize(i));
            t.closeBtnEl = t.contentEl.appendChild(e), t.el && $e35dfd66294e81cf$var$P(t.el, "has-close-btn");
        }
    }
    manageCaption(t) {
        var e, i;
        const n = "fancybox__caption", s = this.container;
        if (!s) return;
        $e35dfd66294e81cf$var$S(s, $e35dfd66294e81cf$var$de);
        const o = this.isCompact || this.option("commonCaption"), a = !o;
        if (this.caption && this.stop(this.caption), a && this.caption && (this.caption.remove(), this.caption = null), o && !this.caption) for (const t of (null === (e = this.carousel) || void 0 === e ? void 0 : e.slides) || [])t.captionEl && (t.captionEl.remove(), t.captionEl = void 0, $e35dfd66294e81cf$var$S(t.el, $e35dfd66294e81cf$var$de), null === (i = t.el) || void 0 === i || i.removeAttribute("aria-labelledby"));
        if (t || (t = this.getSlide()), !t || o && !this.isCurrentSlide(t)) return;
        const r = t.el;
        let l = this.optionFor(t, "caption", "");
        if (!l) return void (o && this.caption && this.animate(this.caption, "f-fadeOut", ()=>{
            this.caption && (this.caption.innerHTML = "");
        }));
        let c = null;
        if (a) {
            if (c = t.captionEl || null, r && !c) {
                const e = n + `_${this.id}_${t.index}`;
                c = document.createElement("div"), $e35dfd66294e81cf$var$P(c, n), c.setAttribute("id", e), t.captionEl = r.appendChild(c), $e35dfd66294e81cf$var$P(r, $e35dfd66294e81cf$var$de), r.setAttribute("aria-labelledby", e);
            }
        } else {
            if (c = this.caption, c || (c = s.querySelector("." + n)), !c) {
                c = document.createElement("div"), c.dataset.fancyboxCaption = "", $e35dfd66294e81cf$var$P(c, n);
                (this.footer || s).prepend(c);
            }
            $e35dfd66294e81cf$var$P(s, $e35dfd66294e81cf$var$de), this.caption = c;
        }
        c && (c.innerHTML = "", $e35dfd66294e81cf$var$ve(l) || "number" == typeof l ? c.innerHTML = l + "" : l instanceof HTMLElement && c.appendChild(l));
    }
    checkFocus(t) {
        this.focus(t);
    }
    focus(t) {
        var e;
        if (this.ignoreFocusChange) return;
        const i = document.activeElement || null, n = (null == t ? void 0 : t.target) || null, s = this.container, o = null === (e = this.carousel) || void 0 === e ? void 0 : e.viewport;
        if (!s || !o) return;
        if (!t && i && s.contains(i)) return;
        const a = this.getSlide(), r = a && a.state === $e35dfd66294e81cf$var$lt.Ready ? a.el : null;
        if (!r || r.contains(i) || s === i) return;
        t && t.cancelable && t.preventDefault(), this.ignoreFocusChange = !0;
        const l = Array.from(s.querySelectorAll($e35dfd66294e81cf$var$nt));
        let c = [], h = null;
        for (let t of l){
            const e = !t.offsetParent || !!t.closest('[aria-hidden="true"]'), i = r && r.contains(t), n = !o.contains(t);
            if (t === s || (i || n) && !e) {
                c.push(t);
                const e = t.dataset.origTabindex;
                void 0 !== e && e && (t.tabIndex = parseFloat(e)), t.removeAttribute("data-orig-tabindex"), !t.hasAttribute("autoFocus") && h || (h = t);
            } else {
                const e = void 0 === t.dataset.origTabindex ? t.getAttribute("tabindex") || "" : t.dataset.origTabindex;
                e && (t.dataset.origTabindex = e), t.tabIndex = -1;
            }
        }
        let d = null;
        t ? (!n || c.indexOf(n) < 0) && (d = h || s, c.length && (i === $e35dfd66294e81cf$var$xe ? d = c[0] : this.lastFocus !== s && i !== $e35dfd66294e81cf$var$we || (d = c[c.length - 1]))) : d = a && "image" === a.type ? s : h || s, d && $e35dfd66294e81cf$var$st(d), this.lastFocus = document.activeElement, this.ignoreFocusChange = !1;
    }
    next() {
        const t = this.carousel;
        t && t.pages.length > 1 && t.slideNext();
    }
    prev() {
        const t = this.carousel;
        t && t.pages.length > 1 && t.slidePrev();
    }
    jumpTo(...t) {
        this.carousel && this.carousel.slideTo(...t);
    }
    isTopmost() {
        var t;
        return (null === (t = $e35dfd66294e81cf$export$cb45b08d97cdc4fd.getInstance()) || void 0 === t ? void 0 : t.id) == this.id;
    }
    animate(t = null, e = "", i) {
        if (!t || !e) return void (i && i());
        this.stop(t);
        const n = (s)=>{
            s.target === t && t.dataset.animationName && (t.removeEventListener("animationend", n), delete t.dataset.animationName, i && i(), $e35dfd66294e81cf$var$S(t, e));
        };
        t.dataset.animationName = e, t.addEventListener("animationend", n), $e35dfd66294e81cf$var$P(t, e);
    }
    stop(t) {
        t && t.dispatchEvent(new CustomEvent("animationend", {
            bubbles: !1,
            cancelable: !0,
            currentTarget: t
        }));
    }
    setContent(t, e = "", i = !0) {
        if (this.isClosing()) return;
        const s = t.el;
        if (!s) return;
        let o = null;
        if ($e35dfd66294e81cf$var$E(e) ? o = e : (o = $e35dfd66294e81cf$var$n(e + ""), $e35dfd66294e81cf$var$E(o) || (o = document.createElement("div"), o.innerHTML = e + "")), [
            "img",
            "picture",
            "iframe",
            "video",
            "audio"
        ].includes(o.nodeName.toLowerCase())) {
            const t = document.createElement("div");
            t.appendChild(o), o = t;
        }
        $e35dfd66294e81cf$var$E(o) && t.filter && !t.error && (o = o.querySelector(t.filter)), o && $e35dfd66294e81cf$var$E(o) ? ($e35dfd66294e81cf$var$P(o, "fancybox__content"), t.id && o.setAttribute("id", t.id), s.classList.add(`has-${t.error ? "error" : t.type || "unknown"}`), s.prepend(o), "none" === o.style.display && (o.style.display = ""), "none" === getComputedStyle(o).getPropertyValue("display") && (o.style.display = t.display || this.option("defaultDisplay") || "flex"), t.contentEl = o, i && this.revealContent(t), this.manageCloseBtn(t), this.manageCaption(t)) : this.setError(t, "{{ELEMENT_NOT_FOUND}}");
    }
    revealContent(t, e) {
        const i = t.el, n = t.contentEl;
        i && n && (this.emit("reveal", t), this.hideLoading(t), t.state = $e35dfd66294e81cf$var$lt.Opening, (e = this.isOpeningSlide(t) ? void 0 === e ? this.optionFor(t, "showClass") : e : "f-fadeIn") ? this.animate(n, e, ()=>{
            this.done(t);
        }) : this.done(t));
    }
    done(t) {
        this.isClosing() || (t.state = $e35dfd66294e81cf$var$lt.Ready, this.emit("done", t), $e35dfd66294e81cf$var$P(t.el, "is-done"), this.isCurrentSlide(t) && this.option("autoFocus") && queueMicrotask(()=>{
            var e;
            null === (e = t.panzoom) || void 0 === e || e.updateControls(), this.option("autoFocus") && this.focus();
        }), this.isOpeningSlide(t) && ($e35dfd66294e81cf$var$S(this.container, $e35dfd66294e81cf$var$he), !this.isCompact && this.option("idle") && this.setIdle()));
    }
    isCurrentSlide(t) {
        const e = this.getSlide();
        return !(!t || !e) && e.index === t.index;
    }
    isOpeningSlide(t) {
        var e, i;
        return null === (null === (e = this.carousel) || void 0 === e ? void 0 : e.prevPage) && t && t.index === (null === (i = this.getSlide()) || void 0 === i ? void 0 : i.index);
    }
    showLoading(t) {
        t.state = $e35dfd66294e81cf$var$lt.Loading;
        const e = t.el;
        if (!e) return;
        $e35dfd66294e81cf$var$P(e, $e35dfd66294e81cf$var$ce), this.emit("loading", t), t.spinnerEl || setTimeout(()=>{
            if (!this.isClosing() && !t.spinnerEl && t.state === $e35dfd66294e81cf$var$lt.Loading) {
                let i = $e35dfd66294e81cf$var$n($e35dfd66294e81cf$var$x);
                $e35dfd66294e81cf$var$P(i, "fancybox-spinner"), t.spinnerEl = i, e.prepend(i), this.animate(i, "f-fadeIn");
            }
        }, 250);
    }
    hideLoading(t) {
        const e = t.el;
        if (!e) return;
        const i = t.spinnerEl;
        this.isClosing() ? null == i || i.remove() : ($e35dfd66294e81cf$var$S(e, $e35dfd66294e81cf$var$ce), i && this.animate(i, "f-fadeOut", ()=>{
            i.remove();
        }), t.state === $e35dfd66294e81cf$var$lt.Loading && (this.emit("loaded", t), t.state = $e35dfd66294e81cf$var$lt.Ready));
    }
    setError(t, e) {
        if (this.isClosing()) return;
        const i = new Event("error", {
            bubbles: !0,
            cancelable: !0
        });
        if (this.emit("error", i, t), i.defaultPrevented) return;
        t.error = e, this.hideLoading(t), this.clearContent(t);
        const n = document.createElement("div");
        n.classList.add("fancybox-error"), n.innerHTML = this.localize(e || "<p>{{ERROR}}</p>"), this.setContent(t, n);
    }
    clearContent(t) {
        if (void 0 === t.state) return;
        this.emit("clearContent", t), t.contentEl && (t.contentEl.remove(), t.contentEl = void 0);
        const e = t.el;
        e && ($e35dfd66294e81cf$var$S(e, "has-error"), $e35dfd66294e81cf$var$S(e, "has-unknown"), $e35dfd66294e81cf$var$S(e, `has-${t.type || "unknown"}`)), t.closeBtnEl && t.closeBtnEl.remove(), t.closeBtnEl = void 0, t.captionEl && t.captionEl.remove(), t.captionEl = void 0, t.spinnerEl && t.spinnerEl.remove(), t.spinnerEl = void 0;
    }
    getSlide() {
        var t;
        const e = this.carousel;
        return (null === (t = null == e ? void 0 : e.pages[null == e ? void 0 : e.page]) || void 0 === t ? void 0 : t.slides[0]) || void 0;
    }
    close(t, e) {
        if (this.isClosing()) return;
        const i = new Event("shouldClose", {
            bubbles: !0,
            cancelable: !0
        });
        if (this.emit("shouldClose", i, t), i.defaultPrevented) return;
        t && t.cancelable && (t.preventDefault(), t.stopPropagation());
        const n = ()=>{
            this.proceedClose(t, e);
        };
        this.startedFs && $e35dfd66294e81cf$var$ye && $e35dfd66294e81cf$var$ye.isFullscreen() ? Promise.resolve($e35dfd66294e81cf$var$ye.exit()).then(()=>n()) : n();
    }
    clearIdle() {
        this.idleTimer && clearTimeout(this.idleTimer), this.idleTimer = null;
    }
    setIdle(t = !1) {
        const e = ()=>{
            this.clearIdle(), this.idle = !0, $e35dfd66294e81cf$var$P(this.container, "is-idle"), this.emit("setIdle");
        };
        if (this.clearIdle(), !this.isClosing()) {
            if (t) e();
            else {
                const t = this.option("idle");
                t && (this.idleTimer = setTimeout(e, t));
            }
        }
    }
    endIdle() {
        this.clearIdle(), this.idle && !this.isClosing() && (this.idle = !1, $e35dfd66294e81cf$var$S(this.container, "is-idle"), this.emit("endIdle"));
    }
    resetIdle() {
        this.endIdle(), this.setIdle();
    }
    toggleIdle() {
        this.idle ? this.endIdle() : this.setIdle(!0);
    }
    toggleFullscreen() {
        $e35dfd66294e81cf$var$ye && ($e35dfd66294e81cf$var$ye.isFullscreen() ? $e35dfd66294e81cf$var$ye.exit() : $e35dfd66294e81cf$var$ye.request().then(()=>{
            this.startedFs = !0;
        }));
    }
    isClosing() {
        return [
            $e35dfd66294e81cf$var$rt.Closing,
            $e35dfd66294e81cf$var$rt.CustomClosing,
            $e35dfd66294e81cf$var$rt.Destroy
        ].includes(this.state);
    }
    proceedClose(t, e) {
        var i, n;
        this.state = $e35dfd66294e81cf$var$rt.Closing, this.clearIdle(), this.detachEvents();
        const s = this.container, o = this.carousel, a = this.getSlide(), r = a && this.option("placeFocusBack") ? a.triggerEl || this.option("triggerEl") : null;
        if (r && ($e35dfd66294e81cf$var$tt(r) ? $e35dfd66294e81cf$var$st(r) : r.focus()), s && ($e35dfd66294e81cf$var$S(s, $e35dfd66294e81cf$var$he), $e35dfd66294e81cf$var$P(s, "is-closing"), s.setAttribute($e35dfd66294e81cf$var$oe, "true"), this.option("animated") && $e35dfd66294e81cf$var$P(s, $e35dfd66294e81cf$var$re), s.style.pointerEvents = "none"), o) {
            o.clearTransitions(), null === (i = o.panzoom) || void 0 === i || i.destroy(), null === (n = o.plugins.Navigation) || void 0 === n || n.detach();
            for (const t of o.slides){
                t.state = $e35dfd66294e81cf$var$lt.Closing, this.hideLoading(t);
                const e = t.contentEl;
                e && this.stop(e);
                const i = null == t ? void 0 : t.panzoom;
                i && (i.stop(), i.detachEvents(), i.detachObserver()), this.isCurrentSlide(t) || o.emit("removeSlide", t);
            }
        }
        $e35dfd66294e81cf$var$Pe = window.scrollX, $e35dfd66294e81cf$var$Ce = window.scrollY, window.addEventListener("scroll", this.onScroll), this.emit("close", t), this.state !== $e35dfd66294e81cf$var$rt.CustomClosing ? (void 0 === e && a && (e = this.optionFor(a, "hideClass")), e && a ? (this.animate(a.contentEl, e, ()=>{
            o && o.emit("removeSlide", a);
        }), setTimeout(()=>{
            this.destroy();
        }, 500)) : this.destroy()) : setTimeout(()=>{
            this.destroy();
        }, 500);
    }
    destroy() {
        var t;
        if (this.state === $e35dfd66294e81cf$var$rt.Destroy) return;
        window.removeEventListener("scroll", this.onScroll), this.state = $e35dfd66294e81cf$var$rt.Destroy, null === (t = this.carousel) || void 0 === t || t.destroy();
        const e = this.container;
        e && e.remove(), $e35dfd66294e81cf$var$Te.delete(this.id);
        const i = $e35dfd66294e81cf$export$cb45b08d97cdc4fd.getInstance();
        i ? i.focus() : ($e35dfd66294e81cf$var$we && ($e35dfd66294e81cf$var$we.remove(), $e35dfd66294e81cf$var$we = null), $e35dfd66294e81cf$var$xe && ($e35dfd66294e81cf$var$xe.remove(), $e35dfd66294e81cf$var$xe = null), $e35dfd66294e81cf$var$S(document.documentElement, $e35dfd66294e81cf$var$ee), (()=>{
            if (!$e35dfd66294e81cf$var$et) return;
            const t = document, e = t.body;
            e.classList.remove($e35dfd66294e81cf$var$ie), e.style.setProperty($e35dfd66294e81cf$var$se, ""), t.documentElement.style.setProperty($e35dfd66294e81cf$var$ne, "");
        })(), this.emit("destroy"));
    }
    static bind(t, e, i) {
        if (!$e35dfd66294e81cf$var$et) return;
        let n, s = "", o = {};
        if (void 0 === t ? n = document.body : $e35dfd66294e81cf$var$ve(t) ? (n = document.body, s = t, "object" == typeof e && (o = e || {})) : (n = t, $e35dfd66294e81cf$var$ve(e) && (s = e), "object" == typeof i && (o = i || {})), !n || !$e35dfd66294e81cf$var$E(n)) return;
        s = s || "[data-fancybox]";
        const a = $e35dfd66294e81cf$export$cb45b08d97cdc4fd.openers.get(n) || new Map;
        a.set(s, o), $e35dfd66294e81cf$export$cb45b08d97cdc4fd.openers.set(n, a), 1 === a.size && n.addEventListener("click", $e35dfd66294e81cf$export$cb45b08d97cdc4fd.fromEvent);
    }
    static unbind(t, e) {
        let i, n = "";
        if ($e35dfd66294e81cf$var$ve(t) ? (i = document.body, n = t) : (i = t, $e35dfd66294e81cf$var$ve(e) && (n = e)), !i) return;
        const s = $e35dfd66294e81cf$export$cb45b08d97cdc4fd.openers.get(i);
        s && n && s.delete(n), n && s || ($e35dfd66294e81cf$export$cb45b08d97cdc4fd.openers.delete(i), i.removeEventListener("click", $e35dfd66294e81cf$export$cb45b08d97cdc4fd.fromEvent));
    }
    static destroy() {
        let t;
        for(; t = $e35dfd66294e81cf$export$cb45b08d97cdc4fd.getInstance();)t.destroy();
        for (const t of $e35dfd66294e81cf$export$cb45b08d97cdc4fd.openers.keys())t.removeEventListener("click", $e35dfd66294e81cf$export$cb45b08d97cdc4fd.fromEvent);
        $e35dfd66294e81cf$export$cb45b08d97cdc4fd.openers = new Map;
    }
    static fromEvent(t) {
        if (t.defaultPrevented) return;
        if (t.button && 0 !== t.button) return;
        if (t.ctrlKey || t.metaKey || t.shiftKey) return;
        let e = t.composedPath()[0];
        const i = e.closest("[data-fancybox-trigger]");
        if (i) {
            const t = i.dataset.fancyboxTrigger || "", n = document.querySelectorAll(`[data-fancybox="${t}"]`), s = parseInt(i.dataset.fancyboxIndex || "", 10) || 0;
            e = n[s] || e;
        }
        if (!(e && e instanceof Element)) return;
        let n, s, o, a;
        if ([
            ...$e35dfd66294e81cf$export$cb45b08d97cdc4fd.openers
        ].reverse().find(([t, i])=>!(!t.contains(e) || ![
                ...i
            ].reverse().find(([i, r])=>{
                let l = e.closest(i);
                return !!l && (n = t, s = i, o = l, a = r, !0);
            }))), !n || !s || !o) return;
        a = a || {}, t.preventDefault(), e = o;
        let r = [], l = $e35dfd66294e81cf$var$u({}, $e35dfd66294e81cf$var$at, a);
        l.event = t, l.triggerEl = e, l.delegate = i;
        const c = l.groupAll, h = l.groupAttr, d = h && e ? e.getAttribute(`${h}`) : "";
        if ((!e || d || c) && (r = [].slice.call(n.querySelectorAll(s))), e && !c && (r = d ? r.filter((t)=>t.getAttribute(`${h}`) === d) : [
            e
        ]), !r.length) return;
        const p = $e35dfd66294e81cf$export$cb45b08d97cdc4fd.getInstance();
        return p && p.options.triggerEl && r.indexOf(p.options.triggerEl) > -1 ? void 0 : (e && (l.startIndex = r.indexOf(e)), $e35dfd66294e81cf$export$cb45b08d97cdc4fd.fromNodes(r, l));
    }
    static fromSelector(t, e, i) {
        let n = null, s = "", o = {};
        if ($e35dfd66294e81cf$var$ve(t) ? (n = document.body, s = t, "object" == typeof e && (o = e || {})) : t instanceof HTMLElement && $e35dfd66294e81cf$var$ve(e) && (n = t, s = e, "object" == typeof i && (o = i || {})), !n || !s) return !1;
        const a = $e35dfd66294e81cf$export$cb45b08d97cdc4fd.openers.get(n);
        return !!a && (o = $e35dfd66294e81cf$var$u({}, a.get(s) || {}, o), !!o && $e35dfd66294e81cf$export$cb45b08d97cdc4fd.fromNodes(Array.from(n.querySelectorAll(s)), o));
    }
    static fromNodes(t, e) {
        e = $e35dfd66294e81cf$var$u({}, $e35dfd66294e81cf$var$at, e || {});
        const i = [];
        for (const n of t){
            const t = n.dataset || {}, s = t[$e35dfd66294e81cf$var$me] || n.getAttribute($e35dfd66294e81cf$var$ge) || n.getAttribute("currentSrc") || n.getAttribute($e35dfd66294e81cf$var$me) || void 0;
            let o;
            const a = e.delegate;
            let r;
            a && i.length === e.startIndex && (o = a instanceof HTMLImageElement ? a : a.querySelector("img:not([aria-hidden])")), o || (o = n instanceof HTMLImageElement ? n : n.querySelector("img:not([aria-hidden])")), o && (r = o.currentSrc || o[$e35dfd66294e81cf$var$me] || void 0, !r && o.dataset && (r = o.dataset.lazySrc || o.dataset[$e35dfd66294e81cf$var$me] || void 0));
            const l = {
                src: s,
                triggerEl: n,
                thumbEl: o,
                thumbElSrc: r,
                thumbSrc: r
            };
            for(const e in t){
                let i = t[e] + "";
                i = "false" !== i && ("true" === i || i), l[e] = i;
            }
            i.push(l);
        }
        return new $e35dfd66294e81cf$export$cb45b08d97cdc4fd(i, e);
    }
    static getInstance(t) {
        if (t) return $e35dfd66294e81cf$var$Te.get(t);
        return Array.from($e35dfd66294e81cf$var$Te.values()).reverse().find((t)=>!t.isClosing() && t) || null;
    }
    static getSlide() {
        var t;
        return (null === (t = $e35dfd66294e81cf$export$cb45b08d97cdc4fd.getInstance()) || void 0 === t ? void 0 : t.getSlide()) || null;
    }
    static show(t = [], e = {}) {
        return new $e35dfd66294e81cf$export$cb45b08d97cdc4fd(t, e);
    }
    static next() {
        const t = $e35dfd66294e81cf$export$cb45b08d97cdc4fd.getInstance();
        t && t.next();
    }
    static prev() {
        const t = $e35dfd66294e81cf$export$cb45b08d97cdc4fd.getInstance();
        t && t.prev();
    }
    static close(t = !0, ...e) {
        if (t) for (const t of $e35dfd66294e81cf$var$Te.values())t.close(...e);
        else {
            const t = $e35dfd66294e81cf$export$cb45b08d97cdc4fd.getInstance();
            t && t.close(...e);
        }
    }
}
Object.defineProperty($e35dfd66294e81cf$export$cb45b08d97cdc4fd, "version", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: "5.0.36"
}), Object.defineProperty($e35dfd66294e81cf$export$cb45b08d97cdc4fd, "defaults", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: $e35dfd66294e81cf$var$at
}), Object.defineProperty($e35dfd66294e81cf$export$cb45b08d97cdc4fd, "Plugins", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: $e35dfd66294e81cf$var$te
}), Object.defineProperty($e35dfd66294e81cf$export$cb45b08d97cdc4fd, "openers", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: new Map
});


const $8e7ff2bfafa270a8$export$939e43573ccd2f80 = ()=>{
    var fancyboxContainer = document.querySelectorAll(".gallery-block__gallery-container");
    if (fancyboxContainer) (0, $e35dfd66294e81cf$export$cb45b08d97cdc4fd).bind('[data-fancybox="gallery"]', {
        Carousel: {
            Dots: false
        }
    });
};


var $8399e4e9dca8c987$exports = {};
/**!
 * MixItUp v3.3.2
 * A high-performance, dependency-free library for animated filtering, sorting and more
 * Build 94e0fbf6-cd0b-4987-b3c0-14b59b67b8a0
 *
 * @copyright Copyright 2014-2024 KunkaLabs Limited.
 * @author    KunkaLabs Limited.
 * @link      https://github.com/patrickkunka/mixitup
 * @license   Apache-2.0
 */ (function(window1) {
    "use strict";
    var mixitup = null, h = null;
    (function() {
        var VENDORS = [
            "webkit",
            "moz",
            "o",
            "ms"
        ], canary = window1.document.createElement("div"), i = -1;
        // window.requestAnimationFrame
        for(i = 0; i < VENDORS.length && !window1.requestAnimationFrame; i++)window1.requestAnimationFrame = window1[VENDORS[i] + "RequestAnimationFrame"];
        // Element.nextElementSibling
        if (typeof canary.nextElementSibling === "undefined") Object.defineProperty(window1.Element.prototype, "nextElementSibling", {
            get: function() {
                var el = this.nextSibling;
                while(el){
                    if (el.nodeType === 1) return el;
                    el = el.nextSibling;
                }
                return null;
            }
        });
        // Element.matches
        (function(ElementPrototype) {
            ElementPrototype.matches = ElementPrototype.matches || ElementPrototype.machesSelector || ElementPrototype.mozMatchesSelector || ElementPrototype.msMatchesSelector || ElementPrototype.oMatchesSelector || ElementPrototype.webkitMatchesSelector || function(selector) {
                return Array.prototype.indexOf.call(this.parentElement.querySelectorAll(selector), this) > -1;
            };
        })(window1.Element.prototype);
        // Object.keys
        // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/keys
        if (!Object.keys) Object.keys = function() {
            var hasOwnProperty = Object.prototype.hasOwnProperty, hasDontEnumBug = false, dontEnums = [], dontEnumsLength = -1;
            hasDontEnumBug = !({
                toString: null
            }).propertyIsEnumerable("toString");
            dontEnums = [
                "toString",
                "toLocaleString",
                "valueOf",
                "hasOwnProperty",
                "isPrototypeOf",
                "propertyIsEnumerable",
                "constructor"
            ];
            dontEnumsLength = dontEnums.length;
            return function(obj) {
                var result = [], prop = "", i = -1;
                if (typeof obj !== "object" && (typeof obj !== "function" || obj === null)) throw new TypeError("Object.keys called on non-object");
                for(prop in obj)if (hasOwnProperty.call(obj, prop)) result.push(prop);
                if (hasDontEnumBug) {
                    for(i = 0; i < dontEnumsLength; i++)if (hasOwnProperty.call(obj, dontEnums[i])) result.push(dontEnums[i]);
                }
                return result;
            };
        }();
        // Array.isArray
        // https://developer.mozilla.org/en/docs/Web/JavaScript/Reference/Global_Objects/Array/isArray
        if (!Array.isArray) Array.isArray = function(arg) {
            return Object.prototype.toString.call(arg) === "[object Array]";
        };
        // Object.create
        // https://developer.mozilla.org/en/docs/Web/JavaScript/Reference/Global_Objects/Object/create
        if (typeof Object.create !== "function") Object.create = function(undefined) {
            var Temp = function() {};
            return function(prototype, propertiesObject) {
                if (prototype !== Object(prototype) && prototype !== null) throw TypeError("Argument must be an object, or null");
                Temp.prototype = prototype || {};
                var result = new Temp();
                Temp.prototype = null;
                if (propertiesObject !== undefined) Object.defineProperties(result, propertiesObject);
                if (prototype === null) /* jshint ignore:start */ result.__proto__ = null;
                return result;
            };
        }();
        // String.prototyoe.trim
        if (!String.prototype.trim) String.prototype.trim = function() {
            return this.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
        };
        // Array.prototype.indexOf
        // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/indexOf
        if (!Array.prototype.indexOf) Array.prototype.indexOf = function(searchElement) {
            var n, k, t, len;
            if (this === null) throw new TypeError();
            t = Object(this);
            len = t.length >>> 0;
            if (len === 0) return -1;
            n = 0;
            if (arguments.length > 1) {
                n = Number(arguments[1]);
                if (n !== n) n = 0;
                else if (n !== 0 && n !== Infinity && n !== -Infinity) n = (n > 0 || -1) * Math.floor(Math.abs(n));
            }
            if (n >= len) return -1;
            for(k = n >= 0 ? n : Math.max(len - Math.abs(n), 0); k < len; k++){
                if (k in t && t[k] === searchElement) return k;
            }
            return -1;
        };
        // Function.prototype.bind
        // https://developer.mozilla.org/en/docs/Web/JavaScript/Reference/Global_objects/Function/bind
        if (!Function.prototype.bind) Function.prototype.bind = function(oThis) {
            var aArgs, self, FNOP, fBound;
            if (typeof this !== "function") throw new TypeError();
            aArgs = Array.prototype.slice.call(arguments, 1);
            self = this;
            FNOP = function() {};
            fBound = function() {
                return self.apply(this instanceof FNOP ? this : oThis, aArgs.concat(Array.prototype.slice.call(arguments)));
            };
            if (this.prototype) FNOP.prototype = this.prototype;
            fBound.prototype = new FNOP();
            return fBound;
        };
        // Element.prototype.dispatchEvent
        if (!window1.Element.prototype.dispatchEvent) window1.Element.prototype.dispatchEvent = function(event) {
            try {
                return this.fireEvent("on" + event.type, event);
            } catch (err) {}
        };
    })();
    /**
     * The `mixitup()` "factory" function creates and returns individual instances
     * of MixItUp, known as "mixers", on which API methods can be called.
     *
     * When loading MixItUp via a script tag, the factory function is accessed
     * via the global variable `mixitup`. When using a module loading
     * system (e.g. ES2015, CommonJS, RequireJS), the factory function is
     * exported into your module when you require the MixItUp library.
     *
     * @example
     * mixitup(container [,config] [,foreignDoc])
     *
     * @example <caption>Example 1: Creating a mixer instance with an element reference</caption>
     * var containerEl = document.querySelector('.container');
     *
     * var mixer = mixitup(containerEl);
     *
     * @example <caption>Example 2: Creating a mixer instance with a selector string</caption>
     * var mixer = mixitup('.container');
     *
     * @example <caption>Example 3: Passing a configuration object</caption>
     * var mixer = mixitup(containerEl, {
     *     animation: {
     *         effects: 'fade scale(0.5)'
     *     }
     * });
     *
     * @example <caption>Example 4: Passing an iframe reference</caption>
     * var mixer = mixitup(containerEl, config, foreignDocument);
     *
     * @global
     * @namespace
     * @public
     * @kind        function
     * @since       3.0.0
     * @param       {(Element|string)}  container
     *      A DOM element or selector string representing the container(s) on which to instantiate MixItUp.
     * @param       {object}            [config]
     *      An optional "configuration object" used to customize the behavior of the MixItUp instance.
     * @param       {object}            [foreignDoc]
     *      An optional reference to a `document`, which can be used to control a MixItUp instance in an iframe.
     * @return      {mixitup.Mixer}
     *      A "mixer" object holding the MixItUp instance.
     */ mixitup = function(container, config, foreignDoc) {
        var el = null, returnCollection = false, instance = null, facade = null, doc = null, output = null, instances = [], id = "", elements = [], i = -1;
        doc = foreignDoc || window1.document;
        if (returnCollection = arguments[3]) // A non-documented 4th paramater enabling control of multiple instances
        returnCollection = typeof returnCollection === "boolean";
        if (typeof container === "string") elements = doc.querySelectorAll(container);
        else if (container && typeof container === "object" && h.isElement(container, doc)) elements = [
            container
        ];
        else if (container && typeof container === "object" && container.length) // Although not documented, the container may also be an array-like list of
        // elements such as a NodeList or jQuery collection, is returnCollection is true
        elements = container;
        else throw new Error(mixitup.messages.errorFactoryInvalidContainer());
        if (elements.length < 1) throw new Error(mixitup.messages.errorFactoryContainerNotFound());
        for(i = 0; el = elements[i]; i++){
            if (i > 0 && !returnCollection) break;
            if (!el.id) {
                id = "MixItUp" + h.randomHex();
                el.id = id;
            } else id = el.id;
            if (mixitup.instances[id] instanceof mixitup.Mixer) {
                instance = mixitup.instances[id];
                if (!config || config && config.debug && config.debug.showWarnings !== false) console.warn(mixitup.messages.warningFactoryPreexistingInstance());
            } else {
                instance = new mixitup.Mixer();
                instance.attach(el, doc, id, config);
                mixitup.instances[id] = instance;
            }
            facade = new mixitup.Facade(instance);
            if (config && config.debug && config.debug.enable) instances.push(instance);
            else instances.push(facade);
        }
        if (returnCollection) output = new mixitup.Collection(instances);
        else // Return the first instance regardless
        output = instances[0];
        return output;
    };
    /**
     * The `.use()` static method is used to extend the functionality of mixitup with compatible
     * extensions and libraries in an environment with modular scoping e.g. ES2015, CommonJS, or RequireJS.
     *
     * You need only call the `.use()` function once per project, per extension, as module loaders
     * will cache a single reference to MixItUp inclusive of all changes made.
     *
     * @example
     * mixitup.use(extension)
     *
     * @example <caption>Example 1: Extending MixItUp with the Pagination Extension</caption>
     *
     * import mixitup from 'mixitup';
     * import mixitupPagination from 'mixitup-pagination';
     *
     * mixitup.use(mixitupPagination);
     *
     * // All mixers created by the factory function in all modules will now
     * // have pagination functionality
     *
     * var mixer = mixitup('.container');
     *
     * @public
     * @name     use
     * @memberof mixitup
     * @kind     function
     * @static
     * @since    3.0.0
     * @param    {*}  extension   A reference to the extension or library to be used.
     * @return   {void}
     */ mixitup.use = function(extension) {
        mixitup.Base.prototype.callActions.call(mixitup, "beforeUse", arguments);
        // Call the extension's factory function, passing
        // the mixitup factory as a paramater
        if (typeof extension === "function" && extension.TYPE === "mixitup-extension") // Mixitup extension
        {
            if (typeof mixitup.extensions[extension.NAME] === "undefined") {
                extension(mixitup);
                mixitup.extensions[extension.NAME] = extension;
            }
        } else if (extension.fn && extension.fn.jquery) // jQuery
        mixitup.libraries.$ = extension;
        mixitup.Base.prototype.callActions.call(mixitup, "afterUse", arguments);
    };
    mixitup.instances = {};
    mixitup.extensions = {};
    mixitup.libraries = {};
    /**
     * @private
     */ h = {
        /**
         * @private
         * @param   {HTMLElement}   el
         * @param   {string}        cls
         * @return  {boolean}
         */ hasClass: function(el, cls) {
            return !!el.className.match(new RegExp("(\\s|^)" + cls + "(\\s|$)"));
        },
        /**
         * @private
         * @param   {HTMLElement}   el
         * @param   {string}        cls
         * @return  {void}
         */ addClass: function(el, cls) {
            if (!this.hasClass(el, cls)) el.className += el.className ? " " + cls : cls;
        },
        /**
         * @private
         * @param   {HTMLElement}   el
         * @param   {string}        cls
         * @return  {void}
         */ removeClass: function(el, cls) {
            if (this.hasClass(el, cls)) {
                var reg = new RegExp("(\\s|^)" + cls + "(\\s|$)");
                el.className = el.className.replace(reg, " ").trim();
            }
        },
        /**
         * Merges the properties of the source object onto the
         * target object. Alters the target object.
         *
         * @private
         * @param   {object}    destination
         * @param   {object}    source
         * @param   {boolean}   [deep=false]
         * @param   {boolean}   [handleErrors=false]
         * @return  {void}
         */ extend: function(destination, source, deep, handleErrors) {
            var sourceKeys = [], key = "", i = -1;
            deep = deep || false;
            handleErrors = handleErrors || false;
            try {
                if (Array.isArray(source)) for(i = 0; i < source.length; i++)sourceKeys.push(i);
                else if (source) sourceKeys = Object.keys(source);
                for(i = 0; i < sourceKeys.length; i++){
                    key = sourceKeys[i];
                    if (!deep || typeof source[key] !== "object" || this.isElement(source[key])) // All non-object properties, or all properties if shallow extend
                    destination[key] = source[key];
                    else if (Array.isArray(source[key])) {
                        // Arrays
                        if (!destination[key]) destination[key] = [];
                        this.extend(destination[key], source[key], deep, handleErrors);
                    } else {
                        // Objects
                        if (!destination[key]) destination[key] = {};
                        this.extend(destination[key], source[key], deep, handleErrors);
                    }
                }
            } catch (err) {
                if (handleErrors) this.handleExtendError(err, destination);
                else throw err;
            }
            return destination;
        },
        /**
         * @private
         * @param   {Error}  err
         * @param   {object} destination
         * @return  {void}
         */ handleExtendError: function(err, destination) {
            var re = /property "?(\w*)"?[,:] object/i, matches = null, erroneous = "", message = "", suggestion = "", probableMatch = "", key = "", mostMatchingChars = -1, i = -1;
            if (err instanceof TypeError && (matches = re.exec(err.message))) {
                erroneous = matches[1];
                for(key in destination){
                    i = 0;
                    while(i < erroneous.length && erroneous.charAt(i) === key.charAt(i))i++;
                    if (i > mostMatchingChars) {
                        mostMatchingChars = i;
                        probableMatch = key;
                    }
                }
                if (mostMatchingChars > 1) suggestion = mixitup.messages.errorConfigInvalidPropertySuggestion({
                    probableMatch: probableMatch
                });
                message = mixitup.messages.errorConfigInvalidProperty({
                    erroneous: erroneous,
                    suggestion: suggestion
                });
                throw new TypeError(message);
            }
            throw err;
        },
        /**
         * @private
         * @param   {string} str
         * @return  {function}
         */ template: function(str) {
            var re = /\${([\w]*)}/g, dynamics = {}, matches = null;
            while(matches = re.exec(str))dynamics[matches[1]] = new RegExp("\\${" + matches[1] + "}", "g");
            return function(data) {
                var key = "", output = str;
                data = data || {};
                for(key in dynamics)output = output.replace(dynamics[key], typeof data[key] !== "undefined" ? data[key] : "");
                return output;
            };
        },
        /**
         * @private
         * @param   {HTMLElement}   el
         * @param   {string}        type
         * @param   {function}      fn
         * @param   {boolean}       useCapture
         * @return  {void}
         */ on: function(el, type, fn, useCapture) {
            if (!el) return;
            if (el.addEventListener) el.addEventListener(type, fn, useCapture);
            else if (el.attachEvent) {
                el["e" + type + fn] = fn;
                el[type + fn] = function() {
                    el["e" + type + fn](window1.event);
                };
                el.attachEvent("on" + type, el[type + fn]);
            }
        },
        /**
         * @private
         * @param   {HTMLElement}   el
         * @param   {string}        type
         * @param   {function}      fn
         * @return  {void}
         */ off: function(el, type, fn) {
            if (!el) return;
            if (el.removeEventListener) el.removeEventListener(type, fn, false);
            else if (el.detachEvent) {
                el.detachEvent("on" + type, el[type + fn]);
                el[type + fn] = null;
            }
        },
        /**
         * @private
         * @param   {string}      eventType
         * @param   {object}      detail
         * @param   {Document}    [doc]
         * @return  {CustomEvent}
         */ getCustomEvent: function(eventType, detail, doc) {
            var event = null;
            doc = doc || window1.document;
            if (typeof window1.CustomEvent === "function") event = new window1.CustomEvent(eventType, {
                detail: detail,
                bubbles: true,
                cancelable: true
            });
            else if (typeof doc.createEvent === "function") {
                event = doc.createEvent("CustomEvent");
                event.initCustomEvent(eventType, true, true, detail);
            } else {
                event = doc.createEventObject(), event.type = eventType;
                event.returnValue = false;
                event.cancelBubble = false;
                event.detail = detail;
            }
            return event;
        },
        /**
         * @private
         * @param   {Event} e
         * @return  {Event}
         */ getOriginalEvent: function(e) {
            if (e.touches && e.touches.length) return e.touches[0];
            else if (e.changedTouches && e.changedTouches.length) return e.changedTouches[0];
            else return e;
        },
        /**
         * @private
         * @param   {HTMLElement}   el
         * @param   {string}        selector
         * @return  {Number}
         */ index: function(el, selector) {
            var i = 0;
            while((el = el.previousElementSibling) !== null)if (!selector || el.matches(selector)) ++i;
            return i;
        },
        /**
         * Converts a dash or snake-case string to camel case.
         *
         * @private
         * @param   {string}    str
         * @param   {boolean}   [isPascal]
         * @return  {string}
         */ camelCase: function(str) {
            return str.toLowerCase().replace(/([_-][a-z])/g, function($1) {
                return $1.toUpperCase().replace(/[_-]/, "");
            });
        },
        /**
         * Converts a dash or snake-case string to pascal case.
         *
         * @private
         * @param   {string}    str
         * @param   {boolean}   [isPascal]
         * @return  {string}
         */ pascalCase: function(str) {
            return (str = this.camelCase(str)).charAt(0).toUpperCase() + str.slice(1);
        },
        /**
         * Converts a camel or pascal-case string to dash case.
         *
         * @private
         * @param   {string}    str
         * @return  {string}
         */ dashCase: function(str) {
            return str.replace(/([A-Z])/g, "-$1").replace(/^-/, "").toLowerCase();
        },
        /**
         * @private
         * @param   {HTMLElement}       el
         * @param   {HTMLHtmlElement}   [doc]
         * @return  {boolean}
         */ isElement: function(el, doc) {
            doc = doc || window1.document;
            if (window1.HTMLElement && el instanceof window1.HTMLElement) return true;
            else if (doc.defaultView && doc.defaultView.HTMLElement && el instanceof doc.defaultView.HTMLElement) return true;
            else return el !== null && el.nodeType === 1 && typeof el.nodeName === "string";
        },
        /**
         * @private
         * @param   {string}            htmlString
         * @param   {HTMLHtmlElement}   [doc]
         * @return  {DocumentFragment}
         */ createElement: function(htmlString, doc) {
            var frag = null, temp = null;
            doc = doc || window1.document;
            frag = doc.createDocumentFragment();
            temp = doc.createElement("div");
            temp.innerHTML = htmlString.trim();
            while(temp.firstChild)frag.appendChild(temp.firstChild);
            return frag;
        },
        /**
         * @private
         * @param   {Node} node
         * @return  {void}
         */ removeWhitespace: function(node) {
            var deleting;
            while(node && node.nodeName === "#text"){
                deleting = node;
                node = node.previousSibling;
                deleting.parentElement && deleting.parentElement.removeChild(deleting);
            }
        },
        /**
         * @private
         * @param   {Array<*>}  a
         * @param   {Array<*>}  b
         * @return  {boolean}
         */ isEqualArray: function(a, b) {
            var i = a.length;
            if (i !== b.length) return false;
            while(i--){
                if (a[i] !== b[i]) return false;
            }
            return true;
        },
        /**
         * @private
         * @param   {object}  a
         * @param   {object}  b
         * @return  {boolean}
         */ deepEquals: function(a, b) {
            var key;
            if (typeof a === "object" && a && typeof b === "object" && b) {
                if (Object.keys(a).length !== Object.keys(b).length) return false;
                for(key in a){
                    if (!b.hasOwnProperty(key) || !this.deepEquals(a[key], b[key])) return false;
                }
            } else if (a !== b) return false;
            return true;
        },
        /**
         * @private
         * @param   {Array<*>}  oldArray
         * @return  {Array<*>}
         */ arrayShuffle: function(oldArray) {
            var newArray = oldArray.slice(), len = newArray.length, i = len, p = -1, t = [];
            while(i--){
                p = ~~(Math.random() * len);
                t = newArray[i];
                newArray[i] = newArray[p];
                newArray[p] = t;
            }
            return newArray;
        },
        /**
         * @private
         * @param   {object}    list
         */ arrayFromList: function(list) {
            var output, i;
            try {
                return Array.prototype.slice.call(list);
            } catch (err) {
                output = [];
                for(i = 0; i < list.length; i++)output.push(list[i]);
                return output;
            }
        },
        /**
         * @private
         * @param   {function}  func
         * @param   {Number}    wait
         * @param   {boolean}   immediate
         * @return  {function}
         */ debounce: function(func, wait, immediate) {
            var timeout;
            return function() {
                var self = this, args = arguments, callNow = immediate && !timeout, later = null;
                later = function() {
                    timeout = null;
                    if (!immediate) func.apply(self, args);
                };
                clearTimeout(timeout);
                timeout = setTimeout(later, wait);
                if (callNow) func.apply(self, args);
            };
        },
        /**
         * @private
         * @param   {HTMLElement}   element
         * @return  {object}
         */ position: function(element) {
            var xPosition = 0, yPosition = 0, offsetParent = element;
            while(element){
                xPosition -= element.scrollLeft;
                yPosition -= element.scrollTop;
                if (element === offsetParent) {
                    xPosition += element.offsetLeft;
                    yPosition += element.offsetTop;
                    offsetParent = element.offsetParent;
                }
                element = element.parentElement;
            }
            return {
                x: xPosition,
                y: yPosition
            };
        },
        /**
         * @private
         * @param   {object}    node1
         * @param   {object}    node2
         * @return  {Number}
         */ getHypotenuse: function(node1, node2) {
            var distanceX = node1.x - node2.x, distanceY = node1.y - node2.y;
            distanceX = distanceX < 0 ? distanceX * -1 : distanceX, distanceY = distanceY < 0 ? distanceY * -1 : distanceY;
            return Math.sqrt(Math.pow(distanceX, 2) + Math.pow(distanceY, 2));
        },
        /**
         * Calcuates the area of intersection between two rectangles and expresses it as
         * a ratio in comparison to the area of the first rectangle.
         *
         * @private
         * @param   {Rect}  box1
         * @param   {Rect}  box2
         * @return  {number}
         */ getIntersectionRatio: function(box1, box2) {
            var controlArea = box1.width * box1.height, intersectionX = -1, intersectionY = -1, intersectionArea = -1, ratio = -1;
            intersectionX = Math.max(0, Math.min(box1.left + box1.width, box2.left + box2.width) - Math.max(box1.left, box2.left));
            intersectionY = Math.max(0, Math.min(box1.top + box1.height, box2.top + box2.height) - Math.max(box1.top, box2.top));
            intersectionArea = intersectionY * intersectionX;
            ratio = intersectionArea / controlArea;
            return ratio;
        },
        /**
         * @private
         * @param   {object}            el
         * @param   {string}            selector
         * @param   {boolean}           [includeSelf]
         * @param   {HTMLHtmlElement}   [doc]
         * @return  {Element|null}
         */ closestParent: function(el, selector, includeSelf, doc) {
            var parent = el.parentNode;
            doc = doc || window1.document;
            if (includeSelf && el.matches(selector)) return el;
            while(parent && parent != doc.body){
                if (parent.matches && parent.matches(selector)) return parent;
                else if (parent.parentNode) parent = parent.parentNode;
                else return null;
            }
            return null;
        },
        /**
         * @private
         * @param   {HTMLElement}       el
         * @param   {string}            selector
         * @param   {HTMLHtmlElement}   [doc]
         * @return  {NodeList}
         */ children: function(el, selector, doc) {
            var children = [], tempId = "";
            doc = doc || window1.doc;
            if (el) {
                if (!el.id) {
                    tempId = "Temp" + this.randomHexKey();
                    el.id = tempId;
                }
                children = doc.querySelectorAll("#" + el.id + " > " + selector);
                if (tempId) el.removeAttribute("id");
            }
            return children;
        },
        /**
         * Creates a clone of a provided array, with any empty strings removed.
         *
         * @private
         * @param   {Array<*>} originalArray
         * @return  {Array<*>}
         */ clean: function(originalArray) {
            var cleanArray = [], i = -1;
            for(i = 0; i < originalArray.length; i++)if (originalArray[i] !== "") cleanArray.push(originalArray[i]);
            return cleanArray;
        },
        /**
         * Abstracts an ES6 promise into a q-like deferred interface for storage and deferred resolution.
         *
         * @private
         * @param  {object} libraries
         * @return {h.Deferred}
         */ defer: function(libraries) {
            var deferred = null, promiseWrapper = null, $ = null;
            promiseWrapper = new this.Deferred();
            if (mixitup.features.has.promises) // ES6 native promise or polyfill
            promiseWrapper.promise = new Promise(function(resolve, reject) {
                promiseWrapper.resolve = resolve;
                promiseWrapper.reject = reject;
            });
            else if (($ = window1.jQuery || libraries.$) && typeof $.Deferred === "function") {
                // jQuery
                deferred = $.Deferred();
                promiseWrapper.promise = deferred.promise();
                promiseWrapper.resolve = deferred.resolve;
                promiseWrapper.reject = deferred.reject;
            } else if (window1.console) // No implementation
            console.warn(mixitup.messages.warningNoPromiseImplementation());
            return promiseWrapper;
        },
        /**
         * @private
         * @param   {Array<Promise>}    tasks
         * @param   {object}            libraries
         * @return  {Promise<Array>}
         */ all: function(tasks, libraries) {
            var $ = null;
            if (mixitup.features.has.promises) return Promise.all(tasks);
            else if (($ = window1.jQuery || libraries.$) && typeof $.when === "function") return $.when.apply($, tasks).done(function() {
                // jQuery when returns spread arguments rather than an array or resolutions
                return arguments;
            });
            // No implementation
            if (window1.console) console.warn(mixitup.messages.warningNoPromiseImplementation());
            return [];
        },
        /**
         * @private
         * @param   {HTMLElement}   el
         * @param   {string}        property
         * @param   {Array<string>} vendors
         * @return  {string}
         */ getPrefix: function(el, property, vendors) {
            var i = -1, prefix = "";
            if (h.dashCase(property) in el.style) return "";
            for(i = 0; prefix = vendors[i]; i++){
                if (prefix + property in el.style) return prefix.toLowerCase();
            }
            return "unsupported";
        },
        /**
         * @private
         * @return  {string}
         */ randomHex: function() {
            return ("00000" + (Math.random() * 16777216 << 0).toString(16)).substr(-6).toUpperCase();
        },
        /**
         * @private
         * @param   {HTMLDocument}  [doc]
         * @return  {object}
         */ getDocumentState: function(doc) {
            doc = typeof doc.body === "object" ? doc : window1.document;
            return {
                scrollTop: window1.pageYOffset,
                scrollLeft: window1.pageXOffset,
                docHeight: doc.documentElement.scrollHeight,
                docWidth: doc.documentElement.scrollWidth,
                viewportHeight: doc.documentElement.clientHeight,
                viewportWidth: doc.documentElement.clientWidth
            };
        },
        /**
         * @private
         * @param   {object}    obj
         * @param   {function}  fn
         * @return  {function}
         */ bind: function(obj, fn) {
            return function() {
                return fn.apply(obj, arguments);
            };
        },
        /**
         * @private
         * @param   {HTMLElement}   el
         * @return  {boolean}
         */ isVisible: function(el) {
            var styles = null;
            if (el.offsetParent) return true;
            styles = window1.getComputedStyle(el);
            if (styles.position === "fixed" && styles.visibility !== "hidden" && styles.opacity !== "0") // Fixed elements report no offsetParent,
            // but may still be invisible
            return true;
            return false;
        },
        /**
         * @private
         * @param   {object}    obj
         */ seal: function(obj) {
            if (typeof Object.seal === "function") Object.seal(obj);
        },
        /**
         * @private
         * @param   {object}    obj
         */ freeze: function(obj) {
            if (typeof Object.freeze === "function") Object.freeze(obj);
        },
        /**
         * @private
         * @param   {string}    control
         * @param   {string}    specimen
         * @return  {boolean}
         */ compareVersions: function(control, specimen) {
            var controlParts = control.split("."), specimenParts = specimen.split("."), controlPart = -1, specimenPart = -1, i = -1;
            for(i = 0; i < controlParts.length; i++){
                controlPart = parseInt(controlParts[i].replace(/[^\d.]/g, ""));
                specimenPart = parseInt(specimenParts[i].replace(/[^\d.]/g, "") || 0);
                if (specimenPart < controlPart) return false;
                else if (specimenPart > controlPart) return true;
            }
            return true;
        },
        /**
         * @private
         * @constructor
         */ Deferred: function() {
            this.promise = null;
            this.resolve = null;
            this.reject = null;
            this.id = h.randomHex();
        },
        /**
         * @private
         * @param   {object}  obj
         * @return  {boolean}
         */ isEmptyObject: function(obj) {
            var key = "";
            if (typeof Object.keys === "function") return Object.keys(obj).length === 0;
            for(key in obj){
                if (obj.hasOwnProperty(key)) return false;
            }
            return true;
        },
        /**
         * @param   {mixitup.Config.ClassNames}   classNames
         * @param   {string}                      elementName
         * @param   {string}                      [modifier]
         * @return  {string}
         */ getClassname: function(classNames, elementName, modifier) {
            var classname = "";
            classname += classNames.block;
            if (classname.length) classname += classNames.delineatorElement;
            classname += classNames["element" + this.pascalCase(elementName)];
            if (!modifier) return classname;
            if (classname.length) classname += classNames.delineatorModifier;
            classname += modifier;
            return classname;
        },
        /**
         * Returns the value of a property on a given object via its string key.
         *
         * @param   {object}    obj
         * @param   {string}    stringKey
         * @return  {*} value
         */ getProperty: function(obj, stringKey) {
            var parts = stringKey.split("."), returnCurrent = null, current = "", i = 0;
            if (!stringKey) return obj;
            returnCurrent = function(obj) {
                if (!obj) return null;
                else return obj[current];
            };
            while(i < parts.length){
                current = parts[i];
                obj = returnCurrent(obj);
                i++;
            }
            if (typeof obj !== "undefined") return obj;
            else return null;
        }
    };
    mixitup.h = h;
    /**
     * The Base class adds instance methods to all other extensible MixItUp classes,
     * enabling the calling of any registered hooks.
     *
     * @constructor
     * @namespace
     * @memberof    mixitup
     * @private
     * @since       3.0.0
     */ mixitup.Base = function() {};
    mixitup.Base.prototype = {
        constructor: mixitup.Base,
        /**
         * Calls any registered hooks for the provided action.
         *
         * @memberof    mixitup.Base
         * @private
         * @instance
         * @since       2.0.0
         * @param       {string}    actionName
         * @param       {Array<*>}  args
         * @return      {void}
         */ callActions: function(actionName, args) {
            var self = this, hooks = self.constructor.actions[actionName], extensionName = "";
            if (!hooks || h.isEmptyObject(hooks)) return;
            for(extensionName in hooks)hooks[extensionName].apply(self, args);
        },
        /**
         * Calls any registered hooks for the provided filter.
         *
         * @memberof    mixitup.Base
         * @private
         * @instance
         * @since       2.0.0
         * @param       {string}    filterName
         * @param       {*}         input
         * @param       {Array<*>}  args
         * @return      {*}
         */ callFilters: function(filterName, input, args) {
            var self = this, hooks = self.constructor.filters[filterName], output = input, extensionName = "";
            if (!hooks || h.isEmptyObject(hooks)) return output;
            args = args || [];
            for(extensionName in hooks){
                args = h.arrayFromList(args);
                args.unshift(output);
                output = hooks[extensionName].apply(self, args);
            }
            return output;
        }
    };
    /**
     * The BaseStatic class holds a set of static methods which are then added to all other
     * extensible MixItUp classes as a means of integrating extensions via the addition of new
     * methods and/or actions and hooks.
     *
     * @constructor
     * @namespace
     * @memberof    mixitup
     * @private
     * @since       3.0.0
     */ mixitup.BaseStatic = function() {
        this.actions = {};
        this.filters = {};
        /**
         * Performs a shallow extend on the class's prototype, adding one or more new members to
         * the class in a single operation.
         *
         * @memberof    mixitup.BaseStatic
         * @public
         * @static
         * @since       2.1.0
         * @param       {object} extension
         * @return      {void}
         */ this.extend = function(extension) {
            h.extend(this.prototype, extension);
        };
        /**
         * Registers a function to be called on the action hook of the provided name.
         *
         * @memberof    mixitup.BaseStatic
         * @public
         * @static
         * @since       2.1.0
         * @param       {string}    hookName
         * @param       {string}    extensionName
         * @param       {function}  func
         * @return      {void}
         */ this.registerAction = function(hookName, extensionName, func) {
            (this.actions[hookName] = this.actions[hookName] || {})[extensionName] = func;
        };
        /**
         * Registers a function to be called on the filter of the provided name.
         *
         * @memberof    mixitup.BaseStatic
         * @public
         * @static
         * @since       2.1.0
         * @param       {string}    hookName
         * @param       {string}    extensionName
         * @param       {function}  func
         * @return      {void}
         */ this.registerFilter = function(hookName, extensionName, func) {
            (this.filters[hookName] = this.filters[hookName] || {})[extensionName] = func;
        };
    };
    /**
     * The `mixitup.Features` class performs all feature and CSS prefix detection
     * neccessary for MixItUp to function correctly, as well as storing various
     * string and array constants. All feature decection is on evaluation of the
     * library and stored in a singleton instance for use by other internal classes.
     *
     * @constructor
     * @namespace
     * @memberof    mixitup
     * @private
     * @since       3.0.0
     */ mixitup.Features = function() {
        mixitup.Base.call(this);
        this.callActions("beforeConstruct");
        this.boxSizingPrefix = "";
        this.transformPrefix = "";
        this.transitionPrefix = "";
        this.boxSizingPrefix = "";
        this.transformProp = "";
        this.transformRule = "";
        this.transitionProp = "";
        this.perspectiveProp = "";
        this.perspectiveOriginProp = "";
        this.has = new mixitup.Has();
        this.canary = null;
        this.BOX_SIZING_PROP = "boxSizing";
        this.TRANSITION_PROP = "transition";
        this.TRANSFORM_PROP = "transform";
        this.PERSPECTIVE_PROP = "perspective";
        this.PERSPECTIVE_ORIGIN_PROP = "perspectiveOrigin";
        this.VENDORS = [
            "Webkit",
            "moz",
            "O",
            "ms"
        ];
        this.TWEENABLE = [
            "opacity",
            "width",
            "height",
            "marginRight",
            "marginBottom",
            "x",
            "y",
            "scale",
            "translateX",
            "translateY",
            "translateZ",
            "rotateX",
            "rotateY",
            "rotateZ"
        ];
        this.callActions("afterConstruct");
    };
    mixitup.BaseStatic.call(mixitup.Features);
    mixitup.Features.prototype = Object.create(mixitup.Base.prototype);
    h.extend(mixitup.Features.prototype, /** @lends mixitup.Features */ {
        constructor: mixitup.Features,
        /**
         * @private
         * @return  {void}
         */ init: function() {
            var self = this;
            self.callActions("beforeInit", arguments);
            self.canary = document.createElement("div");
            self.setPrefixes();
            self.runTests();
            self.callActions("beforeInit", arguments);
        },
        /**
         * @private
         * @return  {void}
         */ runTests: function() {
            var self = this;
            self.callActions("beforeRunTests", arguments);
            self.has.promises = typeof window1.Promise === "function";
            self.has.transitions = self.transitionPrefix !== "unsupported";
            self.callActions("afterRunTests", arguments);
            h.freeze(self.has);
        },
        /**
         * @private
         * @return  {void}
         */ setPrefixes: function() {
            var self = this;
            self.callActions("beforeSetPrefixes", arguments);
            self.transitionPrefix = h.getPrefix(self.canary, "Transition", self.VENDORS);
            self.transformPrefix = h.getPrefix(self.canary, "Transform", self.VENDORS);
            self.boxSizingPrefix = h.getPrefix(self.canary, "BoxSizing", self.VENDORS);
            self.boxSizingProp = self.boxSizingPrefix ? self.boxSizingPrefix + h.pascalCase(self.BOX_SIZING_PROP) : self.BOX_SIZING_PROP;
            self.transitionProp = self.transitionPrefix ? self.transitionPrefix + h.pascalCase(self.TRANSITION_PROP) : self.TRANSITION_PROP;
            self.transformProp = self.transformPrefix ? self.transformPrefix + h.pascalCase(self.TRANSFORM_PROP) : self.TRANSFORM_PROP;
            self.transformRule = self.transformPrefix ? "-" + self.transformPrefix + "-" + self.TRANSFORM_PROP : self.TRANSFORM_PROP;
            self.perspectiveProp = self.transformPrefix ? self.transformPrefix + h.pascalCase(self.PERSPECTIVE_PROP) : self.PERSPECTIVE_PROP;
            self.perspectiveOriginProp = self.transformPrefix ? self.transformPrefix + h.pascalCase(self.PERSPECTIVE_ORIGIN_PROP) : self.PERSPECTIVE_ORIGIN_PROP;
            self.callActions("afterSetPrefixes", arguments);
        }
    });
    /**
     * @constructor
     * @memberof    mixitup
     * @private
     * @since       3.0.0
     */ mixitup.Has = function() {
        this.transitions = false;
        this.promises = false;
        h.seal(this);
    };
    // Assign a singleton instance to `mixitup.features` and initialise:
    mixitup.features = new mixitup.Features();
    mixitup.features.init();
    /**
     * A group of properties defining the mixer's animation and effects settings.
     *
     * @constructor
     * @memberof    mixitup.Config
     * @name        animation
     * @namespace
     * @public
     * @since       2.0.0
     */ mixitup.ConfigAnimation = function() {
        mixitup.Base.call(this);
        this.callActions("beforeConstruct");
        /**
         * A boolean dictating whether or not animation should be enabled for the MixItUp instance.
         * If `false`, all operations will occur instantly and syncronously, although callback
         * functions and any returned promises will still be fulfilled.
         *
         * @example <caption>Example: Create a mixer with all animations disabled</caption>
         * var mixer = mixitup(containerEl, {
         *     animation: {
         *         enable: false
         *     }
         * });
         *
         * @name        enable
         * @memberof    mixitup.Config.animation
         * @instance
         * @type        {boolean}
         * @default     true
         */ this.enable = true;
        /**
         * A string of one or more space-separated properties to which transitions will be
         * applied for all filtering animations.
         *
         * Properties can be listed any order or combination, although they will be applied in a specific
         * predefined order to produce consistent results.
         *
         * To learn more about available effects, experiment by providing different animation configurations to any of our [demos](https://patrickunka.github.io/mixitup/demos).
         *
         * @example <caption>Example: Apply "fade" and "translateZ" effects to all animations</caption>
         * // As targets are filtered in and out, they will fade between
         * // opacity 1 and 0 and transform between translateZ(-100px) and
         * // translateZ(0).
         *
         * var mixer = mixitup(containerEl, {
         *     animation: {
         *         effects: 'fade translateZ(-100px)'
         *     }
         * });
         *
         * @name        effects
         * @memberof    mixitup.Config.animation
         * @instance
         * @type        {string}
         * @default     'fade scale'
         */ this.effects = "fade scale";
        /**
         * A string of one or more space-seperated effects to be applied only to filter-in
         * animations, overriding `config.animation.effects` if set.
         *
         * @example <caption>Example: Apply downwards vertical translate to targets being filtered in</caption>
         *
         * var mixer = mixitup(containerEl, {
         *     animation: {
         *         effectsIn: 'fade translateY(-100%)'
         *     }
         * });
         *
         * @name        effectsIn
         * @memberof    mixitup.Config.animation
         * @instance
         * @type        {string}
         * @default     ''
         */ this.effectsIn = "";
        /**
         * A string of one or more space-seperated effects to be applied only to filter-out
         * animations, overriding `config.animation.effects` if set.
         *
         * @example <caption>Example: Apply upwards vertical translate to targets being filtered out</caption>
         *
         * var mixer = mixitup(containerEl, {
         *     animation: {
         *         effectsOut: 'fade translateY(-100%)'
         *     }
         * });
         *
         * @name        effectsOut
         * @memberof    mixitup.Config.animation
         * @instance
         * @type        {string}
         * @default     ''
         */ this.effectsOut = "";
        /**
         * An integer dictating the duration of all MixItUp animations in milliseconds, not
         * including any additional delay apllied via the `'stagger'` effect.
         *
         * @example <caption>Example: Apply an animation duration of 200ms to all mixitup animations</caption>
         *
         * var mixer = mixitup(containerEl, {
         *     animation: {
         *         duration: 200
         *     }
         * });
         *
         * @name        duration
         * @memberof    mixitup.Config.animation
         * @instance
         * @type        {number}
         * @default     600
         */ this.duration = 600;
        /**
         * A valid CSS3 transition-timing function or shorthand. For a full list of accepted
         * values, visit <a href="http://easings.net" target="_blank">easings.net</a>.
         *
         * @example <caption>Example 1: Apply "ease-in-out" easing to all animations</caption>
         *
         * var mixer = mixitup(containerEl, {
         *     animation: {
         *         easing: 'ease-in-out'
         *     }
         * });
         *
         * @example <caption>Example 2: Apply a custom "cubic-bezier" easing function to all animations</caption>
         * var mixer = mixitup(containerEl, {
         *     animation: {
         *         easing: 'cubic-bezier(0.645, 0.045, 0.355, 1)'
         *     }
         * });
         *
         * @name        easing
         * @memberof    mixitup.Config.animation
         * @instance
         * @type        {string}
         * @default     'ease'
         */ this.easing = "ease";
        /**
         * A boolean dictating whether or not to apply perspective to the MixItUp container
         * during animations. By default, perspective is always applied and creates the
         * illusion of three-dimensional space for effects such as `translateZ`, `rotateX`,
         * and `rotateY`.
         *
         * You may wish to disable this and define your own perspective settings via CSS.
         *
         * @example <caption>Example: Prevent perspective from being applied to any 3D transforms</caption>
         * var mixer = mixitup(containerEl, {
         *     animation: {
         *         applyPerspective: false
         *     }
         * });
         *
         * @name        applyPerspective
         * @memberof    mixitup.Config.animation
         * @instance
         * @type        {bolean}
         * @default     true
         */ this.applyPerspective = true;
        /**
         * The perspective distance value to be applied to the container during animations,
         * affecting any 3D-transform-based effects.
         *
         * @example <caption>Example: Set a perspective distance of 2000px</caption>
         * var mixer = mixitup(containerEl, {
         *     animation: {
         *         effects: 'rotateY(-25deg)',
         *         perspectiveDistance: '2000px'
         *     }
         * });
         *
         * @name        perspectiveDistance
         * @memberof    mixitup.Config.animation
         * @instance
         * @type        {string}
         * @default     '3000px'
         */ this.perspectiveDistance = "3000px";
        /**
         * The perspective-origin value to be applied to the container during animations,
         * affecting any 3D-transform-based effects.
         *
         * @example <caption>Example: Set a perspective origin in the top-right of the container</caption>
         * var mixer = mixitup(containerEl, {
         *     animation: {
         *         effects: 'transateZ(-200px)',
         *         perspectiveOrigin: '100% 0'
         *     }
         * });
         *
         * @name        perspectiveOrigin
         * @memberof    mixitup.Config.animation
         * @instance
         * @type        {string}
         * @default     '50% 50%'
         */ this.perspectiveOrigin = "50% 50%";
        /**
         * A boolean dictating whether or not to enable the queuing of operations.
         *
         * If `true` (default), and a control is clicked or an API call is made while another
         * operation is progress, the operation will go into the queue and will be automatically exectuted
         * when the previous operaitons is finished.
         *
         * If `false`, any requested operations will be ignored, and the `onMixBusy` callback and `mixBusy`
         * event will be fired. If `debug.showWarnings` is enabled, a console warning will also occur.
         *
         * @example <caption>Example: Disable queuing</caption>
         * var mixer = mixitup(containerEl, {
         *     animation: {
         *         queue: false
         *     }
         * });
         *
         * @name        queue
         * @memberof    mixitup.Config.animation
         * @instance
         * @type        {boolean}
         * @default     true
         */ this.queue = true;
        /**
         * An integer dictacting the maximum number of operations allowed in the queue at
         * any time, when queuing is enabled.
         *
         * @example <caption>Example: Allow a maximum of 5 operations in the queue at any time</caption>
         * var mixer = mixitup(containerEl, {
         *     animation: {
         *         queueLimit: 5
         *     }
         * });
         *
         * @name        queueLimit
         * @memberof    mixitup.Config.animation
         * @instance
         * @type        {number}
         * @default     3
         */ this.queueLimit = 3;
        /**
         * A boolean dictating whether or not to transition the height and width of the
         * container as elements are filtered in and out. If disabled, the container height
         * will change abruptly.
         *
         * It may be desirable to disable this on mobile devices as the CSS `height` and
         * `width` properties do not receive GPU-acceleration and can therefore cause stuttering.
         *
         * @example <caption>Example 1: Disable the transitioning of the container height and/or width</caption>
         * var mixer = mixitup(containerEl, {
         *     animation: {
         *         animateResizeContainer: false
         *     }
         * });
         *
         * @example <caption>Example 2: Disable the transitioning of the container height and/or width for mobile devices only</caption>
         * var mixer = mixitup(containerEl, {
         *     animation: {
         *         animateResizeContainer: myFeatureTests.isMobile ? false : true
         *     }
         * });
         *
         * @name        animateResizeContainer
         * @memberof    mixitup.Config.animation
         * @instance
         * @type        {boolean}
         * @default     true
         */ this.animateResizeContainer = true;
        /**
         * A boolean dictating whether or not to transition the height and width of target
         * elements as they change throughout the course of an animation.
         *
         * This is often a must for flex-box grid layouts where the size of target elements may change
         * depending on final their position in relation to their siblings, or for `.changeLayout()`
         * operations where the size of targets change between layouts.
         *
         * NB: This feature requires additional calculations and manipulation to non-hardware-accelerated
         * properties which may adversely affect performance on slower devices, and is therefore
         * disabled by default.
         *
         * @example <caption>Example: Enable the transitioning of target widths and heights</caption>
         * var mixer = mixitup(containerEl, {
         *     animation: {
         *         animateResizeTargets: true
         *     }
         * });
         *
         * @name        animateResizeTargets
         * @memberof    mixitup.Config.animation
         * @instance
         * @type        {boolean}
         * @default     false
         */ this.animateResizeTargets = false;
        /**
         * A custom function used to manipulate the order in which the stagger delay is
         * incremented when using the ‘stagger’ effect.
         *
         * When using the 'stagger' effect, the delay applied to each target element is incremented
         * based on its index. You may create a custom function to manipulate the order in which the
         * delay is incremented and create engaging non-linear stagger effects.
         *
         * The function receives the index of the target element as a parameter, and must
         * return an integer which serves as the multiplier for the stagger delay.
         *
         * @example <caption>Example 1: Stagger target elements by column in a 3-column grid</caption>
         * var mixer = mixitup(containerEl, {
         *     animation: {
         *         effects: 'fade stagger(100ms)',
         *         staggerSequence: function(i) {
         *             return i % 3;
         *         }
         *     }
         * });
         *
         * @example <caption>Example 2: Using an algorithm to produce a more complex sequence</caption>
         * var mixer = mixitup(containerEl, {
         *     animation: {
         *         effects: 'fade stagger(100ms)',
         *         staggerSequence: function(i) {
         *             return (2*i) - (5*((i/3) - ((1/3) * (i%3))));
         *         }
         *     }
         * });
         *
         * @name        staggerSequence
         * @memberof    mixitup.Config.animation
         * @instance
         * @type        {function}
         * @default     null
         */ this.staggerSequence = null;
        /**
         * A boolean dictating whether or not to reverse the direction of `translate`
         * and `rotate` transforms for elements being filtered out.
         *
         * It can be used to create carousel-like animations where elements enter and exit
         * from opposite directions. If enabled, the effect `translateX(-100%)` for elements
         * being filtered in would become `translateX(100%)` for targets being filtered out.
         *
         * This functionality can also be achieved by providing seperate effects
         * strings for `config.animation.effectsIn` and `config.animation.effectsOut`.
         *
         * @example <caption>Example: Reverse the desired direction on any translate/rotate effect for targets being filtered out</caption>
         * // Elements being filtered in will be translated from '100%' to '0' while
         * // elements being filtered out will be translated from 0 to '-100%'
         *
         * var mixer = mixitup(containerEl, {
         *     animation: {
         *         effects: 'fade translateX(100%)',
         *         reverseOut: true,
         *         nudge: false // Disable nudging to create a carousel-like effect
         *     }
         * });
         *
         * @name        reverseOut
         * @memberof    mixitup.Config.animation
         * @instance
         * @type        {boolean}
         * @default     false
         */ this.reverseOut = false;
        /**
         * A boolean dictating whether or not to "nudge" the animation path of targets
         * when they are being filtered in and out simulatenously.
         *
         * This has been the default behavior of MixItUp since version 1, but it
         * may be desirable to disable this effect when filtering directly from
         * one exclusive set of targets to a different exclusive set of targets,
         * to create a carousel-like effect, or a generally more subtle animation.
         *
         * @example <caption>Example: Disable the "nudging" of targets being filtered in and out simulatenously</caption>
         *
         * var mixer = mixitup(containerEl, {
         *     animation: {
         *         nudge: false
         *     }
         * });
         *
         * @name        nudge
         * @memberof    mixitup.Config.animation
         * @instance
         * @type        {boolean}
         * @default     true
         */ this.nudge = true;
        /**
         * A boolean dictating whether or not to clamp the height of the container while MixItUp's
         * geometry tests are carried out before an operation.
         *
         * To prevent scroll-bar flicker, clamping is turned on by default. But in the case where the
         * height of the container might affect its vertical positioning in the viewport
         * (e.g. a vertically-centered container), this should be turned off to ensure accurate
         * test results and a smooth animation.
         *
         * @example <caption>Example: Disable container height-clamping</caption>
         *
         * var mixer = mixitup(containerEl, {
         *     animation: {
         *         clampHeight: false
         *     }
         * });
         *
         * @name        clampHeight
         * @memberof    mixitup.Config.animation
         * @instance
         * @type        {boolean}
         * @default     true
         */ this.clampHeight = true;
        /**
         * A boolean dictating whether or not to clamp the width of the container while MixItUp's
         * geometry tests are carried out before an operation.
         *
         * To prevent scroll-bar flicker, clamping is turned on by default. But in the case where the
         * width of the container might affect its horitzontal positioning in the viewport
         * (e.g. a horizontall-centered container), this should be turned off to ensure accurate
         * test results and a smooth animation.
         *
         * @example <caption>Example: Disable container width-clamping</caption>
         *
         * var mixer = mixitup(containerEl, {
         *     animation: {
         *         clampWidth: false
         *     }
         * });
         *
         * @name        clampWidth
         * @memberof    mixitup.Config.animation
         * @instance
         * @type        {boolean}
         * @default     true
         */ this.clampWidth = true;
        this.callActions("afterConstruct");
        h.seal(this);
    };
    mixitup.BaseStatic.call(mixitup.ConfigAnimation);
    mixitup.ConfigAnimation.prototype = Object.create(mixitup.Base.prototype);
    mixitup.ConfigAnimation.prototype.constructor = mixitup.ConfigAnimation;
    /**
     * A group of properties relating to the behavior of the Mixer.
     *
     * @constructor
     * @memberof    mixitup.Config
     * @name        behavior
     * @namespace
     * @public
     * @since       3.1.12
     */ mixitup.ConfigBehavior = function() {
        mixitup.Base.call(this);
        this.callActions("beforeConstruct");
        /**
         * A boolean dictating whether to allow "live" sorting of the mixer.
         *
         * Because of the expensive nature of sorting, MixItUp makes use of several
         * internal optimizations to skip redundant sorting operations, such as when
         * the newly requested sort command is the same as the active one. The caveat
         * to this optimization is that "live" edits to the value of a target's sorting
         * attribute will be ignored when requesting a re-sort by the same attribute.
         *
         * By setting to `behavior.liveSort` to `true`, the mixer will always re-sort
         * regardless of whether or not the sorting attribute and order have changed.
         *
         * @example <caption>Example: Enabling `liveSort` to allow for re-sorting</caption>
         *
         * var mixer = mixitup(containerEl, {
         *     behavior: {
         *         liveSort: true
         *     },
         *     load: {
         *         sort: 'edited:desc'
         *     }
         * });
         *
         * var target = containerEl.children[3];
         *
         * console.log(target.getAttribute('data-edited')); // '2015-04-24'
         *
         * target.setAttribute('data-edited', '2017-08-10'); // Update the target's edited date
         *
         * mixer.sort('edited:desc')
         *     .then(function(state) {
         *         // The target is now at the top of the list
         *
         *         console.log(state.targets[0] === target); // true
         *     });
         *
         * @name        liveSort
         * @memberof    mixitup.Config.behavior
         * @instance
         * @type        {boolean}
         * @default     false
         */ this.liveSort = false;
        this.callActions("afterConstruct");
        h.seal(this);
    };
    mixitup.BaseStatic.call(mixitup.ConfigBehavior);
    mixitup.ConfigBehavior.prototype = Object.create(mixitup.Base.prototype);
    mixitup.ConfigBehavior.prototype.constructor = mixitup.ConfigBehavior;
    /**
     * A group of optional callback functions to be invoked at various
     * points within the lifecycle of a mixer operation.
     *
     * Each function is analogous to an event of the same name triggered from the
     * container element, and is invoked immediately after it.
     *
     * All callback functions receive the current `state` object as their first
     * argument, as well as other more specific arguments described below.
     *
     * @constructor
     * @memberof    mixitup.Config
     * @name        callbacks
     * @namespace
     * @public
     * @since       2.0.0
     */ mixitup.ConfigCallbacks = function() {
        mixitup.Base.call(this);
        this.callActions("beforeConstruct");
        /**
         * A callback function invoked immediately after any MixItUp operation is requested
         * and before animations have begun.
         *
         * A second `futureState` argument is passed to the function which represents the final
         * state of the mixer once the requested operation has completed.
         *
         * @example <caption>Example: Adding an `onMixStart` callback function</caption>
         * var mixer = mixitup(containerEl, {
         *     callbacks: {
         *         onMixStart: function(state, futureState) {
         *              console.log('Starting operation...');
         *         }
         *     }
         * });
         *
         * @name        onMixStart
         * @memberof    mixitup.Config.callbacks
         * @instance
         * @type        {function}
         * @default     null
         */ this.onMixStart = null;
        /**
         * A callback function invoked when a MixItUp operation is requested while another
         * operation is in progress, and the animation queue is full, or queueing
         * is disabled.
         *
         * @example <caption>Example: Adding an `onMixBusy` callback function</caption>
         * var mixer = mixitup(containerEl, {
         *     callbacks: {
         *         onMixBusy: function(state) {
         *              console.log('Mixer busy');
         *         }
         *     }
         * });
         *
         * @name        onMixBusy
         * @memberof    mixitup.Config.callbacks
         * @instance
         * @type        {function}
         * @default     null
         */ this.onMixBusy = null;
        /**
         * A callback function invoked after any MixItUp operation has completed, and the
         * state has been updated.
         *
         * @example <caption>Example: Adding an `onMixEnd` callback function</caption>
         * var mixer = mixitup(containerEl, {
         *     callbacks: {
         *         onMixEnd: function(state) {
         *              console.log('Operation complete');
         *         }
         *     }
         * });
         *
         * @name        onMixEnd
         * @memberof    mixitup.Config.callbacks
         * @instance
         * @type        {function}
         * @default     null
         */ this.onMixEnd = null;
        /**
         * A callback function invoked whenever an operation "fails", i.e. no targets
         * could be found matching the requested filter.
         *
         * @example <caption>Example: Adding an `onMixFail` callback function</caption>
         * var mixer = mixitup(containerEl, {
         *     callbacks: {
         *         onMixFail: function(state) {
         *              console.log('No items could be found matching the requested filter');
         *         }
         *     }
         * });
         *
         * @name        onMixFail
         * @memberof    mixitup.Config.callbacks
         * @instance
         * @type        {function}
         * @default     null
         */ this.onMixFail = null;
        /**
         * A callback function invoked whenever a MixItUp control is clicked, and before its
         * respective operation is requested.
         *
         * The clicked element is assigned to the `this` keyword within the function. The original
         * click event is passed to the function as the second argument, which can be useful if
         * using `<a>` tags as controls where the default behavior needs to be prevented.
         *
         * Returning `false` from the callback will prevent the control click from triggering
         * an operation.
         *
         * @example <caption>Example 1: Adding an `onMixClick` callback function</caption>
         * var mixer = mixitup(containerEl, {
         *     callbacks: {
         *         onMixClick: function(state, originalEvent) {
         *              console.log('The control "' + this.innerText + '" was clicked');
         *         }
         *     }
         * });
         *
         * @example <caption>Example 2: Using `onMixClick` to manipulate the original click event</caption>
         * var mixer = mixitup(containerEl, {
         *     callbacks: {
         *         onMixClick: function(state, originalEvent) {
         *              // Prevent original click event from bubbling up:
         *              originalEvent.stopPropagation();
         *
         *              // Prevent default behavior of clicked element:
         *              originalEvent.preventDefault();
         *         }
         *     }
         * });
         *
         * @example <caption>Example 3: Using `onMixClick` to conditionally cancel operations</caption>
         * var mixer = mixitup(containerEl, {
         *     callbacks: {
         *         onMixClick: function(state, originalEvent) {
         *              // Perform some conditional check:
         *
         *              if (myApp.isLoading) {
         *                  // By returning false, we can prevent the control click from triggering an operation.
         *
         *                  return false;
         *              }
         *         }
         *     }
         * });
         *
         * @name        onMixClick
         * @memberof    mixitup.Config.callbacks
         * @instance
         * @type        {function}
         * @default     null
         */ this.onMixClick = null;
        this.callActions("afterConstruct");
        h.seal(this);
    };
    mixitup.BaseStatic.call(mixitup.ConfigCallbacks);
    mixitup.ConfigCallbacks.prototype = Object.create(mixitup.Base.prototype);
    mixitup.ConfigCallbacks.prototype.constructor = mixitup.ConfigCallbacks;
    /**
     * A group of properties relating to clickable control elements.
     *
     * @constructor
     * @memberof    mixitup.Config
     * @name        controls
     * @namespace
     * @public
     * @since       2.0.0
     */ mixitup.ConfigControls = function() {
        mixitup.Base.call(this);
        this.callActions("beforeConstruct");
        /**
         * A boolean dictating whether or not controls should be enabled for the mixer instance.
         *
         * If `true` (default behavior), MixItUp will search the DOM for any clickable elements with
         * `data-filter`, `data-sort` or `data-toggle` attributes, and bind them for click events.
         *
         * If `false`, no click handlers will be bound, and all functionality must therefore be performed
         * via the mixer's API methods.
         *
         * If you do not intend to use the default controls, setting this property to `false` will
         * marginally improve the startup time of your mixer instance, and will also prevent any other active
         * mixer instances in the DOM which are bound to controls from controlling the instance.
         *
         * @example <caption>Example: Disabling controls</caption>
         * var mixer = mixitup(containerEl, {
         *     controls: {
         *         enable: false
         *     }
         * });
         *
         * // With the default controls disabled, we can only control
         * // the mixer via its API methods, e.g.:
         *
         * mixer.filter('.cat-1');
         *
         * @name        enable
         * @memberof    mixitup.Config.controls
         * @instance
         * @type        {boolean}
         * @default     true
         */ this.enable = true;
        /**
         * A boolean dictating whether or not to use event delegation when binding click events
         * to the default controls.
         *
         * If `false` (default behavior), each control button in the DOM will be found and
         * individually bound when a mixer is instantiated, with their corresponding actions
         * cached for performance.
         *
         * If `true`, a single click handler will be applied to the `window` (or container element - see
         * `config.controls.scope`), and any click events triggered by elements with `data-filter`,
         * `data-sort` or `data-toggle` attributes present will be handled as they propagate upwards.
         *
         * If you require a user interface where control buttons may be added, removed, or changed during the
         * lifetime of a mixer, `controls.live` should be set to `true`. There is a marginal but unavoidable
         * performance deficit when using live controls, as the value of each control button must be read
         * from the DOM in real time once the click event has propagated.
         *
         * @example <caption>Example: Setting live controls</caption>
         * var mixer = mixitup(containerEl, {
         *     controls: {
         *         live: true
         *     }
         * });
         *
         * // Control buttons can now be added, remove and changed without breaking
         * // the mixer's UI
         *
         * @name        live
         * @memberof    mixitup.Config.controls
         * @instance
         * @type        {boolean}
         * @default     true
         */ this.live = false;
        /**
         * A string dictating the "scope" to use when binding or querying the default controls. The available
         * values are `'global'` or `'local'`.
         *
         * When set to `'global'` (default behavior), MixItUp will query the entire document for control buttons
         * to bind, or delegate click events from (see `config.controls.live`).
         *
         * When set to `'local'`, MixItUp will only query (or bind click events to) its own container element.
         * This may be desireable if you require multiple active mixer instances within the same document, with
         * controls that would otherwise intefere with each other if scoped globally.
         *
         * Conversely, if you wish to control multiple instances with a single UI, you would create one
         * set of controls and keep the controls scope of each mixer set to `global`.
         *
         * @example <caption>Example: Setting 'local' scoped controls</caption>
         * var mixerOne = mixitup(containerOne, {
         *     controls: {
         *         scope: 'local'
         *     }
         * });
         *
         * var mixerTwo = mixitup(containerTwo, {
         *     controls: {
         *         scope: 'local'
         *     }
         * });
         *
         * // Both mixers can now exist within the same document with
         * // isolated controls placed within their container elements.
         *
         * @name        scope
         * @memberof    mixitup.Config.controls
         * @instance
         * @type        {string}
         * @default     'global'
         */ this.scope = "global"; // enum: ['local' ,'global']
        /**
         * A string dictating the type of logic to apply when concatenating the filter selectors of
         * active toggle buttons (i.e. any clickable element with a `data-toggle` attribute).
         *
         * If set to `'or'` (default behavior), selectors will be concatenated together as
         * a comma-seperated list. For example:
         *
         * `'.cat-1, .cat-2'` (shows any elements matching `'.cat-1'` OR `'.cat-2'`)
         *
         * If set to `'and'`, selectors will be directly concatenated together. For example:
         *
         * `'.cat-1.cat-2'` (shows any elements which match both `'.cat-1'` AND `'.cat-2'`)
         *
         * @example <caption>Example: Setting "and" toggle logic</caption>
         * var mixer = mixitup(containerEl, {
         *     controls: {
         *         toggleLogic: 'and'
         *     }
         * });
         *
         * @name        toggleLogic
         * @memberof    mixitup.Config.controls
         * @instance
         * @type        {string}
         * @default     'or'
         */ this.toggleLogic = "or"; // enum: ['or', 'and']
        /**
         * A string dictating the filter behavior when all toggles are inactive.
         *
         * When set to `'all'` (default behavior), *all* targets will be shown by default
         * when no toggles are active, or at the moment all active toggles are toggled off.
         *
         * When set to `'none'`, no targets will be shown by default when no toggles are
         * active, or at the moment all active toggles are toggled off.
         *
         * @example <caption>Example 1: Setting the default toggle behavior to `'all'`</caption>
         * var mixer = mixitup(containerEl, {
         *     controls: {
         *         toggleDefault: 'all'
         *     }
         * });
         *
         * mixer.toggleOn('.cat-2')
         *     .then(function() {
         *         // Deactivate all active toggles
         *
         *         return mixer.toggleOff('.cat-2')
         *     })
         *     .then(function(state) {
         *          console.log(state.activeFilter.selector); // 'all'
         *          console.log(state.totalShow); // 12
         *     });
         *
         * @example <caption>Example 2: Setting the default toggle behavior to `'none'`</caption>
         * var mixer = mixitup(containerEl, {
         *     controls: {
         *         toggleDefault: 'none'
         *     }
         * });
         *
         * mixer.toggleOn('.cat-2')
         *     .then(function() {
         *         // Deactivate all active toggles
         *
         *         return mixer.toggleOff('.cat-2')
         *     })
         *     .then(function(state) {
         *          console.log(state.activeFilter.selector); // 'none'
         *          console.log(state.totalShow); // 0
         *     });
         *
         * @name        toggleDefault
         * @memberof    mixitup.Config.controls
         * @instance
         * @type        {string}
         * @default     'all'
         */ this.toggleDefault = "all"; // enum: ['all', 'none']
        this.callActions("afterConstruct");
        h.seal(this);
    };
    mixitup.BaseStatic.call(mixitup.ConfigControls);
    mixitup.ConfigControls.prototype = Object.create(mixitup.Base.prototype);
    mixitup.ConfigControls.prototype.constructor = mixitup.ConfigControls;
    /**
     * A group of properties defining the output and structure of class names programmatically
     * added to controls and containers to reflect the state of the mixer.
     *
     * Most commonly, class names are added to controls by MixItUp to indicate that
     * the control is active so that it can be styled accordingly - `'mixitup-control-active'` by default.
     *
     * Using a "BEM" like structure, each classname is broken into the three parts:
     * a block namespace (`'mixitup'`), an element name (e.g. `'control'`), and an optional modifier
     * name (e.g. `'active'`) reflecting the state of the element.
     *
     * By default, each part of the classname is concatenated together using single hyphens as
     * delineators, but this can be easily customised to match the naming convention and style of
     * your project.
     *
     * @constructor
     * @memberof    mixitup.Config
     * @name        classNames
     * @namespace
     * @public
     * @since       3.0.0
     */ mixitup.ConfigClassNames = function() {
        mixitup.Base.call(this);
        this.callActions("beforeConstruct");
        /**
         * The "block" portion, or top-level namespace added to the start of any class names created by MixItUp.
         *
         * @example <caption>Example 1: changing the `config.classNames.block` value</caption>
         * var mixer = mixitup(containerEl, {
         *     classNames: {
         *         block: 'portfolio'
         *     }
         * });
         *
         * // Active control output: "portfolio-control-active"
         *
         * @example <caption>Example 2: Removing `config.classNames.block`</caption>
         * var mixer = mixitup(containerEl, {
         *     classNames: {
         *         block: ''
         *     }
         * });
         *
         * // Active control output: "control-active"
         *
         * @name        block
         * @memberof    mixitup.Config.classNames
         * @instance
         * @type        {string}
         * @default     'mixitup'
         */ this.block = "mixitup";
        /**
         * The "element" portion of the class name added to container.
         *
         * @name        elementContainer
         * @memberof    mixitup.Config.classNames
         * @instance
         * @type        {string}
         * @default     'container'
         */ this.elementContainer = "container";
        /**
         * The "element" portion of the class name added to filter controls.
         *
         * By default, all filter, sort, multimix and toggle controls take the same element value of `'control'`, but
         * each type's element value can be individually overwritten to match the unique classNames of your controls as needed.
         *
         * @example <caption>Example 1: changing the `config.classNames.elementFilter` value</caption>
         * var mixer = mixitup(containerEl, {
         *     classNames: {
         *         elementFilter: 'filter'
         *     }
         * });
         *
         * // Active filter output: "mixitup-filter-active"
         *
         * @example <caption>Example 2: changing the `config.classNames.block` and `config.classNames.elementFilter` values</caption>
         * var mixer = mixitup(containerEl, {
         *     classNames: {
         *         block: 'portfolio',
         *         elementFilter: 'filter'
         *     }
         * });
         *
         * // Active filter output: "portfolio-filter-active"
         *
         * @name        elementFilter
         * @memberof    mixitup.Config.classNames
         * @instance
         * @type        {string}
         * @default     'control'
         */ this.elementFilter = "control";
        /**
         * The "element" portion of the class name added to sort controls.
         *
         * By default, all filter, sort, multimix and toggle controls take the same element value of `'control'`, but
         * each type's element value can be individually overwritten to match the unique classNames of your controls as needed.
         *
         * @example <caption>Example 1: changing the `config.classNames.elementSort` value</caption>
         * var mixer = mixitup(containerEl, {
         *     classNames: {
         *         elementSort: 'sort'
         *     }
         * });
         *
         * // Active sort output: "mixitup-sort-active"
         *
         * @example <caption>Example 2: changing the `config.classNames.block` and `config.classNames.elementSort` values</caption>
         * var mixer = mixitup(containerEl, {
         *     classNames: {
         *         block: 'portfolio',
         *         elementSort: 'sort'
         *     }
         * });
         *
         * // Active sort output: "portfolio-sort-active"
         *
         * @name        elementSort
         * @memberof    mixitup.Config.classNames
         * @instance
         * @type        {string}
         * @default     'control'
         */ this.elementSort = "control";
        /**
         * The "element" portion of the class name added to multimix controls.
         *
         * By default, all filter, sort, multimix and toggle controls take the same element value of `'control'`, but
         * each type's element value can be individually overwritten to match the unique classNames of your controls as needed.
         *
         * @example <caption>Example 1: changing the `config.classNames.elementMultimix` value</caption>
         * var mixer = mixitup(containerEl, {
         *     classNames: {
         *         elementMultimix: 'multimix'
         *     }
         * });
         *
         * // Active multimix output: "mixitup-multimix-active"
         *
         * @example <caption>Example 2: changing the `config.classNames.block` and `config.classNames.elementMultimix` values</caption>
         * var mixer = mixitup(containerEl, {
         *     classNames: {
         *         block: 'portfolio',
         *         elementSort: 'multimix'
         *     }
         * });
         *
         * // Active multimix output: "portfolio-multimix-active"
         *
         * @name        elementMultimix
         * @memberof    mixitup.Config.classNames
         * @instance
         * @type        {string}
         * @default     'control'
         */ this.elementMultimix = "control";
        /**
         * The "element" portion of the class name added to toggle controls.
         *
         * By default, all filter, sort, multimix and toggle controls take the same element value of `'control'`, but
         * each type's element value can be individually overwritten to match the unique classNames of your controls as needed.
         *
         * @example <caption>Example 1: changing the `config.classNames.elementToggle` value</caption>
         * var mixer = mixitup(containerEl, {
         *     classNames: {
         *         elementToggle: 'toggle'
         *     }
         * });
         *
         * // Active toggle output: "mixitup-toggle-active"
         *
         * @example <caption>Example 2: changing the `config.classNames.block` and `config.classNames.elementToggle` values</caption>
         * var mixer = mixitup(containerEl, {
         *     classNames: {
         *         block: 'portfolio',
         *         elementToggle: 'toggle'
         *     }
         * });
         *
         * // Active toggle output: "portfolio-toggle-active"
         *
         * @name        elementToggle
         * @memberof    mixitup.Config.classNames
         * @instance
         * @type        {string}
         * @default     'control'
         */ this.elementToggle = "control";
        /**
         * The "modifier" portion of the class name added to active controls.
         * @name        modifierActive
         * @memberof    mixitup.Config.classNames
         * @instance
         * @type        {string}
         * @default     'active'
         */ this.modifierActive = "active";
        /**
         * The "modifier" portion of the class name added to disabled controls.
         *
         * @name        modifierDisabled
         * @memberof    mixitup.Config.classNames
         * @instance
         * @type        {string}
         * @default     'disabled'
         */ this.modifierDisabled = "disabled";
        /**
         * The "modifier" portion of the class name added to the container when in a "failed" state.
         *
         * @name        modifierFailed
         * @memberof    mixitup.Config.classNames
         * @instance
         * @type        {string}
         * @default     'failed'
         */ this.modifierFailed = "failed";
        /**
         * The delineator used between the "block" and "element" portions of any class name added by MixItUp.
         *
         * If the block portion is ommited by setting it to an empty string, no delineator will be added.
         *
         * @example <caption>Example: changing the delineator to match BEM convention</caption>
         * var mixer = mixitup(containerEl, {
         *     classNames: {
         *         delineatorElement: '__'
         *     }
         * });
         *
         * // example active control output: "mixitup__control-active"
         *
         * @name        delineatorElement
         * @memberof    mixitup.Config.classNames
         * @instance
         * @type        {string}
         * @default     '-'
         */ this.delineatorElement = "-";
        /**
         * The delineator used between the "element" and "modifier" portions of any class name added by MixItUp.
         *
         * If the element portion is ommited by setting it to an empty string, no delineator will be added.
         *
         * @example <caption>Example: changing both delineators to match BEM convention</caption>
         * var mixer = mixitup(containerEl, {
         *     classNames: {
         *         delineatorElement: '__'
         *         delineatorModifier: '--'
         *     }
         * });
         *
         * // Active control output: "mixitup__control--active"
         *
         * @name        delineatorModifier
         * @memberof    mixitup.Config.classNames
         * @instance
         * @type        {string}
         * @default     '-'
         */ this.delineatorModifier = "-";
        this.callActions("afterConstruct");
        h.seal(this);
    };
    mixitup.BaseStatic.call(mixitup.ConfigClassNames);
    mixitup.ConfigClassNames.prototype = Object.create(mixitup.Base.prototype);
    mixitup.ConfigClassNames.prototype.constructor = mixitup.ConfigClassNames;
    /**
     * A group of properties relating to MixItUp's dataset API.
     *
     * @constructor
     * @memberof    mixitup.Config
     * @name        data
     * @namespace
     * @public
     * @since       3.0.0
     */ mixitup.ConfigData = function() {
        mixitup.Base.call(this);
        this.callActions("beforeConstruct");
        /**
         * A string specifying the name of the key containing your data model's unique
         * identifier (UID). To use the dataset API, a UID key must be specified and
         * be present and unique on all objects in the dataset you provide to MixItUp.
         *
         * For example, if your dataset is made up of MongoDB documents, the UID
         * key would be `'id'` or `'_id'`.
         *
         * @example <caption>Example: Setting the UID to `'id'`</caption>
         * var mixer = mixitup(containerEl, {
         *     data: {
         *         uidKey: 'id'
         *     }
         * });
         *
         * @name        uidKey
         * @memberof    mixitup.Config.data
         * @instance
         * @type        {string}
         * @default     ''
         */ this.uidKey = "";
        /**
         * A boolean dictating whether or not MixItUp should "dirty check" each object in
         * your dataset for changes whenever `.dataset()` is called, and re-render any targets
         * for which a change is found.
         *
         * Depending on the complexity of your data model, dirty checking can be expensive
         * and is therefore disabled by default.
         *
         * NB: For changes to be detected, a new immutable instance of the edited model must be
         * provided to mixitup, rather than manipulating properties on the existing instance.
         * If your changes are a result of a DB write and read, you will most likely be calling
         * `.dataset()` with a clean set of objects each time, so this will not be an issue.
         *
         * @example <caption>Example: Enabling dirty checking</caption>
         *
         * var myDataset = [
         *     {
         *         id: 0,
         *         title: "Blog Post Title 0"
         *         ...
         *     },
         *     {
         *         id: 1,
         *         title: "Blog Post Title 1"
         *         ...
         *     }
         * ];
         *
         * // Instantiate a mixer with a pre-loaded dataset, and a target renderer
         * // function defined
         *
         * var mixer = mixitup(containerEl, {
         *     data: {
         *         uidKey: 'id',
         *         dirtyCheck: true
         *     },
         *     load: {
         *         dataset: myDataset
         *     },
         *     render: {
         *         target: function() { ... }
         *     }
         * });
         *
         * // For illustration, we will clone and edit the second object in the dataset.
         * // NB: this would typically be done server-side in response to a DB update,
         * and then re-queried via an API.
         *
         * myDataset[1] = Object.assign({}, myDataset[1]);
         *
         * myDataset[1].title = 'Blog Post Title 11';
         *
         * mixer.dataset(myDataset)
         *    .then(function() {
         *        // the target with ID "1", will be re-rendered reflecting its new title
         *    });
         *
         * @name        dirtyCheck
         * @memberof    mixitup.Config.data
         * @instance
         * @type        {boolean}
         * @default     false
         */ this.dirtyCheck = false;
        this.callActions("afterConstruct");
        h.seal(this);
    };
    mixitup.BaseStatic.call(mixitup.ConfigData);
    mixitup.ConfigData.prototype = Object.create(mixitup.Base.prototype);
    mixitup.ConfigData.prototype.constructor = mixitup.ConfigData;
    /**
     * A group of properties allowing the toggling of various debug features.
     *
     * @constructor
     * @memberof    mixitup.Config
     * @name        debug
     * @namespace
     * @public
     * @since       3.0.0
     */ mixitup.ConfigDebug = function() {
        mixitup.Base.call(this);
        this.callActions("beforeConstruct");
        /**
         * A boolean dictating whether or not the mixer instance returned by the
         * `mixitup()` factory function should expose private properties and methods.
         *
         * By default, mixer instances only expose their public API, but enabling
         * debug mode will give you access to various mixer internals which may aid
         * in debugging, or the authoring of extensions.
         *
         * @example <caption>Example: Enabling debug mode</caption>
         *
         * var mixer = mixitup(containerEl, {
         *     debug: {
         *         enable: true
         *     }
         * });
         *
         * // Private properties and methods will now be visible on the mixer instance:
         *
         * console.log(mixer);
         *
         * @name        enable
         * @memberof    mixitup.Config.debug
         * @instance
         * @type        {boolean}
         * @default     false
         */ this.enable = false;
        /**
         * A boolean dictating whether or not warnings should be shown when various
         * common gotchas occur.
         *
         * Warnings are intended to provide insights during development when something
         * occurs that is not a fatal, but may indicate an issue with your integration,
         * and are therefore turned on by default. However, you may wish to disable
         * them in production.
         *
         * @example <caption>Example 1: Disabling warnings</caption>
         *
         * var mixer = mixitup(containerEl, {
         *     debug: {
         *         showWarnings: false
         *     }
         * });
         *
         * @example <caption>Example 2: Disabling warnings based on environment</caption>
         *
         * var showWarnings = myAppConfig.environment === 'development' ? true : false;
         *
         * var mixer = mixitup(containerEl, {
         *     debug: {
         *         showWarnings: showWarnings
         *     }
         * });
         *
         * @name        showWarnings
         * @memberof    mixitup.Config.debug
         * @instance
         * @type        {boolean}
         * @default     true
         */ this.showWarnings = true;
        /**
         * Used for server-side testing only.
         *
         * @private
         * @name        fauxAsync
         * @memberof    mixitup.Config.debug
         * @instance
         * @type        {boolean}
         * @default     false
         */ this.fauxAsync = false;
        this.callActions("afterConstruct");
        h.seal(this);
    };
    mixitup.BaseStatic.call(mixitup.ConfigDebug);
    mixitup.ConfigDebug.prototype = Object.create(mixitup.Base.prototype);
    mixitup.ConfigDebug.prototype.constructor = mixitup.ConfigDebug;
    /**
     * A group of properties relating to the layout of the container.
     *
     * @constructor
     * @memberof    mixitup.Config
     * @name        layout
     * @namespace
     * @public
     * @since       3.0.0
     */ mixitup.ConfigLayout = function() {
        mixitup.Base.call(this);
        this.callActions("beforeConstruct");
        /**
         * A boolean dictating whether or not mixitup should query all descendants
         * of the container for targets, or only immediate children.
         *
         * By default, mixitup will query all descendants matching the
         * `selectors.target` selector when indexing targets upon instantiation.
         * This allows for targets to be nested inside a sub-container which is
         * useful when ring-fencing targets from locally scoped controls in your
         * markup (see `controls.scope`).
         *
         * However, if you are building a more complex UI requiring the nesting
         * of mixers within mixers, you will most likely want to limit targets to
         * immediate children of the container by setting this property to `false`.
         *
         * @example <caption>Example: Restricting targets to immediate children</caption>
         *
         * var mixer = mixitup(containerEl, {
         *     layout: {
         *         allowNestedTargets: false
         *     }
         * });
         *
         * @name        allowNestedTargets
         * @memberof    mixitup.Config.layout
         * @instance
         * @type        {boolean}
         * @default     true
         */ this.allowNestedTargets = true;
        /**
         * A string specifying an optional class name to apply to the container when in
         * its default state.
         *
         * By changing this class name or adding a class name to the container via the
         * `.changeLayout()` API method, the CSS layout of the container can be changed,
         * and MixItUp will attemp to gracefully animate the container and its targets
         * between states.
         *
         * @example <caption>Example 1: Specifying a container class name</caption>
         *
         * var mixer = mixitup(containerEl, {
         *     layout: {
         *         containerClassName: 'grid'
         *     }
         * });
         *
         * @example <caption>Example 2: Changing the default class name with `.changeLayout()`</caption>
         *
         * var mixer = mixitup(containerEl, {
         *     layout: {
         *         containerClassName: 'grid'
         *     }
         * });
         *
         * mixer.changeLayout('list')
         *     .then(function(state) {
         *          console.log(state.activeContainerClass); // "list"
         *     });
         *
         * @name        containerClassName
         * @memberof    mixitup.Config.layout
         * @instance
         * @type        {string}
         * @default     ''
         */ this.containerClassName = "";
        /**
         * A reference to a non-target sibling element after which to insert targets
         * when there are no targets in the container.
         *
         * @example <caption>Example: Setting a `siblingBefore` reference element</caption>
         *
         * var addButton = containerEl.querySelector('button');
         *
         * var mixer = mixitup(containerEl, {
         *     layout: {
         *         siblingBefore: addButton
         *     }
         * });
         *
         * @name        siblingBefore
         * @memberof    mixitup.Config.layout
         * @instance
         * @type        {HTMLElement}
         * @default     null
         */ this.siblingBefore = null;
        /**
         * A reference to a non-target sibling element before which to insert targets
         * when there are no targets in the container.
         *
         * @example <caption>Example: Setting an `siblingAfter` reference element</caption>
         *
         * var gap = containerEl.querySelector('.gap');
         *
         * var mixer = mixitup(containerEl, {
         *     layout: {
         *         siblingAfter: gap
         *     }
         * });
         *
         * @name        siblingAfter
         * @memberof    mixitup.Config.layout
         * @instance
         * @type        {HTMLElement}
         * @default     null
         */ this.siblingAfter = null;
        this.callActions("afterConstruct");
        h.seal(this);
    };
    mixitup.BaseStatic.call(mixitup.ConfigLayout);
    mixitup.ConfigLayout.prototype = Object.create(mixitup.Base.prototype);
    mixitup.ConfigLayout.prototype.constructor = mixitup.ConfigLayout;
    /**
     * A group of properties defining the initial state of the mixer on load (instantiation).
     *
     * @constructor
     * @memberof    mixitup.Config
     * @name        load
     * @namespace
     * @public
     * @since       2.0.0
     */ mixitup.ConfigLoad = function() {
        mixitup.Base.call(this);
        this.callActions("beforeConstruct");
        /**
         * A string defining any filtering to be statically applied to the mixer on load.
         * As per the `.filter()` API, this can be any valid selector string, or the
         * values `'all'` or `'none'`.
         *
         * @example <caption>Example 1: Defining an initial filter selector to be applied on load</caption>
         *
         * // The mixer will show only those targets matching '.category-a' on load.
         *
         * var mixer = mixitup(containerEl, {
         *     load: {
         *         filter: '.category-a'
         *     }
         * });
         *
         * @example <caption>Example 2: Hiding all targets on load</caption>
         *
         * // The mixer will show hide all targets on load.
         *
         * var mixer = mixitup(containerEl, {
         *     load: {
         *         filter: 'none'
         *     }
         * });
         *
         * @name        filter
         * @memberof    mixitup.Config.load
         * @instance
         * @type        {string}
         * @default     'all'
         */ this.filter = "all";
        /**
         * A string defining any sorting to be statically applied to the mixer on load.
         * As per the `.sort()` API, this should be a valid "sort string" made up of
         * an attribute to sort by (or `'default'`) followed by an optional sorting
         * order, or the value `'random'`;
         *
         * @example <caption>Example: Defining sorting to be applied on load</caption>
         *
         * // The mixer will sort the container by the value of the `data-published-date`
         * // attribute, in descending order.
         *
         * var mixer = mixitup(containerEl, {
         *     load: {
         *         sort: 'published-date:desc'
         *     }
         * });
         *
         * @name        sort
         * @memberof    mixitup.Config.load
         * @instance
         * @type        {string}
         * @default     'default:asc'
         */ this.sort = "default:asc";
        /**
         * An array of objects representing the underlying data of any pre-rendered targets,
         * when using the `.dataset()` API.
         *
         * NB: If targets are pre-rendered when the mixer is instantiated, this must be set.
         *
         * @example <caption>Example: Defining the initial underyling dataset</caption>
         *
         * var myDataset = [
         *     {
         *         id: 0,
         *         title: "Blog Post Title 0",
         *         ...
         *     },
         *     {
         *         id: 1,
         *         title: "Blog Post Title 1",
         *         ...
         *     }
         * ];
         *
         * var mixer = mixitup(containerEl, {
         *     data: {
         *         uidKey: 'id'
         *     },
         *     load: {
         *         dataset: myDataset
         *     }
         * });
         *
         * @name        dataset
         * @memberof    mixitup.Config.load
         * @instance
         * @type        {Array.<object>}
         * @default     null
         */ this.dataset = null;
        this.callActions("afterConstruct");
        h.seal(this);
    };
    mixitup.BaseStatic.call(mixitup.ConfigLoad);
    mixitup.ConfigLoad.prototype = Object.create(mixitup.Base.prototype);
    mixitup.ConfigLoad.prototype.constructor = mixitup.ConfigLoad;
    /**
     * A group of properties defining the selectors used to query elements within a mixitup container.
     *
     * @constructor
     * @memberof    mixitup.Config
     * @name        selectors
     * @namespace
     * @public
     * @since       3.0.0
     */ mixitup.ConfigSelectors = function() {
        mixitup.Base.call(this);
        this.callActions("beforeConstruct");
        /**
         * A selector string used to query and index target elements within the container.
         *
         * By default, the class selector `'.mix'` is used, but this can be changed to an
         * attribute or element selector to match the style of your project.
         *
         * @example <caption>Example 1: Changing the target selector</caption>
         *
         * var mixer = mixitup(containerEl, {
         *     selectors: {
         *         target: '.portfolio-item'
         *     }
         * });
         *
         * @example <caption>Example 2: Using an attribute selector as a target selector</caption>
         *
         * // The mixer will search for any children with the attribute `data-ref="mix"`
         *
         * var mixer = mixitup(containerEl, {
         *     selectors: {
         *         target: '[data-ref="mix"]'
         *     }
         * });
         *
         * @name        target
         * @memberof    mixitup.Config.selectors
         * @instance
         * @type        {string}
         * @default     '.mix'
         */ this.target = ".mix";
        /**
         * A optional selector string used to add further specificity to the querying of control elements,
         * in addition to their mandatory data attribute (e.g. `data-filter`, `data-toggle`, `data-sort`).
         *
         * This can be used if other elements in your document must contain the above attributes
         * (e.g. for use in third-party scripts), and would otherwise interfere with MixItUp. Adding
         * an additional `control` selector of your choice allows MixItUp to restrict event handling
         * to only those elements matching the defined selector.
         *
         * @name        control
         * @memberof    mixitup.Config.selectors
         * @instance
         * @type        {string}
         * @default     ''
         *
         * @example <caption>Example 1: Adding a `selectors.control` selector</caption>
         *
         * var mixer = mixitup(containerEl, {
         *     selectors: {
         *         control: '.mixitup-control'
         *     }
         * });
         *
         * // Will not be handled:
         * // <button data-filter=".category-a"></button>
         *
         * // Will be handled:
         * // <button class="mixitup-control" data-filter=".category-a"></button>
         */ this.control = "";
        this.callActions("afterConstruct");
        h.seal(this);
    };
    mixitup.BaseStatic.call(mixitup.ConfigSelectors);
    mixitup.ConfigSelectors.prototype = Object.create(mixitup.Base.prototype);
    mixitup.ConfigSelectors.prototype.constructor = mixitup.ConfigSelectors;
    /**
     * A group of optional render functions for creating and updating elements.
     *
     * All render functions receive a data object, and should return a valid HTML string.
     *
     * @constructor
     * @memberof    mixitup.Config
     * @name        render
     * @namespace
     * @public
     * @since       3.0.0
     */ mixitup.ConfigRender = function() {
        mixitup.Base.call(this);
        this.callActions("beforeConstruct");
        /**
         * A function returning an HTML string representing a target element, or a reference to a
         * single DOM element.
         *
         * The function is invoked as part of the `.dataset()` API, whenever a new item is added
         * to the dataset, or an item in the dataset changes (if `dataset.dirtyCheck` is enabled).
         *
         * The function receives the relevant dataset item as its first parameter.
         *
         * @example <caption>Example 1: Using string concatenation</caption>
         *
         * var mixer = mixitup(containerEl, {
         *     render: {
         *         target: function(item) {
         *             return (
         *                 '&lt;div class="mix"&gt;' +
         *                     '&lt;h2&gt;' + item.title + '&lt;/h2&gt;' +
         *                 '&lt;/div&gt;'
         *             );
         *         }
         *     }
         * });
         *
         * @example <caption>Example 2: Using an ES2015 template literal</caption>
         *
         * var mixer = mixitup(containerEl, {
         *     render: {
         *         target: function(item) {
         *             return (
         *                 `&lt;div class="mix"&gt;
         *                     &lt;h2&gt;${item.title}&lt;/h2&gt;
         *                  &lt;/div&gt;`
         *             );
         *         }
         *     }
         * });
         *
         * @example <caption>Example 3: Using a Handlebars template</caption>
         *
         * var targetTemplate = Handlebars.compile('&lt;div class="mix"&gt;&lt;h2&gt;{{title}}&lt;/h2&gt;&lt;/div&gt;');
         *
         * var mixer = mixitup(containerEl, {
         *     render: {
         *         target: targetTemplate
         *     }
         * });
         *
         * @example <caption>Example 4: Returning a DOM element</caption>
         *
         * var mixer = mixitup(containerEl, {
         *     render: {
         *         target: function(item) {
         *              // Create a single element using your framework's built-in renderer
         *
         *              var el = ...
         *
         *              return el;
         *         }
         *     }
         * });
         *
         * @name        target
         * @memberof    mixitup.Config.render
         * @instance
         * @type        {function}
         * @default     'null'
         */ this.target = null;
        this.callActions("afterConstruct");
        h.seal(this);
    };
    mixitup.BaseStatic.call(mixitup.ConfigRender);
    mixitup.ConfigRender.prototype = Object.create(mixitup.Base.prototype);
    mixitup.ConfigRender.prototype.constructor = mixitup.ConfigRender;
    /**
     * @constructor
     * @memberof    mixitup
     * @private
     * @since       3.0.0
     */ mixitup.ConfigTemplates = function() {
        mixitup.Base.call(this);
        this.callActions("beforeConstruct");
        this.callActions("afterConstruct");
        h.seal(this);
    };
    mixitup.BaseStatic.call(mixitup.ConfigTemplates);
    mixitup.ConfigTemplates.prototype = Object.create(mixitup.Base.prototype);
    mixitup.ConfigTemplates.prototype.constructor = mixitup.ConfigTemplates;
    /**
     * `mixitup.Config` is an interface used for customising the functionality of a
     * mixer instance. It is organised into several semantically distinct sub-objects,
     * each one pertaining to a particular aspect of MixItUp functionality.
     *
     * An object literal containing any or all of the available properies,
     * known as the "configuration object", can be passed as the second parameter to
     * the `mixitup` factory function when creating a mixer instance to customise its
     * functionality as needed.
     *
     * If no configuration object is passed, the mixer instance will take on the default
     * configuration values detailed below.
     *
     * @example <caption>Example 1: Creating and passing the configuration object</caption>
     * // Create a configuration object with desired values
     *
     * var config = {
     *     animation: {
     *         enable: false
     *     },
     *     selectors: {
     *         target: '.item'
     *     }
     * };
     *
     * // Pass the configuration object to the mixitup factory function
     *
     * var mixer = mixitup(containerEl, config);
     *
     * @example <caption>Example 2: Passing the configuration object inline</caption>
     * // Typically, the configuration object is passed inline for brevity.
     *
     * var mixer = mixitup(containerEl, {
     *     controls: {
     *         live: true,
     *         toggleLogic: 'and'
     *     }
     * });
     *
     *
     * @constructor
     * @memberof    mixitup
     * @namespace
     * @public
     * @since       2.0.0
     */ mixitup.Config = function() {
        mixitup.Base.call(this);
        this.callActions("beforeConstruct");
        this.animation = new mixitup.ConfigAnimation();
        this.behavior = new mixitup.ConfigBehavior();
        this.callbacks = new mixitup.ConfigCallbacks();
        this.controls = new mixitup.ConfigControls();
        this.classNames = new mixitup.ConfigClassNames();
        this.data = new mixitup.ConfigData();
        this.debug = new mixitup.ConfigDebug();
        this.layout = new mixitup.ConfigLayout();
        this.load = new mixitup.ConfigLoad();
        this.selectors = new mixitup.ConfigSelectors();
        this.render = new mixitup.ConfigRender();
        this.templates = new mixitup.ConfigTemplates();
        this.callActions("afterConstruct");
        h.seal(this);
    };
    mixitup.BaseStatic.call(mixitup.Config);
    mixitup.Config.prototype = Object.create(mixitup.Base.prototype);
    mixitup.Config.prototype.constructor = mixitup.Config;
    /**
     * @constructor
     * @memberof    mixitup
     * @private
     * @since       3.0.0
     */ mixitup.MixerDom = function() {
        mixitup.Base.call(this);
        this.callActions("beforeConstruct");
        this.document = null;
        this.body = null;
        this.container = null;
        this.parent = null;
        this.targets = [];
        this.callActions("afterConstruct");
        h.seal(this);
    };
    mixitup.BaseStatic.call(mixitup.MixerDom);
    mixitup.MixerDom.prototype = Object.create(mixitup.Base.prototype);
    mixitup.MixerDom.prototype.constructor = mixitup.MixerDom;
    /**
     * @constructor
     * @memberof    mixitup
     * @private
     * @since       3.0.0
     */ mixitup.UiClassNames = function() {
        mixitup.Base.call(this);
        this.callActions("beforeConstruct");
        this.base = "";
        this.active = "";
        this.disabled = "";
        this.callActions("afterConstruct");
        h.seal(this);
    };
    mixitup.BaseStatic.call(mixitup.UiClassNames);
    mixitup.UiClassNames.prototype = Object.create(mixitup.Base.prototype);
    mixitup.UiClassNames.prototype.constructor = mixitup.UiClassNames;
    /**
     * An object into which all arbitrary arguments sent to '.dataset()' are mapped.
     *
     * @constructor
     * @memberof    mixitup
     * @private
     * @since       3.0.0
     */ mixitup.CommandDataset = function() {
        mixitup.Base.call(this);
        this.callActions("beforeConstruct");
        this.dataset = null;
        this.callActions("afterConstruct");
        h.seal(this);
    };
    mixitup.BaseStatic.call(mixitup.CommandDataset);
    mixitup.CommandDataset.prototype = Object.create(mixitup.Base.prototype);
    mixitup.CommandDataset.prototype.constructor = mixitup.CommandDataset;
    /**
     * An object into which all arbitrary arguments sent to '.multimix()' are mapped.
     *
     * @constructor
     * @memberof    mixitup
     * @private
     * @since       3.0.0
     */ mixitup.CommandMultimix = function() {
        mixitup.Base.call(this);
        this.callActions("beforeConstruct");
        this.filter = null;
        this.sort = null;
        this.insert = null;
        this.remove = null;
        this.changeLayout = null;
        this.callActions("afterConstruct");
        h.seal(this);
    };
    mixitup.BaseStatic.call(mixitup.CommandMultimix);
    mixitup.CommandMultimix.prototype = Object.create(mixitup.Base.prototype);
    mixitup.CommandMultimix.prototype.constructor = mixitup.CommandMultimix;
    /**
     * An object into which all arbitrary arguments sent to '.filter()' are mapped.
     *
     * @constructor
     * @memberof    mixitup
     * @private
     * @since       3.0.0
     */ mixitup.CommandFilter = function() {
        mixitup.Base.call(this);
        this.callActions("beforeConstruct");
        this.selector = "";
        this.collection = null;
        this.action = "show"; // enum: ['show', 'hide']
        this.callActions("afterConstruct");
        h.seal(this);
    };
    mixitup.BaseStatic.call(mixitup.CommandFilter);
    mixitup.CommandFilter.prototype = Object.create(mixitup.Base.prototype);
    mixitup.CommandFilter.prototype.constructor = mixitup.CommandFilter;
    /**
     * An object into which all arbitrary arguments sent to '.sort()' are mapped.
     *
     * @constructor
     * @memberof    mixitup
     * @private
     * @since       3.0.0
     */ mixitup.CommandSort = function() {
        mixitup.Base.call(this);
        this.callActions("beforeConstruct");
        this.sortString = "";
        this.attribute = "";
        this.order = "asc";
        this.collection = null;
        this.next = null;
        this.callActions("afterConstruct");
        h.seal(this);
    };
    mixitup.BaseStatic.call(mixitup.CommandSort);
    mixitup.CommandSort.prototype = Object.create(mixitup.Base.prototype);
    mixitup.CommandSort.prototype.constructor = mixitup.CommandSort;
    /**
     * An object into which all arbitrary arguments sent to '.insert()' are mapped.
     *
     * @constructor
     * @memberof    mixitup
     * @private
     * @since       3.0.0
     */ mixitup.CommandInsert = function() {
        mixitup.Base.call(this);
        this.callActions("beforeConstruct");
        this.index = 0;
        this.collection = [];
        this.position = "before"; // enum: ['before', 'after']
        this.sibling = null;
        this.callActions("afterConstruct");
        h.seal(this);
    };
    mixitup.BaseStatic.call(mixitup.CommandInsert);
    mixitup.CommandInsert.prototype = Object.create(mixitup.Base.prototype);
    mixitup.CommandInsert.prototype.constructor = mixitup.CommandInsert;
    /**
     * An object into which all arbitrary arguments sent to '.remove()' are mapped.
     *
     * @constructor
     * @memberof    mixitup
     * @private
     * @since       3.0.0
     */ mixitup.CommandRemove = function() {
        mixitup.Base.call(this);
        this.callActions("beforeConstruct");
        this.targets = [];
        this.collection = [];
        this.callActions("afterConstruct");
        h.seal(this);
    };
    mixitup.BaseStatic.call(mixitup.CommandRemove);
    mixitup.CommandRemove.prototype = Object.create(mixitup.Base.prototype);
    mixitup.CommandRemove.prototype.constructor = mixitup.CommandRemove;
    /**
     * An object into which all arbitrary arguments sent to '.changeLayout()' are mapped.
     *
     * @constructor
     * @memberof    mixitup
     * @private
     * @since       3.0.0
     */ mixitup.CommandChangeLayout = function() {
        mixitup.Base.call(this);
        this.callActions("beforeConstruct");
        this.containerClassName = "";
        this.callActions("afterConstruct");
        h.seal(this);
    };
    mixitup.BaseStatic.call(mixitup.CommandChangeLayout);
    mixitup.CommandChangeLayout.prototype = Object.create(mixitup.Base.prototype);
    mixitup.CommandChangeLayout.prototype.constructor = mixitup.CommandChangeLayout;
    /**
     * @constructor
     * @memberof    mixitup
     * @private
     * @since       3.0.0
     * @param       {string}        type
     * @param       {string}        selector
     * @param       {boolean}       [live]
     * @param       {string}        [parent]
     *     An optional string representing the name of the mixer.dom property containing a reference to a parent element.
     */ mixitup.ControlDefinition = function(type, selector, live, parent) {
        mixitup.Base.call(this);
        this.callActions("beforeConstruct");
        this.type = type;
        this.selector = selector;
        this.live = live || false;
        this.parent = parent || "";
        this.callActions("afterConstruct");
        h.freeze(this);
        h.seal(this);
    };
    mixitup.BaseStatic.call(mixitup.ControlDefinition);
    mixitup.ControlDefinition.prototype = Object.create(mixitup.Base.prototype);
    mixitup.ControlDefinition.prototype.constructor = mixitup.ControlDefinition;
    mixitup.controlDefinitions = [];
    mixitup.controlDefinitions.push(new mixitup.ControlDefinition("multimix", "[data-filter][data-sort]"));
    mixitup.controlDefinitions.push(new mixitup.ControlDefinition("filter", "[data-filter]"));
    mixitup.controlDefinitions.push(new mixitup.ControlDefinition("sort", "[data-sort]"));
    mixitup.controlDefinitions.push(new mixitup.ControlDefinition("toggle", "[data-toggle]"));
    /**
     * @constructor
     * @memberof    mixitup
     * @private
     * @since       3.0.0
     */ mixitup.Control = function() {
        mixitup.Base.call(this);
        this.callActions("beforeConstruct");
        this.el = null;
        this.selector = "";
        this.bound = [];
        this.pending = -1;
        this.type = "";
        this.status = "inactive"; // enum: ['inactive', 'active', 'disabled', 'live']
        this.filter = "";
        this.sort = "";
        this.canDisable = false;
        this.handler = null;
        this.classNames = new mixitup.UiClassNames();
        this.callActions("afterConstruct");
        h.seal(this);
    };
    mixitup.BaseStatic.call(mixitup.Control);
    mixitup.Control.prototype = Object.create(mixitup.Base.prototype);
    h.extend(mixitup.Control.prototype, /** @lends mixitup.Control */ {
        constructor: mixitup.Control,
        /**
         * @private
         * @param {HTMLElement} el
         * @param {string}      type
         * @param {string}      selector
         */ init: function(el, type, selector) {
            var self = this;
            this.callActions("beforeInit", arguments);
            self.el = el;
            self.type = type;
            self.selector = selector;
            if (self.selector) self.status = "live";
            else {
                self.canDisable = typeof self.el.disable === "boolean";
                switch(self.type){
                    case "filter":
                        self.filter = self.el.getAttribute("data-filter");
                        break;
                    case "toggle":
                        self.filter = self.el.getAttribute("data-toggle");
                        break;
                    case "sort":
                        self.sort = self.el.getAttribute("data-sort");
                        break;
                    case "multimix":
                        self.filter = self.el.getAttribute("data-filter");
                        self.sort = self.el.getAttribute("data-sort");
                        break;
                }
            }
            self.bindClick();
            mixitup.controls.push(self);
            this.callActions("afterInit", arguments);
        },
        /**
         * @private
         * @param  {mixitup.Mixer} mixer
         * @return {boolean}
         */ isBound: function(mixer) {
            var self = this, isBound = false;
            this.callActions("beforeIsBound", arguments);
            isBound = self.bound.indexOf(mixer) > -1;
            return self.callFilters("afterIsBound", isBound, arguments);
        },
        /**
         * @private
         * @param  {mixitup.Mixer} mixer
         * @return {void}
         */ addBinding: function(mixer) {
            var self = this;
            this.callActions("beforeAddBinding", arguments);
            if (!self.isBound()) self.bound.push(mixer);
            this.callActions("afterAddBinding", arguments);
        },
        /**
         * @private
         * @param  {mixitup.Mixer} mixer
         * @return {void}
         */ removeBinding: function(mixer) {
            var self = this, removeIndex = -1;
            this.callActions("beforeRemoveBinding", arguments);
            if ((removeIndex = self.bound.indexOf(mixer)) > -1) self.bound.splice(removeIndex, 1);
            if (self.bound.length < 1) {
                // No bindings exist, unbind event click handlers
                self.unbindClick();
                // Remove from `mixitup.controls` list
                removeIndex = mixitup.controls.indexOf(self);
                mixitup.controls.splice(removeIndex, 1);
                if (self.status === "active") self.renderStatus(self.el, "inactive");
            }
            this.callActions("afterRemoveBinding", arguments);
        },
        /**
         * @private
         * @return {void}
         */ bindClick: function() {
            var self = this;
            this.callActions("beforeBindClick", arguments);
            self.handler = function(e) {
                self.handleClick(e);
            };
            h.on(self.el, "click", self.handler);
            this.callActions("afterBindClick", arguments);
        },
        /**
         * @private
         * @return {void}
         */ unbindClick: function() {
            var self = this;
            this.callActions("beforeUnbindClick", arguments);
            h.off(self.el, "click", self.handler);
            self.handler = null;
            this.callActions("afterUnbindClick", arguments);
        },
        /**
         * @private
         * @param   {MouseEvent} e
         * @return  {void}
         */ handleClick: function(e) {
            var self = this, button = null, mixer = null, isActive = false, returnValue = void 0, command = {}, clone = null, commands = [], i = -1;
            this.callActions("beforeHandleClick", arguments);
            this.pending = 0;
            mixer = self.bound[0];
            if (!self.selector) button = self.el;
            else button = h.closestParent(e.target, mixer.config.selectors.control + self.selector, true, mixer.dom.document);
            if (!button) {
                self.callActions("afterHandleClick", arguments);
                return;
            }
            switch(self.type){
                case "filter":
                    command.filter = self.filter || button.getAttribute("data-filter");
                    break;
                case "sort":
                    command.sort = self.sort || button.getAttribute("data-sort");
                    break;
                case "multimix":
                    command.filter = self.filter || button.getAttribute("data-filter");
                    command.sort = self.sort || button.getAttribute("data-sort");
                    break;
                case "toggle":
                    command.filter = self.filter || button.getAttribute("data-toggle");
                    if (self.status === "live") isActive = h.hasClass(button, self.classNames.active);
                    else isActive = self.status === "active";
                    break;
            }
            for(i = 0; i < self.bound.length; i++){
                // Create a clone of the command for each bound mixer instance
                clone = new mixitup.CommandMultimix();
                h.extend(clone, command);
                commands.push(clone);
            }
            commands = self.callFilters("commandsHandleClick", commands, arguments);
            self.pending = self.bound.length;
            for(i = 0; mixer = self.bound[i]; i++){
                command = commands[i];
                if (!command) continue;
                if (!mixer.lastClicked) mixer.lastClicked = button;
                mixitup.events.fire("mixClick", mixer.dom.container, {
                    state: mixer.state,
                    instance: mixer,
                    originalEvent: e,
                    control: mixer.lastClicked
                }, mixer.dom.document);
                if (typeof mixer.config.callbacks.onMixClick === "function") {
                    returnValue = mixer.config.callbacks.onMixClick.call(mixer.lastClicked, mixer.state, e, mixer);
                    if (returnValue === false) continue;
                }
                if (self.type === "toggle") isActive ? mixer.toggleOff(command.filter) : mixer.toggleOn(command.filter);
                else mixer.multimix(command);
            }
            this.callActions("afterHandleClick", arguments);
        },
        /**
         * @param   {object}          command
         * @param   {Array<string>}   toggleArray
         * @return  {void}
         */ update: function(command, toggleArray) {
            var self = this, actions = new mixitup.CommandMultimix();
            self.callActions("beforeUpdate", arguments);
            self.pending--;
            self.pending = Math.max(0, self.pending);
            if (self.pending > 0) return;
            if (self.status === "live") // Live control (status unknown)
            self.updateLive(command, toggleArray);
            else {
                // Static control
                actions.sort = self.sort;
                actions.filter = self.filter;
                self.callFilters("actionsUpdate", actions, arguments);
                self.parseStatusChange(self.el, command, actions, toggleArray);
            }
            self.callActions("afterUpdate", arguments);
        },
        /**
         * @param   {mixitup.CommandMultimix} command
         * @param   {Array<string>}           toggleArray
         * @return  {void}
         */ updateLive: function(command, toggleArray) {
            var self = this, controlButtons = null, actions = null, button = null, i = -1;
            self.callActions("beforeUpdateLive", arguments);
            if (!self.el) return;
            controlButtons = self.el.querySelectorAll(self.selector);
            for(i = 0; button = controlButtons[i]; i++){
                actions = new mixitup.CommandMultimix();
                switch(self.type){
                    case "filter":
                        actions.filter = button.getAttribute("data-filter");
                        break;
                    case "sort":
                        actions.sort = button.getAttribute("data-sort");
                        break;
                    case "multimix":
                        actions.filter = button.getAttribute("data-filter");
                        actions.sort = button.getAttribute("data-sort");
                        break;
                    case "toggle":
                        actions.filter = button.getAttribute("data-toggle");
                        break;
                }
                actions = self.callFilters("actionsUpdateLive", actions, arguments);
                self.parseStatusChange(button, command, actions, toggleArray);
            }
            self.callActions("afterUpdateLive", arguments);
        },
        /**
         * @param   {HTMLElement}             button
         * @param   {mixitup.CommandMultimix} command
         * @param   {mixitup.CommandMultimix} actions
         * @param   {Array<string>}           toggleArray
         * @return  {void}
         */ parseStatusChange: function(button, command, actions, toggleArray) {
            var self = this, alias = "", toggle = "", i = -1;
            self.callActions("beforeParseStatusChange", arguments);
            switch(self.type){
                case "filter":
                    if (command.filter === actions.filter) self.renderStatus(button, "active");
                    else self.renderStatus(button, "inactive");
                    break;
                case "multimix":
                    if (command.sort === actions.sort && command.filter === actions.filter) self.renderStatus(button, "active");
                    else self.renderStatus(button, "inactive");
                    break;
                case "sort":
                    if (command.sort.match(/:asc/g)) alias = command.sort.replace(/:asc/g, "");
                    if (command.sort === actions.sort || alias === actions.sort) self.renderStatus(button, "active");
                    else self.renderStatus(button, "inactive");
                    break;
                case "toggle":
                    if (toggleArray.length < 1) self.renderStatus(button, "inactive");
                    if (command.filter === actions.filter) self.renderStatus(button, "active");
                    for(i = 0; i < toggleArray.length; i++){
                        toggle = toggleArray[i];
                        if (toggle === actions.filter) {
                            // Button matches one active toggle
                            self.renderStatus(button, "active");
                            break;
                        }
                        self.renderStatus(button, "inactive");
                    }
                    break;
            }
            self.callActions("afterParseStatusChange", arguments);
        },
        /**
         * @param   {HTMLElement}   button
         * @param   {string}        status
         * @return  {void}
         */ renderStatus: function(button, status) {
            var self = this;
            self.callActions("beforeRenderStatus", arguments);
            switch(status){
                case "active":
                    h.addClass(button, self.classNames.active);
                    h.removeClass(button, self.classNames.disabled);
                    if (self.canDisable) self.el.disabled = false;
                    break;
                case "inactive":
                    h.removeClass(button, self.classNames.active);
                    h.removeClass(button, self.classNames.disabled);
                    if (self.canDisable) self.el.disabled = false;
                    break;
                case "disabled":
                    if (self.canDisable) self.el.disabled = true;
                    h.addClass(button, self.classNames.disabled);
                    h.removeClass(button, self.classNames.active);
                    break;
            }
            if (self.status !== "live") // Update the control's status propery if not live
            self.status = status;
            self.callActions("afterRenderStatus", arguments);
        }
    });
    mixitup.controls = [];
    /**
     * @constructor
     * @memberof    mixitup
     * @private
     * @since       3.0.0
     */ mixitup.StyleData = function() {
        mixitup.Base.call(this);
        this.callActions("beforeConstruct");
        this.x = 0;
        this.y = 0;
        this.top = 0;
        this.right = 0;
        this.bottom = 0;
        this.left = 0;
        this.width = 0;
        this.height = 0;
        this.marginRight = 0;
        this.marginBottom = 0;
        this.opacity = 0;
        this.scale = new mixitup.TransformData();
        this.translateX = new mixitup.TransformData();
        this.translateY = new mixitup.TransformData();
        this.translateZ = new mixitup.TransformData();
        this.rotateX = new mixitup.TransformData();
        this.rotateY = new mixitup.TransformData();
        this.rotateZ = new mixitup.TransformData();
        this.callActions("afterConstruct");
        h.seal(this);
    };
    mixitup.BaseStatic.call(mixitup.StyleData);
    mixitup.StyleData.prototype = Object.create(mixitup.Base.prototype);
    mixitup.StyleData.prototype.constructor = mixitup.StyleData;
    /**
     * @constructor
     * @memberof    mixitup
     * @private
     * @since       3.0.0
     */ mixitup.TransformData = function() {
        mixitup.Base.call(this);
        this.callActions("beforeConstruct");
        this.value = 0;
        this.unit = "";
        this.callActions("afterConstruct");
        h.seal(this);
    };
    mixitup.BaseStatic.call(mixitup.TransformData);
    mixitup.TransformData.prototype = Object.create(mixitup.Base.prototype);
    mixitup.TransformData.prototype.constructor = mixitup.TransformData;
    /**
     * @constructor
     * @memberof    mixitup
     * @private
     * @since       3.0.0
     */ mixitup.TransformDefaults = function() {
        mixitup.StyleData.apply(this);
        this.callActions("beforeConstruct");
        this.scale.value = 0.01;
        this.scale.unit = "";
        this.translateX.value = 20;
        this.translateX.unit = "px";
        this.translateY.value = 20;
        this.translateY.unit = "px";
        this.translateZ.value = 20;
        this.translateZ.unit = "px";
        this.rotateX.value = 90;
        this.rotateX.unit = "deg";
        this.rotateY.value = 90;
        this.rotateY.unit = "deg";
        this.rotateX.value = 90;
        this.rotateX.unit = "deg";
        this.rotateZ.value = 180;
        this.rotateZ.unit = "deg";
        this.callActions("afterConstruct");
        h.seal(this);
    };
    mixitup.BaseStatic.call(mixitup.TransformDefaults);
    mixitup.TransformDefaults.prototype = Object.create(mixitup.StyleData.prototype);
    mixitup.TransformDefaults.prototype.constructor = mixitup.TransformDefaults;
    /**
     * @private
     * @static
     * @since   3.0.0
     * @type    {mixitup.TransformDefaults}
     */ mixitup.transformDefaults = new mixitup.TransformDefaults();
    /**
     * @constructor
     * @memberof    mixitup
     * @private
     * @since       3.0.0
     */ mixitup.EventDetail = function() {
        this.state = null;
        this.futureState = null;
        this.instance = null;
        this.originalEvent = null;
    };
    /**
     * The `mixitup.Events` class contains all custom events dispatched by MixItUp at various
     * points within the lifecycle of a mixer operation.
     *
     * Each event is analogous to the callback function of the same name defined in
     * the `callbacks` configuration object, and is triggered immediately before it.
     *
     * Events are always triggered from the container element on which MixItUp is instantiated
     * upon.
     *
     * As with any event, registered event handlers receive the event object as a parameter
     * which includes a `detail` property containting references to the current `state`,
     * the `mixer` instance, and other event-specific properties described below.
     *
     * @constructor
     * @namespace
     * @memberof    mixitup
     * @public
     * @since       3.0.0
     */ mixitup.Events = function() {
        mixitup.Base.call(this);
        this.callActions("beforeConstruct");
        /**
         * A custom event triggered immediately after any MixItUp operation is requested
         * and before animations have begun.
         *
         * The `mixStart` event also exposes a `futureState` property via the
         * `event.detail` object, which represents the final state of the mixer once
         * the requested operation has completed.
         *
         * @name        mixStart
         * @memberof    mixitup.Events
         * @static
         * @type        {CustomEvent}
         */ this.mixStart = null;
        /**
         * A custom event triggered when a MixItUp operation is requested while another
         * operation is in progress, and the animation queue is full, or queueing
         * is disabled.
         *
         * @name        mixBusy
         * @memberof    mixitup.Events
         * @static
         * @type        {CustomEvent}
         */ this.mixBusy = null;
        /**
         * A custom event triggered after any MixItUp operation has completed, and the
         * state has been updated.
         *
         * @name        mixEnd
         * @memberof    mixitup.Events
         * @static
         * @type        {CustomEvent}
         */ this.mixEnd = null;
        /**
         * A custom event triggered whenever a filter operation "fails", i.e. no targets
         * could be found matching the requested filter.
         *
         * @name        mixFail
         * @memberof    mixitup.Events
         * @static
         * @type        {CustomEvent}
         */ this.mixFail = null;
        /**
         * A custom event triggered whenever a MixItUp control is clicked, and before its
         * respective operation is requested.
         *
         * This event also exposes an `originalEvent` property via the `event.detail`
         * object, which holds a reference to the original click event.
         *
         * @name        mixClick
         * @memberof    mixitup.Events
         * @static
         * @type        {CustomEvent}
         */ this.mixClick = null;
        this.callActions("afterConstruct");
        h.seal(this);
    };
    mixitup.BaseStatic.call(mixitup.Events);
    mixitup.Events.prototype = Object.create(mixitup.Base.prototype);
    mixitup.Events.prototype.constructor = mixitup.Events;
    /**
     * @private
     * @param   {string}      eventType
     * @param   {Element}     el
     * @param   {object}      detail
     * @param   {Document}    [doc]
     */ mixitup.Events.prototype.fire = function(eventType, el, detail, doc) {
        var self = this, event = null, eventDetail = new mixitup.EventDetail();
        self.callActions("beforeFire", arguments);
        if (typeof self[eventType] === "undefined") throw new Error('Event type "' + eventType + '" not found.');
        eventDetail.state = new mixitup.State();
        h.extend(eventDetail.state, detail.state);
        if (detail.futureState) {
            eventDetail.futureState = new mixitup.State();
            h.extend(eventDetail.futureState, detail.futureState);
        }
        eventDetail.instance = detail.instance;
        if (detail.originalEvent) eventDetail.originalEvent = detail.originalEvent;
        event = h.getCustomEvent(eventType, eventDetail, doc);
        self.callFilters("eventFire", event, arguments);
        el.dispatchEvent(event);
    };
    // Asign a singleton instance to `mixitup.events`:
    mixitup.events = new mixitup.Events();
    /**
     * @constructor
     * @memberof    mixitup
     * @private
     * @since       3.0.0
     */ mixitup.QueueItem = function() {
        mixitup.Base.call(this);
        this.callActions("beforeConstruct");
        this.args = [];
        this.instruction = null;
        this.triggerElement = null;
        this.deferred = null;
        this.isToggling = false;
        this.callActions("afterConstruct");
        h.seal(this);
    };
    mixitup.BaseStatic.call(mixitup.QueueItem);
    mixitup.QueueItem.prototype = Object.create(mixitup.Base.prototype);
    mixitup.QueueItem.prototype.constructor = mixitup.QueueItem;
    /**
     * The `mixitup.Mixer` class is used to hold discreet, user-configured
     * instances of MixItUp on a provided container element.
     *
     * Mixer instances are returned whenever the `mixitup()` factory function is called,
     * which expose a range of methods enabling API-based filtering, sorting,
     * insertion, removal and more.
     *
     * @constructor
     * @namespace
     * @memberof    mixitup
     * @public
     * @since       3.0.0
     */ mixitup.Mixer = function() {
        mixitup.Base.call(this);
        this.callActions("beforeConstruct");
        this.config = new mixitup.Config();
        this.id = "";
        this.isBusy = false;
        this.isToggling = false;
        this.incPadding = true;
        this.controls = [];
        this.targets = [];
        this.origOrder = [];
        this.cache = {};
        this.toggleArray = [];
        this.targetsMoved = 0;
        this.targetsImmovable = 0;
        this.targetsBound = 0;
        this.targetsDone = 0;
        this.staggerDuration = 0;
        this.effectsIn = null;
        this.effectsOut = null;
        this.transformIn = [];
        this.transformOut = [];
        this.queue = [];
        this.state = null;
        this.lastOperation = null;
        this.lastClicked = null;
        this.userCallback = null;
        this.userDeferred = null;
        this.dom = new mixitup.MixerDom();
        this.callActions("afterConstruct");
        h.seal(this);
    };
    mixitup.BaseStatic.call(mixitup.Mixer);
    mixitup.Mixer.prototype = Object.create(mixitup.Base.prototype);
    h.extend(mixitup.Mixer.prototype, /** @lends mixitup.Mixer */ {
        constructor: mixitup.Mixer,
        /**
         * @private
         * @instance
         * @since 3.0.0
         * @param {HTMLElement} container
         * @param {HTMLElement} document
         * @param {string}      id
         * @param {object}      [config]
         */ attach: function(container, document1, id, config) {
            var self = this, target = null, i = -1;
            self.callActions("beforeAttach", arguments);
            self.id = id;
            if (config) h.extend(self.config, config, true, true);
            self.sanitizeConfig();
            self.cacheDom(container, document1);
            if (self.config.layout.containerClassName) h.addClass(self.dom.container, self.config.layout.containerClassName);
            if (!mixitup.features.has.transitions) self.config.animation.enable = false;
            if (typeof window1.console === "undefined") self.config.debug.showWarnings = false;
            if (self.config.data.uidKey) // If the dataset API is in use, force disable controls
            self.config.controls.enable = false;
            self.indexTargets();
            self.state = self.getInitialState();
            for(i = 0; target = self.lastOperation.toHide[i]; i++)target.hide();
            if (self.config.controls.enable) {
                self.initControls();
                self.buildToggleArray(null, self.state);
                self.updateControls({
                    filter: self.state.activeFilter,
                    sort: self.state.activeSort
                });
            }
            self.parseEffects();
            self.callActions("afterAttach", arguments);
        },
        /**
         * @private
         * @instance
         * @since 3.0.0
         * @return {void}
         */ sanitizeConfig: function() {
            var self = this;
            self.callActions("beforeSanitizeConfig", arguments);
            // Sanitize enum/string config options
            self.config.controls.scope = self.config.controls.scope.toLowerCase().trim();
            self.config.controls.toggleLogic = self.config.controls.toggleLogic.toLowerCase().trim();
            self.config.controls.toggleDefault = self.config.controls.toggleDefault.toLowerCase().trim();
            self.config.animation.effects = self.config.animation.effects.trim();
            self.callActions("afterSanitizeConfig", arguments);
        },
        /**
         * @private
         * @instance
         * @since   3.0.0
         * @return  {mixitup.State}
         */ getInitialState: function() {
            var self = this, state = new mixitup.State(), operation = new mixitup.Operation();
            self.callActions("beforeGetInitialState", arguments);
            // Map initial values into a mock state object in order to construct an operation
            state.activeContainerClassName = self.config.layout.containerClassName;
            if (self.config.load.dataset) {
                // Dataset API
                if (!self.config.data.uidKey || typeof self.config.data.uidKey !== "string") throw new TypeError(mixitup.messages.errorConfigDataUidKeyNotSet());
                operation.startDataset = operation.newDataset = state.activeDataset = self.config.load.dataset.slice();
                operation.startContainerClassName = operation.newContainerClassName = state.activeContainerClassName;
                operation.show = self.targets.slice();
                state = self.callFilters("stateGetInitialState", state, arguments);
            } else {
                // DOM API
                state.activeFilter = self.parseFilterArgs([
                    self.config.load.filter
                ]).command;
                state.activeSort = self.parseSortArgs([
                    self.config.load.sort
                ]).command;
                state.totalTargets = self.targets.length;
                state = self.callFilters("stateGetInitialState", state, arguments);
                if (state.activeSort.collection || state.activeSort.attribute || state.activeSort.order === "random" || state.activeSort.order === "desc") {
                    // Sorting on load
                    operation.newSort = state.activeSort;
                    self.sortOperation(operation);
                    self.printSort(false, operation);
                    self.targets = operation.newOrder;
                } else operation.startOrder = operation.newOrder = self.targets;
                operation.startFilter = operation.newFilter = state.activeFilter;
                operation.startSort = operation.newSort = state.activeSort;
                operation.startContainerClassName = operation.newContainerClassName = state.activeContainerClassName;
                if (operation.newFilter.selector === "all") operation.newFilter.selector = self.config.selectors.target;
                else if (operation.newFilter.selector === "none") operation.newFilter.selector = "";
            }
            operation = self.callFilters("operationGetInitialState", operation, [
                state
            ]);
            self.lastOperation = operation;
            if (operation.newFilter) self.filterOperation(operation);
            state = self.buildState(operation);
            return state;
        },
        /**
         * Caches references of DOM elements neccessary for the mixer's functionality.
         *
         * @private
         * @instance
         * @since   3.0.0
         * @param   {HTMLElement}       el
         * @param   {HTMLHtmlElement}   document
         * @return  {void}
         */ cacheDom: function(el, document1) {
            var self = this;
            self.callActions("beforeCacheDom", arguments);
            self.dom.document = document1;
            self.dom.body = self.dom.document.querySelector("body");
            self.dom.container = el;
            self.dom.parent = el;
            self.callActions("afterCacheDom", arguments);
        },
        /**
         * Indexes all child elements of the mixer matching the `selectors.target`
         * selector, instantiating a mixitup.Target for each one.
         *
         * @private
         * @instance
         * @since   3.0.0
         * @return  {void}
         */ indexTargets: function() {
            var self = this, target = null, el = null, dataset = null, i = -1;
            self.callActions("beforeIndexTargets", arguments);
            self.dom.targets = self.config.layout.allowNestedTargets ? self.dom.container.querySelectorAll(self.config.selectors.target) : h.children(self.dom.container, self.config.selectors.target, self.dom.document);
            self.dom.targets = h.arrayFromList(self.dom.targets);
            self.targets = [];
            if ((dataset = self.config.load.dataset) && dataset.length !== self.dom.targets.length) throw new Error(mixitup.messages.errorDatasetPrerenderedMismatch());
            if (self.dom.targets.length) {
                for(i = 0; el = self.dom.targets[i]; i++){
                    target = new mixitup.Target();
                    target.init(el, self, dataset ? dataset[i] : void 0);
                    target.isInDom = true;
                    self.targets.push(target);
                }
                self.dom.parent = self.dom.targets[0].parentElement === self.dom.container ? self.dom.container : self.dom.targets[0].parentElement;
            }
            self.origOrder = self.targets;
            self.callActions("afterIndexTargets", arguments);
        },
        initControls: function() {
            var self = this, definition = "", controlElements = null, el = null, parent = null, delagators = null, control = null, i = -1, j = -1;
            self.callActions("beforeInitControls", arguments);
            switch(self.config.controls.scope){
                case "local":
                    parent = self.dom.container;
                    break;
                case "global":
                    parent = self.dom.document;
                    break;
                default:
                    throw new Error(mixitup.messages.errorConfigInvalidControlsScope());
            }
            for(i = 0; definition = mixitup.controlDefinitions[i]; i++)if (self.config.controls.live || definition.live) {
                if (definition.parent) {
                    delagators = self.dom[definition.parent];
                    if (!delagators || delagators.length < 0) continue;
                    if (typeof delagators.length !== "number") delagators = [
                        delagators
                    ];
                } else delagators = [
                    parent
                ];
                for(j = 0; el = delagators[j]; j++){
                    control = self.getControl(el, definition.type, definition.selector);
                    self.controls.push(control);
                }
            } else {
                controlElements = parent.querySelectorAll(self.config.selectors.control + definition.selector);
                for(j = 0; el = controlElements[j]; j++){
                    control = self.getControl(el, definition.type, "");
                    if (!control) continue;
                    self.controls.push(control);
                }
            }
            self.callActions("afterInitControls", arguments);
        },
        /**
         * @private
         * @instance
         * @since   3.0.0
         * @param   {HTMLElement} el
         * @param   {string}      type
         * @param   {string}      selector
         * @return  {mixitup.Control|null}
         */ getControl: function(el, type, selector) {
            var self = this, control = null, i = -1;
            self.callActions("beforeGetControl", arguments);
            if (!selector) // Static controls only
            for(i = 0; control = mixitup.controls[i]; i++){
                if (control.el === el && control.isBound(self)) // Control already bound to this mixer (as another type).
                // NB: This prevents duplicate controls from being registered where a selector
                // might collide, eg: "[data-filter]" and "[data-filter][data-sort]"
                return self.callFilters("controlGetControl", null, arguments);
                else if (control.el === el && control.type === type && control.selector === selector) {
                    // Another mixer is already using this control, add this mixer as a binding
                    control.addBinding(self);
                    return self.callFilters("controlGetControl", control, arguments);
                }
            }
            // Create new control
            control = new mixitup.Control();
            control.init(el, type, selector);
            control.classNames.base = h.getClassname(self.config.classNames, type);
            control.classNames.active = h.getClassname(self.config.classNames, type, self.config.classNames.modifierActive);
            control.classNames.disabled = h.getClassname(self.config.classNames, type, self.config.classNames.modifierDisabled);
            // Add a reference to this mixer as a binding
            control.addBinding(self);
            return self.callFilters("controlGetControl", control, arguments);
        },
        /**
         * Creates a compound selector by joining the `toggleArray` value as per the
         * defined toggle logic.
         *
         * @private
         * @instance
         * @since   3.0.0
         * @return  {string}
         */ getToggleSelector: function() {
            var self = this, delineator = self.config.controls.toggleLogic === "or" ? ", " : "", toggleSelector = "";
            self.callActions("beforeGetToggleSelector", arguments);
            self.toggleArray = h.clean(self.toggleArray);
            toggleSelector = self.toggleArray.join(delineator);
            if (toggleSelector === "") toggleSelector = self.config.controls.toggleDefault;
            return self.callFilters("selectorGetToggleSelector", toggleSelector, arguments);
        },
        /**
         * Breaks compound selector strings in an array of discreet selectors,
         * as per the active `controls.toggleLogic` configuration option. Accepts
         * either a dynamic command object, or a state object.
         *
         * @private
         * @instance
         * @since   2.0.0
         * @param   {object}        [command]
         * @param   {mixitup.State} [state]
         * @return  {void}
         */ buildToggleArray: function(command, state) {
            var self = this, activeFilterSelector = "";
            self.callActions("beforeBuildToggleArray", arguments);
            if (command && command.filter) activeFilterSelector = command.filter.selector.replace(/\s/g, "");
            else if (state) activeFilterSelector = state.activeFilter.selector.replace(/\s/g, "");
            else return;
            if (activeFilterSelector === self.config.selectors.target || activeFilterSelector === "all") activeFilterSelector = "";
            if (self.config.controls.toggleLogic === "or") self.toggleArray = activeFilterSelector.split(",");
            else self.toggleArray = self.splitCompoundSelector(activeFilterSelector);
            self.toggleArray = h.clean(self.toggleArray);
            self.callActions("afterBuildToggleArray", arguments);
        },
        /**
         * Takes a compound selector (e.g. `.cat-1.cat-2`, `[data-cat="1"][data-cat="2"]`)
         * and breaks into its individual selectors.
         *
         * @private
         * @instance
         * @since   3.0.0
         * @param   {string} compoundSelector
         * @return  {string[]}
         */ splitCompoundSelector: function(compoundSelector) {
            // Break at a `.` or `[`, capturing the delineator
            var partials = compoundSelector.split(/([\.\[])/g), toggleArray = [], selector = "", i = -1;
            if (partials[0] === "") partials.shift();
            for(i = 0; i < partials.length; i++){
                if (i % 2 === 0) selector = "";
                selector += partials[i];
                if (i % 2 !== 0) toggleArray.push(selector);
            }
            return toggleArray;
        },
        /**
         * Updates controls to their active/inactive state based on the command or
         * current state of the mixer.
         *
         * @private
         * @instance
         * @since   2.0.0
         * @param   {object} command
         * @return  {void}
         */ updateControls: function(command) {
            var self = this, control = null, output = new mixitup.CommandMultimix(), i = -1;
            self.callActions("beforeUpdateControls", arguments);
            // Sanitise to defaults
            if (command.filter) output.filter = command.filter.selector;
            else output.filter = self.state.activeFilter.selector;
            if (command.sort) output.sort = self.buildSortString(command.sort);
            else output.sort = self.buildSortString(self.state.activeSort);
            if (output.filter === self.config.selectors.target) output.filter = "all";
            if (output.filter === "") output.filter = "none";
            h.freeze(output);
            for(i = 0; control = self.controls[i]; i++)control.update(output, self.toggleArray);
            self.callActions("afterUpdateControls", arguments);
        },
        /**
         * @private
         * @instance
         * @since   3.0.0
         * @param   {mixitup.CommandSort}   command
         * @return  {string}
         */ buildSortString: function(command) {
            var self = this;
            var output = "";
            output += command.sortString;
            if (command.next) output += " " + self.buildSortString(command.next);
            return output;
        },
        /**
         * @private
         * @instance
         * @since   3.0.0
         * @param   {object}        command
         * @param   {Operation}     operation
         * @return  {Promise.<mixitup.State>}
         */ insertTargets: function(command, operation) {
            var self = this, nextSibling = null, insertionIndex = -1, frag = null, target = null, el = null, i = -1;
            self.callActions("beforeInsertTargets", arguments);
            if (typeof command.index === "undefined") command.index = 0;
            nextSibling = self.getNextSibling(command.index, command.sibling, command.position);
            frag = self.dom.document.createDocumentFragment();
            if (nextSibling) insertionIndex = h.index(nextSibling, self.config.selectors.target);
            else insertionIndex = self.targets.length;
            if (command.collection) {
                for(i = 0; el = command.collection[i]; i++){
                    if (self.dom.targets.indexOf(el) > -1) throw new Error(mixitup.messages.errorInsertPreexistingElement());
                    // Ensure elements are hidden when they are added to the DOM, so they can
                    // be animated in gracefully
                    el.style.display = "none";
                    frag.appendChild(el);
                    frag.appendChild(self.dom.document.createTextNode(" "));
                    if (!h.isElement(el, self.dom.document) || !el.matches(self.config.selectors.target)) continue;
                    target = new mixitup.Target();
                    target.init(el, self);
                    target.isInDom = true;
                    self.targets.splice(insertionIndex, 0, target);
                    insertionIndex++;
                }
                self.dom.parent.insertBefore(frag, nextSibling);
            }
            // Since targets have been added, the original order must be updated
            operation.startOrder = self.origOrder = self.targets;
            self.callActions("afterInsertTargets", arguments);
        },
        /**
         * @private
         * @instance
         * @since   3.0.0
         * @param   {Number}      [index]
         * @param   {Element}     [sibling]
         * @param   {string}      [position]
         * @return  {Element}
         */ getNextSibling: function(index, sibling, position) {
            var self = this, element = null;
            index = Math.max(index, 0);
            if (sibling && position === "before") // Explicit sibling
            element = sibling;
            else if (sibling && position === "after") // Explicit sibling
            element = sibling.nextElementSibling || null;
            else if (self.targets.length > 0 && typeof index !== "undefined") // Index and targets exist
            element = index < self.targets.length || !self.targets.length ? self.targets[index].dom.el : self.targets[self.targets.length - 1].dom.el.nextElementSibling;
            else if (self.targets.length === 0 && self.dom.parent.children.length > 0) {
                // No targets but other siblings
                if (self.config.layout.siblingAfter) element = self.config.layout.siblingAfter;
                else if (self.config.layout.siblingBefore) element = self.config.layout.siblingBefore.nextElementSibling;
                else self.dom.parent.children[0];
            } else element;
            return self.callFilters("elementGetNextSibling", element, arguments);
        },
        /**
         * @private
         * @instance
         * @since   2.0.0
         * @param   {Operation}     operation
         * @return  {void}
         */ filterOperation: function(operation) {
            var self = this, testResult = false, index = -1, action = "", target = null, i = -1;
            self.callActions("beforeFilterOperation", arguments);
            action = operation.newFilter.action;
            for(i = 0; target = operation.newOrder[i]; i++){
                if (operation.newFilter.collection) // show via collection
                testResult = operation.newFilter.collection.indexOf(target.dom.el) > -1;
                else // show via selector
                if (operation.newFilter.selector === "") testResult = false;
                else testResult = target.dom.el.matches(operation.newFilter.selector);
                self.evaluateHideShow(testResult, target, action, operation);
            }
            if (operation.toRemove.length) {
                for(i = 0; target = operation.show[i]; i++)if (operation.toRemove.indexOf(target) > -1) {
                    // If any shown targets should be removed, move them into the toHide array
                    operation.show.splice(i, 1);
                    if ((index = operation.toShow.indexOf(target)) > -1) operation.toShow.splice(index, 1);
                    operation.toHide.push(target);
                    operation.hide.push(target);
                    i--;
                }
            }
            operation.matching = operation.show.slice();
            if (operation.show.length === 0 && operation.newFilter.selector !== "" && self.targets.length !== 0) operation.hasFailed = true;
            self.callActions("afterFilterOperation", arguments);
        },
        /**
         * @private
         * @instance
         * @since   3.0.0
         * @param   {boolean}   testResult
         * @param   {Element}   target
         * @param   {string}    action
         * @param   {Operation} operation
         * @return  {void}
         */ evaluateHideShow: function(testResult, target, action, operation) {
            var self = this, filteredTestResult = false, args = Array.prototype.slice.call(arguments, 1);
            filteredTestResult = self.callFilters("testResultEvaluateHideShow", testResult, args);
            self.callActions("beforeEvaluateHideShow", arguments);
            if (filteredTestResult === true && action === "show" || filteredTestResult === false && action === "hide") {
                operation.show.push(target);
                !target.isShown && operation.toShow.push(target);
            } else {
                operation.hide.push(target);
                target.isShown && operation.toHide.push(target);
            }
            self.callActions("afterEvaluateHideShow", arguments);
        },
        /**
         * @private
         * @instance
         * @since   2.0.0
         * @param   {Operation}     operation
         * @return  {void}
         */ sortOperation: function(operation) {
            var self = this, newOrder = [], target = null, el = null, i = -1;
            self.callActions("beforeSortOperation", arguments);
            operation.startOrder = self.targets;
            if (operation.newSort.collection) {
                // Sort by collection
                newOrder = [];
                for(i = 0; el = operation.newSort.collection[i]; i++){
                    if (self.dom.targets.indexOf(el) < 0) throw new Error(mixitup.messages.errorSortNonExistentElement());
                    target = new mixitup.Target();
                    target.init(el, self);
                    target.isInDom = true;
                    newOrder.push(target);
                }
                operation.newOrder = newOrder;
            } else if (operation.newSort.order === "random") // Sort random
            operation.newOrder = h.arrayShuffle(operation.startOrder);
            else if (operation.newSort.attribute === "") {
                // Sort by default
                operation.newOrder = self.origOrder.slice();
                if (operation.newSort.order === "desc") operation.newOrder.reverse();
            } else {
                // Sort by attribute
                operation.newOrder = operation.startOrder.slice();
                operation.newOrder.sort(function(a, b) {
                    return self.compare(a, b, operation.newSort);
                });
            }
            if (h.isEqualArray(operation.newOrder, operation.startOrder)) operation.willSort = false;
            self.callActions("afterSortOperation", arguments);
        },
        /**
         * @private
         * @instance
         * @since   2.0.0
         * @param   {mixitup.Target}        a
         * @param   {mixitup.Target}        b
         * @param   {mixitup.CommandSort}   command
         * @return  {Number}
         */ compare: function(a, b, command) {
            var self = this, order = command.order, attrA = self.getAttributeValue(a, command.attribute), attrB = self.getAttributeValue(b, command.attribute);
            if (isNaN(attrA * 1) || isNaN(attrB * 1)) {
                attrA = attrA.toLowerCase();
                attrB = attrB.toLowerCase();
            } else {
                attrA = attrA * 1;
                attrB = attrB * 1;
            }
            if (attrA < attrB) return order === "asc" ? -1 : 1;
            if (attrA > attrB) return order === "asc" ? 1 : -1;
            if (attrA === attrB && command.next) return self.compare(a, b, command.next);
            return 0;
        },
        /**
         * Reads the values of any data attributes present the provided target element
         * which match the current sort command.
         *
         * @private
         * @instance
         * @since   3.0.0
         * @param   {mixitup.Target}    target
         * @param   {string}            [attribute]
         * @return  {(String|Number)}
         */ getAttributeValue: function(target, attribute) {
            var self = this, value = "";
            value = target.dom.el.getAttribute("data-" + attribute);
            if (value === null) {
                if (self.config.debug.showWarnings) // Encourage users to assign values to all targets to avoid erroneous sorting
                // when types are mixed
                console.warn(mixitup.messages.warningInconsistentSortingAttributes({
                    attribute: "data-" + attribute
                }));
            }
            // If an attribute is not present, return 0 as a safety value
            return self.callFilters("valueGetAttributeValue", value || 0, arguments);
        },
        /**
         * Inserts elements into the DOM in the appropriate
         * order using a document fragment for minimal
         * DOM thrashing
         *
         * @private
         * @instance
         * @since   2.0.0
         * @param   {boolean}   isResetting
         * @param   {Operation} operation
         * @return  {void}
         */ printSort: function(isResetting, operation) {
            var self = this, startOrder = isResetting ? operation.newOrder : operation.startOrder, newOrder = isResetting ? operation.startOrder : operation.newOrder, nextSibling = startOrder.length ? startOrder[startOrder.length - 1].dom.el.nextElementSibling : null, frag = window1.document.createDocumentFragment(), whitespace = null, target = null, el = null, i = -1;
            self.callActions("beforePrintSort", arguments);
            // Empty the container
            for(i = 0; target = startOrder[i]; i++){
                el = target.dom.el;
                if (el.style.position === "absolute") continue;
                h.removeWhitespace(el.previousSibling);
                el.parentElement.removeChild(el);
            }
            whitespace = nextSibling ? nextSibling.previousSibling : self.dom.parent.lastChild;
            if (whitespace && whitespace.nodeName === "#text") h.removeWhitespace(whitespace);
            for(i = 0; target = newOrder[i]; i++){
                // Add targets into a document fragment
                el = target.dom.el;
                if (h.isElement(frag.lastChild)) frag.appendChild(window1.document.createTextNode(" "));
                frag.appendChild(el);
            }
            // Insert the document fragment into the container
            // before any other non-target elements
            if (self.dom.parent.firstChild && self.dom.parent.firstChild !== nextSibling) frag.insertBefore(window1.document.createTextNode(" "), frag.childNodes[0]);
            if (nextSibling) {
                frag.appendChild(window1.document.createTextNode(" "));
                self.dom.parent.insertBefore(frag, nextSibling);
            } else self.dom.parent.appendChild(frag);
            self.callActions("afterPrintSort", arguments);
        },
        /**
         * Parses user-defined sort strings (i.e. `default:asc`) into sort commands objects.
         *
         * @private
         * @instance
         * @since   3.0.0
         * @param   {string}                sortString
         * @param   {mixitup.CommandSort}   command
         * @return  {mixitup.CommandSort}
         */ parseSortString: function(sortString, command) {
            var self = this, rules = sortString.split(" "), current = command, rule = [], i = -1;
            // command.sortString = sortString;
            for(i = 0; i < rules.length; i++){
                rule = rules[i].split(":");
                current.sortString = rules[i];
                current.attribute = h.dashCase(rule[0]);
                current.order = rule[1] || "asc";
                switch(current.attribute){
                    case "default":
                        // treat "default" as sorting by no attribute
                        current.attribute = "";
                        break;
                    case "random":
                        // treat "random" as an order not an attribute
                        current.attribute = "";
                        current.order = "random";
                        break;
                }
                if (!current.attribute || current.order === "random") break;
                if (i < rules.length - 1) {
                    // Embed reference to the next command
                    current.next = new mixitup.CommandSort();
                    h.freeze(current);
                    current = current.next;
                }
            }
            return self.callFilters("commandsParseSort", command, arguments);
        },
        /**
         * Parses all effects out of the user-defined `animation.effects` string into
         * their respective properties and units.
         *
         * @private
         * @instance
         * @since   2.0.0
         * @return  {void}
         */ parseEffects: function() {
            var self = this, transformName = "", effectsIn = self.config.animation.effectsIn || self.config.animation.effects, effectsOut = self.config.animation.effectsOut || self.config.animation.effects;
            self.callActions("beforeParseEffects", arguments);
            self.effectsIn = new mixitup.StyleData();
            self.effectsOut = new mixitup.StyleData();
            self.transformIn = [];
            self.transformOut = [];
            self.effectsIn.opacity = self.effectsOut.opacity = 1;
            self.parseEffect("fade", effectsIn, self.effectsIn, self.transformIn);
            self.parseEffect("fade", effectsOut, self.effectsOut, self.transformOut, true);
            for(transformName in mixitup.transformDefaults){
                if (!(mixitup.transformDefaults[transformName] instanceof mixitup.TransformData)) continue;
                self.parseEffect(transformName, effectsIn, self.effectsIn, self.transformIn);
                self.parseEffect(transformName, effectsOut, self.effectsOut, self.transformOut, true);
            }
            self.parseEffect("stagger", effectsIn, self.effectsIn, self.transformIn);
            self.parseEffect("stagger", effectsOut, self.effectsOut, self.transformOut, true);
            self.callActions("afterParseEffects", arguments);
        },
        /**
         * @private
         * @instance
         * @since   2.0.0
         * @param   {string}    effectName
         * @param   {string}    effectString
         * @param   {StyleData} effects
         * @param   {String[]}  transform
         * @param   {boolean}   [isOut]
         */ parseEffect: function(effectName, effectString, effects, transform, isOut) {
            var self = this, re = /\(([^)]+)\)/, propIndex = -1, str = "", match = [], val = "", units = [
                "%",
                "px",
                "em",
                "rem",
                "vh",
                "vw",
                "deg"
            ], unit = "", i = -1;
            self.callActions("beforeParseEffect", arguments);
            if (typeof effectString !== "string") throw new TypeError(mixitup.messages.errorConfigInvalidAnimationEffects());
            if (effectString.indexOf(effectName) < 0) {
                // The effect is not present in the effects string
                if (effectName === "stagger") // Reset stagger to 0
                self.staggerDuration = 0;
                return;
            }
            // The effect is present
            propIndex = effectString.indexOf(effectName + "(");
            if (propIndex > -1) {
                // The effect has a user defined value in parentheses
                // Extract from the first parenthesis to the end of string
                str = effectString.substring(propIndex);
                // Match any number of characters between "(" and ")"
                match = re.exec(str);
                val = match[1];
            }
            switch(effectName){
                case "fade":
                    effects.opacity = val ? parseFloat(val) : 0;
                    break;
                case "stagger":
                    self.staggerDuration = val ? parseFloat(val) : 100;
                    break;
                default:
                    // All other effects are transforms following the same structure
                    if (isOut && self.config.animation.reverseOut && effectName !== "scale") effects[effectName].value = (val ? parseFloat(val) : mixitup.transformDefaults[effectName].value) * -1;
                    else effects[effectName].value = val ? parseFloat(val) : mixitup.transformDefaults[effectName].value;
                    if (val) {
                        for(i = 0; unit = units[i]; i++)if (val.indexOf(unit) > -1) {
                            effects[effectName].unit = unit;
                            break;
                        }
                    } else effects[effectName].unit = mixitup.transformDefaults[effectName].unit;
                    transform.push(effectName + "(" + effects[effectName].value + effects[effectName].unit + ")");
            }
            self.callActions("afterParseEffect", arguments);
        },
        /**
         * @private
         * @instance
         * @since   2.0.0
         * @param   {Operation}     operation
         * @return  {State}
         */ buildState: function(operation) {
            var self = this, state = new mixitup.State(), target = null, i = -1;
            self.callActions("beforeBuildState", arguments);
            // Map target elements into state arrays.
            // the real target objects should never be exposed
            for(i = 0; target = self.targets[i]; i++)if (!operation.toRemove.length || operation.toRemove.indexOf(target) < 0) state.targets.push(target.dom.el);
            for(i = 0; target = operation.matching[i]; i++)state.matching.push(target.dom.el);
            for(i = 0; target = operation.show[i]; i++)state.show.push(target.dom.el);
            for(i = 0; target = operation.hide[i]; i++)if (!operation.toRemove.length || operation.toRemove.indexOf(target) < 0) state.hide.push(target.dom.el);
            state.id = self.id;
            state.container = self.dom.container;
            state.activeFilter = operation.newFilter;
            state.activeSort = operation.newSort;
            state.activeDataset = operation.newDataset;
            state.activeContainerClassName = operation.newContainerClassName;
            state.hasFailed = operation.hasFailed;
            state.totalTargets = self.targets.length;
            state.totalShow = operation.show.length;
            state.totalHide = operation.hide.length;
            state.totalMatching = operation.matching.length;
            state.triggerElement = operation.triggerElement;
            return self.callFilters("stateBuildState", state, arguments);
        },
        /**
         * @private
         * @instance
         * @since   2.0.0
         * @param   {boolean}   shouldAnimate
         * @param   {Operation} operation
         * @return  {void}
         */ goMix: function(shouldAnimate, operation) {
            var self = this, deferred = null;
            self.callActions("beforeGoMix", arguments);
            // If the animation duration is set to 0ms,
            // or no effects specified,
            // or the container is hidden
            // then abort animation
            if (!self.config.animation.duration || !self.config.animation.effects || !h.isVisible(self.dom.container)) shouldAnimate = false;
            if (!operation.toShow.length && !operation.toHide.length && !operation.willSort && !operation.willChangeLayout) // If nothing to show or hide, and not sorting or
            // changing layout
            shouldAnimate = false;
            if (!operation.startState.show.length && !operation.show.length) // If nothing currently shown, nothing to show
            shouldAnimate = false;
            mixitup.events.fire("mixStart", self.dom.container, {
                state: operation.startState,
                futureState: operation.newState,
                instance: self
            }, self.dom.document);
            if (typeof self.config.callbacks.onMixStart === "function") self.config.callbacks.onMixStart.call(self.dom.container, operation.startState, operation.newState, self);
            h.removeClass(self.dom.container, h.getClassname(self.config.classNames, "container", self.config.classNames.modifierFailed));
            if (!self.userDeferred) // Queue empty, no pending operations
            deferred = self.userDeferred = h.defer(mixitup.libraries);
            else // Use existing deferred
            deferred = self.userDeferred;
            self.isBusy = true;
            if (!shouldAnimate || !mixitup.features.has.transitions) {
                // Abort
                if (self.config.debug.fauxAsync) setTimeout(function() {
                    self.cleanUp(operation);
                }, self.config.animation.duration);
                else self.cleanUp(operation);
                return self.callFilters("promiseGoMix", deferred.promise, arguments);
            }
            // If we should animate and the platform supports transitions, go for it
            if (window1.pageYOffset !== operation.docState.scrollTop) window1.scrollTo(operation.docState.scrollLeft, operation.docState.scrollTop);
            if (self.config.animation.applyPerspective) {
                self.dom.parent.style[mixitup.features.perspectiveProp] = self.config.animation.perspectiveDistance;
                self.dom.parent.style[mixitup.features.perspectiveOriginProp] = self.config.animation.perspectiveOrigin;
            }
            if (self.config.animation.animateResizeContainer && operation.startHeight !== operation.newHeight && operation.viewportDeltaY !== operation.startHeight - operation.newHeight) self.dom.parent.style.height = operation.startHeight + "px";
            if (self.config.animation.animateResizeContainer && operation.startWidth !== operation.newWidth && operation.viewportDeltaX !== operation.startWidth - operation.newWidth) self.dom.parent.style.width = operation.startWidth + "px";
            if (operation.startHeight === operation.newHeight) self.dom.parent.style.height = operation.startHeight + "px";
            if (operation.startWidth === operation.newWidth) self.dom.parent.style.width = operation.startWidth + "px";
            if (operation.startHeight === operation.newHeight && operation.startWidth === operation.newWidth) self.dom.parent.style.overflow = "hidden";
            requestAnimationFrame(function() {
                self.moveTargets(operation);
            });
            return self.callFilters("promiseGoMix", deferred.promise, arguments);
        },
        /**
         * @private
         * @instance
         * @since   2.0.0
         * @param   {Operation}     operation
         * @return  {void}
         */ getStartMixData: function(operation) {
            var self = this, parentStyle = window1.getComputedStyle(self.dom.parent), parentRect = self.dom.parent.getBoundingClientRect(), target = null, data = {}, i = -1, boxSizing = parentStyle[mixitup.features.boxSizingProp];
            self.incPadding = boxSizing === "border-box";
            self.callActions("beforeGetStartMixData", arguments);
            for(i = 0; target = operation.show[i]; i++){
                data = target.getPosData();
                operation.showPosData[i] = {
                    startPosData: data
                };
            }
            for(i = 0; target = operation.toHide[i]; i++){
                data = target.getPosData();
                operation.toHidePosData[i] = {
                    startPosData: data
                };
            }
            operation.startX = parentRect.left;
            operation.startY = parentRect.top;
            operation.startHeight = self.incPadding ? parentRect.height : parentRect.height - parseFloat(parentStyle.paddingTop) - parseFloat(parentStyle.paddingBottom) - parseFloat(parentStyle.borderTop) - parseFloat(parentStyle.borderBottom);
            operation.startWidth = self.incPadding ? parentRect.width : parentRect.width - parseFloat(parentStyle.paddingLeft) - parseFloat(parentStyle.paddingRight) - parseFloat(parentStyle.borderLeft) - parseFloat(parentStyle.borderRight);
            self.callActions("afterGetStartMixData", arguments);
        },
        /**
         * @private
         * @instance
         * @since   2.0.0
         * @param   {Operation}     operation
         * @return  {void}
         */ setInter: function(operation) {
            var self = this, target = null, i = -1;
            self.callActions("beforeSetInter", arguments);
            // Prevent scrollbar flicker on non-inertial scroll platforms by clamping height/width
            if (self.config.animation.clampHeight) {
                self.dom.parent.style.height = operation.startHeight + "px";
                self.dom.parent.style.overflow = "hidden";
            }
            if (self.config.animation.clampWidth) {
                self.dom.parent.style.width = operation.startWidth + "px";
                self.dom.parent.style.overflow = "hidden";
            }
            for(i = 0; target = operation.toShow[i]; i++)target.show();
            if (operation.willChangeLayout) {
                h.removeClass(self.dom.container, operation.startContainerClassName);
                h.addClass(self.dom.container, operation.newContainerClassName);
            }
            self.callActions("afterSetInter", arguments);
        },
        /**
         * @private
         * @instance
         * @since   2.0.0
         * @param   {Operation}     operation
         * @return  {void}
         */ getInterMixData: function(operation) {
            var self = this, target = null, i = -1;
            self.callActions("beforeGetInterMixData", arguments);
            for(i = 0; target = operation.show[i]; i++)operation.showPosData[i].interPosData = target.getPosData();
            for(i = 0; target = operation.toHide[i]; i++)operation.toHidePosData[i].interPosData = target.getPosData();
            self.callActions("afterGetInterMixData", arguments);
        },
        /**
         * @private
         * @instance
         * @since   2.0.0
         * @param   {Operation}     operation
         * @return  {void}
         */ setFinal: function(operation) {
            var self = this, target = null, i = -1;
            self.callActions("beforeSetFinal", arguments);
            operation.willSort && self.printSort(false, operation);
            for(i = 0; target = operation.toHide[i]; i++)target.hide();
            self.callActions("afterSetFinal", arguments);
        },
        /**
         * @private
         * @instance
         * @since   2.0.0
         * @param   {Operation}     operation
         * @return  {void}
         */ getFinalMixData: function(operation) {
            var self = this, parentStyle = null, parentRect = null, target = null, i = -1;
            self.callActions("beforeGetFinalMixData", arguments);
            for(i = 0; target = operation.show[i]; i++)operation.showPosData[i].finalPosData = target.getPosData();
            for(i = 0; target = operation.toHide[i]; i++)operation.toHidePosData[i].finalPosData = target.getPosData();
            // Remove clamping
            if (self.config.animation.clampHeight || self.config.animation.clampWidth) self.dom.parent.style.height = self.dom.parent.style.width = self.dom.parent.style.overflow = "";
            if (!self.incPadding) parentStyle = window1.getComputedStyle(self.dom.parent);
            parentRect = self.dom.parent.getBoundingClientRect();
            operation.newX = parentRect.left;
            operation.newY = parentRect.top;
            operation.newHeight = self.incPadding ? parentRect.height : parentRect.height - parseFloat(parentStyle.paddingTop) - parseFloat(parentStyle.paddingBottom) - parseFloat(parentStyle.borderTop) - parseFloat(parentStyle.borderBottom);
            operation.newWidth = self.incPadding ? parentRect.width : parentRect.width - parseFloat(parentStyle.paddingLeft) - parseFloat(parentStyle.paddingRight) - parseFloat(parentStyle.borderLeft) - parseFloat(parentStyle.borderRight);
            operation.viewportDeltaX = operation.docState.viewportWidth - this.dom.document.documentElement.clientWidth;
            operation.viewportDeltaY = operation.docState.viewportHeight - this.dom.document.documentElement.clientHeight;
            if (operation.willSort) self.printSort(true, operation);
            for(i = 0; target = operation.toShow[i]; i++)target.hide();
            for(i = 0; target = operation.toHide[i]; i++)target.show();
            if (operation.willChangeLayout) {
                h.removeClass(self.dom.container, operation.newContainerClassName);
                h.addClass(self.dom.container, self.config.layout.containerClassName);
            }
            self.callActions("afterGetFinalMixData", arguments);
        },
        /**
         * @private
         * @instance
         * @since    3.0.0
         * @param    {Operation}     operation
         */ getTweenData: function(operation) {
            var self = this, target = null, posData = null, effectNames = Object.getOwnPropertyNames(self.effectsIn), effectName = "", effect = null, widthChange = -1, heightChange = -1, i = -1, j = -1;
            self.callActions("beforeGetTweenData", arguments);
            for(i = 0; target = operation.show[i]; i++){
                posData = operation.showPosData[i];
                posData.posIn = new mixitup.StyleData();
                posData.posOut = new mixitup.StyleData();
                posData.tweenData = new mixitup.StyleData();
                // Process x and y
                if (target.isShown) {
                    posData.posIn.x = posData.startPosData.x - posData.interPosData.x;
                    posData.posIn.y = posData.startPosData.y - posData.interPosData.y;
                } else posData.posIn.x = posData.posIn.y = 0;
                posData.posOut.x = posData.finalPosData.x - posData.interPosData.x;
                posData.posOut.y = posData.finalPosData.y - posData.interPosData.y;
                // Process opacity
                posData.posIn.opacity = target.isShown ? 1 : self.effectsIn.opacity;
                posData.posOut.opacity = 1;
                posData.tweenData.opacity = posData.posOut.opacity - posData.posIn.opacity;
                // Adjust x and y if not nudging
                if (!target.isShown && !self.config.animation.nudge) {
                    posData.posIn.x = posData.posOut.x;
                    posData.posIn.y = posData.posOut.y;
                }
                posData.tweenData.x = posData.posOut.x - posData.posIn.x;
                posData.tweenData.y = posData.posOut.y - posData.posIn.y;
                // Process width, height, and margins
                if (self.config.animation.animateResizeTargets) {
                    posData.posIn.width = posData.startPosData.width;
                    posData.posIn.height = posData.startPosData.height;
                    // "||" Prevents width/height change from including 0 width/height if hiding or showing
                    widthChange = (posData.startPosData.width || posData.finalPosData.width) - posData.interPosData.width;
                    posData.posIn.marginRight = posData.startPosData.marginRight - widthChange;
                    heightChange = (posData.startPosData.height || posData.finalPosData.height) - posData.interPosData.height;
                    posData.posIn.marginBottom = posData.startPosData.marginBottom - heightChange;
                    posData.posOut.width = posData.finalPosData.width;
                    posData.posOut.height = posData.finalPosData.height;
                    widthChange = (posData.finalPosData.width || posData.startPosData.width) - posData.interPosData.width;
                    posData.posOut.marginRight = posData.finalPosData.marginRight - widthChange;
                    heightChange = (posData.finalPosData.height || posData.startPosData.height) - posData.interPosData.height;
                    posData.posOut.marginBottom = posData.finalPosData.marginBottom - heightChange;
                    posData.tweenData.width = posData.posOut.width - posData.posIn.width;
                    posData.tweenData.height = posData.posOut.height - posData.posIn.height;
                    posData.tweenData.marginRight = posData.posOut.marginRight - posData.posIn.marginRight;
                    posData.tweenData.marginBottom = posData.posOut.marginBottom - posData.posIn.marginBottom;
                }
                // Process transforms
                for(j = 0; effectName = effectNames[j]; j++){
                    effect = self.effectsIn[effectName];
                    if (!(effect instanceof mixitup.TransformData) || !effect.value) continue;
                    posData.posIn[effectName].value = effect.value;
                    posData.posOut[effectName].value = 0;
                    posData.tweenData[effectName].value = posData.posOut[effectName].value - posData.posIn[effectName].value;
                    posData.posIn[effectName].unit = posData.posOut[effectName].unit = posData.tweenData[effectName].unit = effect.unit;
                }
            }
            for(i = 0; target = operation.toHide[i]; i++){
                posData = operation.toHidePosData[i];
                posData.posIn = new mixitup.StyleData();
                posData.posOut = new mixitup.StyleData();
                posData.tweenData = new mixitup.StyleData();
                // Process x and y
                posData.posIn.x = target.isShown ? posData.startPosData.x - posData.interPosData.x : 0;
                posData.posIn.y = target.isShown ? posData.startPosData.y - posData.interPosData.y : 0;
                posData.posOut.x = self.config.animation.nudge ? 0 : posData.posIn.x;
                posData.posOut.y = self.config.animation.nudge ? 0 : posData.posIn.y;
                posData.tweenData.x = posData.posOut.x - posData.posIn.x;
                posData.tweenData.y = posData.posOut.y - posData.posIn.y;
                // Process width, height, and margins
                if (self.config.animation.animateResizeTargets) {
                    posData.posIn.width = posData.startPosData.width;
                    posData.posIn.height = posData.startPosData.height;
                    widthChange = posData.startPosData.width - posData.interPosData.width;
                    posData.posIn.marginRight = posData.startPosData.marginRight - widthChange;
                    heightChange = posData.startPosData.height - posData.interPosData.height;
                    posData.posIn.marginBottom = posData.startPosData.marginBottom - heightChange;
                }
                // Process opacity
                posData.posIn.opacity = 1;
                posData.posOut.opacity = self.effectsOut.opacity;
                posData.tweenData.opacity = posData.posOut.opacity - posData.posIn.opacity;
                // Process transforms
                for(j = 0; effectName = effectNames[j]; j++){
                    effect = self.effectsOut[effectName];
                    if (!(effect instanceof mixitup.TransformData) || !effect.value) continue;
                    posData.posIn[effectName].value = 0;
                    posData.posOut[effectName].value = effect.value;
                    posData.tweenData[effectName].value = posData.posOut[effectName].value - posData.posIn[effectName].value;
                    posData.posIn[effectName].unit = posData.posOut[effectName].unit = posData.tweenData[effectName].unit = effect.unit;
                }
            }
            self.callActions("afterGetTweenData", arguments);
        },
        /**
         * @private
         * @instance
         * @since   3.0.0
         * @param   {Operation}     operation
         * @return  {void}
         */ moveTargets: function(operation) {
            var self = this, target = null, moveData = null, posData = null, statusChange = "", willTransition = false, staggerIndex = -1, i = -1, checkProgress = self.checkProgress.bind(self);
            self.callActions("beforeMoveTargets", arguments);
            // TODO: this is an extra loop in addition to the calcs
            // done in getOperation, could some of this be done there?
            for(i = 0; target = operation.show[i]; i++){
                moveData = new mixitup.IMoveData();
                posData = operation.showPosData[i];
                statusChange = target.isShown ? "none" : "show";
                willTransition = self.willTransition(statusChange, operation.hasEffect, posData.posIn, posData.posOut);
                if (willTransition) // Prevent non-transitioning targets from incrementing the staggerIndex
                staggerIndex++;
                target.show();
                moveData.posIn = posData.posIn;
                moveData.posOut = posData.posOut;
                moveData.statusChange = statusChange;
                moveData.staggerIndex = staggerIndex;
                moveData.operation = operation;
                moveData.callback = willTransition ? checkProgress : null;
                target.move(moveData);
            }
            for(i = 0; target = operation.toHide[i]; i++){
                posData = operation.toHidePosData[i];
                moveData = new mixitup.IMoveData();
                statusChange = "hide";
                willTransition = self.willTransition(statusChange, posData.posIn, posData.posOut);
                moveData.posIn = posData.posIn;
                moveData.posOut = posData.posOut;
                moveData.statusChange = statusChange;
                moveData.staggerIndex = i;
                moveData.operation = operation;
                moveData.callback = willTransition ? checkProgress : null;
                target.move(moveData);
            }
            if (self.config.animation.animateResizeContainer) {
                self.dom.parent.style[mixitup.features.transitionProp] = "height " + self.config.animation.duration + "ms ease, " + "width " + self.config.animation.duration + "ms ease ";
                requestAnimationFrame(function() {
                    if (operation.startHeight !== operation.newHeight && operation.viewportDeltaY !== operation.startHeight - operation.newHeight) self.dom.parent.style.height = operation.newHeight + "px";
                    if (operation.startWidth !== operation.newWidth && operation.viewportDeltaX !== operation.startWidth - operation.newWidth) self.dom.parent.style.width = operation.newWidth + "px";
                });
            }
            if (operation.willChangeLayout) {
                h.removeClass(self.dom.container, self.config.layout.ContainerClassName);
                h.addClass(self.dom.container, operation.newContainerClassName);
            }
            self.callActions("afterMoveTargets", arguments);
        },
        /**
         * @private
         * @instance
         * @return  {boolean}
         */ hasEffect: function() {
            var self = this, EFFECTABLES = [
                "scale",
                "translateX",
                "translateY",
                "translateZ",
                "rotateX",
                "rotateY",
                "rotateZ"
            ], effectName = "", effect = null, result = false, value = -1, i = -1;
            if (self.effectsIn.opacity !== 1) return self.callFilters("resultHasEffect", true, arguments);
            for(i = 0; effectName = EFFECTABLES[i]; i++){
                effect = self.effectsIn[effectName];
                value = typeof effect && effect.value !== "undefined" ? effect.value : effect;
                if (value !== 0) {
                    result = true;
                    break;
                }
            }
            return self.callFilters("resultHasEffect", result, arguments);
        },
        /**
         * Determines if a target element will transition in
         * some fasion and therefore requires binding of
         * transitionEnd
         *
         * @private
         * @instance
         * @since   3.0.0
         * @param   {string}        statusChange
         * @param   {boolean}       hasEffect
         * @param   {StyleData}     posIn
         * @param   {StyleData}     posOut
         * @return  {boolean}
         */ willTransition: function(statusChange, hasEffect, posIn, posOut) {
            var self = this, result = false;
            if (!h.isVisible(self.dom.container)) // If the container is not visible, the transitionEnd
            // event will not occur and MixItUp will hang
            result = false;
            else if (statusChange !== "none" && hasEffect || posIn.x !== posOut.x || posIn.y !== posOut.y) // If opacity and/or translate will change
            result = true;
            else if (self.config.animation.animateResizeTargets) // Check if width, height or margins will change
            result = posIn.width !== posOut.width || posIn.height !== posOut.height || posIn.marginRight !== posOut.marginRight || posIn.marginTop !== posOut.marginTop;
            else result = false;
            return self.callFilters("resultWillTransition", result, arguments);
        },
        /**
         * @private
         * @instance
         * @since   2.0.0
         * @param   {Operation}     operation
         * @return  {void}
         */ checkProgress: function(operation) {
            var self = this;
            self.targetsDone++;
            if (self.targetsBound === self.targetsDone) self.cleanUp(operation);
        },
        /**
         * @private
         * @instance
         * @since   2.0.0
         * @param   {Operation}     operation
         * @return  {void}
         */ cleanUp: function(operation) {
            var self = this, target = null, whitespaceBefore = null, whitespaceAfter = null, nextInQueue = null, i = -1;
            self.callActions("beforeCleanUp", arguments);
            self.targetsMoved = self.targetsImmovable = self.targetsBound = self.targetsDone = 0;
            for(i = 0; target = operation.show[i]; i++){
                target.cleanUp();
                target.show();
            }
            for(i = 0; target = operation.toHide[i]; i++){
                target.cleanUp();
                target.hide();
            }
            if (operation.willSort) self.printSort(false, operation);
            // Remove any styles applied to the parent container
            self.dom.parent.style[mixitup.features.transitionProp] = self.dom.parent.style.height = self.dom.parent.style.width = self.dom.parent.style.overflow = self.dom.parent.style[mixitup.features.perspectiveProp] = self.dom.parent.style[mixitup.features.perspectiveOriginProp] = "";
            if (operation.willChangeLayout) {
                h.removeClass(self.dom.container, operation.startContainerClassName);
                h.addClass(self.dom.container, operation.newContainerClassName);
            }
            if (operation.toRemove.length) {
                for(i = 0; target = self.targets[i]; i++)if (operation.toRemove.indexOf(target) > -1) {
                    if ((whitespaceBefore = target.dom.el.previousSibling) && whitespaceBefore.nodeName === "#text" && (whitespaceAfter = target.dom.el.nextSibling) && whitespaceAfter.nodeName === "#text") h.removeWhitespace(whitespaceBefore);
                    if (!operation.willSort) // NB: Sorting will remove targets as a bi-product of `printSort()`
                    self.dom.parent.removeChild(target.dom.el);
                    self.targets.splice(i, 1);
                    target.isInDom = false;
                    i--;
                }
                // Since targets have been removed, the original order must be updated
                self.origOrder = self.targets;
            }
            if (operation.willSort) self.targets = operation.newOrder;
            self.state = operation.newState;
            self.lastOperation = operation;
            self.dom.targets = self.state.targets;
            // mixEnd
            mixitup.events.fire("mixEnd", self.dom.container, {
                state: self.state,
                instance: self
            }, self.dom.document);
            if (typeof self.config.callbacks.onMixEnd === "function") self.config.callbacks.onMixEnd.call(self.dom.container, self.state, self);
            if (operation.hasFailed) {
                // mixFail
                mixitup.events.fire("mixFail", self.dom.container, {
                    state: self.state,
                    instance: self
                }, self.dom.document);
                if (typeof self.config.callbacks.onMixFail === "function") self.config.callbacks.onMixFail.call(self.dom.container, self.state, self);
                h.addClass(self.dom.container, h.getClassname(self.config.classNames, "container", self.config.classNames.modifierFailed));
            }
            // User-defined callback function
            if (typeof self.userCallback === "function") self.userCallback.call(self.dom.container, self.state, self);
            if (typeof self.userDeferred.resolve === "function") self.userDeferred.resolve(self.state);
            self.userCallback = null;
            self.userDeferred = null;
            self.lastClicked = null;
            self.isToggling = false;
            self.isBusy = false;
            if (self.queue.length) {
                self.callActions("beforeReadQueueCleanUp", arguments);
                nextInQueue = self.queue.shift();
                // Update non-public API properties stored in queue
                self.userDeferred = nextInQueue.deferred;
                self.isToggling = nextInQueue.isToggling;
                self.lastClicked = nextInQueue.triggerElement;
                if (nextInQueue.instruction.command instanceof mixitup.CommandMultimix) self.multimix.apply(self, nextInQueue.args);
                else self.dataset.apply(self, nextInQueue.args);
            }
            self.callActions("afterCleanUp", arguments);
        },
        /**
         * @private
         * @instance
         * @since   2.0.0
         * @param   {Array<*>}  args
         * @return  {mixitup.UserInstruction}
         */ parseMultimixArgs: function(args) {
            var self = this, instruction = new mixitup.UserInstruction(), arg = null, i = -1;
            instruction.animate = self.config.animation.enable;
            instruction.command = new mixitup.CommandMultimix();
            for(i = 0; i < args.length; i++){
                arg = args[i];
                if (arg === null) continue;
                if (typeof arg === "object") h.extend(instruction.command, arg);
                else if (typeof arg === "boolean") instruction.animate = arg;
                else if (typeof arg === "function") instruction.callback = arg;
            }
            // Coerce arbitrary command arguments into typed command objects
            if (instruction.command.insert && !(instruction.command.insert instanceof mixitup.CommandInsert)) instruction.command.insert = self.parseInsertArgs([
                instruction.command.insert
            ]).command;
            if (instruction.command.remove && !(instruction.command.remove instanceof mixitup.CommandRemove)) instruction.command.remove = self.parseRemoveArgs([
                instruction.command.remove
            ]).command;
            if (instruction.command.filter && !(instruction.command.filter instanceof mixitup.CommandFilter)) instruction.command.filter = self.parseFilterArgs([
                instruction.command.filter
            ]).command;
            if (instruction.command.sort && !(instruction.command.sort instanceof mixitup.CommandSort)) instruction.command.sort = self.parseSortArgs([
                instruction.command.sort
            ]).command;
            if (instruction.command.changeLayout && !(instruction.command.changeLayout instanceof mixitup.CommandChangeLayout)) instruction.command.changeLayout = self.parseChangeLayoutArgs([
                instruction.command.changeLayout
            ]).command;
            instruction = self.callFilters("instructionParseMultimixArgs", instruction, arguments);
            h.freeze(instruction);
            return instruction;
        },
        /**
         * @private
         * @instance
         * @since   2.0.0
         * @param   {Array<*>}  args
         * @return  {mixitup.UserInstruction}
         */ parseFilterArgs: function(args) {
            var self = this, instruction = new mixitup.UserInstruction(), arg = null, i = -1;
            instruction.animate = self.config.animation.enable;
            instruction.command = new mixitup.CommandFilter();
            for(i = 0; i < args.length; i++){
                arg = args[i];
                if (typeof arg === "string") // Selector
                instruction.command.selector = arg;
                else if (arg === null) instruction.command.collection = [];
                else if (typeof arg === "object" && h.isElement(arg, self.dom.document)) // Single element
                instruction.command.collection = [
                    arg
                ];
                else if (typeof arg === "object" && typeof arg.length !== "undefined") // Multiple elements in array, NodeList or jQuery collection
                instruction.command.collection = h.arrayFromList(arg);
                else if (typeof arg === "object") // Filter command
                h.extend(instruction.command, arg);
                else if (typeof arg === "boolean") instruction.animate = arg;
                else if (typeof arg === "function") instruction.callback = arg;
            }
            if (instruction.command.selector && instruction.command.collection) throw new Error(mixitup.messages.errorFilterInvalidArguments());
            instruction = self.callFilters("instructionParseFilterArgs", instruction, arguments);
            h.freeze(instruction);
            return instruction;
        },
        parseSortArgs: function(args) {
            var self = this, instruction = new mixitup.UserInstruction(), arg = null, sortString = "", i = -1;
            instruction.animate = self.config.animation.enable;
            instruction.command = new mixitup.CommandSort();
            for(i = 0; i < args.length; i++){
                arg = args[i];
                if (arg === null) continue;
                switch(typeof arg){
                    case "string":
                        // Sort string
                        sortString = arg;
                        break;
                    case "object":
                        // Array of element references
                        if (arg.length) instruction.command.collection = h.arrayFromList(arg);
                        break;
                    case "boolean":
                        instruction.animate = arg;
                        break;
                    case "function":
                        instruction.callback = arg;
                        break;
                }
            }
            if (sortString) instruction.command = self.parseSortString(sortString, instruction.command);
            instruction = self.callFilters("instructionParseSortArgs", instruction, arguments);
            h.freeze(instruction);
            return instruction;
        },
        /**
         * @private
         * @instance
         * @since   2.0.0
         * @param   {Array<*>}  args
         * @return  {mixitup.UserInstruction}
         */ parseInsertArgs: function(args) {
            var self = this, instruction = new mixitup.UserInstruction(), arg = null, i = -1;
            instruction.animate = self.config.animation.enable;
            instruction.command = new mixitup.CommandInsert();
            for(i = 0; i < args.length; i++){
                arg = args[i];
                if (arg === null) continue;
                if (typeof arg === "number") // Insert index
                instruction.command.index = arg;
                else if (typeof arg === "string" && [
                    "before",
                    "after"
                ].indexOf(arg) > -1) // 'before'/'after'
                instruction.command.position = arg;
                else if (typeof arg === "string") // Markup
                instruction.command.collection = h.arrayFromList(h.createElement(arg).childNodes);
                else if (typeof arg === "object" && h.isElement(arg, self.dom.document)) // Single element
                !instruction.command.collection.length ? instruction.command.collection = [
                    arg
                ] : instruction.command.sibling = arg;
                else if (typeof arg === "object" && arg.length) // Multiple elements in array or jQuery collection
                !instruction.command.collection.length ? instruction.command.collection = arg : instruction.command.sibling = arg[0];
                else if (typeof arg === "object" && arg.childNodes && arg.childNodes.length) // Document fragment
                !instruction.command.collection.length ? instruction.command.collection = h.arrayFromList(arg.childNodes) : instruction.command.sibling = arg.childNodes[0];
                else if (typeof arg === "object") // Insert command
                h.extend(instruction.command, arg);
                else if (typeof arg === "boolean") instruction.animate = arg;
                else if (typeof arg === "function") instruction.callback = arg;
            }
            if (instruction.command.index && instruction.command.sibling) throw new Error(mixitup.messages.errorInsertInvalidArguments());
            if (!instruction.command.collection.length && self.config.debug.showWarnings) console.warn(mixitup.messages.warningInsertNoElements());
            instruction = self.callFilters("instructionParseInsertArgs", instruction, arguments);
            h.freeze(instruction);
            return instruction;
        },
        /**
         * @private
         * @instance
         * @since   3.0.0
         * @param   {Array<*>}  args
         * @return  {mixitup.UserInstruction}
         */ parseRemoveArgs: function(args) {
            var self = this, instruction = new mixitup.UserInstruction(), target = null, arg = null, i = -1;
            instruction.animate = self.config.animation.enable;
            instruction.command = new mixitup.CommandRemove();
            for(i = 0; i < args.length; i++){
                arg = args[i];
                if (arg === null) continue;
                switch(typeof arg){
                    case "number":
                        if (self.targets[arg]) instruction.command.targets[0] = self.targets[arg];
                        break;
                    case "string":
                        instruction.command.collection = h.arrayFromList(self.dom.parent.querySelectorAll(arg));
                        break;
                    case "object":
                        if (arg && arg.length) instruction.command.collection = arg;
                        else if (h.isElement(arg, self.dom.document)) instruction.command.collection = [
                            arg
                        ];
                        else // Remove command
                        h.extend(instruction.command, arg);
                        break;
                    case "boolean":
                        instruction.animate = arg;
                        break;
                    case "function":
                        instruction.callback = arg;
                        break;
                }
            }
            if (instruction.command.collection.length) {
                for(i = 0; target = self.targets[i]; i++)if (instruction.command.collection.indexOf(target.dom.el) > -1) instruction.command.targets.push(target);
            }
            if (!instruction.command.targets.length && self.config.debug.showWarnings) console.warn(mixitup.messages.warningRemoveNoElements());
            h.freeze(instruction);
            return instruction;
        },
        /**
         * @private
         * @instance
         * @since   3.0.0
         * @param   {Array<*>}  args
         * @return  {mixitup.UserInstruction}
         */ parseDatasetArgs: function(args) {
            var self = this, instruction = new mixitup.UserInstruction(), arg = null, i = -1;
            instruction.animate = self.config.animation.enable;
            instruction.command = new mixitup.CommandDataset();
            for(i = 0; i < args.length; i++){
                arg = args[i];
                if (arg === null) continue;
                switch(typeof arg){
                    case "object":
                        if (Array.isArray(arg) || typeof arg.length === "number") instruction.command.dataset = arg;
                        else // Change layout command
                        h.extend(instruction.command, arg);
                        break;
                    case "boolean":
                        instruction.animate = arg;
                        break;
                    case "function":
                        instruction.callback = arg;
                        break;
                }
            }
            h.freeze(instruction);
            return instruction;
        },
        /**
         * @private
         * @instance
         * @since   3.0.0
         * @param   {Array<*>}  args
         * @return  {mixitup.UserInstruction}
         */ parseChangeLayoutArgs: function(args) {
            var self = this, instruction = new mixitup.UserInstruction(), arg = null, i = -1;
            instruction.animate = self.config.animation.enable;
            instruction.command = new mixitup.CommandChangeLayout();
            for(i = 0; i < args.length; i++){
                arg = args[i];
                if (arg === null) continue;
                switch(typeof arg){
                    case "string":
                        instruction.command.containerClassName = arg;
                        break;
                    case "object":
                        // Change layout command
                        h.extend(instruction.command, arg);
                        break;
                    case "boolean":
                        instruction.animate = arg;
                        break;
                    case "function":
                        instruction.callback = arg;
                        break;
                }
            }
            h.freeze(instruction);
            return instruction;
        },
        /**
         * @private
         * @instance
         * @since       3.0.0
         * @param       {mixitup.QueueItem}         queueItem
         * @return      {Promise.<mixitup.State>}
         */ queueMix: function(queueItem) {
            var self = this, deferred = null, toggleSelector = "";
            self.callActions("beforeQueueMix", arguments);
            deferred = h.defer(mixitup.libraries);
            if (self.config.animation.queue && self.queue.length < self.config.animation.queueLimit) {
                queueItem.deferred = deferred;
                self.queue.push(queueItem);
                // Keep controls in sync with user interactions. Mixer will catch up as it drains the queue.
                if (self.config.controls.enable) {
                    if (self.isToggling) {
                        self.buildToggleArray(queueItem.instruction.command);
                        toggleSelector = self.getToggleSelector();
                        self.updateControls({
                            filter: {
                                selector: toggleSelector
                            }
                        });
                    } else self.updateControls(queueItem.instruction.command);
                }
            } else {
                if (self.config.debug.showWarnings) console.warn(mixitup.messages.warningMultimixInstanceQueueFull());
                deferred.resolve(self.state);
                mixitup.events.fire("mixBusy", self.dom.container, {
                    state: self.state,
                    instance: self
                }, self.dom.document);
                if (typeof self.config.callbacks.onMixBusy === "function") self.config.callbacks.onMixBusy.call(self.dom.container, self.state, self);
            }
            return self.callFilters("promiseQueueMix", deferred.promise, arguments);
        },
        /**
         * @private
         * @instance
         * @since   3.0.0
         * @param   {Array.<object>}    newDataset
         * @return  {Operation}
         */ getDataOperation: function(newDataset) {
            var self = this, operation = new mixitup.Operation(), startDataset = [];
            operation = self.callFilters("operationUnmappedGetDataOperation", operation, arguments);
            if (self.dom.targets.length && !(startDataset = self.state.activeDataset || []).length) throw new Error(mixitup.messages.errorDatasetNotSet());
            operation.id = h.randomHex();
            operation.startState = self.state;
            operation.startDataset = startDataset;
            operation.newDataset = newDataset.slice();
            self.diffDatasets(operation);
            operation.startOrder = self.targets;
            operation.newOrder = operation.show;
            if (self.config.animation.enable) {
                self.getStartMixData(operation);
                self.setInter(operation);
                operation.docState = h.getDocumentState(self.dom.document);
                self.getInterMixData(operation);
                self.setFinal(operation);
                self.getFinalMixData(operation);
                self.parseEffects();
                operation.hasEffect = self.hasEffect();
                self.getTweenData(operation);
            }
            self.targets = operation.show.slice();
            operation.newState = self.buildState(operation);
            // NB: Targets to be removed must be included in `self.targets` for removal during clean up,
            // but are added after state is built so that state is accurate
            Array.prototype.push.apply(self.targets, operation.toRemove);
            operation = self.callFilters("operationMappedGetDataOperation", operation, arguments);
            return operation;
        },
        /**
         * @private
         * @instance
         * @since   3.0.0
         * @param   {mixitup.Operation} operation
         * @return  {void}
         */ diffDatasets: function(operation) {
            var self = this, persistantStartIds = [], persistantNewIds = [], insertedTargets = [], data = null, target = null, el = null, frag = null, nextEl = null, uids = {}, id = "", i = -1;
            self.callActions("beforeDiffDatasets", arguments);
            for(i = 0; data = operation.newDataset[i]; i++){
                if (typeof (id = data[self.config.data.uidKey]) === "undefined" || id.toString().length < 1) throw new TypeError(mixitup.messages.errorDatasetInvalidUidKey({
                    uidKey: self.config.data.uidKey
                }));
                if (!uids[id]) uids[id] = true;
                else throw new Error(mixitup.messages.errorDatasetDuplicateUid({
                    uid: id
                }));
                if ((target = self.cache[id]) instanceof mixitup.Target) {
                    // Already in cache
                    if (self.config.data.dirtyCheck && !h.deepEquals(data, target.data)) {
                        // change detected
                        el = target.render(data);
                        target.data = data;
                        if (el !== target.dom.el) {
                            // Update target element reference
                            if (target.isInDom) {
                                target.unbindEvents();
                                self.dom.parent.replaceChild(el, target.dom.el);
                            }
                            if (!target.isShown) el.style.display = "none";
                            target.dom.el = el;
                            if (target.isInDom) target.bindEvents();
                        }
                    }
                    el = target.dom.el;
                } else {
                    // New target
                    target = new mixitup.Target();
                    target.init(null, self, data);
                    target.hide();
                }
                if (!target.isInDom) {
                    // Adding to DOM
                    if (!frag) // Open frag
                    frag = self.dom.document.createDocumentFragment();
                    if (frag.lastElementChild) frag.appendChild(self.dom.document.createTextNode(" "));
                    frag.appendChild(target.dom.el);
                    target.isInDom = true;
                    target.unbindEvents();
                    target.bindEvents();
                    target.hide();
                    operation.toShow.push(target);
                    insertedTargets.push(target);
                } else {
                    // Already in DOM
                    nextEl = target.dom.el.nextElementSibling;
                    persistantNewIds.push(id);
                    if (frag) {
                        // Close and insert previously opened frag
                        if (frag.lastElementChild) frag.appendChild(self.dom.document.createTextNode(" "));
                        self.insertDatasetFrag(frag, target.dom.el, insertedTargets);
                        frag = null;
                    }
                }
                operation.show.push(target);
            }
            if (frag) {
                // Unclosed frag remaining
                nextEl = nextEl || self.config.layout.siblingAfter;
                if (nextEl) frag.appendChild(self.dom.document.createTextNode(" "));
                self.insertDatasetFrag(frag, nextEl, insertedTargets);
            }
            for(i = 0; data = operation.startDataset[i]; i++){
                id = data[self.config.data.uidKey];
                target = self.cache[id];
                if (operation.show.indexOf(target) < 0) {
                    // Previously shown but now absent
                    operation.hide.push(target);
                    operation.toHide.push(target);
                    operation.toRemove.push(target);
                } else persistantStartIds.push(id);
            }
            if (!h.isEqualArray(persistantStartIds, persistantNewIds)) operation.willSort = true;
            self.callActions("afterDiffDatasets", arguments);
        },
        /**
         * @private
         * @instance
         * @since   3.1.5
         * @param   {DocumentFragment}          frag
         * @param   {(HTMLElement|null)}        nextEl
         * @param   {Array.<mixitup.Target>}    targets
         * @return  {void}
         */ insertDatasetFrag: function(frag, nextEl, targets) {
            var self = this;
            var insertAt = nextEl ? h.arrayFromList(self.dom.parent.children).indexOf(nextEl) : self.targets.length;
            self.dom.parent.insertBefore(frag, nextEl);
            while(targets.length){
                self.targets.splice(insertAt, 0, targets.shift());
                insertAt++;
            }
        },
        /**
         * @private
         * @instance
         * @since   3.0.0
         * @param   {mixitup.CommandSort} sortCommandA
         * @param   {mixitup.CommandSort} sortCommandB
         * @return  {boolean}
         */ willSort: function(sortCommandA, sortCommandB) {
            var self = this, result = false;
            if (self.config.behavior.liveSort || sortCommandA.order === "random" || sortCommandA.attribute !== sortCommandB.attribute || sortCommandA.order !== sortCommandB.order || sortCommandA.collection !== sortCommandB.collection || sortCommandA.next === null && sortCommandB.next || sortCommandA.next && sortCommandB.next === null) result = true;
            else if (sortCommandA.next && sortCommandB.next) result = self.willSort(sortCommandA.next, sortCommandB.next);
            else result = false;
            return self.callFilters("resultWillSort", result, arguments);
        },
        /**
         * A shorthand method for `.filter('all')`. Shows all targets in the container.
         *
         * @example
         *
         * .show()
         *
         * @example <caption>Example: Showing all targets</caption>
         *
         * mixer.show()
         *     .then(function(state) {
         *         console.log(state.totalShow === state.totalTargets); // true
         *     });
         *
         * @public
         * @instance
         * @since       3.0.0
         * @return      {Promise.<mixitup.State>}
         */ show: function() {
            var self = this;
            return self.filter("all");
        },
        /**
         * A shorthand method for `.filter('none')`. Hides all targets in the container.
         *
         * @example
         *
         * .hide()
         *
         * @example <caption>Example: Hiding all targets</caption>
         *
         * mixer.hide()
         *     .then(function(state) {
         *         console.log(state.totalShow === 0); // true
         *         console.log(state.totalHide === state.totalTargets); // true
         *     });
         *
         * @public
         * @instance
         * @since       3.0.0
         * @return      {Promise.<mixitup.State>}
         */ hide: function() {
            var self = this;
            return self.filter("none");
        },
        /**
         * Returns a boolean indicating whether or not a MixItUp operation is
         * currently in progress.
         *
         * @example
         *
         * .isMixing()
         *
         * @example <caption>Example: Checking the status of a mixer</caption>
         *
         * mixer.sort('random', function() {
         *     console.log(mixer.isMixing()) // false
         * });
         *
         * console.log(mixer.isMixing()) // true
         *
         * @public
         * @instance
         * @since   2.0.0
         * @return  {boolean}
         */ isMixing: function() {
            var self = this;
            return self.isBusy;
        },
        /**
         * Filters all targets in the container by a provided selector string, or the values `'all'`
         * or `'none'`. Only targets matching the selector will be shown.
         *
         * @example
         *
         * .filter(selector [, animate] [, callback])
         *
         * @example <caption>Example 1: Filtering targets by a class selector</caption>
         *
         * mixer.filter('.category-a')
         *     .then(function(state) {
         *         console.log(state.totalShow === containerEl.querySelectorAll('.category-a').length); // true
         *     });
         *
         * @example <caption>Example 2: Filtering targets by an attribute selector</caption>
         *
         * mixer.filter('[data-category~="a"]')
         *     .then(function(state) {
         *         console.log(state.totalShow === containerEl.querySelectorAll('[data-category~="a"]').length); // true
         *     });
         *
         * @example <caption>Example 3: Filtering targets by a compound selector</caption>
         *
         * // Show only those targets with the classes 'category-a' AND 'category-b'
         *
         * mixer.filter('.category-a.category-c')
         *     .then(function(state) {
         *         console.log(state.totalShow === containerEl.querySelectorAll('.category-a.category-c').length); // true
         *     });
         *
         * @example <caption>Example 4: Filtering via an element collection</caption>
         *
         * var collection = Array.from(container.querySelectorAll('.mix'));
         *
         * console.log(collection.length); // 34
         *
         * // Filter the collection manually using Array.prototype.filter
         *
         * var filtered = collection.filter(function(target) {
         *    return parseInt(target.getAttribute('data-price')) > 10;
         * });
         *
         * console.log(filtered.length); // 22
         *
         * // Pass the filtered collection to MixItUp
         *
         * mixer.filter(filtered)
         *    .then(function(state) {
         *        console.log(state.activeFilter.collection.length === 22); // true
         *    });
         *
         * @public
         * @instance
         * @since       2.0.0
         * @param       {(string|HTMLElement|Array.<HTMLElement>)} selector
         *      Any valid CSS selector (i.e. `'.category-a'`), or the values `'all'` or `'none'`. The filter method also accepts a reference to single target element or a collection of target elements to show.
         * @param       {boolean}   [animate=true]
         *      An optional boolean dictating whether the operation should animate, or occur syncronously with no animation. `true` by default.
         * @param       {function}  [callback=null]
         *      An optional callback function to be invoked after the operation has completed.
         * @return      {Promise.<mixitup.State>}
         *      A promise resolving with the current state object.
         */ filter: function() {
            var self = this, instruction = self.parseFilterArgs(arguments);
            return self.multimix({
                filter: instruction.command
            }, instruction.animate, instruction.callback);
        },
        /**
         * Adds an additional selector to the currently active filter selector, concatenating
         * as per the logic defined in `controls.toggleLogic`.
         *
         * @example
         *
         * .toggleOn(selector [, animate] [, callback])
         *
         * @example <caption>Example: Toggling on a filter selector</caption>
         *
         * console.log(mixer.getState().activeFilter.selector); // '.category-a'
         *
         * mixer.toggleOn('.category-b')
         *     .then(function(state) {
         *         console.log(state.activeFilter.selector); // '.category-a, .category-b'
         *     });
         *
         * @public
         * @instance
         * @since       3.0.0
         * @param       {string}    selector
         *      Any valid CSS selector (i.e. `'.category-a'`)
         * @param       {boolean}   [animate=true]
         *      An optional boolean dictating whether the operation should animate, or occur syncronously with no animation. `true` by default.
         * @param       {function}  [callback=null]
         *      An optional callback function to be invoked after the operation has completed.
         * @return      {Promise.<mixitup.State>}
         *      A promise resolving with the current state object.
         */ toggleOn: function() {
            var self = this, instruction = self.parseFilterArgs(arguments), selector = instruction.command.selector, toggleSelector = "";
            self.isToggling = true;
            if (self.toggleArray.indexOf(selector) < 0) self.toggleArray.push(selector);
            toggleSelector = self.getToggleSelector();
            return self.multimix({
                filter: toggleSelector
            }, instruction.animate, instruction.callback);
        },
        /**
         * Removes a selector from the active filter selector.
         *
         * @example
         *
         * .toggleOff(selector [, animate] [, callback])
         *
         * @example <caption>Example: Toggling off a filter selector</caption>
         *
         * console.log(mixer.getState().activeFilter.selector); // '.category-a, .category-b'
         *
         * mixer.toggleOff('.category-b')
         *     .then(function(state) {
         *         console.log(state.activeFilter.selector); // '.category-a'
         *     });
         *
         * @public
         * @instance
         * @since       3.0.0
         * @param       {string}    selector
         *      Any valid CSS selector (i.e. `'.category-a'`)
         * @param       {boolean}   [animate=true]
         *      An optional boolean dictating whether the operation should animate, or occur syncronously with no animation. `true` by default.
         * @param       {function}  [callback=null]
         *      An optional callback function to be invoked after the operation has completed.
         * @return      {Promise.<mixitup.State>}
         *      A promise resolving with the current state object.
         */ toggleOff: function() {
            var self = this, instruction = self.parseFilterArgs(arguments), selector = instruction.command.selector, selectorIndex = self.toggleArray.indexOf(selector), toggleSelector = "";
            self.isToggling = true;
            if (selectorIndex > -1) self.toggleArray.splice(selectorIndex, 1);
            toggleSelector = self.getToggleSelector();
            return self.multimix({
                filter: toggleSelector
            }, instruction.animate, instruction.callback);
        },
        /**
         * Sorts all targets in the container according to a provided sort string.
         *
         * @example
         *
         * .sort(sortString [, animate] [, callback])
         *
         * @example <caption>Example 1: Sorting by the default DOM order</caption>
         *
         * // Reverse the default order of the targets
         *
         * mixer.sort('default:desc')
         *     .then(function(state) {
         *         console.log(state.activeSort.attribute === 'default'); // true
         *         console.log(state.activeSort.order === 'desc'); // true
         *     });
         *
         * @example <caption>Example 2: Sorting by a custom data-attribute</caption>
         *
         * // Sort the targets by the value of a `data-published-date` attribute
         *
         * mixer.sort('published-date:asc')
         *     .then(function(state) {
         *         console.log(state.activeSort.attribute === 'published-date'); // true
         *         console.log(state.activeSort.order === 'asc'); // true
         *     });
         *
         * @example <caption>Example 3: Sorting by multiple attributes</caption>
         *
         * // Sort the targets by the value of a `data-published-date` attribute, then by `data-title`
         *
         * mixer.sort('published-date:desc data-title:asc')
         *     .then(function(state) {
         *         console.log(state.activeSort.attribute === 'published-date'); // true
         *         console.log(state.activeSort.order === 'desc'); // true
         *
         *         console.log(state.activeSort.next.attribute === 'title'); // true
         *         console.log(state.activeSort.next.order === 'asc'); // true
         *     });
         *
         * @example <caption>Example 4: Sorting by random</caption>
         *
         * mixer.sort('random')
         *     .then(function(state) {
         *         console.log(state.activeSort.order === 'random') // true
         *     });
         *
         * @example <caption>Example 5: Sorting via an element collection</caption>
         *
         * var collection = Array.from(container.querySelectorAll('.mix'));
         *
         * // Swap the position of two elements in the collection:
         *
         * var temp = collection[1];
         *
         * collection[1] = collection[0];
         * collection[0] = temp;
         *
         * // Pass the sorted collection to MixItUp
         *
         * mixer.sort(collection)
         *     .then(function(state) {
         *         console.log(state.targets[0] === collection[0]); // true
         *     });
         *
         * @public
         * @instance
         * @since       2.0.0
         * @param       {(string|Array.<HTMLElement>)}    sortString
         *      A valid sort string (e.g. `'default'`, `'published-date:asc'`, or `'random'`). The sort method also accepts an array of all target elements in a user-defined order.
         * @param       {boolean}   [animate=true]
         *      An optional boolean dictating whether the operation should animate, or occur syncronously with no animation. `true` by default.
         * @param       {function}  [callback=null]
         *      An optional callback function to be invoked after the operation has completed.
         * @return      {Promise.<mixitup.State>}
         *      A promise resolving with the current state object.
         */ sort: function() {
            var self = this, instruction = self.parseSortArgs(arguments);
            return self.multimix({
                sort: instruction.command
            }, instruction.animate, instruction.callback);
        },
        /**
         * Changes the layout of the container by adding, removing or updating a
         * layout-specific class name. If `animation.animateResizetargets` is
         * enabled, MixItUp will attempt to gracefully animate the width, height,
         * and position of targets between layout states.
         *
         * @example
         *
         * .changeLayout(containerClassName [, animate] [, callback])
         *
         * @example <caption>Example 1: Adding a new class name to the container</caption>
         *
         * mixer.changeLayout('container-list')
         *      .then(function(state) {
         *          console.log(state.activeContainerClass === 'container-list'); // true
         *      });
         *
         * @example <caption>Example 2: Removing a previously added class name from the container</caption>
         *
         * mixer.changeLayout('')
         *      .then(function(state) {
         *          console.log(state.activeContainerClass === ''); // true
         *      });
         *
         * @public
         * @instance
         * @since       2.0.0
         * @param       {string}    containerClassName
         *      A layout-specific class name to add to the container.
         * @param       {boolean}   [animate=true]
         *      An optional boolean dictating whether the operation should animate, or occur syncronously with no animation. `true` by default.
         * @param       {function}  [callback=null]
         *      An optional callback function to be invoked after the operation has completed.
         * @return      {Promise.<mixitup.State>}
         *      A promise resolving with the current state object.
         */ changeLayout: function() {
            var self = this, instruction = self.parseChangeLayoutArgs(arguments);
            return self.multimix({
                changeLayout: instruction.command
            }, instruction.animate, instruction.callback);
        },
        /**
         * Updates the contents and order of the container to reflect the provided dataset,
         * if the dataset API is in use.
         *
         * The dataset API is designed for use in API-driven JavaScript applications, and
         * can be used instead of DOM-based methods such as `.filter()`, `.sort()`,
         * `.insert()`, etc. When used, insertion, removal, sorting and pagination can be
         * achieved purely via changes to your data model, without the uglyness of having
         * to interact with or query the DOM directly.
         *
         * @example
         *
         * .dataset(dataset [, animate] [, callback])
         *
         * @example <caption>Example 1: Rendering a dataset</caption>
         *
         * var myDataset = [
         *     {id: 1, ...},
         *     {id: 2, ...},
         *     {id: 3, ...}
         * ];
         *
         * mixer.dataset(myDataset)
         *     .then(function(state) {
         *         console.log(state.totalShow === 3); // true
         *     });
         *
         * @example <caption>Example 2: Sorting a dataset</caption>
         *
         * // Create a new dataset in reverse order
         *
         * var newDataset = myDataset.slice().reverse();
         *
         * mixer.dataset(newDataset)
         *     .then(function(state) {
         *         console.log(state.activeDataset[0] === myDataset[2]); // true
         *     });
         *
         * @example <caption>Example 3: Removing an item from the dataset</caption>
         *
         * console.log(myDataset.length); // 3
         *
         * // Create a new dataset with the last item removed.
         *
         * var newDataset = myDataset.slice().pop();
         *
         * mixer.dataset(newDataset)
         *     .then(function(state) {
         *         console.log(state.totalShow === 2); // true
         *     });
         *
         * @public
         * @instance
         * @since       3.0.0
         * @param       {Array.<object>}    dataset
         *      An array of objects, each one representing the underlying data model of a target to be rendered.
         * @param       {boolean}           [animate=true]
         *      An optional boolean dictating whether the operation should animate, or occur syncronously with no animation. `true` by default.
         * @param       {function}          [callback=null]
         *      An optional callback function to be invoked after the operation has completed.
         * @return      {Promise.<mixitup.State>}
         *      A promise resolving with the current state object.
         */ dataset: function() {
            var self = this, instruction = self.parseDatasetArgs(arguments), operation = null, queueItem = null, animate = false;
            self.callActions("beforeDataset", arguments);
            if (!self.isBusy) {
                if (instruction.callback) self.userCallback = instruction.callback;
                animate = instruction.animate ^ self.config.animation.enable ? instruction.animate : self.config.animation.enable;
                operation = self.getDataOperation(instruction.command.dataset);
                return self.goMix(animate, operation);
            } else {
                queueItem = new mixitup.QueueItem();
                queueItem.args = arguments;
                queueItem.instruction = instruction;
                return self.queueMix(queueItem);
            }
        },
        /**
         * Performs simultaneous `filter`, `sort`, `insert`, `remove` and `changeLayout`
         * operations as requested.
         *
         * @example
         *
         * .multimix(multimixCommand [, animate] [, callback])
         *
         * @example <caption>Example 1: Performing simultaneous filtering and sorting</caption>
         *
         * mixer.multimix({
         *     filter: '.category-b',
         *     sort: 'published-date:desc'
         * })
         *     .then(function(state) {
         *         console.log(state.activeFilter.selector === '.category-b'); // true
         *         console.log(state.activeSort.attribute === 'published-date'); // true
         *     });
         *
         * @example <caption>Example 2: Performing simultaneous sorting, insertion, and removal</caption>
         *
         * console.log(mixer.getState().totalShow); // 6
         *
         * // NB: When inserting via `multimix()`, an object should be provided as the value
         * // for the `insert` portion of the command, allowing for a collection of elements
         * // and an insertion index to be specified.
         *
         * mixer.multimix({
         *     sort: 'published-date:desc', // Sort the container, including any new elements
         *     insert: {
         *         collection: [newElementReferenceA, newElementReferenceB], // Add 2 new elements at index 5
         *         index: 5
         *     },
         *     remove: existingElementReference // Remove 1 existing element
         * })
         *     .then(function(state) {
         *         console.log(state.activeSort.attribute === 'published-date'); // true
         *         console.log(state.totalShow === 7); // true
         *     });
         *
         * @public
         * @instance
         * @since       2.0.0
         * @param       {object}    multimixCommand
         *      An object containing one or more things to do
         * @param       {boolean}   [animate=true]
         *      An optional boolean dictating whether the operation should animate, or occur syncronously with no animation. `true` by default.
         * @param       {function}  [callback=null]
         *      An optional callback function to be invoked after the operation has completed.
         * @return      {Promise.<mixitup.State>}
         *      A promise resolving with the current state object.
         */ multimix: function() {
            var self = this, operation = null, animate = false, queueItem = null, instruction = self.parseMultimixArgs(arguments);
            self.callActions("beforeMultimix", arguments);
            if (!self.isBusy) {
                operation = self.getOperation(instruction.command);
                if (self.config.controls.enable) {
                    // Update controls for API calls
                    if (instruction.command.filter && !self.isToggling) {
                        // As we are not toggling, reset the toggle array
                        // so new filter overrides existing toggles
                        self.toggleArray.length = 0;
                        self.buildToggleArray(operation.command);
                    }
                    if (self.queue.length < 1) self.updateControls(operation.command);
                }
                if (instruction.callback) self.userCallback = instruction.callback;
                // Always allow the instruction to override the instance setting
                animate = instruction.animate ^ self.config.animation.enable ? instruction.animate : self.config.animation.enable;
                self.callFilters("operationMultimix", operation, arguments);
                return self.goMix(animate, operation);
            } else {
                queueItem = new mixitup.QueueItem();
                queueItem.args = arguments;
                queueItem.instruction = instruction;
                queueItem.triggerElement = self.lastClicked;
                queueItem.isToggling = self.isToggling;
                return self.queueMix(queueItem);
            }
        },
        /**
         * @private
         * @instance
         * @since   3.0.0
         * @param   {object}            multimixCommand
         * @param   {boolean}           [isPreFetch]
         *      An optional boolean indicating that the operation is being pre-fetched for execution at a later time.
         * @return  {Operation|null}
         */ getOperation: function(multimixCommand) {
            var self = this, sortCommand = multimixCommand.sort, filterCommand = multimixCommand.filter, changeLayoutCommand = multimixCommand.changeLayout, removeCommand = multimixCommand.remove, insertCommand = multimixCommand.insert, operation = new mixitup.Operation();
            operation = self.callFilters("operationUnmappedGetOperation", operation, arguments);
            operation.id = h.randomHex();
            operation.command = multimixCommand;
            operation.startState = self.state;
            operation.triggerElement = self.lastClicked;
            if (self.isBusy) {
                if (self.config.debug.showWarnings) console.warn(mixitup.messages.warningGetOperationInstanceBusy());
                return null;
            }
            if (insertCommand) self.insertTargets(insertCommand, operation);
            if (removeCommand) operation.toRemove = removeCommand.targets;
            operation.startSort = operation.newSort = operation.startState.activeSort;
            operation.startOrder = operation.newOrder = self.targets;
            if (sortCommand) {
                operation.startSort = operation.startState.activeSort;
                operation.newSort = sortCommand;
                operation.willSort = self.willSort(sortCommand, operation.startState.activeSort);
                if (operation.willSort) self.sortOperation(operation);
            }
            operation.startFilter = operation.startState.activeFilter;
            if (filterCommand) operation.newFilter = filterCommand;
            else operation.newFilter = h.extend(new mixitup.CommandFilter(), operation.startFilter);
            if (operation.newFilter.selector === "all") operation.newFilter.selector = self.config.selectors.target;
            else if (operation.newFilter.selector === "none") operation.newFilter.selector = "";
            self.filterOperation(operation);
            operation.startContainerClassName = operation.startState.activeContainerClassName;
            if (changeLayoutCommand) {
                operation.newContainerClassName = changeLayoutCommand.containerClassName;
                if (operation.newContainerClassName !== operation.startContainerClassName) operation.willChangeLayout = true;
            } else operation.newContainerClassName = operation.startContainerClassName;
            if (self.config.animation.enable) {
                // Populate the operation's position data
                self.getStartMixData(operation);
                self.setInter(operation);
                operation.docState = h.getDocumentState(self.dom.document);
                self.getInterMixData(operation);
                self.setFinal(operation);
                self.getFinalMixData(operation);
                self.parseEffects();
                operation.hasEffect = self.hasEffect();
                self.getTweenData(operation);
            }
            if (operation.willSort) self.targets = operation.newOrder;
            operation.newState = self.buildState(operation);
            return self.callFilters("operationMappedGetOperation", operation, arguments);
        },
        /**
         * Renders a previously created operation at a specific point in its path, as
         * determined by a multiplier between 0 and 1.
         *
         * @example
         * .tween(operation, multiplier)
         *
         * @private
         * @instance
         * @since   3.0.0
         * @param   {mixitup.Operation}     operation
         *      An operation object created via the `getOperation` method
         *
         * @param   {Float}                 multiplier
         *      Any number between 0 and 1 representing the percentage complete of the operation
         * @return  {void}
         */ tween: function(operation, multiplier) {
            var target = null, posData = null, toHideIndex = -1, i = -1;
            multiplier = Math.min(multiplier, 1);
            multiplier = Math.max(multiplier, 0);
            for(i = 0; target = operation.show[i]; i++){
                posData = operation.showPosData[i];
                target.applyTween(posData, multiplier);
            }
            for(i = 0; target = operation.hide[i]; i++){
                if (target.isShown) target.hide();
                if ((toHideIndex = operation.toHide.indexOf(target)) > -1) {
                    posData = operation.toHidePosData[toHideIndex];
                    if (!target.isShown) target.show();
                    target.applyTween(posData, multiplier);
                }
            }
        },
        /**
         * Inserts one or more new target elements into the container at a specified
         * index.
         *
         * To be indexed as targets, new elements must match the `selectors.target`
         * selector (`'.mix'` by default).
         *
         * @example
         *
         * .insert(newElements [, index] [, animate], [, callback])
         *
         * @example <caption>Example 1: Inserting a single element via reference</caption>
         *
         * console.log(mixer.getState().totalShow); // 0
         *
         * // Create a new element
         *
         * var newElement = document.createElement('div');
         * newElement.classList.add('mix');
         *
         * mixer.insert(newElement)
         *     .then(function(state) {
         *         console.log(state.totalShow === 1); // true
         *     });
         *
         * @example <caption>Example 2: Inserting a single element via HTML string</caption>
         *
         * console.log(mixer.getState().totalShow); // 1
         *
         * // Create a new element via reference
         *
         * var newElementHtml = '&lt;div class="mix"&gt;&lt;/div&gt;';
         *
         * // Create and insert the new element at index 1
         *
         * mixer.insert(newElementHtml, 1)
         *     .then(function(state) {
         *         console.log(state.totalShow === 2); // true
         *         console.log(state.show[1].outerHTML === newElementHtml); // true
         *     });
         *
         * @example <caption>Example 3: Inserting multiple elements via reference</caption>
         *
         * console.log(mixer.getState().totalShow); // 2
         *
         * // Create an array of new elements to insert.
         *
         * var newElement1 = document.createElement('div');
         * var newElement2 = document.createElement('div');
         *
         * newElement1.classList.add('mix');
         * newElement2.classList.add('mix');
         *
         * var newElementsCollection = [newElement1, newElement2];
         *
         * // Insert the new elements starting at index 1
         *
         * mixer.insert(newElementsCollection, 1)
         *     .then(function(state) {
         *         console.log(state.totalShow === 4); // true
         *         console.log(state.show[1] === newElement1); // true
         *         console.log(state.show[2] === newElement2); // true
         *     });
         *
         * @example <caption>Example 4: Inserting a jQuery collection object containing one or more elements</caption>
         *
         * console.log(mixer.getState().totalShow); // 4
         *
         * var $newElement = $('&lt;div class="mix"&gt;&lt;/div&gt;');
         *
         * // Insert the new elements starting at index 3
         *
         * mixer.insert($newElement, 3)
         *     .then(function(state) {
         *         console.log(state.totalShow === 5); // true
         *         console.log(state.show[3] === $newElement[0]); // true
         *     });
         *
         * @public
         * @instance
         * @since       2.0.0
         * @param       {(HTMLElement|Array.<HTMLElement>|string)}    newElements
         *      A reference to a single element to insert, an array-like collection of elements, or an HTML string representing a single element.
         * @param       {number}    index=0
         *      The index at which to insert the new element(s). `0` by default.
         * @param       {boolean}   [animate=true]
         *      An optional boolean dictating whether the operation should animate, or occur syncronously with no animation. `true` by default.
         * @param       {function}  [callback=null]
         *      An optional callback function to be invoked after the operation has completed.
         * @return      {Promise.<mixitup.State>}
         *      A promise resolving with the current state object.
         */ insert: function() {
            var self = this, args = self.parseInsertArgs(arguments);
            return self.multimix({
                insert: args.command
            }, args.animate, args.callback);
        },
        /**
         * Inserts one or more new elements before a provided reference element.
         *
         * @example
         *
         * .insertBefore(newElements, referenceElement [, animate] [, callback])
         *
         * @example <caption>Example: Inserting a new element before a reference element</caption>
         *
         * // An existing reference element is chosen at index 2
         *
         * var referenceElement = mixer.getState().show[2];
         *
         * // Create a new element
         *
         * var newElement = document.createElement('div');
         * newElement.classList.add('mix');
         *
         * mixer.insertBefore(newElement, referenceElement)
         *     .then(function(state) {
         *         // The new element is inserted into the container at index 2, before the reference element
         *
         *         console.log(state.show[2] === newElement); // true
         *
         *         // The reference element is now at index 3
         *
         *         console.log(state.show[3] === referenceElement); // true
         *     });
         *
         * @public
         * @instance
         * @since       3.0.0
         * @param       {(HTMLElement|Array.<HTMLElement>|string)}    newElements
         *      A reference to a single element to insert, an array-like collection of elements, or an HTML string representing a single element.
         * @param       {HTMLElement}    referenceElement
         *      A reference to an existing element in the container to insert new elements before.
         *@param       {boolean}   [animate=true]
         *      An optional boolean dictating whether the operation should animate, or occur syncronously with no animation. `true` by default.
         * @param       {function}  [callback=null]
         *      An optional callback function to be invoked after the operation has completed.
         * @return      {Promise.<mixitup.State>}
         *      A promise resolving with the current state object.
         */ insertBefore: function() {
            var self = this, args = self.parseInsertArgs(arguments);
            return self.insert(args.command.collection, "before", args.command.sibling, args.animate, args.callback);
        },
        /**
         * Inserts one or more new elements after a provided reference element.
         *
         * @example
         *
         * .insertAfter(newElements, referenceElement [, animate] [, callback])
         *
         * @example <caption>Example: Inserting a new element after a reference element</caption>
         *
         * // An existing reference element is chosen at index 2
         *
         * var referenceElement = mixer.getState().show[2];
         *
         * // Create a new element
         *
         * var newElement = document.createElement('div');
         * newElement.classList.add('mix');
         *
         * mixer.insertAfter(newElement, referenceElement)
         *     .then(function(state) {
         *         // The new element is inserted into the container at index 3, after the reference element
         *
         *         console.log(state.show[3] === newElement); // true
         *     });
         *
         * @public
         * @instance
         * @since       3.0.0
         * @param       {(HTMLElement|Array.<HTMLElement>|string)}    newElements
         *      A reference to a single element to insert, an array-like collection of elements, or an HTML string representing a single element.
         * @param       {HTMLElement}    referenceElement
         *      A reference to an existing element in the container to insert new elements after.
         * @param       {boolean}   [animate=true]
         *      An optional boolean dictating whether the operation should animate, or occur syncronously with no animation. `true` by default.
         * @param       {function}  [callback=null]
         *      An optional callback function to be invoked after the operation has completed.
         * @return      {Promise.<mixitup.State>}
         *      A promise resolving with the current state object.
         */ insertAfter: function() {
            var self = this, args = self.parseInsertArgs(arguments);
            return self.insert(args.command.collection, "after", args.command.sibling, args.animate, args.callback);
        },
        /**
         * Inserts one or more new elements into the container before all existing targets.
         *
         * @example
         *
         * .prepend(newElements [,animate] [,callback])
         *
         * @example <caption>Example: Prepending a new element</caption>
         *
         * // Create a new element
         *
         * var newElement = document.createElement('div');
         * newElement.classList.add('mix');
         *
         * // Insert the element into the container
         *
         * mixer.prepend(newElement)
         *     .then(function(state) {
         *         console.log(state.show[0] === newElement); // true
         *     });
         *
         * @public
         * @instance
         * @since       3.0.0
         * @param       {(HTMLElement|Array.<HTMLElement>|string)}    newElements
         *      A reference to a single element to insert, an array-like collection of elements, or an HTML string representing a single element.
         * @param       {boolean}   [animate=true]
         *      An optional boolean dictating whether the operation should animate, or occur syncronously with no animation. `true` by default.
         * @param       {function}  [callback=null]
         *      An optional callback function to be invoked after the operation has completed.
         * @return      {Promise.<mixitup.State>}
         *      A promise resolving with the current state object.
         */ prepend: function() {
            var self = this, args = self.parseInsertArgs(arguments);
            return self.insert(0, args.command.collection, args.animate, args.callback);
        },
        /**
         * Inserts one or more new elements into the container after all existing targets.
         *
         * @example
         *
         * .append(newElements [,animate] [,callback])
         *
         * @example <caption>Example: Appending a new element</caption>
         *
         * // Create a new element
         *
         * var newElement = document.createElement('div');
         * newElement.classList.add('mix');
         *
         * // Insert the element into the container
         *
         * mixer.append(newElement)
         *     .then(function(state) {
         *         console.log(state.show[state.show.length - 1] === newElement); // true
         *     });
         *
         * @public
         * @instance
         * @since       3.0.0
         * @param       {(HTMLElement|Array.<HTMLElement>|string)}    newElements
         *      A reference to a single element to insert, an array-like collection of elements, or an HTML string representing a single element.
         * @param       {boolean}   [animate=true]
         *      An optional boolean dictating whether the operation should animate, or occur syncronously with no animation. `true` by default.
         * @param       {function}  [callback=null]
         *      An optional callback function to be invoked after the operation has completed.
         * @return      {Promise.<mixitup.State>}
         *      A promise resolving with the current state object.
         */ append: function() {
            var self = this, args = self.parseInsertArgs(arguments);
            return self.insert(self.state.totalTargets, args.command.collection, args.animate, args.callback);
        },
        /**
         * Removes one or more existing target elements from the container.
         *
         * @example
         *
         * .remove(elements [, animate] [, callback])
         *
         * @example <caption>Example 1: Removing an element by reference</caption>
         *
         * var elementToRemove = containerEl.firstElementChild;
         *
         * mixer.remove(elementToRemove)
         *      .then(function(state) {
         *          console.log(state.targets.indexOf(elementToRemove) === -1); // true
         *      });
         *
         * @example <caption>Example 2: Removing a collection of elements by reference</caption>
         *
         * var elementsToRemove = containerEl.querySelectorAll('.category-a');
         *
         * console.log(elementsToRemove.length) // 3
         *
         * mixer.remove(elementsToRemove)
         *      .then(function() {
         *          console.log(containerEl.querySelectorAll('.category-a').length); // 0
         *      });
         *
         * @example <caption>Example 3: Removing one or more elements by selector</caption>
         *
         * mixer.remove('.category-a')
         *      .then(function() {
         *          console.log(containerEl.querySelectorAll('.category-a').length); // 0
         *      });
         *
         * @example <caption>Example 4: Removing an element by index</caption>
         *
         * console.log(mixer.getState.totalShow); // 4
         *
         * // Remove the element at index 3
         *
         * mixer.remove(3)
         *      .then(function(state) {
         *          console.log(state.totalShow); // 3
         *          console.log(state.show[3]); // undefined
         *      });
         *
         *
         * @public
         * @instance
         * @since       3.0.0
         * @param       {(HTMLElement|Array.<HTMLElement>|string|number)}    elements
         *      A reference to a single element to remove, an array-like collection of elements, a selector string, or the index of an element to remove.
         * @param       {boolean}   [animate=true]
         *      An optional boolean dictating whether the operation should animate, or occur syncronously with no animation. `true` by default.
         * @param       {function}  [callback=null]
         *      An optional callback function to be invoked after the operation has completed.
         * @return      {Promise.<mixitup.State>}
         *      A promise resolving with the current state object.
         */ remove: function() {
            var self = this, args = self.parseRemoveArgs(arguments);
            return self.multimix({
                remove: args.command
            }, args.animate, args.callback);
        },
        /**
         * Retrieves the the value of any property or sub-object within the current
         * mixitup configuration, or the whole configuration object.
         *
         * @example
         *
         * .getConfig([stringKey])
         *
         * @example <caption>Example 1: retrieve the entire configuration object</caption>
         *
         * var config = mixer.getConfig(); // Config { ... }
         *
         * @example <caption>Example 2: retrieve a named sub-object of configuration object</caption>
         *
         * var animation = mixer.getConfig('animation'); // ConfigAnimation { ... }
         *
         * @example <caption>Example 3: retrieve a value of configuration object via a dot-notation string key</caption>
         *
         * var effects = mixer.getConfig('animation.effects'); // 'fade scale'
         *
         * @public
         * @instance
         * @since       2.0.0
         * @param       {string}    [stringKey]    A "dot-notation" string key
         * @return      {*}
         */ getConfig: function(stringKey) {
            var self = this, value = null;
            if (!stringKey) value = self.config;
            else value = h.getProperty(self.config, stringKey);
            return self.callFilters("valueGetConfig", value, arguments);
        },
        /**
         * Updates the configuration of the mixer, after it has been instantiated.
         *
         * See the Configuration Object documentation for a full list of avilable
         * configuration options.
         *
         * @example
         *
         * .configure(config)
         *
         * @example <caption>Example 1: Updating animation options</caption>
         *
         * mixer.configure({
         *     animation: {
         *         effects: 'fade translateX(-100%)',
         *         duration: 300
         *     }
         * });
         *
         * @example <caption>Example 2: Removing a callback after it has been set</caption>
         *
         * var mixer;
         *
         * function handleMixEndOnce() {
         *     // Do something ..
         *
         *     // Then nullify the callback
         *
         *     mixer.configure({
         *         callbacks: {
         *             onMixEnd: null
         *         }
         *     });
         * };
         *
         * // Instantiate a mixer with a callback defined
         *
         * mixer = mixitup(containerEl, {
         *     callbacks: {
         *         onMixEnd: handleMixEndOnce
         *     }
         * });
         *
         * @public
         * @instance
         * @since       3.0.0
         * @param       {object}    config
         *      An object containing one of more configuration options.
         * @return      {void}
         */ configure: function(config) {
            var self = this;
            self.callActions("beforeConfigure", arguments);
            h.extend(self.config, config, true, true);
            self.callActions("afterConfigure", arguments);
        },
        /**
         * Returns an object containing information about the current state of the
         * mixer. See the State Object documentation for more information.
         *
         * NB: State objects are immutable and should therefore be regenerated
         * after any operation.
         *
         * @example
         *
         * .getState();
         *
         * @example <caption>Example: Retrieving a state object</caption>
         *
         * var state = mixer.getState();
         *
         * console.log(state.totalShow + 'targets are currently shown');
         *
         * @public
         * @instance
         * @since       2.0.0
         * @return      {mixitup.State} An object reflecting the current state of the mixer.
         */ getState: function() {
            var self = this, state = null;
            state = new mixitup.State();
            h.extend(state, self.state);
            h.freeze(state);
            return self.callFilters("stateGetState", state, arguments);
        },
        /**
         * Forces the re-indexing all targets within the container.
         *
         * This should only be used if some other piece of code in your application
         * has manipulated the contents of your container, which should be avoided.
         *
         * If you need to add or remove target elements from the container, use
         * the built-in `.insert()` or `.remove()` methods, and MixItUp will keep
         * itself up to date.
         *
         * @example
         *
         * .forceRefresh()
         *
         * @example <caption>Example: Force refreshing the mixer after external DOM manipulation</caption>
         *
         * console.log(mixer.getState().totalShow); // 3
         *
         * // An element is removed from the container via some external DOM manipulation code:
         *
         * containerEl.removeChild(containerEl.firstElementChild);
         *
         * // The mixer does not know that the number of targets has changed:
         *
         * console.log(mixer.getState().totalShow); // 3
         *
         * mixer.forceRefresh();
         *
         * // After forceRefresh, the mixer is in sync again:
         *
         * console.log(mixer.getState().totalShow); // 2
         *
         * @public
         * @instance
         * @since 2.1.2
         * @return {void}
         */ forceRefresh: function() {
            var self = this;
            self.indexTargets();
        },
        /**
         * Forces the re-rendering of all targets when using the Dataset API.
         *
         * By default, targets are only re-rendered when `data.dirtyCheck` is
         * enabled, and an item's data has changed when `dataset()` is called.
         *
         * The `forceRender()` method allows for the re-rendering of all targets
         * in response to some arbitrary event, such as the changing of the target
         * render function.
         *
         * Targets are rendered against their existing data.
         *
         * @example
         *
         * .forceRender()
         *
         * @example <caption>Example: Force render targets after changing the target render function</caption>
         *
         * console.log(container.innerHTML); // ... &lt;span class="mix"&gt;Foo&lt;/span&gt; ...
         *
         * mixer.configure({
         *     render: {
         *         target: (item) => `&lt;a href="/${item.slug}/" class="mix"&gt;${item.title}&lt;/a&gt;`
         *     }
         * });
         *
         * mixer.forceRender();
         *
         * console.log(container.innerHTML); // ... &lt;a href="/foo/" class="mix"&gt;Foo&lt;/a&gt; ...
         *
         * @public
         * @instance
         * @since 3.2.1
         * @return {void}
         */ forceRender: function() {
            var self = this, target = null, el = null, id = "";
            for(id in self.cache){
                target = self.cache[id];
                el = target.render(target.data);
                if (el !== target.dom.el) {
                    // Update target element reference
                    if (target.isInDom) {
                        target.unbindEvents();
                        self.dom.parent.replaceChild(el, target.dom.el);
                    }
                    if (!target.isShown) el.style.display = "none";
                    target.dom.el = el;
                    if (target.isInDom) target.bindEvents();
                }
            }
            self.state = self.buildState(self.lastOperation);
        },
        /**
         * Removes mixitup functionality from the container, unbinds all control
         * event handlers, and deletes the mixer instance from MixItUp's internal
         * cache.
         *
         * This should be performed whenever a mixer's container is removed from
         * the DOM, such as during a page change in a single page application,
         * or React's `componentWillUnmount()`.
         *
         * @example
         *
         * .destroy([cleanUp])
         *
         * @example <caption>Example: Destroying the mixer before removing its container element</caption>
         *
         * mixer.destroy();
         *
         * containerEl.parentElement.removeChild(containerEl);
         *
         * @public
         * @instance
         * @since   2.0.0
         * @param   {boolean}   [cleanUp=false]
         *     An optional boolean dictating whether or not to clean up any inline `display: none;` styling applied to hidden targets.
         * @return  {void}
         */ destroy: function(cleanUp) {
            var self = this, control = null, target = null, i = 0;
            self.callActions("beforeDestroy", arguments);
            for(i = 0; control = self.controls[i]; i++)control.removeBinding(self);
            for(i = 0; target = self.targets[i]; i++){
                if (cleanUp) target.show();
                target.unbindEvents();
            }
            if (self.dom.container.id.match(/^MixItUp/)) self.dom.container.removeAttribute("id");
            delete mixitup.instances[self.id];
            self.callActions("afterDestroy", arguments);
        }
    });
    /**
     * @constructor
     * @memberof    mixitup
     * @private
     * @since       3.0.0
     */ mixitup.IMoveData = function() {
        mixitup.Base.call(this);
        this.callActions("beforeConstruct");
        this.posIn = null;
        this.posOut = null;
        this.operation = null;
        this.callback = null;
        this.statusChange = "";
        this.duration = -1;
        this.staggerIndex = -1;
        this.callActions("afterConstruct");
        h.seal(this);
    };
    mixitup.BaseStatic.call(mixitup.IMoveData);
    mixitup.IMoveData.prototype = Object.create(mixitup.Base.prototype);
    mixitup.IMoveData.prototype.constructor = mixitup.IMoveData;
    /**
     * @constructor
     * @memberof    mixitup
     * @private
     * @since       3.0.0
     */ mixitup.TargetDom = function() {
        mixitup.Base.call(this);
        this.callActions("beforeConstruct");
        this.el = null;
        this.callActions("afterConstruct");
        h.seal(this);
    };
    mixitup.BaseStatic.call(mixitup.TargetDom);
    mixitup.TargetDom.prototype = Object.create(mixitup.Base.prototype);
    mixitup.TargetDom.prototype.constructor = mixitup.TargetDom;
    /**
     * @constructor
     * @namespace
     * @memberof    mixitup
     * @private
     * @since       3.0.0
     */ mixitup.Target = function() {
        mixitup.Base.call(this);
        this.callActions("beforeConstruct");
        this.id = "";
        this.sortString = "";
        this.mixer = null;
        this.callback = null;
        this.isShown = false;
        this.isBound = false;
        this.isExcluded = false;
        this.isInDom = false;
        this.handler = null;
        this.operation = null;
        this.data = null;
        this.dom = new mixitup.TargetDom();
        this.callActions("afterConstruct");
        h.seal(this);
    };
    mixitup.BaseStatic.call(mixitup.Target);
    mixitup.Target.prototype = Object.create(mixitup.Base.prototype);
    h.extend(mixitup.Target.prototype, {
        constructor: mixitup.Target,
        /**
         * Initialises a newly instantiated Target.
         *
         * @private
         * @instance
         * @since   3.0.0
         * @param   {(Element|null)}    el
         * @param   {object}            mixer
         * @param   {object}            [data]
         * @return  {void}
         */ init: function(el, mixer, data) {
            var self = this, id = "";
            self.callActions("beforeInit", arguments);
            self.mixer = mixer;
            if (!el) // If no element is provided, render it
            el = self.render(data);
            self.cacheDom(el);
            self.bindEvents();
            if (self.dom.el.style.display !== "none") self.isShown = true;
            if (data && mixer.config.data.uidKey) {
                if (typeof (id = data[mixer.config.data.uidKey]) === "undefined" || id.toString().length < 1) throw new TypeError(mixitup.messages.errorDatasetInvalidUidKey({
                    uidKey: mixer.config.data.uidKey
                }));
                self.id = id;
                self.data = data;
                mixer.cache[id] = self;
            }
            self.callActions("afterInit", arguments);
        },
        /**
         * Renders the target element using a user-defined renderer function.
         *
         * @private
         * @instance
         * @since   3.1.4
         * @param   {object} data
         * @return  {void}
         */ render: function(data) {
            var self = this, render = null, el = null, temp = null, output = "";
            self.callActions("beforeRender", arguments);
            render = self.callFilters("renderRender", self.mixer.config.render.target, arguments);
            if (typeof render !== "function") throw new TypeError(mixitup.messages.errorDatasetRendererNotSet());
            output = render(data);
            if (output && typeof output === "object" && h.isElement(output)) el = output;
            else if (typeof output === "string") {
                temp = document.createElement("div");
                temp.innerHTML = output;
                el = temp.firstElementChild;
            }
            return self.callFilters("elRender", el, arguments);
        },
        /**
         * Caches references of DOM elements neccessary for the target's functionality.
         *
         * @private
         * @instance
         * @since   3.0.0
         * @param   {Element} el
         * @return  {void}
         */ cacheDom: function(el) {
            var self = this;
            self.callActions("beforeCacheDom", arguments);
            self.dom.el = el;
            self.callActions("afterCacheDom", arguments);
        },
        /**
         * @private
         * @instance
         * @since   3.0.0
         * @param   {string}    attributeName
         * @return  {void}
         */ getSortString: function(attributeName) {
            var self = this, value = self.dom.el.getAttribute("data-" + attributeName) || "";
            self.callActions("beforeGetSortString", arguments);
            value = isNaN(value * 1) ? value.toLowerCase() : value * 1;
            self.sortString = value;
            self.callActions("afterGetSortString", arguments);
        },
        /**
         * @private
         * @instance
         * @since   3.0.0
         * @return  {void}
         */ show: function() {
            var self = this;
            self.callActions("beforeShow", arguments);
            if (!self.isShown) {
                self.dom.el.style.display = "";
                self.isShown = true;
            }
            self.callActions("afterShow", arguments);
        },
        /**
         * @private
         * @instance
         * @since   3.0.0
         * @return  {void}
         */ hide: function() {
            var self = this;
            self.callActions("beforeHide", arguments);
            if (self.isShown) {
                self.dom.el.style.display = "none";
                self.isShown = false;
            }
            self.callActions("afterHide", arguments);
        },
        /**
         * @private
         * @instance
         * @since   3.0.0
         * @param   {mixitup.IMoveData} moveData
         * @return  {void}
         */ move: function(moveData) {
            var self = this;
            self.callActions("beforeMove", arguments);
            if (!self.isExcluded) self.mixer.targetsMoved++;
            self.applyStylesIn(moveData);
            requestAnimationFrame(function() {
                self.applyStylesOut(moveData);
            });
            self.callActions("afterMove", arguments);
        },
        /**
         * @private
         * @instance
         * @since   3.0.0
         * @param   {object}    posData
         * @param   {number}    multiplier
         * @return  {void}
         */ applyTween: function(posData, multiplier) {
            var self = this, propertyName = "", tweenData = null, posIn = posData.posIn, currentTransformValues = [], currentValues = new mixitup.StyleData(), i = -1;
            self.callActions("beforeApplyTween", arguments);
            currentValues.x = posIn.x;
            currentValues.y = posIn.y;
            if (multiplier === 0) self.hide();
            else if (!self.isShown) self.show();
            for(i = 0; propertyName = mixitup.features.TWEENABLE[i]; i++){
                tweenData = posData.tweenData[propertyName];
                if (propertyName === "x") {
                    if (!tweenData) continue;
                    currentValues.x = posIn.x + tweenData * multiplier;
                } else if (propertyName === "y") {
                    if (!tweenData) continue;
                    currentValues.y = posIn.y + tweenData * multiplier;
                } else if (tweenData instanceof mixitup.TransformData) {
                    if (!tweenData.value) continue;
                    currentValues[propertyName].value = posIn[propertyName].value + tweenData.value * multiplier;
                    currentValues[propertyName].unit = tweenData.unit;
                    currentTransformValues.push(propertyName + "(" + currentValues[propertyName].value + tweenData.unit + ")");
                } else {
                    if (!tweenData) continue;
                    currentValues[propertyName] = posIn[propertyName] + tweenData * multiplier;
                    self.dom.el.style[propertyName] = currentValues[propertyName];
                }
            }
            if (currentValues.x || currentValues.y) currentTransformValues.unshift("translate(" + currentValues.x + "px, " + currentValues.y + "px)");
            if (currentTransformValues.length) self.dom.el.style[mixitup.features.transformProp] = currentTransformValues.join(" ");
            self.callActions("afterApplyTween", arguments);
        },
        /**
         * Applies the initial styling to a target element before any transition
         * is applied.
         *
         * @private
         * @instance
         * @param   {mixitup.IMoveData} moveData
         * @return  {void}
         */ applyStylesIn: function(moveData) {
            var self = this, posIn = moveData.posIn, isFading = self.mixer.effectsIn.opacity !== 1, transformValues = [];
            self.callActions("beforeApplyStylesIn", arguments);
            transformValues.push("translate(" + posIn.x + "px, " + posIn.y + "px)");
            if (self.mixer.config.animation.animateResizeTargets) {
                if (moveData.statusChange !== "show") {
                    // Don't apply posIn width or height or showing, as will be 0
                    self.dom.el.style.width = posIn.width + "px";
                    self.dom.el.style.height = posIn.height + "px";
                }
                self.dom.el.style.marginRight = posIn.marginRight + "px";
                self.dom.el.style.marginBottom = posIn.marginBottom + "px";
            }
            isFading && (self.dom.el.style.opacity = posIn.opacity);
            if (moveData.statusChange === "show") transformValues = transformValues.concat(self.mixer.transformIn);
            self.dom.el.style[mixitup.features.transformProp] = transformValues.join(" ");
            self.callActions("afterApplyStylesIn", arguments);
        },
        /**
         * Applies a transition followed by the final styles for the element to
         * transition towards.
         *
         * @private
         * @instance
         * @param   {mixitup.IMoveData} moveData
         * @return  {void}
         */ applyStylesOut: function(moveData) {
            var self = this, transitionRules = [], transformValues = [], isResizing = self.mixer.config.animation.animateResizeTargets, isFading = typeof self.mixer.effectsIn.opacity !== "undefined";
            self.callActions("beforeApplyStylesOut", arguments);
            // Build the transition rules
            transitionRules.push(self.writeTransitionRule(mixitup.features.transformRule, moveData.staggerIndex));
            if (moveData.statusChange !== "none") transitionRules.push(self.writeTransitionRule("opacity", moveData.staggerIndex, moveData.duration));
            if (isResizing) {
                transitionRules.push(self.writeTransitionRule("width", moveData.staggerIndex, moveData.duration));
                transitionRules.push(self.writeTransitionRule("height", moveData.staggerIndex, moveData.duration));
                transitionRules.push(self.writeTransitionRule("margin", moveData.staggerIndex, moveData.duration));
            }
            // If no callback was provided, the element will
            // not transition in any way so tag it as "immovable"
            if (!moveData.callback) {
                self.mixer.targetsImmovable++;
                if (self.mixer.targetsMoved === self.mixer.targetsImmovable) // If the total targets moved is equal to the
                // number of immovable targets, the operation
                // should be considered finished
                self.mixer.cleanUp(moveData.operation);
                return;
            }
            // If the target will transition in some fasion,
            // assign a callback function
            self.operation = moveData.operation;
            self.callback = moveData.callback;
            // As long as the target is not excluded, increment
            // the total number of targets bound
            !self.isExcluded && self.mixer.targetsBound++;
            // Tag the target as bound to differentiate from transitionEnd
            // events that may come from stylesheet driven effects
            self.isBound = true;
            // Apply the transition
            self.applyTransition(transitionRules);
            // Apply width, height and margin negation
            if (isResizing && moveData.posOut.width > 0 && moveData.posOut.height > 0) {
                self.dom.el.style.width = moveData.posOut.width + "px";
                self.dom.el.style.height = moveData.posOut.height + "px";
                self.dom.el.style.marginRight = moveData.posOut.marginRight + "px";
                self.dom.el.style.marginBottom = moveData.posOut.marginBottom + "px";
            }
            if (!self.mixer.config.animation.nudge && moveData.statusChange === "hide") // If we're not nudging, the translation should be
            // applied before any other transforms to prevent
            // lateral movement
            transformValues.push("translate(" + moveData.posOut.x + "px, " + moveData.posOut.y + "px)");
            // Apply fade
            switch(moveData.statusChange){
                case "hide":
                    isFading && (self.dom.el.style.opacity = self.mixer.effectsOut.opacity);
                    transformValues = transformValues.concat(self.mixer.transformOut);
                    break;
                case "show":
                    isFading && (self.dom.el.style.opacity = 1);
            }
            if (self.mixer.config.animation.nudge || !self.mixer.config.animation.nudge && moveData.statusChange !== "hide") // Opposite of above - apply translate after
            // other transform
            transformValues.push("translate(" + moveData.posOut.x + "px, " + moveData.posOut.y + "px)");
            // Apply transforms
            self.dom.el.style[mixitup.features.transformProp] = transformValues.join(" ");
            self.callActions("afterApplyStylesOut", arguments);
        },
        /**
         * Combines the name of a CSS property with the appropriate duration and delay
         * values to created a valid transition rule.
         *
         * @private
         * @instance
         * @since   3.0.0
         * @param   {string}    property
         * @param   {number}    staggerIndex
         * @param   {number}    duration
         * @return  {string}
         */ writeTransitionRule: function(property, staggerIndex, duration) {
            var self = this, delay = self.getDelay(staggerIndex), rule = "";
            rule = property + " " + (duration > 0 ? duration : self.mixer.config.animation.duration) + "ms " + delay + "ms " + (property === "opacity" ? "linear" : self.mixer.config.animation.easing);
            return self.callFilters("ruleWriteTransitionRule", rule, arguments);
        },
        /**
         * Calculates the transition delay for each target element based on its index, if
         * staggering is applied. If defined, A custom `animation.staggerSeqeuence`
         * function can be used to manipulate the order of indices to produce custom
         * stagger effects (e.g. for use in a grid with irregular row lengths).
         *
         * @private
         * @instance
         * @since   2.0.0
         * @param   {number}    index
         * @return  {number}
         */ getDelay: function(index) {
            var self = this, delay = -1;
            if (typeof self.mixer.config.animation.staggerSequence === "function") index = self.mixer.config.animation.staggerSequence.call(self, index, self.state);
            delay = !!self.mixer.staggerDuration ? index * self.mixer.staggerDuration : 0;
            return self.callFilters("delayGetDelay", delay, arguments);
        },
        /**
         * @private
         * @instance
         * @since   3.0.0
         * @param   {string[]}  rules
         * @return  {void}
         */ applyTransition: function(rules) {
            var self = this, transitionString = rules.join(", ");
            self.callActions("beforeApplyTransition", arguments);
            self.dom.el.style[mixitup.features.transitionProp] = transitionString;
            self.callActions("afterApplyTransition", arguments);
        },
        /**
         * @private
         * @instance
         * @since   3.0.0
         * @param   {Event} e
         * @return  {void}
         */ handleTransitionEnd: function(e) {
            var self = this, propName = e.propertyName, canResize = self.mixer.config.animation.animateResizeTargets;
            self.callActions("beforeHandleTransitionEnd", arguments);
            if (self.isBound && e.target.matches(self.mixer.config.selectors.target) && (propName.indexOf("transform") > -1 || propName.indexOf("opacity") > -1 || canResize && propName.indexOf("height") > -1 || canResize && propName.indexOf("width") > -1 || canResize && propName.indexOf("margin") > -1)) {
                self.callback.call(self, self.operation);
                self.isBound = false;
                self.callback = null;
                self.operation = null;
            }
            self.callActions("afterHandleTransitionEnd", arguments);
        },
        /**
         * @private
         * @instance
         * @since   3.0.0
         * @param   {Event}     e
         * @return  {void}
         */ eventBus: function(e) {
            var self = this;
            self.callActions("beforeEventBus", arguments);
            switch(e.type){
                case "webkitTransitionEnd":
                case "transitionend":
                    self.handleTransitionEnd(e);
            }
            self.callActions("afterEventBus", arguments);
        },
        /**
         * @private
         * @instance
         * @since   3.0.0
         * @return  {void}
         */ unbindEvents: function() {
            var self = this;
            self.callActions("beforeUnbindEvents", arguments);
            h.off(self.dom.el, "webkitTransitionEnd", self.handler);
            h.off(self.dom.el, "transitionend", self.handler);
            self.callActions("afterUnbindEvents", arguments);
        },
        /**
         * @private
         * @instance
         * @since   3.0.0
         * @return  {void}
         */ bindEvents: function() {
            var self = this, transitionEndEvent = "";
            self.callActions("beforeBindEvents", arguments);
            transitionEndEvent = mixitup.features.transitionPrefix === "webkit" ? "webkitTransitionEnd" : "transitionend";
            self.handler = function(e) {
                return self.eventBus(e);
            };
            h.on(self.dom.el, transitionEndEvent, self.handler);
            self.callActions("afterBindEvents", arguments);
        },
        /**
         * @private
         * @instance
         * @since   3.0.0
         * @param   {boolean}   [getBox]
         * @return  {PosData}
         */ getPosData: function(getBox) {
            var self = this, styles = {}, rect = null, posData = new mixitup.StyleData();
            self.callActions("beforeGetPosData", arguments);
            posData.x = self.dom.el.offsetLeft;
            posData.y = self.dom.el.offsetTop;
            if (self.mixer.config.animation.animateResizeTargets || getBox) {
                rect = self.dom.el.getBoundingClientRect();
                posData.top = rect.top;
                posData.right = rect.right;
                posData.bottom = rect.bottom;
                posData.left = rect.left;
                posData.width = rect.width;
                posData.height = rect.height;
            }
            if (self.mixer.config.animation.animateResizeTargets) {
                styles = window1.getComputedStyle(self.dom.el);
                posData.marginBottom = parseFloat(styles.marginBottom);
                posData.marginRight = parseFloat(styles.marginRight);
            }
            return self.callFilters("posDataGetPosData", posData, arguments);
        },
        /**
         * @private
         * @instance
         * @since       3.0.0
         * @return      {void}
         */ cleanUp: function() {
            var self = this;
            self.callActions("beforeCleanUp", arguments);
            self.dom.el.style[mixitup.features.transformProp] = "";
            self.dom.el.style[mixitup.features.transitionProp] = "";
            self.dom.el.style.opacity = "";
            if (self.mixer.config.animation.animateResizeTargets) {
                self.dom.el.style.width = "";
                self.dom.el.style.height = "";
                self.dom.el.style.marginRight = "";
                self.dom.el.style.marginBottom = "";
            }
            self.callActions("afterCleanUp", arguments);
        }
    });
    /**
     * A jQuery-collection-like wrapper around one or more `mixitup.Mixer` instances
     * allowing simultaneous control of said instances similar to the MixItUp 2 API.
     *
     * @example
     * new mixitup.Collection(instances)
     *
     * @constructor
     * @namespace
     * @memberof    mixitup
     * @private
     * @since       3.0.0
     * @param       {mixitup.Mixer[]}   instances
     */ mixitup.Collection = function(instances) {
        var instance = null, i = -1;
        this.callActions("beforeConstruct");
        for(i = 0; instance = instances[i]; i++)this[i] = instance;
        this.length = instances.length;
        this.callActions("afterConstruct");
        h.freeze(this);
    };
    mixitup.BaseStatic.call(mixitup.Collection);
    mixitup.Collection.prototype = Object.create(mixitup.Base.prototype);
    h.extend(mixitup.Collection.prototype, /** @lends mixitup.Collection */ {
        constructor: mixitup.Collection,
        /**
         * Calls a method on all instances in the collection by passing the method
         * name as a string followed by any applicable parameters to be curried into
         * to the method.
         *
         * @example
         * .mixitup(methodName[,arg1][,arg2..]);
         *
         * @example
         * var collection = new Collection([mixer1, mixer2]);
         *
         * return collection.mixitup('filter', '.category-a')
         *     .then(function(states) {
         *         state.forEach(function(state) {
         *             console.log(state.activeFilter.selector); // .category-a
         *         });
         *     });
         *
         * @public
         * @instance
         * @since       3.0.0
         * @param       {string}  methodName
         * @return      {Promise<Array<mixitup.State>>}
         */ mixitup: function(methodName) {
            var self = this, instance = null, args = Array.prototype.slice.call(arguments), tasks = [], i = -1;
            this.callActions("beforeMixitup");
            args.shift();
            for(i = 0; instance = self[i]; i++)tasks.push(instance[methodName].apply(instance, args));
            return self.callFilters("promiseMixitup", h.all(tasks, mixitup.libraries), arguments);
        }
    });
    /**
     * `mixitup.Operation` objects contain all data neccessary to describe the full
     * lifecycle of any MixItUp operation. They can be used to compute and store an
     * operation for use at a later time (e.g. programmatic tweening).
     *
     * @constructor
     * @namespace
     * @memberof    mixitup
     * @private
     * @since       3.0.0
     */ mixitup.Operation = function() {
        mixitup.Base.call(this);
        this.callActions("beforeConstruct");
        this.id = "";
        this.args = [];
        this.command = null;
        this.showPosData = [];
        this.toHidePosData = [];
        this.startState = null;
        this.newState = null;
        this.docState = null;
        this.willSort = false;
        this.willChangeLayout = false;
        this.hasEffect = false;
        this.hasFailed = false;
        this.triggerElement = null;
        this.show = [];
        this.hide = [];
        this.matching = [];
        this.toShow = [];
        this.toHide = [];
        this.toMove = [];
        this.toRemove = [];
        this.startOrder = [];
        this.newOrder = [];
        this.startSort = null;
        this.newSort = null;
        this.startFilter = null;
        this.newFilter = null;
        this.startDataset = null;
        this.newDataset = null;
        this.viewportDeltaX = 0;
        this.viewportDeltaY = 0;
        this.startX = 0;
        this.startY = 0;
        this.startHeight = 0;
        this.startWidth = 0;
        this.newX = 0;
        this.newY = 0;
        this.newHeight = 0;
        this.newWidth = 0;
        this.startContainerClassName = "";
        this.startDisplay = "";
        this.newContainerClassName = "";
        this.newDisplay = "";
        this.callActions("afterConstruct");
        h.seal(this);
    };
    mixitup.BaseStatic.call(mixitup.Operation);
    mixitup.Operation.prototype = Object.create(mixitup.Base.prototype);
    mixitup.Operation.prototype.constructor = mixitup.Operation;
    /**
     * `mixitup.State` objects expose various pieces of data detailing the state of
     * a MixItUp instance. They are provided at the start and end of any operation via
     * callbacks and events, with the most recent state stored between operations
     * for retrieval at any time via the API.
     *
     * @constructor
     * @namespace
     * @memberof    mixitup
     * @public
     * @since       3.0.0
     */ mixitup.State = function() {
        mixitup.Base.call(this);
        this.callActions("beforeConstruct");
        /**
         * The ID of the mixer instance.
         *
         * @name        id
         * @memberof    mixitup.State
         * @instance
         * @type        {string}
         * @default     ''
         */ this.id = "";
        /**
         * The currently active filter command as set by a control click or API call.
         *
         * @name        activeFilter
         * @memberof    mixitup.State
         * @instance
         * @type        {mixitup.CommandFilter}
         * @default     null
         */ this.activeFilter = null;
        /**
         * The currently active sort command as set by a control click or API call.
         *
         * @name        activeSort
         * @memberof    mixitup.State
         * @instance
         * @type        {mixitup.CommandSort}
         * @default     null
         */ this.activeSort = null;
        /**
         * The current layout-specific container class name, if applied.
         *
         * @name        activeContainerClassName
         * @memberof    mixitup.State
         * @instance
         * @type        {string}
         * @default     ''
         */ this.activeContainerClassName = "";
        /**
         * A reference to the container element that the mixer is instantiated on.
         *
         * @name        container
         * @memberof    mixitup.State
         * @instance
         * @type        {Element}
         * @default     null
         */ this.container = null;
        /**
         * An array of all target elements indexed by the mixer.
         *
         * @name        targets
         * @memberof    mixitup.State
         * @instance
         * @type        {Array.<Element>}
         * @default     []
         */ this.targets = [];
        /**
         * An array of all target elements not matching the current filter.
         *
         * @name        hide
         * @memberof    mixitup.State
         * @instance
         * @type        {Array.<Element>}
         * @default     []
         */ this.hide = [];
        /**
         * An array of all target elements matching the current filter and any additional
         * limits applied such as pagination.
         *
         * @name        show
         * @memberof    mixitup.State
         * @instance
         * @type        {Array.<Element>}
         * @default     []
         */ this.show = [];
        /**
         * An array of all target elements matching the current filter irrespective of
         * any additional limits applied such as pagination.
         *
         * @name        matching
         * @memberof    mixitup.State
         * @instance
         * @type        {Array.<Element>}
         * @default     []
         */ this.matching = [];
        /**
         * An integer representing the total number of target elements indexed by the
         * mixer. Equivalent to `state.targets.length`.
         *
         * @name        totalTargets
         * @memberof    mixitup.State
         * @instance
         * @type        {number}
         * @default     -1
         */ this.totalTargets = -1;
        /**
         * An integer representing the total number of target elements matching the
         * current filter and any additional limits applied such as pagination.
         * Equivalent to `state.show.length`.
         *
         * @name        totalShow
         * @memberof    mixitup.State
         * @instance
         * @type        {number}
         * @default     -1
         */ this.totalShow = -1;
        /**
         * An integer representing the total number of target elements not matching
         * the current filter. Equivalent to `state.hide.length`.
         *
         * @name        totalHide
         * @memberof    mixitup.State
         * @instance
         * @type        {number}
         * @default     -1
         */ this.totalHide = -1;
        /**
         * An integer representing the total number of target elements matching the
         * current filter irrespective of any other limits applied such as pagination.
         * Equivalent to `state.matching.length`.
         *
         * @name        totalMatching
         * @memberof    mixitup.State
         * @instance
         * @type        {number}
         * @default     -1
         */ this.totalMatching = -1;
        /**
         * A boolean indicating whether the last operation "failed", i.e. no targets
         * could be found matching the filter.
         *
         * @name        hasFailed
         * @memberof    mixitup.State
         * @instance
         * @type        {boolean}
         * @default     false
         */ this.hasFailed = false;
        /**
         * The DOM element that was clicked if the last operation was triggered by the
         * clicking of a control and not an API call.
         *
         * @name        triggerElement
         * @memberof    mixitup.State
         * @instance
         * @type        {Element|null}
         * @default     null
         */ this.triggerElement = null;
        /**
         * The currently active dataset underlying the rendered targets, if the
         * dataset API is in use.
         *
         * @name        activeDataset
         * @memberof    mixitup.State
         * @instance
         * @type        {Array.<object>}
         * @default     null
         */ this.activeDataset = null;
        this.callActions("afterConstruct");
        h.seal(this);
    };
    mixitup.BaseStatic.call(mixitup.State);
    mixitup.State.prototype = Object.create(mixitup.Base.prototype);
    mixitup.State.prototype.constructor = mixitup.State;
    /**
     * @constructor
     * @memberof    mixitup
     * @private
     * @since       3.0.0
     */ mixitup.UserInstruction = function() {
        mixitup.Base.call(this);
        this.callActions("beforeConstruct");
        this.command = {};
        this.animate = false;
        this.callback = null;
        this.callActions("afterConstruct");
        h.seal(this);
    };
    mixitup.BaseStatic.call(mixitup.UserInstruction);
    mixitup.UserInstruction.prototype = Object.create(mixitup.Base.prototype);
    mixitup.UserInstruction.prototype.constructor = mixitup.UserInstruction;
    /**
     * @constructor
     * @memberof    mixitup
     * @private
     * @since       3.0.0
     */ mixitup.Messages = function() {
        mixitup.Base.call(this);
        this.callActions("beforeConstruct");
        /* Errors
        ----------------------------------------------------------------------------- */ this.ERROR_FACTORY_INVALID_CONTAINER = "[MixItUp] An invalid selector or element reference was passed to the mixitup factory function";
        this.ERROR_FACTORY_CONTAINER_NOT_FOUND = "[MixItUp] The provided selector yielded no container element";
        this.ERROR_CONFIG_INVALID_ANIMATION_EFFECTS = "[MixItUp] Invalid value for `animation.effects`";
        this.ERROR_CONFIG_INVALID_CONTROLS_SCOPE = "[MixItUp] Invalid value for `controls.scope`";
        this.ERROR_CONFIG_INVALID_PROPERTY = '[MixitUp] Invalid configuration object property "${erroneous}"${suggestion}';
        this.ERROR_CONFIG_INVALID_PROPERTY_SUGGESTION = '. Did you mean "${probableMatch}"?';
        this.ERROR_CONFIG_DATA_UID_KEY_NOT_SET = "[MixItUp] To use the dataset API, a UID key must be specified using `data.uidKey`";
        this.ERROR_DATASET_INVALID_UID_KEY = '[MixItUp] The specified UID key "${uidKey}" is not present on one or more dataset items';
        this.ERROR_DATASET_DUPLICATE_UID = '[MixItUp] The UID "${uid}" was found on two or more dataset items. UIDs must be unique.';
        this.ERROR_INSERT_INVALID_ARGUMENTS = "[MixItUp] Please provider either an index or a sibling and position to insert, not both";
        this.ERROR_INSERT_PREEXISTING_ELEMENT = "[MixItUp] An element to be inserted already exists in the container";
        this.ERROR_FILTER_INVALID_ARGUMENTS = "[MixItUp] Please provide either a selector or collection `.filter()`, not both";
        this.ERROR_DATASET_NOT_SET = "[MixItUp] To use the dataset API with pre-rendered targets, a starting dataset must be set using `load.dataset`";
        this.ERROR_DATASET_PRERENDERED_MISMATCH = "[MixItUp] `load.dataset` does not match pre-rendered targets";
        this.ERROR_DATASET_RENDERER_NOT_SET = "[MixItUp] To insert an element via the dataset API, a target renderer function must be provided to `render.target`";
        this.ERROR_SORT_NON_EXISTENT_ELEMENT = "[MixItUp] An element to be sorted does not already exist in the container";
        /* Warnings
        ----------------------------------------------------------------------------- */ this.WARNING_FACTORY_PREEXISTING_INSTANCE = "[MixItUp] WARNING: This element already has an active MixItUp instance. The provided configuration object will be ignored. If you wish to perform additional methods on this instance, please create a reference.";
        this.WARNING_INSERT_NO_ELEMENTS = "[MixItUp] WARNING: No valid elements were passed to `.insert()`";
        this.WARNING_REMOVE_NO_ELEMENTS = "[MixItUp] WARNING: No valid elements were passed to `.remove()`";
        this.WARNING_MULTIMIX_INSTANCE_QUEUE_FULL = "[MixItUp] WARNING: An operation was requested but the MixItUp instance was busy. The operation was rejected because the queue is full or queuing is disabled.";
        this.WARNING_GET_OPERATION_INSTANCE_BUSY = "[MixItUp] WARNING: Operations can be be created while the MixItUp instance is busy.";
        this.WARNING_NO_PROMISE_IMPLEMENTATION = "[MixItUp] WARNING: No Promise implementations could be found. If you wish to use promises with MixItUp please install an ES6 Promise polyfill.";
        this.WARNING_INCONSISTENT_SORTING_ATTRIBUTES = '[MixItUp] WARNING: The requested sorting data attribute "${attribute}" was not present on one or more target elements which may product unexpected sort output';
        this.callActions("afterConstruct");
        this.compileTemplates();
        h.seal(this);
    };
    mixitup.BaseStatic.call(mixitup.Messages);
    mixitup.Messages.prototype = Object.create(mixitup.Base.prototype);
    mixitup.Messages.prototype.constructor = mixitup.Messages;
    /**
     * @return {void}
     */ mixitup.Messages.prototype.compileTemplates = function() {
        var errorKey = "";
        var errorMessage = "";
        for(errorKey in this){
            if (typeof (errorMessage = this[errorKey]) !== "string") continue;
            this[h.camelCase(errorKey)] = h.template(errorMessage);
        }
    };
    mixitup.messages = new mixitup.Messages();
    /**
     * @constructor
     * @memberof    mixitup
     * @private
     * @since       3.0.0
     * @param       {mixitup.Mixer} mixer
     */ mixitup.Facade = function Mixer(mixer) {
        mixitup.Base.call(this);
        this.callActions("beforeConstruct", arguments);
        this.configure = mixer.configure.bind(mixer);
        this.show = mixer.show.bind(mixer);
        this.hide = mixer.hide.bind(mixer);
        this.filter = mixer.filter.bind(mixer);
        this.toggleOn = mixer.toggleOn.bind(mixer);
        this.toggleOff = mixer.toggleOff.bind(mixer);
        this.sort = mixer.sort.bind(mixer);
        this.changeLayout = mixer.changeLayout.bind(mixer);
        this.multimix = mixer.multimix.bind(mixer);
        this.dataset = mixer.dataset.bind(mixer);
        this.tween = mixer.tween.bind(mixer);
        this.insert = mixer.insert.bind(mixer);
        this.insertBefore = mixer.insertBefore.bind(mixer);
        this.insertAfter = mixer.insertAfter.bind(mixer);
        this.prepend = mixer.prepend.bind(mixer);
        this.append = mixer.append.bind(mixer);
        this.remove = mixer.remove.bind(mixer);
        this.destroy = mixer.destroy.bind(mixer);
        this.forceRefresh = mixer.forceRefresh.bind(mixer);
        this.forceRender = mixer.forceRender.bind(mixer);
        this.isMixing = mixer.isMixing.bind(mixer);
        this.getOperation = mixer.getOperation.bind(mixer);
        this.getConfig = mixer.getConfig.bind(mixer);
        this.getState = mixer.getState.bind(mixer);
        this.callActions("afterConstruct", arguments);
        h.freeze(this);
        h.seal(this);
    };
    mixitup.BaseStatic.call(mixitup.Facade);
    mixitup.Facade.prototype = Object.create(mixitup.Base.prototype);
    mixitup.Facade.prototype.constructor = mixitup.Facade;
    $8399e4e9dca8c987$exports = mixitup;
    mixitup.BaseStatic.call(mixitup.constructor);
    mixitup.NAME = "mixitup";
    mixitup.CORE_VERSION = "3.3.2";
})(window);


const $4c24304ff1ca3959$export$90b4d2ff6acb88af = ()=>{
    /* Logic for fixed menu position. Adding background when scrolling, and removing background when on top of the page */ document.addEventListener("DOMContentLoaded", function() {
        const menuToggle = document.getElementById("menu-toggle");
        const overlay = document.getElementById("overlay");
        menuToggle.addEventListener("click", ()=>{
            menuToggle.classList.toggle("active");
            overlay.classList.toggle("open");
        });
        //language-toggle
        const languageToggle = document.getElementById("language-navigation");
        const languageButton = document.getElementById("language-button");
        const languageMenu = document.getElementById("language-menu");
        if (languageToggle) languageToggle.addEventListener("click", ()=>{
            // languageToggle.classList.toggle('active');
            languageButton.classList.toggle("active");
            languageMenu.classList.toggle("open");
        });
        const siteHeader = document.querySelector(".site-header");
        if (siteHeader) {
            const pageScroll = ()=>{
                const scrollPosition = window.scrollY;
                const threshold = 1;
                if (scrollPosition > threshold) {
                    siteHeader.classList.add("is-fixed");
                    overlay.style.top = "70px";
                }
                if (scrollPosition === 0) {
                    siteHeader.classList.remove("is-fixed");
                    overlay.style.top = "100px";
                }
            };
            window.addEventListener("scroll", pageScroll);
        }
    });
    const siteHeader = document.querySelector(".site-header");
    const navigationList = document.querySelector(".navigation-list");
    // Dynamic adjustment to header if it is too wide under 1340px.
    if (siteHeader && navigationList) {
        const updateNavigationState = ()=>{
            const screenWidth = window.innerWidth;
            const navigationWidth = navigationList.offsetWidth;
            if (screenWidth < 1445 && navigationWidth > 1050) navigationList.classList.add("navigation-crowded");
            else navigationList.classList.remove("navigation-crowded");
        };
        // Run on load
        updateNavigationState();
        // Run on resize
        window.addEventListener("resize", updateNavigationState);
    }
    /* Videobutton for text & image/videoblock */ const imageVideoControls = document.querySelector(".video-controls");
    const playPauseButton = document.querySelector(".controls-button");
    const video = document.querySelector(".hero-block__video");
    if (imageVideoControls) {
        if (playPauseButton) playPauseButton.addEventListener("click", ()=>{
            playPauseButton.classList.toggle("active");
            if (video.paused) video.play();
            else video.pause();
        });
    }
    document.addEventListener("DOMContentLoaded", ()=>{
        const scrollToDocumentationLink = document.getElementById("scroll-to-documentation");
        if (scrollToDocumentationLink) scrollToDocumentationLink.addEventListener("click", (event)=>{
            event.preventDefault();
            smoothScroll("#documentation");
        });
    });
    function smoothScroll(targetSelector) {
        const targetElement = document.querySelector(targetSelector);
        if (targetElement instanceof HTMLElement) window.scrollTo({
            top: targetElement.offsetTop,
            behavior: "smooth"
        });
    }
    document.addEventListener("DOMContentLoaded", ()=>{
        const containers = document.querySelectorAll(".document-items");
        if (containers.length === 0) return;
        containers.forEach((container)=>{
            (0, (/*@__PURE__*/$parcel$interopDefault($8399e4e9dca8c987$exports)))(container, {
                selectors: {
                    target: ".document-item"
                },
                animation: {
                    enable: false
                }
            });
        });
    });
};


(0, $8e7ff2bfafa270a8$export$939e43573ccd2f80)();
(0, $4c24304ff1ca3959$export$90b4d2ff6acb88af)();

})();
//# sourceMappingURL=main.js.map
